export const getArtinvestProjects = () => {
  return [
    {
      id: 15428,
      date: "2014-12-02T12:00:05",
      date_gmt: "2014-12-02T11:00:05",
      guid: {
        rendered: "https://www.art-invest.de/projekt/alter-wall/",
      },
      modified: "2021-11-04T17:48:01",
      modified_gmt: "2021-11-04T16:48:01",
      slug: "alter-wall",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/alter-wall/",
      title: {
        rendered: "Alter Wall",
      },
      featured_media: 18461,
      template: "",
      projekt_filter: [246, 250, 248, 427, 425, 245],
      acf: {
        highlight_image: 18490,
        highlight_title_project: "Alter Wall",
        highlight_subtitle_project: "Zwischen zwei Welten",
        highlight_description_project:
          "A rediscovery is revolutionizing the city of Hamburg: 15,000 m² of space for art, enjoyment and shopping as well as 18,000 m² of modern working space are being created in the Alter Wall. Behind the city’s longest historical facade, directly opposite the city hall, the architects of Gerkan, Marg und Partner are creating a completely new world, like the hanseatic city has never seen before.",
        highlight_logo_project: 16232,
        website_projects: {
          title: "www.alter-wall-hamburg.de",
          url: "https://www.alter-wall-hamburg.de/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://www.alter-wall-hamburg.de/",
          target: "_blank",
        },
        available_space: [""],
        project: "Project Development",
        location: "Alter Wall, 20457 Hamburg; inner City (Germany)",
        property: "5,000 m²",
        area: "Retail, Catering: 12,000 m² /  Office: 18,000 m² / Museum: 3,000 m²",
        zertifizierung: "",
        parcels: "220",
        use_for: "Retail, Office, Museum, Catering",
        acquired: "2012",
        realization: "Alter Wall 10-32: Q2 2019 / Alter Wall 2-8: Q4 2019",
        sale: "",
        architecture_firm: "gmp - Gerkan Marg und Partner",
        place: "Hamburg",
        fakten: null,
        specifications_image_projects: 18469,
        slider: [
          18484, 18486, 18463, 18471, 18467, 18492, 18465, 18475, 18473, 18481,
          18479,
        ],
        title_details_projects: "ALTER WALL IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Connecting opposites",
            description_repeater_details:
              "The Alsterfleet not only marks the boundary between the Old and New Town. It also connects two retail segments: the exclusive luxury segment of Neuer Wall and Passagenviertel on the one hand and the diverse brand world of Mönckebergstrasse and Spitalerstrasse on the other. The Alter Wall ensemble integrates both worlds by connecting the two most important retail locations of the city with the best pedestrian frequencies, the Bucerius Passage and the Alsterfleetbrücke.",
            image_repeater_details: 18461,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Working in light",
            description_repeater_details:
              "The central axis of the atrium provides natural light for high-quality work surfaces over the entire length of the complex. Thus, under the roof of the ensemble, a bright and open working environment with a clear room height of 3 metres is created. All office areas can be flexibly designed as cellular or group offices for optimal work and meeting quality. The in-house underground car park provides parking space for 220 cars.",
            image_repeater_details: 18481,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Art in the centre",
            description_repeater_details:
              "The Bucerius Kunst Forum opens its new exhibition spaces in the heart of the Old Wall. The Hamburg cultural institution attracts thousands of art lovers to the city every year - in 2015, the number of visitors exceeded 350,000. Since 2002, the Kunst Forum with its changing international exhibitions on antiquity and modernity has been an integral part of Hamburg's art mile.",
            image_repeater_details: 18467,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "From fortness rampart to a boulevard",
            description_repeater_details:
              "The Alter Wall has a varied biography. In the 15th century, it served as a fortification to secure the eastern flank of the old town, Heinrich Heine dined here on Parisian delicacies and at the turn of the century, shopping and commerce pulsated along the chic boulevard. The restored sand and natural stone facade, which is a protected historic monument, today breathes the flair of the fin-de-siècle again.",
            image_repeater_details: 14014,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Alter Wall Movie",
            description_repeater_details: "",
            image_repeater_details: 18484,
            video: "https://player.vimeo.com/video/192611311",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Alter Wall 2, Hamburg, Deutschland",
          lat: 53.5510226,
          lng: 9.991595200000006,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Alter Wall</title>\n<meta name="description" content="Am Alten Wall entstehen hinter der historischen Fassade 12.000 m² Fläche für Kunst, Kultur und Konsum, sowie 18.000 m² Raum für modernes Arbeiten." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/alter-wall/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Alter Wall" />\n<meta property="og:description" content="Am Alten Wall entstehen hinter der historischen Fassade 12.000 m² Fläche für Kunst, Kultur und Konsum, sowie 18.000 m² Raum für modernes Arbeiten." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/alter-wall/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T16:48:01+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2021/05/AlterWall_111.jpg" />\n\t<meta property="og:image:width" content="2000" />\n\t<meta property="og:image:height" content="1357" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/alter-wall/","url":"https://www.art-invest.de/en/projekt/alter-wall/","name":"Art-Invest Real Estate | Alter Wall","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-12-02T11:00:05+00:00","dateModified":"2021-11-04T16:48:01+00:00","description":"Am Alten Wall entstehen hinter der historischen Fassade 12.000 m² Fläche für Kunst, Kultur und Konsum, sowie 18.000 m² Raum für modernes Arbeiten.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/alter-wall/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/alter-wall/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/alter-wall/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Alter Wall"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Alter Wall",
        description:
          "Am Alten Wall entstehen hinter der historischen Fassade 12.000 m² Fläche für Kunst, Kultur und Konsum, sowie 18.000 m² Raum für modernes Arbeiten.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/alter-wall/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Alter Wall",
        og_description:
          "Am Alten Wall entstehen hinter der historischen Fassade 12.000 m² Fläche für Kunst, Kultur und Konsum, sowie 18.000 m² Raum für modernes Arbeiten.",
        og_url: "https://www.art-invest.de/en/projekt/alter-wall/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T16:48:01+00:00",
        og_image: [
          {
            width: 2000,
            height: 1357,
            url: "https://www.art-invest.de/wp-content/uploads/2021/05/AlterWall_111.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/alter-wall/",
              url: "https://www.art-invest.de/en/projekt/alter-wall/",
              name: "Art-Invest Real Estate | Alter Wall",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-12-02T11:00:05+00:00",
              dateModified: "2021-11-04T16:48:01+00:00",
              description:
                "Am Alten Wall entstehen hinter der historischen Fassade 12.000 m² Fläche für Kunst, Kultur und Konsum, sowie 18.000 m² Raum für modernes Arbeiten.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/alter-wall/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/alter-wall/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/alter-wall/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Alter Wall",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2021/05/AlterWall_111-800x800.jpg",
      place: "Hamburg",
      subtitle: "Zwischen zwei Welten",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/15428",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18479",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18481",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18473",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18475",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18465",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18492",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18467",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18471",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18463",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18486",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18484",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18461",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=15428",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=15428",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21171,
      date: "2022-07-27T14:31:57",
      date_gmt: "2022-07-27T12:31:57",
      guid: {
        rendered: "https://www.art-invest.de/projekt/canada-water-dockside/",
      },
      modified: "2024-03-11T18:15:55",
      modified_gmt: "2024-03-11T17:15:55",
      slug: "dockside-canada-water",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/dockside-canada-water/",
      title: {
        rendered: "Dockside Canada Water",
      },
      featured_media: 21078,
      template: "",
      projekt_filter: [246, 427, 425, 245, 262],
      acf: {
        highlight_image: 21099,
        highlight_title_project: "Dockside Canada Water",
        highlight_subtitle_project: "Stadtviertel im Zentrum von London",
        highlight_description_project:
          '<p style="font-weight: 400;">Art-Invest Real Estate is adding a best-in-class mixed-use scheme to its UK portfolio with Dockside Canada Water. Situated on a strategic central London freehold 4.5-acre site, its dockside setting offers an abundance of natural parks, woods and health resources. The development is designed to be a world-class green commercial campus targeting the highest standards of sustainability and wellness amidst expansive amenity spaces.</p>',
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Development",
        location: "Canada Water, London SE16",
        property: "19,000 sqm",
        area: "Site A: 10,720 sqm | Site B: 8,540 sqm",
        zertifizierung: "",
        parcels: "Disabled parking bays only",
        use_for: "Office led with retail and food & beverage at ground floor",
        acquired: "2020",
        realization: "2027",
        sale: "",
        architecture_firm: "Bjarke Ingels Group and HWKN",
        place: "London",
        fakten: [
          {
            bezeichnung: "Specials",
            wert: "Historic docklands ",
            anchor: "",
          },
        ],
        specifications_image_projects: 21078,
        slider: [21074, 21076, 21072, 21082],
        title_details_projects: "Dockside Canada Water in detail",
        details_repeater_projects: [
          {
            title_repeater_details: "Workplace of the Future",
            description_repeater_details:
              '<p style="font-weight: 400;">Bjarke Ingels Group (BIG) is behind the masterplan, which will transform the site into three innovative buildings comprising 1.1 m sq ft of flexible workspace, restaurants, retail outlets and over 89,000 sq ft waterside terraces. With particular focus on health and wellbeing, tenants and visitors alike will enjoy an excellent work-life balance surrounded by a generous amount of green space. Art-Invest\'s proven track record in delivering innovative large-scale projects will lead the area to an environmentally sustainable future by providing a state-of-the-art urban quarter.</p>',
            image_repeater_details: 21080,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Connectivity and Amenities ",
            description_repeater_details:
              '<p style="font-weight: 400;">Strategically positioned within Central London and accessible via outstanding transport connections, this affordable and amenity-rich location has attracted an increasing pool of talented younger demographic in recent years. The site is set to further benefit from its locality, set within one of the largest single master planned mixed-use developments In Europe.</p>',
            image_repeater_details: 21074,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Canada Water, London SE16 7LL, Vereinigtes Königreich",
          lat: 51.4965967,
          lng: -0.0468214,
          zoom: 14,
          place_id:
            "EiFDYW5hZGEgV2F0ZXIsIExvbmRvbiBTRTE2IDdMTCwgVUsiLiosChQKEgkxXb7oIAN2SBGX0D6FOmGO3xIUChIJiaVbdSADdkgRysWGu1AkQLI",
          name: "Canada Water",
          street_name: "Canada Water",
          city: "London",
          state: "England",
          post_code: "SE16 7LL",
          country: "Vereinigtes Königreich",
          country_short: "GB",
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Dockside Canada Water</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/dockside-canada-water/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Dockside Canada Water" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/dockside-canada-water/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2024-03-11T17:15:55+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2022/07/MILLER-HARE_4458_0718_210708_xfer.jpg" />\n\t<meta property="og:image:width" content="1458" />\n\t<meta property="og:image:height" content="1032" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/dockside-canada-water/","url":"https://www.art-invest.de/en/projekt/dockside-canada-water/","name":"Art-Invest Real Estate | Dockside Canada Water","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2022-07-27T12:31:57+00:00","dateModified":"2024-03-11T17:15:55+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/dockside-canada-water/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/dockside-canada-water/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/dockside-canada-water/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Dockside Canada Water"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Dockside Canada Water",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/dockside-canada-water/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Dockside Canada Water",
        og_url: "https://www.art-invest.de/en/projekt/dockside-canada-water/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2024-03-11T17:15:55+00:00",
        og_image: [
          {
            width: 1458,
            height: 1032,
            url: "https://www.art-invest.de/wp-content/uploads/2022/07/MILLER-HARE_4458_0718_210708_xfer.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/dockside-canada-water/",
              url: "https://www.art-invest.de/en/projekt/dockside-canada-water/",
              name: "Art-Invest Real Estate | Dockside Canada Water",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2022-07-27T12:31:57+00:00",
              dateModified: "2024-03-11T17:15:55+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/dockside-canada-water/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/dockside-canada-water/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/dockside-canada-water/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Dockside Canada Water",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2022/07/MILLER-HARE_4458_0718_210708_xfer-800x800.jpg",
      place: "London",
      subtitle: "Stadtviertel im Zentrum von London",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21171",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21082",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21072",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21076",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21074",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21078",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21171",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21171",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16636,
      date: "2015-06-16T12:00:49",
      date_gmt: "2015-06-16T10:00:49",
      guid: {
        rendered: "https://www.art-invest.de/projekt/atlas/",
      },
      modified: "2021-11-04T17:48:37",
      modified_gmt: "2021-11-04T16:48:37",
      slug: "atlas",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/atlas/",
      title: {
        rendered: "ATLAS",
      },
      featured_media: 15438,
      template: "",
      projekt_filter: [246, 426, 249, 425],
      acf: {
        highlight_image: 15444,
        highlight_title_project: "ATLAS",
        highlight_subtitle_project: "Der sagenumwobene Osten",
        highlight_description_project:
          "According to Greek legend, it is the atlas that carries the world on its shoulders – and it is the sphere, visible from afar, that gives the office ensemble ATLAS an elegant appearance as a new landmark in the Werksviertel.",
        highlight_logo_project: 15439,
        website_projects: {
          title: "http://atlas-werksviertel.de/",
          url: "http://atlas-werksviertel.de/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "http://atlas-werksviertel.de/",
          target: "_blank",
        },
        available_space: [""],
        project: "Development",
        location:
          "Rosenheimer Straße 143 a-d, 81671 Munich; nearby Munich East Station",
        property: "6,300 m²",
        area: "approx. 24,500 m² Retail Space",
        zertifizierung: "",
        parcels: "approx. 230",
        use_for: "Office, Gastronomy",
        acquired: "2016",
        realization: "2018",
        sale: "",
        architecture_firm: "OSA Architekten",
        place: "München",
        fakten: null,
        specifications_image_projects: 15440,
        slider: null,
        title_details_projects: "ATLAS IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Der sagenumwobene Osten",
            description_repeater_details:
              "The decision to build the Munich concert hall in the Werksviertel has a signal effect, not only for the 6,300m² ATLAS property on Rosenheimer Strasse, but for the Munich East as a whole. The construction sets an accent for the property with approx. 24,500m² of modern usable space and represents an important urban building block for the development of the east of Munich.",
            image_repeater_details: 15441,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "The new Werksviertel ",
            description_repeater_details:
              "The ATLAS-Plaza is located not far from Munich's Ostbahnhof (East Station) in the new Areal Werksviertel, an exciting young area that redefines the interaction of working and living. From here, there are direct connections to public transport and individual traffic. A direct car priority from Rosenheimer Straße allows direct access – including to approx. 230 parking spaces.",
            image_repeater_details: 15442,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "High quality properties ",
            description_repeater_details:
              "In addition to its airy appearance and elegant visibility, the 53m high office complex with its striking drapery in the facade has a high-quality finishing standard. All areas can be flexibly designed, and future tenants will find modern catering facilities on the ground floor. From the sky lounge with roof terrace, it offers an impressive 360° panoramic view over the Isar river and the Alpine foothills – a view that is directly off the hinges.",
            image_repeater_details: 15443,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Making-of ATLAS",
            description_repeater_details: "",
            image_repeater_details: 15035,
            video: "https://player.vimeo.com/video/379962746",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Rosenheimer Straße 143, 81671 München, Deutschland",
          lat: 48.1234219,
          lng: 11.6044717,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | ATLAS</title>\n<meta name="description" content="Das 14-geschossige Büroensemble mit der markanten Atlaskugel auf dem Dach und ca. 23.000 m² modernster Nutzfläche hebt den Münchner Osten aus dem Abseits." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/atlas/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | ATLAS" />\n<meta property="og:description" content="Das 14-geschossige Büroensemble mit der markanten Atlaskugel auf dem Dach und ca. 23.000 m² modernster Nutzfläche hebt den Münchner Osten aus dem Abseits." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/atlas/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T16:48:37+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/03/atlas-rainer-taepper-architekturfotografie-07-Kopie-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1707" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/atlas/","url":"https://www.art-invest.de/en/projekt/atlas/","name":"Art-Invest Real Estate | ATLAS","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2015-06-16T10:00:49+00:00","dateModified":"2021-11-04T16:48:37+00:00","description":"Das 14-geschossige Büroensemble mit der markanten Atlaskugel auf dem Dach und ca. 23.000 m² modernster Nutzfläche hebt den Münchner Osten aus dem Abseits.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/atlas/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/atlas/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/atlas/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"ATLAS"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | ATLAS",
        description:
          "Das 14-geschossige Büroensemble mit der markanten Atlaskugel auf dem Dach und ca. 23.000 m² modernster Nutzfläche hebt den Münchner Osten aus dem Abseits.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/atlas/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | ATLAS",
        og_description:
          "Das 14-geschossige Büroensemble mit der markanten Atlaskugel auf dem Dach und ca. 23.000 m² modernster Nutzfläche hebt den Münchner Osten aus dem Abseits.",
        og_url: "https://www.art-invest.de/en/projekt/atlas/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T16:48:37+00:00",
        og_image: [
          {
            width: 2560,
            height: 1707,
            url: "https://www.art-invest.de/wp-content/uploads/2020/03/atlas-rainer-taepper-architekturfotografie-07-Kopie-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/atlas/",
              url: "https://www.art-invest.de/en/projekt/atlas/",
              name: "Art-Invest Real Estate | ATLAS",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2015-06-16T10:00:49+00:00",
              dateModified: "2021-11-04T16:48:37+00:00",
              description:
                "Das 14-geschossige Büroensemble mit der markanten Atlaskugel auf dem Dach und ca. 23.000 m² modernster Nutzfläche hebt den Münchner Osten aus dem Abseits.",
              breadcrumb: {
                "@id": "https://www.art-invest.de/en/projekt/atlas/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/atlas/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/atlas/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "ATLAS",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/03/atlas-rainer-taepper-architekturfotografie-07-Kopie-scaled-800x800.jpg",
      place: "München",
      subtitle: "Der sagenumwobene Osten",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16636",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/15438",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16636",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16636",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16571,
      date: "2014-11-04T12:00:39",
      date_gmt: "2014-11-04T11:00:39",
      guid: {
        rendered: "https://www.art-invest.de/projekt/fuerst-friedrich/",
      },
      modified: "2021-11-29T13:01:40",
      modified_gmt: "2021-11-29T12:01:40",
      slug: "fuerst-friedrich",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/fuerst-friedrich/",
      title: {
        rendered: "Fürst & Friedrich",
      },
      featured_media: 16301,
      template: "",
      projekt_filter: [246, 426, 425, 257],
      acf: {
        highlight_image: 16312,
        highlight_title_project: "Fürst & Friedrich",
        highlight_subtitle_project: "Futuristisches Glasgebäude",
        highlight_description_project:
          "The Fürst und Friedrich in Dusseldorf is a spectacular office building that fuses a historical property with a modern new construction to create innovative working environments. Behind the wide glass facade, the building offers space on seven floors for a flexible mix of workspaces.",
        highlight_logo_project: 16574,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Development",
        location: "Friedrichstadt, 40217 Dusseldorf",
        property: "approx. 3,420 m²",
        area: "Rental Space approx. 15,500 m² / BGF approx. 17,000 m²",
        zertifizierung: "",
        parcels: "132",
        use_for: "Office, Gastronomy",
        acquired: "Q4 2015",
        realization: "Q3 2019",
        sale: "",
        architecture_firm: "slapa oberholz pszczulny architekten",
        place: "Düsseldorf",
        fakten: null,
        specifications_image_projects: 16303,
        slider: null,
        title_details_projects: "FÜRST & FRIEDRICH IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Address with a future",
            description_repeater_details:
              "Behind the classicist facade, the foyer opens up to five floors of modern office space. The bright reception room with its panoramic elevators and relief sculptures by the artist Jan Albers is flanked by an espresso bar. Each floor with a rental area of approx. 2,200 m² can be flexibly and efficiently designed to meet all work requirements, only the view from the roof terraces is defined.",
            image_repeater_details: 16305,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Savoir-vivre à la Friedrichstadt",
            description_repeater_details:
              "The Fürst und Friedrich is located directly opposite the Kirchplatz in downtown Düsseldorf. The young district with the high density of Wilhelminian style buildings is part of the Neustadt and is one of the hippest districts in the Rhine metropolis. Various culinary and cultural offers provide creative flair and a high quality of life.",
            image_repeater_details: 16299,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "350 years of city history “op de Eck”",
            description_repeater_details:
              "Two streets and two names that have written Düsseldorf’s history cross at this building. The Palatine prince Jan Wellem (1658-1716) turned the little Rhine town into a brilliant royal residence in the 17th century. The residence of the Prussian governor later stood directly on the corner. Even more than the classicistic natural stone facade, the name Friedrich is a reminder of the Prussian heritage of the town. When Düsseldorf became the Prussian Rhine province after Napoleon, the city dedicated two streets to the Prussian King Frederick William IV (1795-1861) as a sign of its loyalty: Friedrichstraße and Königsallee.",
            image_repeater_details: 16297,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "",
            description_repeater_details: "",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Friedrichstraße 56/ Ecke Fürstenwall",
          lat: 51.2139193,
          lng: 6.776844900000015,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Fürst &amp; Friedrich</title>\n<meta name="description" content="Das Fürst &amp; Friedrich in Düsseldorf ist ein spektakuläres Bürogebäude, das historischen Bestand und modernen Neubau zu innovativen Arbeitswelten fusioniert." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/fuerst-friedrich/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Fürst &amp; Friedrich" />\n<meta property="og:description" content="Das Fürst &amp; Friedrich in Düsseldorf ist ein spektakuläres Bürogebäude, das historischen Bestand und modernen Neubau zu innovativen Arbeitswelten fusioniert." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/fuerst-friedrich/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-29T12:01:40+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/06/DUS_FuerstFriedrich_Auﬂenansicht_Daemmerung_Haupteingang.jpg" />\n\t<meta property="og:image:width" content="2500" />\n\t<meta property="og:image:height" content="1786" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/fuerst-friedrich/","url":"https://www.art-invest.de/en/projekt/fuerst-friedrich/","name":"Art-Invest Real Estate | Fürst & Friedrich","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-11-04T11:00:39+00:00","dateModified":"2021-11-29T12:01:40+00:00","description":"Das Fürst & Friedrich in Düsseldorf ist ein spektakuläres Bürogebäude, das historischen Bestand und modernen Neubau zu innovativen Arbeitswelten fusioniert.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/fuerst-friedrich/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/fuerst-friedrich/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/fuerst-friedrich/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Fürst &#038; Friedrich"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Fürst & Friedrich",
        description:
          "Das Fürst & Friedrich in Düsseldorf ist ein spektakuläres Bürogebäude, das historischen Bestand und modernen Neubau zu innovativen Arbeitswelten fusioniert.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/fuerst-friedrich/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Fürst & Friedrich",
        og_description:
          "Das Fürst & Friedrich in Düsseldorf ist ein spektakuläres Bürogebäude, das historischen Bestand und modernen Neubau zu innovativen Arbeitswelten fusioniert.",
        og_url: "https://www.art-invest.de/en/projekt/fuerst-friedrich/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-29T12:01:40+00:00",
        og_image: [
          {
            width: 2500,
            height: 1786,
            url: "https://www.art-invest.de/wp-content/uploads/2020/06/DUS_FuerstFriedrich_Auﬂenansicht_Daemmerung_Haupteingang.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/fuerst-friedrich/",
              url: "https://www.art-invest.de/en/projekt/fuerst-friedrich/",
              name: "Art-Invest Real Estate | Fürst & Friedrich",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-11-04T11:00:39+00:00",
              dateModified: "2021-11-29T12:01:40+00:00",
              description:
                "Das Fürst & Friedrich in Düsseldorf ist ein spektakuläres Bürogebäude, das historischen Bestand und modernen Neubau zu innovativen Arbeitswelten fusioniert.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/fuerst-friedrich/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/fuerst-friedrich/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/fuerst-friedrich/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Fürst & Friedrich",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/06/DUS_FuerstFriedrich_Auﬂenansicht_Daemmerung_Haupteingang-800x800.jpg",
      place: "Düsseldorf",
      subtitle: "Futuristisches Glasgebäude",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16571",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16301",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16571",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16571",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16203,
      date: "2013-08-16T12:00:52",
      date_gmt: "2013-08-16T10:00:52",
      guid: {
        rendered: "https://www.art-invest.de/projekt/id-cologne/",
      },
      modified: "2023-04-05T10:00:09",
      modified_gmt: "2023-04-05T08:00:09",
      slug: "id-cologne",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/id-cologne/",
      title: {
        rendered: "I/D Cologne",
      },
      featured_media: 16204,
      template: "",
      projekt_filter: [246, 247, 251, 427, 425],
      acf: {
        highlight_image: 16373,
        highlight_title_project: "I/D Cologne",
        highlight_subtitle_project: "Arbeitswelt von morgen",
        highlight_description_project:
          '<span style="vertical-align: inherit;">I/D Cologne is the project name for a new neighbourhood in an identity-forming and individual district. The site in Schanzenstraße was once the former Mulheim freight station. In the future, more than 7,000 people will work in the quarter, which will shape innovative concepts of work and life.\r\n</span>',
        highlight_logo_project: 16372,
        website_projects: {
          title: "www.i-d.cologne",
          url: "https://www.i-d.cologne/",
          target: "",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://www.i-d.cologne/",
          target: "_blank",
        },
        available_space: {
          title: "zum Flächenangebot",
          url: "https://www.aire-mag.com/de/flaechen/id-cologne",
          target: "_blank",
        },
        project: "Development",
        location: "Schanzenstraße, 51063 Cologne-Mülheim (Cologne, Germany)",
        property: "7 ha",
        area: "160,000 m² BGF",
        zertifizierung: "",
        parcels: "2,000",
        use_for: "Office, Hotel, Catering, Fitness",
        acquired: "2016",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Köln",
        fakten: null,
        specifications_image_projects: 16204,
        slider: [16335, 16371],
        title_details_projects: "I/D COLOGNE IM DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "The new side of the Schanzenstraße ",
            description_repeater_details:
              "There is a lot of movement in Cologne-Mülheim. On the right bank of the Rhine on Mülheim's Schanzenstraße, offices, hotels, restaurants and fitness areas provide the building blocks for the new quarter with 160,000 m² gross floor area. It is planned to create a new platform for modern companies, young start-ups and well-known players at the established office location Schanzenstraße.",
            image_repeater_details: 16371,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Numerous connections ",
            description_repeater_details:
              "The location has an optimal connection to public transport as well as to individual car traffic. Over 2,000 parking slots create space for cars. Rail and bus stops with fast connections are located directly on the site, which, as a location between the mature districts of Mülheim and the important media, cultural and office location Schanzenstraße, represents an excellent link with the best location qualities.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Schanzenstraße 30, 51063 Köln-Mülheim",
          lat: 50.9684647,
          lng: 7.011801900000023,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | I/D Cologne</title>\n<meta name="description" content="I/D Cologne ist der Projektname für ein neues Stadtquartier im Kölner Norden. Künftig arbeiten über 7.000 Menschen in der innovativen Arbeitsumgebung." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/id-cologne/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | I/D Cologne" />\n<meta property="og:description" content="I/D Cologne ist der Projektname für ein neues Stadtquartier im Kölner Norden. Künftig arbeiten über 7.000 Menschen in der innovativen Arbeitsumgebung." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/id-cologne/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-04-05T08:00:09+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2013/08/CAM-04-AERIAL-NIGHT-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1952" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/id-cologne/","url":"https://www.art-invest.de/en/projekt/id-cologne/","name":"Art-Invest Real Estate | I/D Cologne","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2013-08-16T10:00:52+00:00","dateModified":"2023-04-05T08:00:09+00:00","description":"I/D Cologne ist der Projektname für ein neues Stadtquartier im Kölner Norden. Künftig arbeiten über 7.000 Menschen in der innovativen Arbeitsumgebung.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/id-cologne/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/id-cologne/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/id-cologne/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"I/D Cologne"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | I/D Cologne",
        description:
          "I/D Cologne ist der Projektname für ein neues Stadtquartier im Kölner Norden. Künftig arbeiten über 7.000 Menschen in der innovativen Arbeitsumgebung.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/id-cologne/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | I/D Cologne",
        og_description:
          "I/D Cologne ist der Projektname für ein neues Stadtquartier im Kölner Norden. Künftig arbeiten über 7.000 Menschen in der innovativen Arbeitsumgebung.",
        og_url: "https://www.art-invest.de/en/projekt/id-cologne/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-04-05T08:00:09+00:00",
        og_image: [
          {
            width: 2560,
            height: 1952,
            url: "https://www.art-invest.de/wp-content/uploads/2013/08/CAM-04-AERIAL-NIGHT-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/id-cologne/",
              url: "https://www.art-invest.de/en/projekt/id-cologne/",
              name: "Art-Invest Real Estate | I/D Cologne",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2013-08-16T10:00:52+00:00",
              dateModified: "2023-04-05T08:00:09+00:00",
              description:
                "I/D Cologne ist der Projektname für ein neues Stadtquartier im Kölner Norden. Künftig arbeiten über 7.000 Menschen in der innovativen Arbeitsumgebung.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/id-cologne/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/id-cologne/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/id-cologne/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "I/D Cologne",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2013/08/CAM-04-AERIAL-NIGHT-1-scaled-800x800.jpg",
      place: "Köln",
      subtitle: "Arbeitswelt von morgen ",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16203",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16371",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16335",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16204",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16203",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16203",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16210,
      date: "2019-10-15T17:23:52",
      date_gmt: "2019-10-15T15:23:52",
      guid: {
        rendered: "https://www.art-invest.de/projekt/101-cleveland-street/",
      },
      modified: "2023-07-19T09:11:01",
      modified_gmt: "2023-07-19T07:11:01",
      slug: "101-on-cleveland",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/101-on-cleveland/",
      title: {
        rendered: "101 on Cleveland",
      },
      featured_media: 16212,
      template: "",
      projekt_filter: [427, 425, 245, 262],
      acf: {
        highlight_image: 13961,
        highlight_title_project: "101 on Cleveland",
        highlight_subtitle_project: "Gehobenes Wohnen in Fitzrovia",
        highlight_description_project:
          "The modern building at 101 Cleveland Street contains about 88 apartments in a high-quality boutique style. Close to the West End the versatile Fitzrovia offers unique London lifestyle. Small restaurants, first-class art galleries - the pulsating life is right on the doorstep. For many years Fitzrovia has been a magnet for creative people and art lovers and embodied the Bohemian lifestyle - today people come here for the unique bars, restaurants and leisure facilities.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment, Development",
        location: "Cleveland Street, Fitzrovia, London",
        property: "17,285 m²",
        area: "4,360 m²",
        zertifizierung:
          '{"title":"www.101oncleveland.com","url":"https:\\/\\/www.101oncleveland.com\\/","target":"_blank"}',
        parcels: "43",
        use_for: "Living, Retail",
        acquired: "Q2 2019",
        realization: "Q2 2021 ",
        sale: "",
        architecture_firm: "Assael",
        place: "London",
        fakten: [
          {
            bezeichnung: "Joint Venture Partner",
            wert: "ECE & Dukelease",
            anchor: "",
          },
        ],
        specifications_image_projects: 11428,
        slider: [16211, 16212],
        title_details_projects: "101 ON CLEVELAND IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Contemporary and timeless design ",
            description_repeater_details:
              "The facade of the property has been skillfully matched to the architecture of the district, in order to blend harmoniously into the street scene, which is full of character. The smooth, dark brick reminds of some of the nearby historic buildings. Metal elements in warm coloured tones, structured concrete and geometric window surrounds give the facade additional modern accents. With three to nine upper floors, the well-thought-out complex of three buildings appears homely yet urban. 88 high-class condominiums and 15 affordable apartments are located in the striking, wedge-shaped floor plan, which blends seamlessly into the surroundings with its creative touch. Selected shops and retailers on the ground floor contribute to the spirit of the district.\r\n\r\nThe spacious, bright apartments convey an urban lifestyle at the highest level. Open rooms with high ceilings and large window fronts meet all the requirements of living together in a modern environment. The interaction of high-quality materials, selected structures and textures with natural elements as well as solutions tailored to customer requirements give each apartment a unique character - classic with a modern twist.",
            image_repeater_details: 11434,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Numerous facilities for the residents ",
            description_repeater_details:
              "The property offers tenants and owners a wide range of hotel-like services. The restaurant, which is only accessible to residents, and the bar convey an exclusive club atmosphere. Traditional materials have been used for the furnishings and refined with modern elements. Dark wood and stone with strong colour accents, fabrics with geometric patterns, Italian designer furniture as well as coverlets and extra large cushions give the rooms a comfortable and homely atmosphere. A cinema hall offers entertainment and the business suite a quiet and comfortable workplace.",
            image_repeater_details: 11430,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "The ideal location for comfortable living ",
            description_repeater_details:
              "Fitzrovia is excellently connected. Four underground stations are close by and the West End is only a ten-minute walk away. Regents' Park with the London Zoo, a number of first-class universities, cultural highlights as well as numerous international companies are located in the immediate vicinity of the property.",
            image_repeater_details: 16211,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "101 Cleveland Street, London, Vereinigtes Königreich",
          lat: 51.5202232,
          lng: -0.1383954,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | 101 on Cleveland</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/101-on-cleveland/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | 101 on Cleveland" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/101-on-cleveland/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-07-19T07:11:01+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2019/10/3696_1200_181207_xfer-Kopie-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1953" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/101-on-cleveland/","url":"https://www.art-invest.de/en/projekt/101-on-cleveland/","name":"Art-Invest Real Estate | 101 on Cleveland","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2019-10-15T15:23:52+00:00","dateModified":"2023-07-19T07:11:01+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/101-on-cleveland/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/101-on-cleveland/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/101-on-cleveland/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"101 on Cleveland"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | 101 on Cleveland",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/101-on-cleveland/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | 101 on Cleveland",
        og_url: "https://www.art-invest.de/en/projekt/101-on-cleveland/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-07-19T07:11:01+00:00",
        og_image: [
          {
            width: 2560,
            height: 1953,
            url: "https://www.art-invest.de/wp-content/uploads/2019/10/3696_1200_181207_xfer-Kopie-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/101-on-cleveland/",
              url: "https://www.art-invest.de/en/projekt/101-on-cleveland/",
              name: "Art-Invest Real Estate | 101 on Cleveland",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2019-10-15T15:23:52+00:00",
              dateModified: "2023-07-19T07:11:01+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/101-on-cleveland/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/101-on-cleveland/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/101-on-cleveland/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "101 on Cleveland",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2019/10/3696_1200_181207_xfer-Kopie-1-scaled.jpg",
      place: "London",
      subtitle: "Gehobenes Wohnen in Fitzrovia ",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16210",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16212",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16211",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16212",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16210",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16210",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16205,
      date: "2018-03-06T18:01:48",
      date_gmt: "2018-03-06T17:01:48",
      guid: {
        rendered: "https://www.art-invest.de/projekt/ol54/",
      },
      modified: "2021-11-04T17:49:57",
      modified_gmt: "2021-11-04T16:49:57",
      slug: "morrow",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/morrow/",
      title: {
        rendered: "Morrow",
      },
      featured_media: 18930,
      template: "",
      projekt_filter: [246, 426, 425, 255],
      acf: {
        highlight_image: 18926,
        highlight_title_project: "Morrow",
        highlight_subtitle_project: "Büroräume mit bester Aussicht",
        highlight_description_project:
          "The Morrow is an impressive property in the middle of Frankfurt in a quiet Westend location near the Alte Oper. Six impressive terraces characterise the office building and provide an unobstructed view of the spectacular Frankfurt skyline.",
        highlight_logo_project: 16223,
        website_projects: {
          title: "www.morrow-frankfurt.de/en/",
          url: "https://morrow-frankfurt.de/en/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://morrow-frankfurt.de/en/",
          target: "_blank",
        },
        available_space: {
          title: "zum Flächenangebot",
          url: "https://www.aire-mag.com/de/flaechen/morrow",
          target: "_blank",
        },
        project: "Refurbishment",
        location: "Oberlindau 54-56, 60323 Frankfurt (Germany)",
        property: "1,524 m²",
        area: "10,500 m²",
        zertifizierung: "",
        parcels: "43",
        use_for: "Office",
        acquired: "Q4 2017",
        realization: "Q4 2020",
        sale: "",
        architecture_firm: "",
        place: "Frankfurt",
        fakten: [
          {
            bezeichnung: "Draft/Plan",
            wert: "msm meyer schmitz-morkramer Main GmbH",
            anchor: "",
          },
        ],
        specifications_image_projects: 18930,
        slider: [18944, 18930, 18934, 18932, 18942, 18940, 18938, 18936],
        title_details_projects: "MORROW IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Tradition meets modernity ",
            description_repeater_details:
              "After extensive renovation in the mid-1990s and further refurbishment in 2012, the property, which dates back to 1976, now offers over 10,000 m² of attractive office space - including flexible room layouts and high-quality standards.",
            image_repeater_details: 18932,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Working with a view ",
            description_repeater_details:
              "With just under 10,000 m² of office space, the property is one of the most popular properties in Westend. A strategically favorable traffic junction and the unique view from the six terraces complete the offer.",
            image_repeater_details: 18936,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Unique location ",
            description_repeater_details:
              "The immediate vicinity of the Rothschild Park and the Alte Oper allows for both tranquillity and pulsating life. This is because the inner-city green space as well as numerous gastronomy and shopping facilities characterise the location. Law firms and financial service providers are located in the direct vicinity.",
            image_repeater_details: 18934,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Oberlindau 54-56, Frankfurt, Deutschland",
          lat: 50.1197091,
          lng: 8.669131300000004,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Morrow</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/morrow/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Morrow" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/morrow/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T16:49:57+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2018/03/morrow_DIV5304_pano.jpg" />\n\t<meta property="og:image:width" content="2480" />\n\t<meta property="og:image:height" content="1601" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/morrow/","url":"https://www.art-invest.de/en/projekt/morrow/","name":"Art-Invest Real Estate | Morrow","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2018-03-06T17:01:48+00:00","dateModified":"2021-11-04T16:49:57+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/morrow/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/morrow/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/morrow/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Morrow"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Morrow",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/morrow/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Morrow",
        og_url: "https://www.art-invest.de/en/projekt/morrow/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T16:49:57+00:00",
        og_image: [
          {
            width: 2480,
            height: 1601,
            url: "https://www.art-invest.de/wp-content/uploads/2018/03/morrow_DIV5304_pano.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/morrow/",
              url: "https://www.art-invest.de/en/projekt/morrow/",
              name: "Art-Invest Real Estate | Morrow",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2018-03-06T17:01:48+00:00",
              dateModified: "2021-11-04T16:49:57+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/morrow/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/morrow/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/morrow/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Morrow",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2018/03/morrow_DIV5304_pano-800x800.jpg",
      place: "Frankfurt",
      subtitle: "Büroräume mit bester Aussicht",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16205",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18936",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18938",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18940",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18942",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18932",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18934",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18930",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18944",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18930",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16205",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16205",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21858,
      date: "2022-11-08T15:38:46",
      date_gmt: "2022-11-08T14:38:46",
      guid: {
        rendered: "https://www.art-invest.de/projekt/mauritius-hoefe/",
      },
      modified: "2022-11-15T11:18:00",
      modified_gmt: "2022-11-15T10:18:00",
      slug: "mauritius-hoefe",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/mauritius-hoefe/",
      title: {
        rendered: "Mauritius Höfe",
      },
      featured_media: 21791,
      template: "",
      projekt_filter: [246, 251, 427, 425, 245, 263],
      acf: {
        highlight_image: 21787,
        highlight_title_project: "Mauritius Höfe",
        highlight_subtitle_project: "Attraktiver Nutzungsmix",
        highlight_description_project:
          "In the middle of Wiesbaden's city center, Art-Invest Real Estate is developing a highly attractive quarter that will breathe new life into the city and offer tenants, users and visitors a special quality of stay. As a place of encounter, the approximately 7,055 sqm area has the potential to become the new hub of Wiesbaden and is thus also of central importance from an urban planning perspective. On a total of 23,800 sqm of gross floor area, the successor to the former City Passage presents itself with a modern mix of uses that naturally combines working, living, leisure and shopping.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Development",
        location: "Wiesbaden-Mitte, 65183 Wiesbaden, Germany",
        property: "7,055 sqm",
        area: "23,800 sqm",
        zertifizierung: "",
        parcels: "80",
        use_for: "Office, retail, hotel, fitness, restaurant, residential",
        acquired: "2022",
        realization: "Expected 2026",
        sale: "",
        architecture_firm: "",
        place: "",
        fakten: null,
        specifications_image_projects: 21789,
        slider: [21791, 21789],
        title_details_projects: "Mauritius Höfe in Detail",
        details_repeater_projects: [
          {
            title_repeater_details: "Green oasis with historical roots",
            description_repeater_details:
              "Based on the historical gardens behind the city walls, a green oasis is being created in the Mauritius Höfe, with conically tapering alleys creating exciting spaces in the form of urban widenings and narrowings. The houses stagger towards the square and are equipped with many green terraces oriented towards the center of the area. The attractive first floor zone is reserved for shopping and gastronomy; the higher floors are for living, lodging and working.\r\n\r\nA modern, partly green facade design as well as planted roof areas characterize the image of a modern, urban quarter that builds on sustainability and feel-good character.",
            image_repeater_details: 21791,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Open area in the heart of Wiesbaden",
            description_repeater_details:
              "In a central location in Wiesbaden, the Mauritius Höfe are particularly impressive due to the continuous path connection between Schwalbacher Straße, Kirchgasse and Kleiner Schwalbacher Straße as well as the connection to Faulbrunnenstraße. The closed concept of the previous City Passage is thus dissolved and an area open to all sides is created. The Kurhaus and Kurpark, the banking district, the Hessian Parliament and the State Theater are all within walking distance - an optimal public transport connection ensures very good accessibility. Numerous restaurants in the immediate vicinity round off the excellent location.",
            image_repeater_details: 21789,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Wiesbaden-Mitte, 65183 Wiesbaden, Deutschland",
          lat: 50.0823281,
          lng: 8.2418705,
          zoom: 14,
          place_id: "ChIJybp3R9m9vUcRvuqCf3M3wok",
          name: "Mitte",
          city: "Wiesbaden",
          city_short: "WI",
          state: "Hessen",
          state_short: "HE",
          post_code: 65183,
          country: "Deutschland",
          country_short: "DE",
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Mauritius Höfe</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/mauritius-hoefe/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Mauritius Höfe" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/mauritius-hoefe/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-11-15T10:18:00+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2022/11/33845_Platz.jpg" />\n\t<meta property="og:image:width" content="2125" />\n\t<meta property="og:image:height" content="1418" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/mauritius-hoefe/","url":"https://www.art-invest.de/en/projekt/mauritius-hoefe/","name":"Art-Invest Real Estate | Mauritius Höfe","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2022-11-08T14:38:46+00:00","dateModified":"2022-11-15T10:18:00+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/mauritius-hoefe/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/mauritius-hoefe/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/mauritius-hoefe/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Mauritius Höfe"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Mauritius Höfe",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/mauritius-hoefe/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Mauritius Höfe",
        og_url: "https://www.art-invest.de/en/projekt/mauritius-hoefe/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-11-15T10:18:00+00:00",
        og_image: [
          {
            width: 2125,
            height: 1418,
            url: "https://www.art-invest.de/wp-content/uploads/2022/11/33845_Platz.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/mauritius-hoefe/",
              url: "https://www.art-invest.de/en/projekt/mauritius-hoefe/",
              name: "Art-Invest Real Estate | Mauritius Höfe",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2022-11-08T14:38:46+00:00",
              dateModified: "2022-11-15T10:18:00+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/mauritius-hoefe/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/mauritius-hoefe/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/mauritius-hoefe/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Mauritius Höfe",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2022/11/33845_Platz-800x800.jpg",
      place: "Wiesbaden",
      subtitle: "Attraktiver Nutzungsmix",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21858",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21789",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21791",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21791",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21858",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21858",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },

    {
      id: 16666,
      date: "2015-05-19T12:00:56",
      date_gmt: "2015-05-19T10:00:56",
      guid: {
        rendered: "https://www.art-invest.de/projekt/neuer-kanzlerplatz/",
      },
      modified: "2021-11-04T17:50:39",
      modified_gmt: "2021-11-04T16:50:39",
      slug: "neuer-kanzlerplatz",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/neuer-kanzlerplatz/",
      title: {
        rendered: "Neuer Kanzlerplatz",
      },
      featured_media: 14742,
      template: "",
      projekt_filter: [246, 427, 425, 263],
      acf: {
        highlight_image: 14040,
        highlight_title_project: "Neuer Kanzlerplatz",
        highlight_subtitle_project: "Ein Meilenstein für Bonn",
        highlight_description_project:
          "At the Bundeskanzlerplatz in Bonn, a new quarter ties in with the history of the Bonn Republic – and at the same time it builds a bridge for the future of the former government quarter. An ensemble of three polygonal buildings defines the floor plans for state-of-the-art working environments –  and establishes a new landmark for Bonn with the striking tower at the top of the Federal Quarter.",
        highlight_logo_project: 16670,
        website_projects: {
          title: "www.neuer-kanzlerplatz.de",
          url: "https://neuer-kanzlerplatz.de/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://neuer-kanzlerplatz.de/",
          target: "_blank",
        },
        available_space: [""],
        project: "Development",
        location: "Bundeskanzlerplatz, 53113 Bonn; city centre (Bonn-Gronau)",
        property: "approx. 15,300 m²",
        area: "approx. 66,000 m² BGF",
        zertifizierung: "",
        parcels: "approx. 1,000 car parking slots / 350 racks",
        use_for: "Office",
        acquired: "August 2014",
        realization: "in 2021",
        sale: "open",
        architecture_firm: "JSWD",
        place: "Bonn",
        fakten: null,
        specifications_image_projects: 16668,
        slider: null,
        title_details_projects: "NEUER KANZLERPLATZ IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Ein Meilenstein für Bonn",
            description_repeater_details:
              "Across the Chancellery, Neuer Kanzlerplatz is a top address for state-of-the-art working environments. The solitaire of up to 100 metres in height completes the crown of high-rise buildings in Bonn that characterises the city silhouette. From here, the view wanders not only back into history but also into the future: the building is an important contribution to the quality improvement of the southern part of the city.",
            image_repeater_details: 16668,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "A campus for visions",
            description_repeater_details:
              "The architecture of the quarter combines spaces of tranquillity, concentration and contemplation with the demands of a productive and communicative working environment. The interaction between the lounges on the ground floor levels and the gastronomy on the exterior and interior surfaces creates a new forum on Bundeskanzlerplatz.",
            image_repeater_details: 14040,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Bundeskanzlerplatz, Bonn, Deutschland",
          lat: 50.71926259999999,
          lng: 7.117011000000048,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Neuer Kanzlerplatz</title>\n<meta name="description" content="Gegenüber vom Kanzleramt ist das neue Bonn-Center nicht nur eine Top-Adresse für modernste Arbeitswelten sondern auch eine neue Zentrale für die Postbank." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/neuer-kanzlerplatz/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Neuer Kanzlerplatz" />\n<meta property="og:description" content="Gegenüber vom Kanzleramt ist das neue Bonn-Center nicht nur eine Top-Adresse für modernste Arbeitswelten sondern auch eine neue Zentrale für die Postbank." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/neuer-kanzlerplatz/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T16:50:39+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2018/01/Abendansicht_Neuer_Kanzlerplatz_Quelle_Art-Invest-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="2474" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/neuer-kanzlerplatz/","url":"https://www.art-invest.de/en/projekt/neuer-kanzlerplatz/","name":"Art-Invest Real Estate | Neuer Kanzlerplatz","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2015-05-19T10:00:56+00:00","dateModified":"2021-11-04T16:50:39+00:00","description":"Gegenüber vom Kanzleramt ist das neue Bonn-Center nicht nur eine Top-Adresse für modernste Arbeitswelten sondern auch eine neue Zentrale für die Postbank.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/neuer-kanzlerplatz/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/neuer-kanzlerplatz/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/neuer-kanzlerplatz/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Neuer Kanzlerplatz"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Neuer Kanzlerplatz",
        description:
          "Gegenüber vom Kanzleramt ist das neue Bonn-Center nicht nur eine Top-Adresse für modernste Arbeitswelten sondern auch eine neue Zentrale für die Postbank.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/neuer-kanzlerplatz/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Neuer Kanzlerplatz",
        og_description:
          "Gegenüber vom Kanzleramt ist das neue Bonn-Center nicht nur eine Top-Adresse für modernste Arbeitswelten sondern auch eine neue Zentrale für die Postbank.",
        og_url: "https://www.art-invest.de/en/projekt/neuer-kanzlerplatz/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T16:50:39+00:00",
        og_image: [
          {
            width: 2560,
            height: 2474,
            url: "https://www.art-invest.de/wp-content/uploads/2018/01/Abendansicht_Neuer_Kanzlerplatz_Quelle_Art-Invest-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/neuer-kanzlerplatz/",
              url: "https://www.art-invest.de/en/projekt/neuer-kanzlerplatz/",
              name: "Art-Invest Real Estate | Neuer Kanzlerplatz",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2015-05-19T10:00:56+00:00",
              dateModified: "2021-11-04T16:50:39+00:00",
              description:
                "Gegenüber vom Kanzleramt ist das neue Bonn-Center nicht nur eine Top-Adresse für modernste Arbeitswelten sondern auch eine neue Zentrale für die Postbank.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/neuer-kanzlerplatz/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/neuer-kanzlerplatz/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/neuer-kanzlerplatz/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Neuer Kanzlerplatz",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2018/01/Abendansicht_Neuer_Kanzlerplatz_Quelle_Art-Invest-1-scaled-800x800.jpg",
      place: "Bonn",
      subtitle: "Ein Meilenstein für Bonn",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16666",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14742",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16666",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16666",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },

    {
      id: 24733,
      date: "2023-06-05T11:53:24",
      date_gmt: "2023-06-05T09:53:24",
      guid: {
        rendered: "https://www.art-invest.de/?post_type=projekt&#038;p=24733",
      },
      modified: "2023-07-04T09:57:04",
      modified_gmt: "2023-07-04T07:57:04",
      slug: "frankfurter-ring-muenchen",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/frankfurter-ring-muenchen/",
      title: {
        rendered: "OTTO",
      },
      featured_media: 25080,
      template: "",
      projekt_filter: [246, 427, 249, 425],
      acf: {
        highlight_image: null,
        highlight_title_project: "Frankfurter Ring, Munich",
        highlight_subtitle_project: "Attraktive Büroflächen in München",
        highlight_description_project:
          "In Schwabing-Freimann - more precisely north of Domagkpark - lies the Frankfurter Ring 209 property, which covers more than 14,750 m2 and was built in 1989. On the site, there are a variety of options for office space on six floors, which impress with a generous, flexible room layout. The diamond-shaped floor plan enriches the complex with a landscaped courtyard, which can be used for short meetings, breaks or even after-work drinks.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment",
        location: "Munich-Nord Frankfurter Ring",
        property: "14.785 m²",
        area: "24.500 m²",
        zertifizierung: "",
        parcels: "298",
        use_for: "Büro",
        acquired: "2022",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "",
        fakten: null,
        specifications_image_projects: 24738,
        slider: null,
        title_details_projects: "Frankfurter Ring in Detail",
        details_repeater_projects: [
          {
            title_repeater_details: "Idyllic location in a lively neighborhood",
            description_repeater_details:
              "Frankfurter Ring 209 is attractively located in the Schwabing-Freimann district - an up-and-coming neighborhood in the north of Munich - within walking distance of Domagkpark and the English Garden. In addition, the Parkstadt Schwabing is located in the immediate vicinity and offers a wide range of gastronomy and shopping facilities, making the area a very popular district that covers living, working and leisure in equal measure. As part of the neighborhood development, a design guideline was developed for Domagkpark, which specifies basic structures such as a color concept and building guidelines, thus ensuring a harmonious appearance for the entire neighborhood.",
            image_repeater_details: 24740,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Good connections to Munich city center",
            description_repeater_details:
              "The site is conveniently located in the north of Munich between the B 13 / Ingolstädter Straße and the A 9 freeway and is therefore very easy to reach by car. But also the connection to the Munich city center and the airport can be reached optimally by public transport. A bus stop is located directly in front of the building complex. The Schwabing Nord streetcar stop is also no more than 15 minutes away on foot and guarantees a fast public transport connection to Münchener Freiheit. By 2026, the property will also be connected to the S-Bahnnordring via a stop within walking distance, which will significantly enhance the micro-location.",
            image_repeater_details: 24742,
            video: "",
            "anchor-link": "",
          },
        ],
        map: null,
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | OTTO, Munich</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/frankfurter-ring-muenchen/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | OTTO, Munich" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/frankfurter-ring-muenchen/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-07-04T07:57:04+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2022/11/1TITELBILD-rainer-taepper-architekturfotografie-007.jpg" />\n\t<meta property="og:image:width" content="1731" />\n\t<meta property="og:image:height" content="1154" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/frankfurter-ring-muenchen/","url":"https://www.art-invest.de/en/projekt/frankfurter-ring-muenchen/","name":"Art-Invest Real Estate | OTTO, Munich","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2023-06-05T09:53:24+00:00","dateModified":"2023-07-04T07:57:04+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/frankfurter-ring-muenchen/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/frankfurter-ring-muenchen/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/frankfurter-ring-muenchen/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"OTTO, Munich"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | OTTO",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/frankfurter-ring-muenchen/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | OTTO",
        og_url:
          "https://www.art-invest.de/en/projekt/frankfurter-ring-muenchen/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-07-04T07:57:04+00:00",
        og_image: [
          {
            width: 1731,
            height: 1154,
            url: "https://www.art-invest.de/wp-content/uploads/2022/11/1TITELBILD-rainer-taepper-architekturfotografie-007.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/frankfurter-ring-muenchen/",
              url: "https://www.art-invest.de/en/projekt/frankfurter-ring-muenchen/",
              name: "Art-Invest Real Estate | OTTO",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2023-06-05T09:53:24+00:00",
              dateModified: "2023-07-04T07:57:04+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/frankfurter-ring-muenchen/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/frankfurter-ring-muenchen/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/frankfurter-ring-muenchen/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "OTTO, Munich",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2022/11/1TITELBILD-rainer-taepper-architekturfotografie-007-800x800.jpg",
      place: "München",
      subtitle: "Attraktive Büroflächen in München",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/24733",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25080",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=24733",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=24733",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 24829,
      date: "2023-06-06T08:38:01",
      date_gmt: "2023-06-06T06:38:01",
      guid: {
        rendered: "https://www.art-invest.de/?post_type=projekt&#038;p=24829",
      },
      modified: "2023-06-06T08:49:50",
      modified_gmt: "2023-06-06T06:49:50",
      slug: "premier-inn-braunschweig-city-centre",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/premier-inn-braunschweig-city-centre/",
      title: {
        rendered: "Premier Inn Braunschweig",
      },
      featured_media: 23761,
      template: "",
      projekt_filter: [250, 251, 427, 425, 263],
      acf: {
        highlight_image: null,
        highlight_title_project: "Premier Inn Braunschweig",
        highlight_subtitle_project: "Modernes Hotel an bester Adresse",
        highlight_description_project:
          "Centrally located in Braunschweig's city center, the Premier Inn Hotel was built in 1982 as part of the Welfenhof ensemble. Extensive renovation work took place in 2015/2016 and an additional 29 rooms were added to the hotel in 2021/2022. In total, the hotel has an area of 9,222 m², with an additional 805 m² distributed over six retail units. The building was built by Brunswick architects Henschker, Schmidtke and Wendt and, with a total of 203 rooms, is one of the largest hotels in the city. Art-Invest Real Estate acquired the building complex from DIO Deutsche Immobilien Opportunitäten AG at the beginning of 2023.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Core-Investment",
        location: "Jöddenstraße 3, 38100 Braunschweig",
        property: "3.877 m²",
        area: "805  m²",
        zertifizierung: "",
        parcels: "500",
        use_for: "Mixed-Use aus Hotel und Retail",
        acquired: "01.01.2023",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "",
        fakten: null,
        specifications_image_projects: null,
        slider: null,
        title_details_projects: "",
        details_repeater_projects: [
          {
            title_repeater_details: "Upgrading of a renowned complex",
            description_repeater_details:
              "Since 2021, the multi-tenant property, which also houses other stores in addition to the Premier Inn, has brought bustle back to the central location of the university city, where space had been vacant time and again until then. Art-Invest Real Estate has recognized the importance and potential of the entire complex and wants to further strengthen both through the attractive accommodation and gastronomy offer. The mixed use will bring life back to the historic Welfenhof, which now once again invites visitors to shop and stay overnight. In addition to the Premier Inn, visitors will also find a bakery, an optician, a hearing aid specialist, a hairdresser and a delicatessen. Within walking distance from the hotel, in addition to the shopping street, there are numerous historical sights such as Dankwarderode Castle, Braunschweig Cathedral and the Schloss-Arkaden, which are attractive destinations for tourists.",
            image_repeater_details: 24846,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Central location for any occasion",
            description_repeater_details:
              "With the acquisition of the hotel of the British chain Premier Inn, Art-Invest Real Estate would like to contribute to making the entire Welfenhof more attractive again. Due to the central city location and the 500 parking spaces, which are divided between an underground garage and municipal use and are also shared with the neighboring property, the location is ideal for both commuters and visitors and offers great potential. In addition, the airport Hannover-Langenhagen is only 60 km away and a journey by public transport is also easy to realize: The main train station is only 2 km away and from there you can take the streetcar lines 1, 2 or 4 in a few minutes to the stop Rathaus or Hagenmarkt, which are located within 100 m of the hotel.",
            image_repeater_details: 24848,
            video: "",
            "anchor-link": "",
          },
        ],
        map: null,
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Premier Inn Braunschweig City Centre</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/premier-inn-braunschweig-city-centre/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Premier Inn Braunschweig City Centre" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/premier-inn-braunschweig-city-centre/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-06-06T06:49:50+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2023/04/DSCF3357.jpg" />\n\t<meta property="og:image:width" content="1500" />\n\t<meta property="og:image:height" content="1125" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/premier-inn-braunschweig-city-centre/","url":"https://www.art-invest.de/en/projekt/premier-inn-braunschweig-city-centre/","name":"Art-Invest Real Estate | Premier Inn Braunschweig City Centre","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2023-06-06T06:38:01+00:00","dateModified":"2023-06-06T06:49:50+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/premier-inn-braunschweig-city-centre/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/premier-inn-braunschweig-city-centre/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/premier-inn-braunschweig-city-centre/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Premier Inn Braunschweig City Centre"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Premier Inn Braunschweig City Centre",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/premier-inn-braunschweig-city-centre/",
        og_locale: "en_US",
        og_type: "article",
        og_title:
          "Art-Invest Real Estate | Premier Inn Braunschweig City Centre",
        og_url:
          "https://www.art-invest.de/en/projekt/premier-inn-braunschweig-city-centre/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-06-06T06:49:50+00:00",
        og_image: [
          {
            width: 1500,
            height: 1125,
            url: "https://www.art-invest.de/wp-content/uploads/2023/04/DSCF3357.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/premier-inn-braunschweig-city-centre/",
              url: "https://www.art-invest.de/en/projekt/premier-inn-braunschweig-city-centre/",
              name: "Art-Invest Real Estate | Premier Inn Braunschweig City Centre",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2023-06-06T06:38:01+00:00",
              dateModified: "2023-06-06T06:49:50+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/premier-inn-braunschweig-city-centre/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/premier-inn-braunschweig-city-centre/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/premier-inn-braunschweig-city-centre/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Premier Inn Braunschweig City Centre",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2023/04/DSCF3357-800x800.jpg",
      place: "Braunschweig",
      subtitle: "Modernes Hotel an bester Adresse",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/24829",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/23761",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=24829",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=24829",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },

    {
      id: 16792,
      date: "2020-07-06T11:28:23",
      date_gmt: "2020-07-06T11:28:23",
      guid: {
        rendered: "https://www.art-invest.de/projekt/urban-village-dresden/",
      },
      modified: "2023-07-13T09:32:11",
      modified_gmt: "2023-07-13T07:32:11",
      slug: "querbeet-dresden",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/querbeet-dresden/",
      title: {
        rendered: "Quartier-Neustadt",
      },
      featured_media: 16744,
      template: "",
      projekt_filter: [427, 252, 425, 263],
      acf: {
        highlight_image: 16746,
        highlight_title_project: "Querbeet",
        highlight_subtitle_project: "Leben und Erholung auf dem Land",
        highlight_description_project:
          "With the Querbeet in Dresden, Art-Invest Real Estate acquires its first project in an excellent location in the Saxon capital. A modern residential project for couples and young families will be created in the surroundings of the trendy district <em>Äußere Neustadt</em>. In addition to the future-oriented construction method, the ensemble guarantees excellent living. One to four room apartments with excellent furnishings and a high feel-good factor await future tenants.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment",
        location: "Königsbrücker Straße 95-97, 01099 Dresden ",
        property: "approx. 7,665 m²",
        area: "8,400 m²",
        zertifizierung: "",
        parcels: "124 underground parking spaces, 6 outdoor parking slots",
        use_for: "Living",
        acquired: "Q4 2019",
        realization: "Q3 2023",
        sale: "",
        architecture_firm: "Peter Bauckhage",
        place: "Dresden",
        fakten: null,
        specifications_image_projects: 16740,
        slider: null,
        title_details_projects: "Querbeet in Detail",
        details_repeater_projects: [
          {
            title_repeater_details:
              "Environmentally friendly living with a view to the future",
            description_repeater_details:
              "The Querbeet captivates with a harmonious interaction of two block buildings, four city villas and exciting courtyards. By the end of 2022, 123 high-quality residential units will be built with a focus on sustainability: the entire complex will be constructed in accordance with the specifications of the KfW 55 energy efficiency standard, which means that the tenants will live efficiently and conserve resources. The three to four storey buildings will be complemented by quiet green inner courtyards as well as outdoor and underground parking spaces.",
            image_repeater_details: 16736,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Dynamic location through excellent connections",
            description_repeater_details:
              "The Querbeet benefits from its proximity to Dresden's young and trendy district <em>Äußere Neustadt</em> and its good connections to the old town, which is well worth seeing. At the same time, tenants can easily reach the wooded area of the Dresdner Heide. With schools, kindergartens, pharmacies, medical practices, local suppliers, restaurants and relaxing areas, the Querbeet offers an excellent infrastructure in the immediate vicinity.",
            image_repeater_details: 16742,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address:
            "Königsbrücker Straße 95-97, Neustadt 01099 Dresden, Deutschland",
          lat: 51.0755797,
          lng: 13.7545157,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Quartier-Neustadt</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/querbeet-dresden/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Quartier-Neustadt" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/querbeet-dresden/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-07-13T07:32:11+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/07/Dresden_Strassenansicht_20200421__urban_village_4.jpg" />\n\t<meta property="og:image:width" content="1500" />\n\t<meta property="og:image:height" content="844" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/querbeet-dresden/","url":"https://www.art-invest.de/en/projekt/querbeet-dresden/","name":"Art-Invest Real Estate | Quartier-Neustadt","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-07-06T11:28:23+00:00","dateModified":"2023-07-13T07:32:11+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/querbeet-dresden/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/querbeet-dresden/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/querbeet-dresden/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Quartier-Neustadt"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Quartier-Neustadt",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/querbeet-dresden/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Quartier-Neustadt",
        og_url: "https://www.art-invest.de/en/projekt/querbeet-dresden/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-07-13T07:32:11+00:00",
        og_image: [
          {
            width: 1500,
            height: 844,
            url: "https://www.art-invest.de/wp-content/uploads/2020/07/Dresden_Strassenansicht_20200421__urban_village_4.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/querbeet-dresden/",
              url: "https://www.art-invest.de/en/projekt/querbeet-dresden/",
              name: "Art-Invest Real Estate | Quartier-Neustadt",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-07-06T11:28:23+00:00",
              dateModified: "2023-07-13T07:32:11+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/querbeet-dresden/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/querbeet-dresden/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/querbeet-dresden/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Quartier-Neustadt",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/07/Dresden_Strassenansicht_20200421__urban_village_4-800x800.jpg",
      place: "Dresden",
      subtitle: "Leben und Erholung auf dem Land",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16792",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16744",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16792",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16792",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },

    {
      id: 16682,
      date: "2019-02-20T14:28:19",
      date_gmt: "2019-02-20T13:28:19",
      guid: {
        rendered: "https://www.art-invest.de/projekt/25hours/",
      },
      modified: "2022-10-10T14:30:22",
      modified_gmt: "2022-10-10T12:30:22",
      slug: "25hours",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/25hours/",
      title: {
        rendered: "25hours",
      },
      featured_media: 16684,
      template: "",
      projekt_filter: [426, 251, 425, 263],
      acf: {
        highlight_image: 16687,
        highlight_title_project: "25hours",
        highlight_subtitle_project: "Modernes Hotel in historischem Gebäude",
        highlight_description_project:
          "In the middle of the historic old town of Florence, a prestigious and modern 25hours hotel is being built in a former bank building.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Development",
        location: "Piazza di San Paolino 2 R, 50123 Florence",
        property: "4,400 m²",
        area: "approx. 13,400 m²",
        zertifizierung: "",
        parcels: "",
        use_for: "Hotel",
        acquired: "Q2 2017",
        realization: "Q2 2021",
        sale: "",
        architecture_firm: "Loci Architettura / Interior Design: Paola Navone",
        place: "Florenz",
        fakten: null,
        specifications_image_projects: 16685,
        slider: null,
        title_details_projects: "25HOURS IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              "Avantgarde design behind a historic facade",
            description_repeater_details:
              "With the new 25hours hotel in the centre of Florence, Tuscany gains an attractive location. The unique complex of buildings, which was built between 1850 and 1930, is currently being renovated. It is in Piazza San Paolino near the main railway station. The 25hours Hotel comprises 172 rooms on 13.400 sqm and generous green spaces.",
            image_repeater_details: 16685,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Spectacular contrast between Dante's Inferno and Paradiso",
            description_repeater_details:
              'The internationally renowned Florentine architects Genius Loci Architettura are responsible for the renovation of the building. Interior designer Paola Navone is in charge of the furnishing. In her special way of combining the traditional with the contemporary, she spans the elaborate design arc between the thematic contrasts Inferno and Paradiso of Dante\'s "Divine Comedy". The result is an impressively stylish interior design that has an impact even in the gastronomic establishments.',
            image_repeater_details: 16683,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Upgrading the district",
            description_repeater_details:
              "The whole of Florence will benefit from the renovation of the old bank building and the development of the 25hours hotel: an Italian restaurant, a modern café and an exquisite bar will be created in the covered patio of the building, which will further enhance the lively quarter.",
            image_repeater_details: 14043,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Making-of-Film | 25hours Piazza San Paolino",
            description_repeater_details: "",
            image_repeater_details: 19287,
            video: "https://player.vimeo.com/video/758656016",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Piazza di S. Paolino, 2R, 50123 Firenze FI, Italien",
          lat: 43.772962872051586,
          lng: 11.24783678528479,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | 25hours</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/25hours/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | 25hours" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/25hours/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-10T12:30:22+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2019/02/Render-FACADE-2-Kopie-1-1.jpg" />\n\t<meta property="og:image:width" content="1240" />\n\t<meta property="og:image:height" content="1860" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/25hours/","url":"https://www.art-invest.de/en/projekt/25hours/","name":"Art-Invest Real Estate | 25hours","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2019-02-20T13:28:19+00:00","dateModified":"2022-10-10T12:30:22+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/25hours/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/25hours/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/25hours/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"25hours"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | 25hours",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/25hours/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | 25hours",
        og_url: "https://www.art-invest.de/en/projekt/25hours/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-10T12:30:22+00:00",
        og_image: [
          {
            width: 1240,
            height: 1860,
            url: "https://www.art-invest.de/wp-content/uploads/2019/02/Render-FACADE-2-Kopie-1-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/25hours/",
              url: "https://www.art-invest.de/en/projekt/25hours/",
              name: "Art-Invest Real Estate | 25hours",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2019-02-20T13:28:19+00:00",
              dateModified: "2022-10-10T12:30:22+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/25hours/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/25hours/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/25hours/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "25hours",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2019/02/Render-FACADE-2-Kopie-1-1-800x800.jpg",
      place: "Florenz",
      subtitle: "Historie trifft modernen Hotelkomfort",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16682",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16684",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16682",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16682",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 17617,
      date: "2020-09-03T13:03:14",
      date_gmt: "2020-09-03T11:03:14",
      guid: {
        rendered: "https://www.art-invest.de/projekt/eschborn-gate/",
      },
      modified: "2021-11-12T16:04:41",
      modified_gmt: "2021-11-12T15:04:41",
      slug: "eschborn-gate",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/eschborn-gate/",
      title: {
        rendered: "Eschborn Gate",
      },
      featured_media: 19560,
      template: "",
      projekt_filter: [246, 427, 425, 245, 255],
      acf: {
        highlight_image: 19572,
        highlight_title_project: "Eschborn Gate",
        highlight_subtitle_project: "Wahrzeichen zwischen Metropole und Taunus",
        highlight_description_project:
          "Eschborn Gate is the new gateway to the sought-after business location Eschborn-South. Thanks to the new campus construction by the joint venture of Art-Invest Real Estate and OFB Projektentwicklung, the area will be characterized by its clear structure. Between office buildings arranged in groups, both public and semi-public spaces will be created with catering facilities and conference areas for healthy working. In renowned neighborhood of international companies, Eschborn Gate functions as a landmark and business hub in the Rhine-Main area.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Development",
        location: "Frankfurter Straße 2-8, 65760 Eschborn",
        property: "31,000 m²",
        area: "50,000  m²",
        zertifizierung: "",
        parcels: "1,200",
        use_for: "Office / Catering",
        acquired: "Q2 2018",
        realization: "",
        sale: "",
        architecture_firm: "SOP",
        place: "Eschborn-South",
        fakten: null,
        specifications_image_projects: 19568,
        slider: [19570, 19568, 19566, 19564, 19562, 19560, 19558],
        title_details_projects: "ESCHBORN GATE IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Modern office location with a view",
            description_repeater_details:
              "On 50,000 m² of floor space, tenants find the best conditions for a demanding working environment. The light-colored facade and generous window areas create light-flooded rooms ­­ – including a view of the Frankfurt skyline. Adaptable floor plans and innovative technical equipment create a flexible working environment. On the outdoor facilities, green spaces with water features form a harmonious ensemble that offers visitors, customers and employees an excellent quality of stay.",
            image_repeater_details: 19566,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Global players as neighbors",
            description_repeater_details:
              "Users of Eschborn Gate not only have access to the high recreational value of the Taunus region, but also to the top-class business environment right on their doorstep. The attractive location factors are completed by the good connection of the Eschborn gate. Users and guests can reach the international airport in Frankfurt am Main in just under 15 minutes. In addition, with 1,200 parking spaces, sufficient parking facilities are available so that the hub can be easily reached from the freeways 5 and 66 in the immediate vicinity.",
            image_repeater_details: 17159,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Frankfurter Straße 2-8, 65760 Eschborn, Deutschland",
          lat: 50.1313886,
          lng: 8.565529100000001,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Eschborn Gate</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/eschborn-gate/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Eschborn Gate" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/eschborn-gate/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-12T15:04:41+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/09/03-Courtyard-006.jpg" />\n\t<meta property="og:image:width" content="2500" />\n\t<meta property="og:image:height" content="1500" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/eschborn-gate/","url":"https://www.art-invest.de/en/projekt/eschborn-gate/","name":"Art-Invest Real Estate | Eschborn Gate","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-09-03T11:03:14+00:00","dateModified":"2021-11-12T15:04:41+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/eschborn-gate/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/eschborn-gate/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/eschborn-gate/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Eschborn Gate"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Eschborn Gate",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/eschborn-gate/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Eschborn Gate",
        og_url: "https://www.art-invest.de/en/projekt/eschborn-gate/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-12T15:04:41+00:00",
        og_image: [
          {
            width: 2500,
            height: 1500,
            url: "https://www.art-invest.de/wp-content/uploads/2020/09/03-Courtyard-006.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/eschborn-gate/",
              url: "https://www.art-invest.de/en/projekt/eschborn-gate/",
              name: "Art-Invest Real Estate | Eschborn Gate",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-09-03T11:03:14+00:00",
              dateModified: "2021-11-12T15:04:41+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/eschborn-gate/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/eschborn-gate/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/eschborn-gate/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Eschborn Gate",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/09/03-Courtyard-006-800x800.jpg",
      place: "Eschborn-South",
      subtitle: "Wo Metropole auf Taunus trifft",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/17617",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19558",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19560",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19562",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19564",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19566",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19568",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19570",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19560",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=17617",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=17617",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16712,
      date: "2020-06-30T15:47:58",
      date_gmt: "2020-06-30T15:47:58",
      guid: {
        rendered: "https://www.art-invest.de/projekt/hanau-business-triangle/",
      },
      modified: "2021-11-04T17:51:10",
      modified_gmt: "2021-11-04T16:51:10",
      slug: "hanow",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/hanow/",
      title: {
        rendered: "HaNow Business Triangle",
      },
      featured_media: 16660,
      template: "",
      projekt_filter: [246, 250, 254, 427, 425, 255],
      acf: {
        highlight_image: 16664,
        highlight_title_project: "HaNow Business Triangle",
        highlight_subtitle_project: "Gebäudekomplex mit Industriegeschichte",
        highlight_description_project:
          "The HaNow Business Triangle is located on the site of a former Degussa production factory and continues its unmistakable charm. Due to the attraction of the industrial flair, the property produces a heterogeneous tenant structure. The ensemble, consisting of six properties and the well-known Weißen Haus on Kurt-Blaum Platz, offers spacious offices with a loft character.",
        highlight_logo_project: null,
        website_projects: {
          title: "www.hanow-triangle.de",
          url: "https://www.hanow-triangle.de/",
          target: "",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://www.hanow-triangle.de/",
          target: "_blank",
        },
        available_space: {
          title: "zum Flächenangebot",
          url: "https://www.aire-mag.com/de/flaechen/hanau-business-triangle",
          target: "_blank",
        },
        project: "Investment & Project Development",
        location: "Leipziger-Straße 2-10 / Willy-Brandt-Straße 23, 63450 Hanau",
        property: "19,650 m²",
        area: "approx. 35,700 m²",
        zertifizierung: "",
        parcels: "1.286",
        use_for: "Office & Industry",
        acquired: "Q1 2020",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Hanau",
        fakten: [
          {
            bezeichnung: "Tenant",
            wert: "Heraeus, Mitusi Kulzer, Vacuumschmelze, Europcell, Klinikum Hanau",
            anchor: "",
          },
        ],
        specifications_image_projects: 16656,
        slider: null,
        title_details_projects: "HaNow Business Triangle in Detail",
        details_repeater_projects: [
          {
            title_repeater_details:
              "Quarter development for maximum flexibility",
            description_repeater_details:
              "The modernisation of the existing buildings and partial new development will increase the quality of stay and revitalise the neighbourhood. Even today, industrial areas still bear witness to the history of the site. One advantage of the former Degussa campus is that the conversion will provide light-flooded rooms with ceilings up to four meters high for healthy working. Tenants from medium-sized companies as well as from the health and education sectors benefit equally from these conditions. Diverse usabilities for the property provide the joint venture of Art-Invest Real Estate and DIE WOHNKOMPANIE Rhein-Main with maximum flexibility to meet the requirements of a wide range of potential buyers.",
            image_repeater_details: 16660,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Close to the centre and optimally connected",
            description_repeater_details:
              "The HaNow Business Triangle forms the border between the industrial part and the residential and leisure areas of Hanau. In direct proximity to Hanau's city centre, tenants, users and visitors enjoy easy access to gastronomy and shopping facilities. The two multi-storey car parks with more than 1,200 parking spaces, the proximity to the main railway station and the connection to the motorways 66, 45 and 3 complete the attractiveness of the location.",
            image_repeater_details: 16658,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Leipziger Straße 2-10, 63450 Hanau, Deutschland",
          lat: 50.1299094,
          lng: 8.9243188,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | HaNow Business Triangle</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/hanow/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | HaNow Business Triangle" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/hanow/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T16:51:10+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/06/Bild-1_AIRE.jpg" />\n\t<meta property="og:image:width" content="1227" />\n\t<meta property="og:image:height" content="921" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/hanow/","url":"https://www.art-invest.de/en/projekt/hanow/","name":"Art-Invest Real Estate | HaNow Business Triangle","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-06-30T15:47:58+00:00","dateModified":"2021-11-04T16:51:10+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/hanow/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/hanow/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/hanow/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"HaNow Business Triangle"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | HaNow Business Triangle",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/hanow/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | HaNow Business Triangle",
        og_url: "https://www.art-invest.de/en/projekt/hanow/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T16:51:10+00:00",
        og_image: [
          {
            width: 1227,
            height: 921,
            url: "https://www.art-invest.de/wp-content/uploads/2020/06/Bild-1_AIRE.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/hanow/",
              url: "https://www.art-invest.de/en/projekt/hanow/",
              name: "Art-Invest Real Estate | HaNow Business Triangle",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-06-30T15:47:58+00:00",
              dateModified: "2021-11-04T16:51:10+00:00",
              breadcrumb: {
                "@id": "https://www.art-invest.de/en/projekt/hanow/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/hanow/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/hanow/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "HaNow Business Triangle",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/06/Bild-1_AIRE-800x800.jpg",
      place: "Hanau",
      subtitle: "Historischer Industriekomplex",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16712",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16660",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16712",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16712",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16625,
      date: "2020-06-18T11:02:11",
      date_gmt: "2020-06-18T11:02:11",
      guid: {
        rendered: "https://www.art-invest.de/projekt/kaemmerei/",
      },
      modified: "2023-07-10T13:53:02",
      modified_gmt: "2023-07-10T11:53:02",
      slug: "kaemmerei",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/kaemmerei/",
      title: {
        rendered: "Kämmerei",
      },
      featured_media: 18605,
      template: "",
      projekt_filter: [246, 250, 254, 427, 425, 245, 257],
      acf: {
        highlight_image: 18609,
        highlight_title_project: "Kämmerei",
        highlight_subtitle_project: "Historisches Ensemble im Stadtzentrum",
        highlight_description_project:
          "In the middle of Düsseldorf's old town, the Kämmerei and the town hall form a striking urban landmark. The extensive refurbishment of the former administration building is taking place with comprehensive consideration of the requirements of the preservation of historic monuments and buildings and is setting it up for the future in a sustainable manner. Taking into account the typical location factors, Art-Invest Real Estate transforms the charm of the listed building into a multi-utilization concept that will give new life into the building.",
        highlight_logo_project: null,
        website_projects: {
          title: "www.kaemmerei.de",
          url: "https://www.kaemmerei.de/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://www.kaemmerei.de/",
          target: "_blank",
        },
        available_space: [""],
        project: "Development / Refurbishment ",
        location: "Marktplatz 5-6, 40213 Dusseldorf ",
        property: "3,381 m²",
        area: "approx. 13.200 m²",
        zertifizierung: "",
        parcels: "",
        use_for: "Gastronomy, Retail, Event, Office",
        acquired: "Q3 2019",
        realization: "Q1 2025",
        sale: "",
        architecture_firm: "sop Architekten, Düsseldorf",
        place: "Düsseldorf",
        fakten: [
          {
            bezeichnung: "Stockwerke",
            wert: "5",
            anchor: "",
          },
        ],
        specifications_image_projects: 18595,
        slider: [18605, 18607, 18611, 18603, 18601, 18599, 18613, 18597, 18595],
        title_details_projects: "KÄMMEREI IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              "Preservation of history under the most modern standards",
            description_repeater_details:
              "The core of the refurbishment is the development of unique office space according to modern standards within the historic building. Highlights of the project are the complete preservation of the conference hall and the reactivation of the inner courtyard as a generous event space. Art-Invest Real Estate will also achieve the harmonious further development of the lively area by adding a new gastronomy offer and opening the building to the market square.",
            image_repeater_details: 18601,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Unbeatable proximity to famous surroundings",
            description_repeater_details:
              'The Kämmerei is located on Düsseldorf\'s market square and forms a representative solitaire with a prominent and central location in the old town. Thus the property is within walking distance and has excellent public transport connections. Thanks to the direct proximity to the "longest counter in the world", users of the Kämmerei have direct access to a varied range of gastronomic offerings.',
            image_repeater_details: 18611,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address:
            "Marktplatz 5-6, Stadtbezirk 1 40213 Düsseldorf, Deutschland",
          lat: 51.2256345,
          lng: 6.7717871,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Kämmerei</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/kaemmerei/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Kämmerei" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/kaemmerei/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-07-10T11:53:02+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/06/06-Marketplatz-011.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1440" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/kaemmerei/","url":"https://www.art-invest.de/en/projekt/kaemmerei/","name":"Art-Invest Real Estate | Kämmerei","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-06-18T11:02:11+00:00","dateModified":"2023-07-10T11:53:02+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/kaemmerei/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/kaemmerei/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/kaemmerei/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Kämmerei"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Kämmerei",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/kaemmerei/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Kämmerei",
        og_url: "https://www.art-invest.de/en/projekt/kaemmerei/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-07-10T11:53:02+00:00",
        og_image: [
          {
            width: 2560,
            height: 1440,
            url: "https://www.art-invest.de/wp-content/uploads/2020/06/06-Marketplatz-011.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/kaemmerei/",
              url: "https://www.art-invest.de/en/projekt/kaemmerei/",
              name: "Art-Invest Real Estate | Kämmerei",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-06-18T11:02:11+00:00",
              dateModified: "2023-07-10T11:53:02+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/kaemmerei/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/kaemmerei/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/kaemmerei/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Kämmerei",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/06/06-Marketplatz-011-800x800.jpg",
      place: "Düsseldorf",
      subtitle: "Altstadtensemble im Herzen der City",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16625",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18595",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18597",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18613",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18599",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18601",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18603",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18611",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18607",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18605",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18605",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16625",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16625",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },

    {
      id: 21982,
      date: "2023-01-04T12:01:34",
      date_gmt: "2023-01-04T11:01:34",
      guid: {
        rendered:
          "https://www.art-invest.de/projekt/buerocampus-wangen-stuttgart/",
      },
      modified: "2023-07-03T10:27:12",
      modified_gmt: "2023-07-03T08:27:12",
      slug: "buerocampus-wangen-stuttgart",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/buerocampus-wangen-stuttgart/",
      title: {
        rendered: "Bürocampus Wangen",
      },
      featured_media: 21971,
      template: "",
      projekt_filter: [246, 250, 427, 245, 259],
      acf: {
        highlight_image: 21980,
        highlight_title_project: "Bürocampus Wangen",
        highlight_subtitle_project: "Vielfältiger Nutzungsmix",
        highlight_description_project:
          "The Bürocampus Wangen (BCW) is located directly next to the Wangener Höhe recreation area in Stuttgart's east. As a leading high-tech and creative location with an international reputation, the Swabian metropolis is an innovation hotspot with a distinct start-up scene in sectors such as the automotive and technology industries as well as mechanical engineering. These industries are also reflected in BCW - the largest office agglomeration in the district. With more than 61,500 m2 of land and 51,100 m2 of usable space, the area offers space for offices, service, retail and storage areas as well as workshops.\r\n\r\nUnder the roofs of the campus, one finds a bright and open working environment. The office spaces can be flexibly divided and designed as cell or group offices, creating an optimal quality of work and meeting.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment & Development",
        location: "East Stuttgart, Germany",
        property: "61,500 sqm plus 27,700 sqm forest area",
        area: "51,300 sqm in stock",
        zertifizierung: "",
        parcels: "600",
        use_for: "Mixed use",
        acquired: "Q4 2021",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "",
        fakten: null,
        specifications_image_projects: 21975,
        slider: [21973, 21971, 21969, 21967],
        title_details_projects: "Bürocampus Wangen in Detail",
        details_repeater_projects: [
          {
            title_repeater_details: "Industrial charm with feel-good factor",
            description_repeater_details:
              "The location has a commercial and industrial character due to its proximity to the Neckar harbor, and yet the city center of Wangen, which stretches along Ulmer Straße, is only 500 meters away.  With the Wangener Höhe, the local recreation area is also not far away, which offers a moment of calm during the lunch break. In the immediate vicinity, the city centers of Wangen and Hedelfing are home to numerous restaurateurs, so that tenants and their employees are well catered for in terms of culinary delights. The gastronomic offerings range from bakeries to local pubs and restaurants in the immediate vicinity of the site. The considerable woodland area of around 27,000 m², which is part of the campus, also invites visitors to linger, relax and go for a walk.",
            image_repeater_details: 21973,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Good accessibility for commuters",
            description_repeater_details:
              "Thanks to a total of around 600 parking spaces and the subway stop located directly in front of the campus, the area is easy to reach for commuters by car as well as by public transport. The central location in the southeast of Stuttgart provides good connections to Stuttgart city center as well as to the airport and the A8 freeway.",
            image_repeater_details: 21967,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Hedelfinger Str. 54-80, Stuttgart, Deutschland",
          lat: 48.7684749,
          lng: 9.2477007,
          zoom: 14,
          place_id:
            "Ei1IZWRlbGZpbmdlciBTdHIuIDU0LCA3MDMyNyBTdHV0dGdhcnQsIEdlcm1hbnkiMBIuChQKEgmXRoUFacSZRxE2inp5Y0fIhhA2KhQKEgnJ6EsEbMSZRxHaPtLqckaEVA",
          name: "Hedelfinger Str. 54",
          street_number: 54,
          street_name: "Hedelfinger Straße",
          street_name_short: "Hedelfinger Str.",
          city: "Stuttgart",
          state: "Baden-Württemberg",
          state_short: "BW",
          post_code: 70327,
          country: "Deutschland",
          country_short: "DE",
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Bürocampus Wangen, Stuttgart</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/buerocampus-wangen-stuttgart/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Bürocampus Wangen, Stuttgart" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/buerocampus-wangen-stuttgart/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-07-03T08:27:12+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2023/01/bcw_R5_4381.jpg" />\n\t<meta property="og:image:width" content="2480" />\n\t<meta property="og:image:height" content="1654" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/buerocampus-wangen-stuttgart/","url":"https://www.art-invest.de/en/projekt/buerocampus-wangen-stuttgart/","name":"Art-Invest Real Estate | Bürocampus Wangen, Stuttgart","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2023-01-04T11:01:34+00:00","dateModified":"2023-07-03T08:27:12+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/buerocampus-wangen-stuttgart/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/buerocampus-wangen-stuttgart/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/buerocampus-wangen-stuttgart/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Bürocampus Wangen, Stuttgart"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Bürocampus Wangen, Stuttgart",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/buerocampus-wangen-stuttgart/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Bürocampus Wangen, Stuttgart",
        og_url:
          "https://www.art-invest.de/en/projekt/buerocampus-wangen-stuttgart/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-07-03T08:27:12+00:00",
        og_image: [
          {
            width: 2480,
            height: 1654,
            url: "https://www.art-invest.de/wp-content/uploads/2023/01/bcw_R5_4381.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/buerocampus-wangen-stuttgart/",
              url: "https://www.art-invest.de/en/projekt/buerocampus-wangen-stuttgart/",
              name: "Art-Invest Real Estate | Bürocampus Wangen, Stuttgart",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2023-01-04T11:01:34+00:00",
              dateModified: "2023-07-03T08:27:12+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/buerocampus-wangen-stuttgart/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/buerocampus-wangen-stuttgart/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/buerocampus-wangen-stuttgart/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Bürocampus Wangen, Stuttgart",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2023/01/bcw_R5_4381-800x800.jpg",
      place: "Stuttgart",
      subtitle: "Vielfältiger Nutzungsmix",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21982",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21967",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21969",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21971",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21973",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21971",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21982",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21982",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16594,
      date: "2015-05-05T12:00:51",
      date_gmt: "2015-05-05T10:00:51",
      guid: {
        rendered: "https://www.art-invest.de/projekt/kaiser-hof/",
      },
      modified: "2022-01-24T17:40:31",
      modified_gmt: "2022-01-24T16:40:31",
      slug: "kaiser-hof",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/kaiser-hof/",
      title: {
        rendered: "Kaiser Hof",
      },
      featured_media: 16652,
      template: "",
      projekt_filter: [246, 247, 427, 425],
      acf: {
        highlight_image: 12976,
        highlight_title_project: "Kaiser Hof",
        highlight_subtitle_project: "Raffinierte Fassadenarchitektur",
        highlight_description_project:
          "With the Kaiser Hof a new exclusive office property is being built on the historic Kaiser-Wilhelm-Ring. As part of an ensemble, this new high-quality property is being built at a top address between the modern MediaPark, the historic Kaiser-Wilhelm-Ring and the trendy Belgian quarter. From 2019, employees will find high-quality office space in the new building on Herrmann-Becker-Straße on approx. 12,350 m² rental space.",
        highlight_logo_project: 11972,
        website_projects: {
          title: "www.kaiserhof.koeln",
          url: "https://www.kaiserhof.koeln/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://www.kaiserhof.koeln/",
          target: "",
        },
        available_space: [""],
        project: "Development",
        location: "Erftstraße 19, 50672 Cologne",
        property: "approx. 3,150 m²",
        area: "12,350 m² MF-G o.i.",
        zertifizierung: "",
        parcels: "168",
        use_for: "Office",
        acquired: "Q4 2014",
        realization: "Q2 2019",
        sale: "",
        architecture_firm: "caspar Architekten",
        place: "Köln",
        fakten: null,
        specifications_image_projects: 11398,
        slider: null,
        title_details_projects: "KAISER HOF IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Raffinierte Fassadenarchitektur",
            description_repeater_details:
              "Differently aligned lenses in the bright outer facade create an extraordinary interaction of shadows, which changes permanently in the change of light incidence. In this way the Kaiser Hof, which quotes the timeless architecture of the neighbouring buildings, sets a special visual accent in the cityscape.",
            image_repeater_details: 11975,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Light-flooded working worlds",
            description_repeater_details:
              "Behind the facade made of high-quality fibre concrete, the building offers a flexible office world with around 1,800 m² of rental space on each floor. Room-high glazing creates a bright and communicative atmosphere in the flexibly designed office areas.",
            image_repeater_details: 11976,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Staggered floor with a view of the cathedral",
            description_repeater_details:
              "A set-back staggered floor forms the top floor, which, with a surrounding terrace, invites all employees to a direct view of the cathedral.",
            image_repeater_details: 12989,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Award-winning design",
            description_repeater_details:
              "The corporate design of the Emperor's Court has been awarded twice with the German Design Award  in 2018. The jury was convinced by the polygonal design concept of the exclusive office building. On the other hand, they awarded the Kaiser Postille, a district magazine in daily newspaper format as an innovative marketing tool with a high design standard and editorial quality content.",
            image_repeater_details: 12978,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "The Kaiser Hof was the first Cologne project to be awarded WiredScore Platinum for its digital infrastructure",
            description_repeater_details:
              "The WiredScore certification is an evaluation system for office properties that provides the necessary transparency and access to important information about the digital infrastructure of a building.",
            image_repeater_details: 12984,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Erftstraße 19, 50672 Köln, Deutschland",
          lat: 50.94616756641625,
          lng: 6.942211996820106,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Kaiser Hof</title>\n<meta name="description" content="Der siebengeschossige Kaiserhof ist Teil der Kölner Kaiser-Wilhelm-Höfe und bietet auf rund 45.600 m² modernste Office-Flächen." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/kaiser-hof/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Kaiser Hof" />\n<meta property="og:description" content="Der siebengeschossige Kaiserhof ist Teil der Kölner Kaiser-Wilhelm-Höfe und bietet auf rund 45.600 m² modernste Office-Flächen." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/kaiser-hof/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-01-24T16:40:31+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2015/05/CGN_Kaiser-Hof_Luftaufnahme_Tag_2.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1757" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/kaiser-hof/","url":"https://www.art-invest.de/en/projekt/kaiser-hof/","name":"Art-Invest Real Estate | Kaiser Hof","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2015-05-05T10:00:51+00:00","dateModified":"2022-01-24T16:40:31+00:00","description":"Der siebengeschossige Kaiserhof ist Teil der Kölner Kaiser-Wilhelm-Höfe und bietet auf rund 45.600 m² modernste Office-Flächen.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/kaiser-hof/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/kaiser-hof/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/kaiser-hof/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Kaiser Hof"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Kaiser Hof",
        description:
          "Der siebengeschossige Kaiserhof ist Teil der Kölner Kaiser-Wilhelm-Höfe und bietet auf rund 45.600 m² modernste Office-Flächen.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/kaiser-hof/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Kaiser Hof",
        og_description:
          "Der siebengeschossige Kaiserhof ist Teil der Kölner Kaiser-Wilhelm-Höfe und bietet auf rund 45.600 m² modernste Office-Flächen.",
        og_url: "https://www.art-invest.de/en/projekt/kaiser-hof/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-01-24T16:40:31+00:00",
        og_image: [
          {
            width: 2560,
            height: 1757,
            url: "https://www.art-invest.de/wp-content/uploads/2015/05/CGN_Kaiser-Hof_Luftaufnahme_Tag_2.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/kaiser-hof/",
              url: "https://www.art-invest.de/en/projekt/kaiser-hof/",
              name: "Art-Invest Real Estate | Kaiser Hof",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2015-05-05T10:00:51+00:00",
              dateModified: "2022-01-24T16:40:31+00:00",
              description:
                "Der siebengeschossige Kaiserhof ist Teil der Kölner Kaiser-Wilhelm-Höfe und bietet auf rund 45.600 m² modernste Office-Flächen.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/kaiser-hof/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/kaiser-hof/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/kaiser-hof/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Kaiser Hof",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2015/05/CGN_Kaiser-Hof_Luftaufnahme_Tag_2-800x800.jpg",
      place: "Köln",
      subtitle: "Raffinierte Fassadenarchitektur",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16594",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16652",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16594",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16594",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16601,
      date: "2019-06-24T18:05:18",
      date_gmt: "2019-06-24T16:05:18",
      guid: {
        rendered:
          "https://www.art-invest.de/projekt/hammerbrooklyn-digitalcampus/",
      },
      modified: "2023-07-13T12:42:09",
      modified_gmt: "2023-07-13T10:42:09",
      slug: "hammerbrooklyn",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/hammerbrooklyn/",
      title: {
        rendered: "Hammerbrooklyn",
      },
      featured_media: 19674,
      template: "",
      projekt_filter: [246, 250, 248, 254, 427, 425],
      acf: {
        highlight_image: 19676,
        highlight_title_project: "Hammerbrooklyn",
        highlight_subtitle_project: "Digital wird real",
        highlight_description_project:
          "Hamburg as a location of innovation with impact on Europe: In the middle of the city, an open place for digital transformation is being created, where companies, the city and science are working together on the future: the Hammerbrooklyn.DigitalCampus. At its center is the Digital Pavilion, which went into operation at the beginning of 2021. It will be followed by the Treetop Tower at the end of 2026 and the HAMMERBROOKLYN Big Market, probably by the end of 2029.",
        highlight_logo_project: 18948,
        website_projects: {
          title: "www.hammerbrooklyn.hamburg",
          url: "https://hammerbrooklyn.hamburg/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://hammerbrooklyn.hamburg/",
          target: "_blank",
        },
        available_space: [""],
        project: "Development",
        location: "Stadtdeich/ Banksstraße 4, 20097 Hamburg",
        property: "15.000 m²",
        area: "68,000 m² ",
        zertifizierung:
          "Digital Pavilion – WiredScore, Treetop Tower und Big Market – LEED Gold",
        parcels: "Switch-Points für Carsharing/E-Mobility",
        use_for:
          "Events, Auditorium, Office, Co-Creation, Co-Working, Digital Workshops, Gastronomy",
        acquired: "Q1 2018",
        realization:
          "Q2 2021 (components 1A and 1B), Q4 2026 (Treetop Tower 1B), overall completion Q1 2029 (component 2)",
        sale: "",
        architecture_firm: "",
        place: "Hamburg",
        fakten: [
          {
            bezeichnung: "Feature",
            wert: "AIRE Smart Building",
            anchor: "smart-building",
          },
          {
            bezeichnung: "Architects Digital Pavilion",
            wert: "James Biber Architects, New York; Metapol Architektur, Berlin; Spine Architects, Hamburg",
            anchor: "",
          },
          {
            bezeichnung: "Architects Treetop Tower",
            wert: "Spine Architects, Hamburg",
            anchor: "",
          },
          {
            bezeichnung: "Architects Big Markets",
            wert: "EM2N, Zürich; Bruther, Paris",
            anchor: "",
          },
        ],
        specifications_image_projects: 19678,
        slider: [17890, 19674, 19680, 19684, 19686, 19688, 19690, 19692],
        title_details_projects: "HAMMERBROOKLYN IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              "New urban district becomes home to agility",
            description_repeater_details:
              'The "city of the future" is being built in a predestined location next to the Oberhafenbrücke, the Deichtorhallen and Hafencity. The Hammerbrooklyn in Hamburg will set futuristic accents with buildings equipped with state-of-the-art technology and create the perfect conditions for workshops, symposia, congresses and exhibitions on the research topic of "digital transformation".',
            image_repeater_details: 19692,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Ahead with innovative power",
            description_repeater_details:
              'The quarter, which is both economically and socially affective, is developing into an ultra-dynamic, networking hub where established companies meet organizations and start-ups and work on the digital vision of the future in an interdisciplinary way - Smart City and Smart Mobility are just a few key points. To make tomorrow\'s world a tangible experience, the first step was to transfer the American EXPO pavilion from Milan to Hamburg, which is currently being rebuilt and upgraded as a fully-fledged building. Altogether, the innovative architecture will accommodate a large Town Hall, an auditorium and areas for offices and studios. The tenant is Factory Berlin, which offers interdisciplinary collaboration between creative, academic, technical and industrial communities a space in Hammerbrooklyn. Another new office building, the "Solution Building," will be realized in hybrid construction and offer further space for new working worlds. A good infrastructure is ensured not least by hip gastronomy offerings that support agile working.',
            image_repeater_details: 19684,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "About AIRE Smart Buildings",
            description_repeater_details:
              '<span lang="EN-US">AIRE Smart Buildings are sustainable buildings that offer tenants, owners and operators numerous added values in terms of sustainability. They provide data-based information on building operation and user behaviour. Tenants benefit from lower operating costs, optimised space utilisation and resource planning as well as an increased well-being of their employees. For owners, the property also becomes more future-proof and adaptable, which has a positive effect on rentability and value stability. By optimising building operation and the resulting reduction in costs, the operator also benefits from the intelligence of an AIRE Smart Building.</span>',
            image_repeater_details: 17819,
            video: "",
            "anchor-link": "smart-building",
          },
        ],
        map: {
          address: "Stadtdeich 2, 20097, Hamburg, Deutschland",
          lat: 53.5454208,
          lng: 10.008226599999944,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Hammerbrooklyn</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/hammerbrooklyn/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Hammerbrooklyn" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/hammerbrooklyn/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-07-13T10:42:09+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2019/06/1.jpg" />\n\t<meta property="og:image:width" content="2500" />\n\t<meta property="og:image:height" content="1864" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/hammerbrooklyn/","url":"https://www.art-invest.de/en/projekt/hammerbrooklyn/","name":"Art-Invest Real Estate | Hammerbrooklyn","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2019-06-24T16:05:18+00:00","dateModified":"2023-07-13T10:42:09+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/hammerbrooklyn/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/hammerbrooklyn/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/hammerbrooklyn/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Hammerbrooklyn"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Hammerbrooklyn",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/hammerbrooklyn/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Hammerbrooklyn",
        og_url: "https://www.art-invest.de/en/projekt/hammerbrooklyn/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-07-13T10:42:09+00:00",
        og_image: [
          {
            width: 2500,
            height: 1864,
            url: "https://www.art-invest.de/wp-content/uploads/2019/06/1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/hammerbrooklyn/",
              url: "https://www.art-invest.de/en/projekt/hammerbrooklyn/",
              name: "Art-Invest Real Estate | Hammerbrooklyn",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2019-06-24T16:05:18+00:00",
              dateModified: "2023-07-13T10:42:09+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/hammerbrooklyn/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/hammerbrooklyn/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/hammerbrooklyn/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Hammerbrooklyn",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2019/06/1-800x800.jpg",
      place: "Hamburg",
      subtitle: "Digital wird real",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16601",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19692",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19690",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19688",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19686",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19684",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19680",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19674",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/17890",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19674",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16601",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16601",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },

    {
      id: 16731,
      date: "2020-05-18T16:09:18",
      date_gmt: "2020-05-18T16:09:18",
      guid: {
        rendered: "https://www.art-invest.de/projekt/h172/",
      },
      modified: "2020-07-03T12:07:17",
      modified_gmt: "2020-07-03T12:07:17",
      slug: "h172",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/h172/",
      title: {
        rendered: "H172",
      },
      featured_media: 15063,
      template: "",
      projekt_filter: [246, 250, 254, 427, 425, 255],
      acf: {
        highlight_image: 15093,
        highlight_title_project: "H172",
        highlight_subtitle_project: "Beeindruckende Glasfront",
        highlight_description_project:
          "Welcome to the H172: The entrance area of the office property with its 21-metre high glass front gives a foretaste of light-flooded office space and contemporary usage concepts. Tenants from the media and creative industries in the multi-tenant property benefit from the exclusive atmosphere of the prestigious lobby. The H172 in Frankfurt's sought-after Ostend is a symbol of the attraction of this up-and-coming district.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location: "Hanauer Landstraße 172, 60314 Frankfurt",
        property: "1,478 m²",
        area: "approx. 5,400 m²",
        zertifizierung: "",
        parcels: "44",
        use_for: "Office",
        acquired: "Q3/2019",
        realization: "",
        sale: "",
        architecture_firm: "B&V Braun Canton Park Architekten",
        place: "Frankfurt",
        fakten: null,
        specifications_image_projects: 15071,
        slider: null,
        title_details_projects: "H172 IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              "Flexible room concepts behind a representative facade",
            description_repeater_details:
              "The appearance of the H172 captivates by a clear geometrical design language of glass and stone. The exterior facade creates optimal conditions for the dynamic working world of tomorrow. Light office units can be flexibly connected horizontally and vertically. Multifunctional usage concepts increase the productivity and the users’ well-being. The quarter has a strong attraction on architects, IT and media specialists as well as advertising, PR and event agencies.",
            image_repeater_details: 15069,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Office property with a harmonious location",
            description_repeater_details:
              "The H172 is located at the intersection of Hanauer Landstraße and Schwedlerstraße and emphasizes the existing urban constellation through its corner location. The environment convinces with an exciting mix of renovated industrial buildings and attractive new office buildings. Numerous cafés, bars and restaurants as well as a first-class connection to the local public transport system and motorway 661 underline the excellent location quality of the office building in Frankfurt's Ostend.",
            image_repeater_details: 15063,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address:
            "Hanauer Landstraße 172, 60314 Frankfurt am Main, Deutschland",
          lat: 50.113757,
          lng: 8.719233899999999,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | H172</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/h172/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | H172" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/h172/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-03T12:07:17+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/05/H172_Frontansicht-1024x683.jpg" />\n\t<meta property="og:image:width" content="1024" />\n\t<meta property="og:image:height" content="683" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/h172/","url":"https://www.art-invest.de/en/projekt/h172/","name":"Art-Invest Real Estate | H172","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-05-18T16:09:18+00:00","dateModified":"2020-07-03T12:07:17+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/h172/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/h172/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/h172/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"H172"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | H172",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/h172/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | H172",
        og_url: "https://www.art-invest.de/en/projekt/h172/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-03T12:07:17+00:00",
        og_image: [
          {
            width: 1024,
            height: 683,
            url: "https://www.art-invest.de/wp-content/uploads/2020/05/H172_Frontansicht-1024x683.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/h172/",
              url: "https://www.art-invest.de/en/projekt/h172/",
              name: "Art-Invest Real Estate | H172",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-05-18T16:09:18+00:00",
              dateModified: "2020-07-03T12:07:17+00:00",
              breadcrumb: {
                "@id": "https://www.art-invest.de/en/projekt/h172/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/h172/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/h172/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "H172",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/05/H172_Frontansicht-800x800.jpg",
      place: "Frankfurt",
      subtitle: "Beeindruckende Glasfront",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16731",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/15063",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16731",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16731",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16207,
      date: "2014-07-20T12:00:58",
      date_gmt: "2014-07-20T10:00:58",
      guid: {
        rendered: "https://www.art-invest.de/projekt/die-macherei/",
      },
      modified: "2023-06-22T17:45:39",
      modified_gmt: "2023-06-22T15:45:39",
      slug: "die-macherei",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/die-macherei/",
      title: {
        rendered: "Die Macherei München",
      },
      featured_media: 16209,
      template: "",
      projekt_filter: [246, 251, 427, 249, 425, 245],
      acf: {
        highlight_image: 16219,
        highlight_title_project: "Die Macherei München",
        highlight_subtitle_project: "Ein Treffpunkt für Macher und Entscheider",
        highlight_description_project:
          "No sooner said than done: Die Macherei is a place for doers. The area opens 67,000 m² for free design and for turning ideas into reality. Working environments, retail space, gastronomy and hotel – versatile uses characterise this new creative hub, which gives a home to everyone who simply wants to do something. An international competition demanded the highest standards of architecture. Three renowned architects have created a heterogeneous ensemble that brings many worlds together in one area. Die Macherei – all in one place.",
        highlight_logo_project: 16218,
        website_projects: {
          title: "www.die-macherei.de",
          url: "https://www.die-macherei.de/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://www.die-macherei.de/",
          target: "",
        },
        available_space: [""],
        project: "Development",
        location:
          "Weihenstephaner Straße 28, 81673 Munich (Germany); central location east of the city centre, directly on the main access road Berg-am-Laim Str. in the up-and-coming east of Munich",
        property: "26,400 m²",
        area: "about 74,400 m²",
        zertifizierung: "",
        parcels: "ca. 800",
        use_for: "Office, Hotel, Co-Working, Retail, Fitness, Catering",
        acquired: "2015",
        realization: "2021",
        sale: "",
        architecture_firm: "",
        place: "München",
        fakten: null,
        specifications_image_projects: 16209,
        slider: [15039, 15043, 14745, 15239, 16217, 15041],
        title_details_projects: "DIE MACHEREI INDETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Staring in the east",
            description_repeater_details:
              'Departure is in the air. Die Macherei is in the middle of a pulsating environment. Various new development projects, such as the new concert hall, are shaping and changing the face of Munich between Ostbahnhof station and the trade fair centre - a district that numerous national and international companies, from Scout24 to Süddeutsche Zeitung, have already discovered as a location for themselves. It is a perfect place to do business, everything that is needed is available on site, everything that is still missing is "in the making".',
            image_repeater_details: 16208,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Münchner Freiheit",
            description_repeater_details:
              "It's the connection: The Schlüsselbergstrasse tram stop right on our doorstep guarantees fast connections to the city and the entire Munich metropolitan area. In just a few minutes you can reach the Frauenkirche or the traffic junction at the main railway station. The Franz-Josef-Strauß Airport is only half an hour away by taxi. For all those who are travelling by car, our own underground car park has about 800 parking spaces. Bike stations are planned as well as shared mobility concepts.",
            image_repeater_details: 16216,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Everything in one place",
            description_repeater_details:
              "The area intelligently integrates various uses: it transforms roof gardens into sports areas or open spaces into meeting zones. Whatever you want to do, in the bright buildings with heterogeneous architecture on a total area of approx. 67,000 m² all room concepts can be variably realized. The infrastructure is excellent for any action: the co-working areas, loft offices next to various cafés and bars invite you to stay a bit longer.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Die Macherei Movie",
            description_repeater_details: "",
            image_repeater_details: 16217,
            video: "https://player.vimeo.com/video/412625754",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Berg-am-Laim-Straße 115, 81673 München, Deutschland",
          lat: 48.13015,
          lng: 11.62523,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Die Macherei Munich</title>\n<meta name="description" content="Das Temmler Areal eröffnet auf ca. 26.400 m² Neuland zur freien Gestaltung im Münchner Osten mit modernsten Office-, Retail-, Gastro- und Hotelwelten." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/die-macherei/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Die Macherei Munich" />\n<meta property="og:description" content="Das Temmler Areal eröffnet auf ca. 26.400 m² Neuland zur freien Gestaltung im Münchner Osten mit modernsten Office-, Retail-, Gastro- und Hotelwelten." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/die-macherei/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-06-22T15:45:39+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/03/Die_Macherei_Exterior_Vogel_200129_FINAL_BLUR-1.jpg" />\n\t<meta property="og:image:width" content="1992" />\n\t<meta property="og:image:height" content="1495" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/die-macherei/","url":"https://www.art-invest.de/en/projekt/die-macherei/","name":"Art-Invest Real Estate | Die Macherei Munich","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-07-20T10:00:58+00:00","dateModified":"2023-06-22T15:45:39+00:00","description":"Das Temmler Areal eröffnet auf ca. 26.400 m² Neuland zur freien Gestaltung im Münchner Osten mit modernsten Office-, Retail-, Gastro- und Hotelwelten.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/die-macherei/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/die-macherei/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/die-macherei/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Die Macherei Munich"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Die Macherei Munich",
        description:
          "Das Temmler Areal eröffnet auf ca. 26.400 m² Neuland zur freien Gestaltung im Münchner Osten mit modernsten Office-, Retail-, Gastro- und Hotelwelten.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/die-macherei/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Die Macherei Munich",
        og_description:
          "Das Temmler Areal eröffnet auf ca. 26.400 m² Neuland zur freien Gestaltung im Münchner Osten mit modernsten Office-, Retail-, Gastro- und Hotelwelten.",
        og_url: "https://www.art-invest.de/en/projekt/die-macherei/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-06-22T15:45:39+00:00",
        og_image: [
          {
            width: 1992,
            height: 1495,
            url: "https://www.art-invest.de/wp-content/uploads/2020/03/Die_Macherei_Exterior_Vogel_200129_FINAL_BLUR-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/die-macherei/",
              url: "https://www.art-invest.de/en/projekt/die-macherei/",
              name: "Art-Invest Real Estate | Die Macherei Munich",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-07-20T10:00:58+00:00",
              dateModified: "2023-06-22T15:45:39+00:00",
              description:
                "Das Temmler Areal eröffnet auf ca. 26.400 m² Neuland zur freien Gestaltung im Münchner Osten mit modernsten Office-, Retail-, Gastro- und Hotelwelten.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/die-macherei/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/die-macherei/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/die-macherei/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Die Macherei Munich",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/03/Die_Macherei_Exterior_Vogel_200129_FINAL_BLUR-1-800x800.jpg",
      place: "München",
      subtitle: "Macher und Entscheider im Dialog,",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16207",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/15041",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16217",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/15239",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14745",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/15043",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/15039",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16209",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16207",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16207",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 20216,
      date: "2022-04-06T11:24:50",
      date_gmt: "2022-04-06T09:24:50",
      guid: {
        rendered: "https://www.art-invest.de/projekt/neuer-stahlhof/",
      },
      modified: "2023-08-31T14:01:09",
      modified_gmt: "2023-08-31T12:01:09",
      slug: "neuer-stahlhof",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/neuer-stahlhof/",
      title: {
        rendered: "Neuer Stahlhof",
      },
      featured_media: 20125,
      template: "",
      projekt_filter: [246, 427, 425, 257],
      acf: {
        highlight_image: 20119,
        highlight_title_project: "Neuer Stahlhof ",
        highlight_subtitle_project: "20er-Jahre-Charme im modernen Gewand",
        highlight_description_project:
          "The Neuer Stahlhof was built in 1922 as an extension of the Alter Stahlhof - today's seat of the administrative court. As the management headquarter of Vereinigte Stahlwerke AG respectively Stumm AG, it had the reputation at the time of being the \"desk of the Ruhr region\". Today, the completely listed building houses the Versorgungswerk der Rechtsanwälte NRW, the Jones Day business law firm, as well as agencies and specialist doctors' practices on a total gross floor area of 10,744 m². The nostalgia of the 1920s has not been lost despite all the modernization measures: The 100-year-old high-quality natural stone floor in the stairwell and the paternoster, which is still one of the last in operation in the city, exude their very own charm as witnesses of the past.",
        highlight_logo_project: 25343,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Long-term investment ",
        location: "Breite Straße 67/69, 40213 Düsseldorf, Carlstadt, Germany",
        property: "5,094 m²",
        area: "10,744 m²",
        zertifizierung: "",
        parcels: "92",
        use_for: "Office, Practice",
        acquired: "01.01.2021",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "",
        fakten: null,
        specifications_image_projects: 20129,
        slider: [20125, 20127, 20129, 20121, 20123, 20119],
        title_details_projects: "Neuer Stahlhof in detail",
        details_repeater_projects: [
          {
            title_repeater_details: "Understatement in expressionist style",
            description_repeater_details:
              'The eleven-story building emerged from an architectural competition in which Paul Bonatz, builder of the Stuttgart train station and main representative of the traditionalist architecture of the "Stuttgarter Schule", convinced the jury with his design. The deliberately chosen unpretentious, sober self-portrayal was reflected in a modern administrative building that on the one hand skilfully represented the status of the Group, but on the other hand did not appear overdone. Connected to the Alter Stahlhof by inner courtyards, the new steel-framed building stood out for its elaborate longwall and characteristic Expressionist-style facade. The triangular, vertically aligned pillars are still the landmark of the Neuer Stahlhof today, which is considered one of the few remaining expressionist building ensembles.',
            image_repeater_details: 20117,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Shopping on the Kö - Market on the Carlsplatz",
            description_repeater_details:
              "The immediate vicinity to the Königsallee leaves nothing to be desired. Whether for a glamorous shopping tour, an elegant night out or a stroll - the famous luxury boulevard offers something for every taste. And those who prefer something more rustic will find themselves in good hands at Carlsplatz. On one of the oldest marketplaces still in operation in Düsseldorf, you will find fresh fruit and vegetables, cheese, meat and fish offered by market vendors, as well as a wide variety of gastronomic offerings.",
            image_repeater_details: 20127,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Breite Straße 67-69, 40213 Düsseldorf, Deutschland",
          lat: 51.2207769,
          lng: 6.7768011,
          zoom: 14,
          place_id: "ChIJj4m4kz3KuEcRC2fL1k5jyuA",
          name: "Breite Str. 67-69",
          street_number: "67-69",
          street_name: "Breite Straße",
          street_name_short: "Breite Str.",
          city: "Düsseldorf",
          state: "Nordrhein-Westfalen",
          state_short: "NRW",
          post_code: 40213,
          country: "Deutschland",
          country_short: "DE",
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Neuer Stahlhof</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/neuer-stahlhof/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Neuer Stahlhof" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/neuer-stahlhof/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-08-31T12:01:09+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2022/04/210615-alter.stahlhof-andreas.endermann-006_bearbeitet.jpg" />\n\t<meta property="og:image:width" content="609" />\n\t<meta property="og:image:height" content="919" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/neuer-stahlhof/","url":"https://www.art-invest.de/en/projekt/neuer-stahlhof/","name":"Art-Invest Real Estate | Neuer Stahlhof","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2022-04-06T09:24:50+00:00","dateModified":"2023-08-31T12:01:09+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/neuer-stahlhof/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/neuer-stahlhof/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/neuer-stahlhof/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Neuer Stahlhof"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Neuer Stahlhof",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/neuer-stahlhof/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Neuer Stahlhof",
        og_url: "https://www.art-invest.de/en/projekt/neuer-stahlhof/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-08-31T12:01:09+00:00",
        og_image: [
          {
            width: 609,
            height: 919,
            url: "https://www.art-invest.de/wp-content/uploads/2022/04/210615-alter.stahlhof-andreas.endermann-006_bearbeitet.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/neuer-stahlhof/",
              url: "https://www.art-invest.de/en/projekt/neuer-stahlhof/",
              name: "Art-Invest Real Estate | Neuer Stahlhof",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2022-04-06T09:24:50+00:00",
              dateModified: "2023-08-31T12:01:09+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/neuer-stahlhof/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/neuer-stahlhof/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/neuer-stahlhof/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Neuer Stahlhof",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2022/04/210615-alter.stahlhof-andreas.endermann-006_bearbeitet-609x800.jpg",
      place: "Düsseldorf",
      subtitle: "20er-Charme, neu interpretiert",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/20216",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20119",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20123",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20121",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20129",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20127",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20125",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20125",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=20216",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=20216",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 19802,
      date: "2020-12-09T11:05:36",
      date_gmt: "2020-12-09T10:05:36",
      guid: {
        rendered: "https://www.art-invest.de/projekt/jaho-berlin/",
      },
      modified: "2023-06-22T10:41:09",
      modified_gmt: "2023-06-22T08:41:09",
      slug: "jaho-berlin",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/jaho-berlin/",
      title: {
        rendered: "JaHo Berlin",
      },
      featured_media: 19785,
      template: "",
      projekt_filter: [246, 250, 427, 425, 245, 256],
      acf: {
        highlight_image: 25053,
        highlight_title_project: "JaHo Berlin",
        highlight_subtitle_project: "Spannender Neubau in der Hauptstadt",
        highlight_description_project:
          "In Berlin-Mitte, an exciting building ensemble is being constructed with the JaHo, which creates a new, urban city space with a high quality of stay. The ensemble of Jannowitz-Turm, Holzmarkt-Kontor and Holzmarkt 5 consists of a multifunctional utilization concept. In particular, the sustainable inclusion of the existing surroundings, such as the railroad arches, the station, and the Spree, makes up the unique character of JaHo Berlin. State-of-the-art office space with innovative concepts as well as gastronomy and shopping facilities for daily needs guarantee residents, tenants and visitors flexibility for living and working.",
        highlight_logo_project: null,
        website_projects: {
          title: "www.jaho-berlin.de",
          url: "http://www.jaho-berlin.de",
          target: "_blank",
        },
        external_projectpage: "",
        available_space: [""],
        project: "Development",
        location: "Holzmarktstr. 3-5, 10179 Berlin-Mitte",
        property: "7,416 m²",
        area: "approx. 50,000 m²",
        zertifizierung: "",
        parcels: "",
        use_for: "Büro, Gastro, Retail",
        acquired: "Q4 2016",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Berlin",
        fakten: [
          {
            bezeichnung: "Completion",
            wert: "2026",
            anchor: "",
          },
          {
            bezeichnung: "Architects Jannowitz-Turm",
            wert: "David Chipperfield Architects Berlin",
            anchor: "",
          },
          {
            bezeichnung: "Architects Holzmarkt-Kontor & Holzmarkt 5",
            wert: "Kuehn Malvezzi Architects",
            anchor: "",
          },
        ],
        specifications_image_projects: null,
        slider: [19785, 19787, 19789, 25053],
        title_details_projects: "JaHo Berlin in Detail",
        details_repeater_projects: [
          {
            title_repeater_details: "Point of attraction Jannowitzbrücke",
            description_repeater_details:
              "The construction of the quarter takes place directly next to the S- &amp; U-Bahn station Jannowitzbrücke. Through JaHo Berlin, the area on the banks of the Spree emerges from the shadow of an interchange and generates a new point of attraction. Not only the central location, but also the excellent connections and numerous bicycle parking spaces support the promising mobility concept. The handsome recreational areas in the newly created city square and the catering/outdoor areas also create a place to stay or spontaneous exchange in the fresh air and thus revitalize the location.",
            image_repeater_details: 19789,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Jannowitz-Turm",
            description_repeater_details:
              "At the intersection of Alexanderstraße and Holzmarktstraße, the JaHo project is enriched by the impressive Jannowitz-Turm. The architecturally striking high-rise with the public skybar on the top floor provides a spectacular panoramic view of the pulsating capital with the Spree and Alexanderplatz.\r\n\r\nThe compact building volume is modulated in a way that projections and recesses clearly relate to the neighboring buildings and the city railroad. Within the tower itself, the recesses form generous green terrace areas with roof gardens. The transparent facade with an outer covering layer of light-colored, horizontal, and vertical aluminum swords protects against sun and heat while creating an interplay of light and shadow.",
            image_repeater_details: 19791,
            video: "",
            "anchor-link": "stadtturm",
          },
          {
            title_repeater_details: "Holzmarkt-Kontor & Holzmarkt 5",
            description_repeater_details:
              "On the eastern construction site, the Holzmarkt-Kontor and Holzmarkt 5 complete the JaHo Berlin project. The Holzmarkt-Kontor, with its two meandering S-shaped structures on top of each other and a height of approx. 45 meters, offers exciting and eventful architecture and at the same time creates green oases of well-being for pausing and taking a breath with the pocket parks on the first floor. The Holzmarkt 5 adjacent to the listed building conclusively completes the overall structure. In harmony with the building architecture and the location, publicly accessible areas with gastronomy and local supply are created on the first floor.",
            image_repeater_details: 25053,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Holzmarktstraße 3-5, Mitte 10179 Berlin, Deutschland",
          lat: 52.5150484,
          lng: 13.419348,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | JaHo Berlin</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/jaho-berlin/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | JaHo Berlin" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/jaho-berlin/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-06-22T08:41:09+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/12/B_JaHo_Aerial_Sunny.jpg" />\n\t<meta property="og:image:width" content="2000" />\n\t<meta property="og:image:height" content="1444" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/jaho-berlin/","url":"https://www.art-invest.de/en/projekt/jaho-berlin/","name":"Art-Invest Real Estate | JaHo Berlin","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-12-09T10:05:36+00:00","dateModified":"2023-06-22T08:41:09+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/jaho-berlin/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/jaho-berlin/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/jaho-berlin/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"JaHo Berlin"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | JaHo Berlin",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/jaho-berlin/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | JaHo Berlin",
        og_url: "https://www.art-invest.de/en/projekt/jaho-berlin/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-06-22T08:41:09+00:00",
        og_image: [
          {
            width: 2000,
            height: 1444,
            url: "https://www.art-invest.de/wp-content/uploads/2020/12/B_JaHo_Aerial_Sunny.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/jaho-berlin/",
              url: "https://www.art-invest.de/en/projekt/jaho-berlin/",
              name: "Art-Invest Real Estate | JaHo Berlin",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-12-09T10:05:36+00:00",
              dateModified: "2023-06-22T08:41:09+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/jaho-berlin/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/jaho-berlin/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/jaho-berlin/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "JaHo Berlin",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/12/B_JaHo_Aerial_Sunny-800x800.jpg",
      place: "Berlin",
      subtitle: "Neubau mit Hauptstadt-Charme",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/19802",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25053",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19789",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19787",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19785",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19785",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=19802",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=19802",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21590,
      date: "2022-01-31T11:36:21",
      date_gmt: "2022-01-31T10:36:21",
      guid: {
        rendered: "https://www.art-invest.de/projekt/alter-wall-40/",
      },
      modified: "2023-07-10T11:50:33",
      modified_gmt: "2023-07-10T09:50:33",
      slug: "alter-wall-40",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/alter-wall-40/",
      title: {
        rendered: "Alter Wall 40",
      },
      featured_media: 25153,
      template: "",
      projekt_filter: [246, 248, 251, 427, 252, 425, 245],
      acf: {
        highlight_image: 23864,
        highlight_title_project: "Alter Wall 40",
        highlight_subtitle_project:
          "Lebendiges Quartier mit schönem Nutzungsmix",
        highlight_description_project:
          "The success story of the Alter Wall is being continued: The redesign concept developed by Winking Froh Architekten for the rear section of the street in the direction of Rödingsmarkt is convincing with a lively, attractive mix of uses comprising office, hotel, retail and residential space, presented by a new perimeter block development on the forecourt of the former hotel building with a total gross floor area of around 40,000 sqm. Together with the London hospitality company Ennismore, the THE CHOCOLATE ON THE PILLOW GROUP will operate a modern international hotel concept here in the future as part of the lifestyle brand The Hoxton.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Development and Redensification",
        location: "Alter Wall 40, Hamburg",
        property: "5,341 sqm",
        area: "Approx. 40,000 sqm",
        zertifizierung: "",
        parcels: "70",
        use_for: "Hotel, Office, Residential, Restaurant and Retail",
        acquired: "2015",
        realization: "Expected in 2026",
        sale: "",
        architecture_firm: "Winking Froh Architekten",
        place: "Hamburg",
        fakten: null,
        specifications_image_projects: 25119,
        slider: [25109, 25113, 25111],
        title_details_projects: "",
        details_repeater_projects: [
          {
            title_repeater_details: "Historic ensemble in a prominent location",
            description_repeater_details:
              "In the midst of the Nikolai Quarter, between the Alsterfleet, City Hall and the luxury shopping boulevard Neuer Wall, Alter Wall 40 is located in a prime, central city location and, with its diverse shopping and gastronomy offerings in the immediate vicinity, is one of the most attractive locations in Hamburg. The architectural concept ties in with the historical significance of the Alter Wall and skilfully leads into the future within the framework of a cautious redensification and modernization of the existing building. The historical building complex will be successively redesigned and continued by the new development with a modern signature.",
            image_repeater_details: 25109,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Attractive commercial space and rooftop floor with a far-reaching view",
            description_repeater_details:
              "In addition to modern, flexibly configurable office space, 1- to 3-room apartments of various sizes are being built on an area of around 7,000 sqm, some of which are located directly on the Alsterfleet. Individual commercial and gastronomy units are planned for the first floor areas. The highlight of the adjoining hotel The Hoxton will be a publicly accessible rooftop floor offering gastronomy and event areas with a panoramic view of the Elbphilharmonie, Hamburg's Michel and the City Hall.",
            image_repeater_details: 25119,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Alter Wall 40, Hamburg, Deutschland",
          lat: 53.5497228,
          lng: 9.988087799999999,
          zoom: 14,
          place_id: "ChIJ5yxS4hqPsUcRzNMD2JRNe-I",
          name: "Alter Wall 40",
          street_number: 40,
          street_name: "Alter Wall",
          city: "Hamburg",
          state: "Hamburg",
          state_short: "HH",
          post_code: 20457,
          country: "Deutschland",
          country_short: "DE",
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Alter Wall 40</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/alter-wall-40/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Alter Wall 40" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/alter-wall-40/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-07-10T09:50:33+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2022/01/Alter_Wall_38-40_Hamburg-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="2560" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/alter-wall-40/","url":"https://www.art-invest.de/en/projekt/alter-wall-40/","name":"Art-Invest Real Estate | Alter Wall 40","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2022-01-31T10:36:21+00:00","dateModified":"2023-07-10T09:50:33+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/alter-wall-40/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/alter-wall-40/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/alter-wall-40/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Alter Wall 40"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Alter Wall 40",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/alter-wall-40/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Alter Wall 40",
        og_url: "https://www.art-invest.de/en/projekt/alter-wall-40/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-07-10T09:50:33+00:00",
        og_image: [
          {
            width: 2560,
            height: 2560,
            url: "https://www.art-invest.de/wp-content/uploads/2022/01/Alter_Wall_38-40_Hamburg-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/alter-wall-40/",
              url: "https://www.art-invest.de/en/projekt/alter-wall-40/",
              name: "Art-Invest Real Estate | Alter Wall 40",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2022-01-31T10:36:21+00:00",
              dateModified: "2023-07-10T09:50:33+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/alter-wall-40/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/alter-wall-40/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/alter-wall-40/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Alter Wall 40",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2022/01/230508_AWH40_Blick-Roedingsmarkt-2-800x800.jpg",
      place: "Hamburg",
      subtitle: "Lebendige Mischung im Quartier",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21590",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25111",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25113",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25109",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25153",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21590",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21590",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },

    {
      id: 16622,
      date: "2014-07-29T12:00:27",
      date_gmt: "2014-07-29T10:00:27",
      guid: {
        rendered: "https://www.art-invest.de/projekt/koe-bogen/",
      },
      modified: "2021-11-04T17:53:58",
      modified_gmt: "2021-11-04T16:53:58",
      slug: "koe-bogen",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/koe-bogen/",
      title: {
        rendered: "Kö-Bogen",
      },
      featured_media: 16624,
      template: "",
      projekt_filter: [246, 427, 425, 245, 257],
      acf: {
        highlight_image: 13845,
        highlight_title_project: "Kö-Bogen",
        highlight_subtitle_project: "Der Wandel macht einen Bogen",
        highlight_description_project:
          "Every building designed by star architect Daniel Libeskind speaks its own unmistakable language – same as the Kö-Bogen in Düsseldorf. With this shopping and office ensemble, the New Yorker has created a modern icon in Düsseldorf that no one can escape.",
        highlight_logo_project: 13459,
        website_projects: {
          title: "www.koebogen.info",
          url: "https://www.koebogen.info/en/home/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://www.koebogen.info/en/home/",
          target: "_blank",
        },
        available_space: [""],
        project: "Core-Investment",
        location:
          "Königsallee 2, 40212 Dusseldorf; Dusseldorf city centre, CBD",
        property: "approx. 9.280 m²",
        area: "approx. 41.200 m² / approx. 25.600 m² Retail, approx. 15.300 m² Office",
        zertifizierung: "",
        parcels: "631",
        use_for: "Office and Retail",
        acquired: "2013",
        realization: "Autumn 2013",
        sale: "",
        architecture_firm: "",
        place: "Düsseldorf",
        fakten: null,
        specifications_image_projects: 13458,
        slider: null,
        title_details_projects: "KÖ-BOGEN IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Der Wandel macht einen Bogen",
            description_repeater_details:
              "Daniel Libeskind, architect, urban planner and designer in the same person, designed a spectacular ensemble of buildings on Jan Wellem-Platz, which was awarded 2014 the world's best building in the urban renewal category. 170,000 cubic metres of excavation pit, 36 offices involved, 45 planning companies, 60,000 plans and protocols and 10 tons of paper, these are just some of the organisational superlatives that characterise the construction of the Kö-Bogen.",
            image_repeater_details: 1302,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "A facade like life",
            description_repeater_details:
              '"Life is complex, feelings are complex, individual needs are complex." For Daniel Libeskind, contemporary architecture must translate this complexity. The Kö-Bogen facade visibly conveys this view to the outside world: contrasting lines merge for the observer to form a homogeneous ensemble that offers space for approx. 25,600 m² of retail space as well as 15,300 m² of office space.',
            image_repeater_details: 16623,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "In the best company",
            description_repeater_details:
              "The top tenants today include exclusive retail brands such as Breuninger, Tesla and Apple. The Boston Consulting Group has moved into its German headquarters here.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Königsallee 2, 40212 Düsseldorf",
          lat: 51.2266671,
          lng: 6.779664799999978,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Kö-Bogen</title>\n<meta name="description" content="Mit dem Einkaufs- und Büroensemble hat der Stararchitekt Daniel Libeskind eine moderne Ikone in Düsseldorf geschaffen, der sich niemand entziehen kann." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/koe-bogen/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Kö-Bogen" />\n<meta property="og:description" content="Mit dem Einkaufs- und Büroensemble hat der Stararchitekt Daniel Libeskind eine moderne Ikone in Düsseldorf geschaffen, der sich niemand entziehen kann." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/koe-bogen/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T16:53:58+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/Koe_Bogen_01_TEASER-e1480509439565-1.jpg" />\n\t<meta property="og:image:width" content="815" />\n\t<meta property="og:image:height" content="815" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/koe-bogen/","url":"https://www.art-invest.de/en/projekt/koe-bogen/","name":"Art-Invest Real Estate | Kö-Bogen","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-07-29T10:00:27+00:00","dateModified":"2021-11-04T16:53:58+00:00","description":"Mit dem Einkaufs- und Büroensemble hat der Stararchitekt Daniel Libeskind eine moderne Ikone in Düsseldorf geschaffen, der sich niemand entziehen kann.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/koe-bogen/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/koe-bogen/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/koe-bogen/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Kö-Bogen"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Kö-Bogen",
        description:
          "Mit dem Einkaufs- und Büroensemble hat der Stararchitekt Daniel Libeskind eine moderne Ikone in Düsseldorf geschaffen, der sich niemand entziehen kann.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/koe-bogen/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Kö-Bogen",
        og_description:
          "Mit dem Einkaufs- und Büroensemble hat der Stararchitekt Daniel Libeskind eine moderne Ikone in Düsseldorf geschaffen, der sich niemand entziehen kann.",
        og_url: "https://www.art-invest.de/en/projekt/koe-bogen/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T16:53:58+00:00",
        og_image: [
          {
            width: 815,
            height: 815,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/Koe_Bogen_01_TEASER-e1480509439565-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/koe-bogen/",
              url: "https://www.art-invest.de/en/projekt/koe-bogen/",
              name: "Art-Invest Real Estate | Kö-Bogen",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-07-29T10:00:27+00:00",
              dateModified: "2021-11-04T16:53:58+00:00",
              description:
                "Mit dem Einkaufs- und Büroensemble hat der Stararchitekt Daniel Libeskind eine moderne Ikone in Düsseldorf geschaffen, der sich niemand entziehen kann.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/koe-bogen/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/koe-bogen/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/koe-bogen/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Kö-Bogen",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/Koe_Bogen_01_TEASER-e1480509439565-1.jpg",
      place: "Düsseldorf",
      subtitle: "Der Wandel macht einen Bogen",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16622",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16624",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16622",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16622",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16585,
      date: "2018-08-14T10:12:28",
      date_gmt: "2018-08-14T08:12:28",
      guid: {
        rendered: "https://www.art-invest.de/projekt/die-macherei-offenbach/",
      },
      modified: "2020-07-03T13:18:16",
      modified_gmt: "2020-07-03T13:18:16",
      slug: "die-macherei-offenbach",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/die-macherei-offenbach/",
      title: {
        rendered: "Die Macherei Hafen Offenbach",
      },
      featured_media: 16587,
      template: "",
      projekt_filter: [246, 427, 425, 255],
      acf: {
        highlight_image: 13960,
        highlight_title_project: "Die Macherei Hafen Offenbach",
        highlight_subtitle_project: "Umhang der Zukunft",
        highlight_description_project:
          'On top of the island in Offenbach\'s port, a striking new city quarter is being created, which is called "Die Macherei Hafen Offenbach". The project’s mix of uses combines hotel, office, co-working, gastronomy, fitness and retail, and with the directly adjoining local recreation area "Park in the Dunes" (formerly King Kamehameha Beach) offers attractive leisure facilities that enhance the entire environment.',
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Development",
        location: "Hafeninsel, 63067 Offenbach am Main",
        property: "10,485 m²",
        area: "",
        zertifizierung: "",
        parcels: "",
        use_for: "Office, Hotel, Fitness, Retail, Gastronomy",
        acquired: "Q4 2017",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Offenbach",
        fakten: [
          {
            bezeichnung: "Office Space",
            wert: "50.000 m²",
            anchor: "",
          },
          {
            bezeichnung: "Design",
            wert: "Schneider+Schumacher Planungsgesellschaft mbH",
            anchor: "",
          },
        ],
        specifications_image_projects: 16586,
        slider: null,
        title_details_projects: "DIE MACHEREI HAFEN OFFENBACH IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Ensemble of three ",
            description_repeater_details:
              "The three new futuristic buildings create an interesting tension through their architectural specials. The building projecting towards the bridge welcomes passers-by coming from the harbour, the hotel and office tower marks the tip of the island as the highest building. Together with the third, central object, they form the transition between the densely built-up harbour area and the dune park.",
            image_repeater_details: 16586,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Local recreation with harbour view",
            description_repeater_details:
              "The project also includes the creation of leisure and recreational facilities. A central place at the waterfront will be the lively meeting place and hub of the site. A sloping lawn for sunbathing will allow the base of the office complex to merge with the park, and the elevated vantage point will invite visitors to linger. The view can sweep into the distance in three directions: to the harbour, the newly created dune park with sandy beach and the Main River. On the top of the island, the exciting interaction of water, park and urban quarter creates an attractive recreation area.",
            image_repeater_details: 13468,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Hafeninsel, 63067 Offenbach am Main, Deutschland",
          lat: 50.11459809999999,
          lng: 8.750157100000024,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Die Macherei Hafen Offenbach</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/die-macherei-offenbach/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Die Macherei Hafen Offenbach" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/die-macherei-offenbach/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-03T13:18:16+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/03/KAP_A1_009-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="2560" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/die-macherei-offenbach/","url":"https://www.art-invest.de/en/projekt/die-macherei-offenbach/","name":"Art-Invest Real Estate | Die Macherei Hafen Offenbach","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2018-08-14T08:12:28+00:00","dateModified":"2020-07-03T13:18:16+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/die-macherei-offenbach/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/die-macherei-offenbach/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/die-macherei-offenbach/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Die Macherei Hafen Offenbach"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Die Macherei Hafen Offenbach",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/die-macherei-offenbach/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Die Macherei Hafen Offenbach",
        og_url: "https://www.art-invest.de/en/projekt/die-macherei-offenbach/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-03T13:18:16+00:00",
        og_image: [
          {
            width: 2560,
            height: 2560,
            url: "https://www.art-invest.de/wp-content/uploads/2020/03/KAP_A1_009-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/die-macherei-offenbach/",
              url: "https://www.art-invest.de/en/projekt/die-macherei-offenbach/",
              name: "Art-Invest Real Estate | Die Macherei Hafen Offenbach",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2018-08-14T08:12:28+00:00",
              dateModified: "2020-07-03T13:18:16+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/die-macherei-offenbach/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/die-macherei-offenbach/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/die-macherei-offenbach/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Die Macherei Hafen Offenbach",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/03/KAP_A1_009-800x800.jpg",
      place: "Offenbach",
      subtitle: "Umhang der Zukunft ",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16585",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16587",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16585",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16585",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16614,
      date: "2015-06-30T12:00:45",
      date_gmt: "2015-06-30T10:00:45",
      guid: {
        rendered: "https://www.art-invest.de/projekt/altes-kloepperhaus/",
      },
      modified: "2021-11-04T17:54:11",
      modified_gmt: "2021-11-04T16:54:11",
      slug: "altes-kloepperhaus",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/altes-kloepperhaus/",
      title: {
        rendered: "Klöpperhaus",
      },
      featured_media: 16654,
      template: "",
      projekt_filter: [246, 426, 248, 425, 245],
      acf: {
        highlight_image: 16621,
        highlight_title_project: "Klöpperhaus",
        highlight_subtitle_project: "Innenstadt im Wandel",
        highlight_description_project:
          "At the turn of the century, cotton merchant Wilhelm Klöpper built a prestigious address for his cotton company directly on Hamburg's Rödingsmarkt - and at the same time created a completely new type of property for Hamburg: the Kontorhaus. Modern furnishings transform the loft-like floors into trendsetting working environments.",
        highlight_logo_project: 16619,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Refurbishment",
        location: "Rödingsmarkt 9, 20459 Hamburg-Neustadt",
        property: "1,508 m²",
        area: "11,180 m² BGF",
        zertifizierung: "",
        parcels: "",
        use_for: "Office, Retail",
        acquired: "Q4 2013",
        realization: "Q4 2016",
        sale: "sold to Cornerstone Core Fund TopCo S.C.A.",
        architecture_firm:
          "MSM Meyer Schmitz-Morkramer Rhein GmbH & Kunst + Herbert, Büro für Forschung und Hausbau",
        place: "Hamburg",
        fakten: null,
        specifications_image_projects: 16620,
        slider: null,
        title_details_projects: "KLÖPPERHAUS IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Innenstadt im Wandel",
            description_repeater_details:
              "Downtown Hamburg is transforming - and the Klöpperhaus is right in the middle of it. The Business Improvement District Nikolaiquartier (BID) is transforming the city centre with various redesign measures on a surface area of 17 football pitches. From the Klöpperhaus to the first harbour quay it is only a subway stop, the Jungfernstieg is just a few minutes' walk away and the Elbphilharmonie Concert Hall unfolds its spectacular silhouette within sight.",
            image_repeater_details: 16616,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Founder's Spirit Resident",
            description_repeater_details:
              "Nowhere in Hamburg is the founding spirit more at home than at Rödingsmarkt. Once the cradle of the Kaufmann City lay here. In the 12th century, Dutch settlers laid out canals and roads for the transport of goods from the port to the city centre. With the construction of the Speicherstadt in the 19th century, many canals became obsolete - and were filled in. Today, the U3 underground line runs where once the barges ran between the city and the port.",
            image_repeater_details: 16615,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "A castle for the workspace",
            description_repeater_details:
              "Seven floors of Art Nouveau with playful ornaments and lovingly restored details lend the monumental building complex a historical patina - behind it, the most modern working worlds open up. Individually tailored workplace concepts can be created on all seven floors. Separate workstations are transformed into open office spaces in no time at all and vice versa. Depending on the work situation, the premises can even be divided or separated.",
            image_repeater_details: 16617,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Klöpperhaus Film",
            description_repeater_details: "Making-of klöpperhaus, Hamburg",
            image_repeater_details: 15033,
            video: "https://player.vimeo.com/video/351394307",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Rödingsmarkt 9, Hamburg-Neustadt",
          lat: 53.5483556,
          lng: 9.987429499999962,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Klöpperhaus</title>\n<meta name="description" content="Das Klöpperhaus am Rödingsmarkt schafft mit seiner flexiblen Raumorganisation auf insgesamt ca. 8400 m² damals wie heute eine innovative Arbeitsumgebung." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/altes-kloepperhaus/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Klöpperhaus" />\n<meta property="og:description" content="Das Klöpperhaus am Rödingsmarkt schafft mit seiner flexiblen Raumorganisation auf insgesamt ca. 8400 m² damals wie heute eine innovative Arbeitsumgebung." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/altes-kloepperhaus/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T16:54:11+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2015/06/160316_AI-ALTESKLOEPPERHAUS_hh_439_1280px_72dpi.jpg" />\n\t<meta property="og:image:width" content="1280" />\n\t<meta property="og:image:height" content="853" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/altes-kloepperhaus/","url":"https://www.art-invest.de/en/projekt/altes-kloepperhaus/","name":"Art-Invest Real Estate | Klöpperhaus","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2015-06-30T10:00:45+00:00","dateModified":"2021-11-04T16:54:11+00:00","description":"Das Klöpperhaus am Rödingsmarkt schafft mit seiner flexiblen Raumorganisation auf insgesamt ca. 8400 m² damals wie heute eine innovative Arbeitsumgebung.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/altes-kloepperhaus/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/altes-kloepperhaus/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/altes-kloepperhaus/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Klöpperhaus"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Klöpperhaus",
        description:
          "Das Klöpperhaus am Rödingsmarkt schafft mit seiner flexiblen Raumorganisation auf insgesamt ca. 8400 m² damals wie heute eine innovative Arbeitsumgebung.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/altes-kloepperhaus/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Klöpperhaus",
        og_description:
          "Das Klöpperhaus am Rödingsmarkt schafft mit seiner flexiblen Raumorganisation auf insgesamt ca. 8400 m² damals wie heute eine innovative Arbeitsumgebung.",
        og_url: "https://www.art-invest.de/en/projekt/altes-kloepperhaus/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T16:54:11+00:00",
        og_image: [
          {
            width: 1280,
            height: 853,
            url: "https://www.art-invest.de/wp-content/uploads/2015/06/160316_AI-ALTESKLOEPPERHAUS_hh_439_1280px_72dpi.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/altes-kloepperhaus/",
              url: "https://www.art-invest.de/en/projekt/altes-kloepperhaus/",
              name: "Art-Invest Real Estate | Klöpperhaus",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2015-06-30T10:00:45+00:00",
              dateModified: "2021-11-04T16:54:11+00:00",
              description:
                "Das Klöpperhaus am Rödingsmarkt schafft mit seiner flexiblen Raumorganisation auf insgesamt ca. 8400 m² damals wie heute eine innovative Arbeitsumgebung.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/altes-kloepperhaus/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/altes-kloepperhaus/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/altes-kloepperhaus/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Klöpperhaus",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2015/06/160316_AI-ALTESKLOEPPERHAUS_hh_439_1280px_72dpi-800x800.jpg",
      place: "Hamburg",
      subtitle: "Innenstadt im Wandel",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16614",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16654",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16614",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16614",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },

    {
      id: 16899,
      date: "2018-07-27T15:36:58",
      date_gmt: "2018-07-27T13:36:58",
      guid: {
        rendered: "https://www.art-invest.de/projekt/odeonsplatz-12/",
      },
      modified: "2020-11-16T09:44:39",
      modified_gmt: "2020-11-16T08:44:39",
      slug: "odeonsplatz-12",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/odeonsplatz-12/",
      title: {
        rendered: "Odeonsplatz 12",
      },
      featured_media: 16900,
      template: "",
      projekt_filter: [246, 427, 249, 425],
      acf: {
        highlight_image: 16903,
        highlight_title_project: "Odeonsplatz 12",
        highlight_subtitle_project: "Wahrzeichen in der Altstadt",
        highlight_description_project:
          "Directly next to the Residenz and in the Hofgarten, there is the Klenze Building with its representative pavilion architecture. At one of the most beautiful places in Munich, the part-ownership offers modern and high-quality office space on 575 m².",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location: "Odeonsplatz 12, 80539 Munich; old town",
        property: "",
        area: "720 m²",
        zertifizierung: "",
        parcels: "",
        use_for: "Office, Warehouse",
        acquired: "Q1 2017",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "München",
        fakten: [
          {
            bezeichnung: "Object category",
            wert: "Commercial part-ownership area",
            anchor: "",
          },
          {
            bezeichnung: "Built in",
            wert: "1824 – 1826, new construction in 1956",
            anchor: "",
          },
        ],
        specifications_image_projects: 16901,
        slider: null,
        title_details_projects: "ODEONSPLATZ 12 IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              "Historic architecture in the heart of Munich",
            description_repeater_details:
              "The property is a listed classicist building by the Bavarian court architect Leo von Klenze from the years 1824 -1826. After reconstruction in 1956, the building is in a very well preserved and restored condition. Behind the classicistic round arched windows on the first floor, there is around 575 m² of office space in a prime location.",
            image_repeater_details: 16901,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Representative location",
            description_repeater_details:
              "In the middle of Munich's old town, Odeonsplatz offers excellent connections to the entire city area. The Hofgarten and the surrounding of magnificent buildings such as the Residenz, Theatinerkirche and Feldherrenhalle set the framework for one of the most prestigious addresses in Munich.",
            image_repeater_details: 14049,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Odeonspl. 12, 80539 München, Deutschland",
          lat: 48.1435061,
          lng: 11.578448200000025,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Odeonsplatz 12</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/odeonsplatz-12/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Odeonsplatz 12" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/odeonsplatz-12/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-11-16T08:44:39+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2018/07/MUC_Odeonsplatz_Panorama_mit-Garten-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1707" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/odeonsplatz-12/","url":"https://www.art-invest.de/en/projekt/odeonsplatz-12/","name":"Art-Invest Real Estate | Odeonsplatz 12","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2018-07-27T13:36:58+00:00","dateModified":"2020-11-16T08:44:39+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/odeonsplatz-12/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/odeonsplatz-12/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/odeonsplatz-12/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Odeonsplatz 12"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Odeonsplatz 12",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/odeonsplatz-12/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Odeonsplatz 12",
        og_url: "https://www.art-invest.de/en/projekt/odeonsplatz-12/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-11-16T08:44:39+00:00",
        og_image: [
          {
            width: 2560,
            height: 1707,
            url: "https://www.art-invest.de/wp-content/uploads/2018/07/MUC_Odeonsplatz_Panorama_mit-Garten-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/odeonsplatz-12/",
              url: "https://www.art-invest.de/en/projekt/odeonsplatz-12/",
              name: "Art-Invest Real Estate | Odeonsplatz 12",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2018-07-27T13:36:58+00:00",
              dateModified: "2020-11-16T08:44:39+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/odeonsplatz-12/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/odeonsplatz-12/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/odeonsplatz-12/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Odeonsplatz 12",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2018/07/MUC_Odeonsplatz_Panorama_mit-Garten-1-scaled-800x800.jpg",
      place: "München",
      subtitle: "Wahrzeichen in der Altstadt",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16899",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16900",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16899",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16899",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16979,
      date: "2020-07-28T14:52:03",
      date_gmt: "2020-07-28T14:52:03",
      guid: {
        rendered:
          "https://www.art-invest.de/projekt/ghotel-hotel-living-goettingen/",
      },
      modified: "2020-07-30T08:38:27",
      modified_gmt: "2020-07-30T08:38:27",
      slug: "ghotel-hotel-living-goettingen",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/ghotel-hotel-living-goettingen/",
      title: {
        rendered: "GHOTEL hotel & living",
      },
      featured_media: 16949,
      template: "",
      projekt_filter: [250, 251, 427, 425, 263],
      acf: {
        highlight_image: 16969,
        highlight_title_project: "GHOTEL hotel & living, Göttingen",
        highlight_subtitle_project:
          "Tagen und Entspannen in der Universitätsstadt",
        highlight_description_project:
          "The GHOTEL hotel &amp; living in Göttingen welcomes its guests in an attractive location. The hotel invites holiday and business customers to stay and meet in a traffic-favorable neighbourhood. Thanks to a rebranding from InterCity Hotel to GHOTEL hotel &amp; living and simultaneous renovation in 2018, the hotel chain's building shines in new splendour – inside and out. Clear forms and warm colours ensure a pleasant stay in the historic university town of Lower Saxony.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment ",
        location: "Bahnhofsallee 1a, 37981 Göttingen ",
        property: "3,658 m²",
        area: "7,448 m²",
        zertifizierung: "",
        parcels: "18",
        use_for: "Hotel, Games Library",
        acquired: "Q2 2020",
        realization: "2000",
        sale: "",
        architecture_firm: "",
        place: "Göttingen",
        fakten: [
          {
            bezeichnung: "Tenant",
            wert: "Ghotel GmbH, Merkur Spiel GmbH",
            anchor: "",
          },
        ],
        specifications_image_projects: 16949,
        slider: null,
        title_details_projects: "GHOTEL hotel & living in Detail",
        details_repeater_projects: [
          {
            title_repeater_details: "Well positioned due to rebranding",
            description_repeater_details:
              "Friendly facades, an open reception area and natural materials and fabrics in the 144 rooms ensure a successful stay. Seven conference rooms, which can be flexibly extended, meet the most diverse requirements of contemporary meeting and conference culture. In addition, the GHOTEL hotel &amp; living Göttingen convinces with extensive amenities: A restaurant with a cosy outdoor area ensures relaxation after an eventful day. A sauna area is also available for relaxation and regeneration.",
            image_repeater_details: 16951,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Modern flair in a city centre location",
            description_repeater_details:
              "Due to the location of Göttingen's main railway station in the immediate vicinity, the GHOTEL has excellent connections. As a central conference and congress location, the hotel optimally serves the needs of its guests. In addition, they can take advantage of the wide range of restaurants in Gottingen's city centre, which can be reached quickly and easily on foot from the hotel.",
            image_repeater_details: 16947,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Bahnhofsallee 1a, Göttingen, Deutschland",
          lat: 51.535713,
          lng: 9.922768699999999,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | GHOTEL hotel &amp; living</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/ghotel-hotel-living-goettingen/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | GHOTEL hotel &amp; living" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/ghotel-hotel-living-goettingen/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-30T08:38:27+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/07/GHotel-Goettingen.jpg" />\n\t<meta property="og:image:width" content="1280" />\n\t<meta property="og:image:height" content="720" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/ghotel-hotel-living-goettingen/","url":"https://www.art-invest.de/en/projekt/ghotel-hotel-living-goettingen/","name":"Art-Invest Real Estate | GHOTEL hotel & living","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-07-28T14:52:03+00:00","dateModified":"2020-07-30T08:38:27+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/ghotel-hotel-living-goettingen/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/ghotel-hotel-living-goettingen/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/ghotel-hotel-living-goettingen/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"GHOTEL hotel &#038; living"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | GHOTEL hotel & living",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/ghotel-hotel-living-goettingen/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | GHOTEL hotel & living",
        og_url:
          "https://www.art-invest.de/en/projekt/ghotel-hotel-living-goettingen/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-30T08:38:27+00:00",
        og_image: [
          {
            width: 1280,
            height: 720,
            url: "https://www.art-invest.de/wp-content/uploads/2020/07/GHotel-Goettingen.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/ghotel-hotel-living-goettingen/",
              url: "https://www.art-invest.de/en/projekt/ghotel-hotel-living-goettingen/",
              name: "Art-Invest Real Estate | GHOTEL hotel & living",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-07-28T14:52:03+00:00",
              dateModified: "2020-07-30T08:38:27+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/ghotel-hotel-living-goettingen/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/ghotel-hotel-living-goettingen/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/ghotel-hotel-living-goettingen/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "GHOTEL hotel & living",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/07/GHotel-Goettingen-800x720.jpg",
      place: "Göttingen",
      subtitle: "Tagen & Entspannen in Uni-Stadt",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16979",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16949",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16979",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16979",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16631,
      date: "2014-12-16T12:00:07",
      date_gmt: "2014-12-16T11:00:07",
      guid: {
        rendered: "https://www.art-invest.de/projekt/alter-wall-3840/",
      },
      modified: "2023-10-09T10:38:29",
      modified_gmt: "2023-10-09T08:38:29",
      slug: "alter-wall-3840",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/alter-wall-3840/",
      title: {
        rendered: "Alter Wall 38",
      },
      featured_media: 25586,
      template: "",
      projekt_filter: [246, 250, 248, 254, 427, 425],
      acf: {
        highlight_image: 25586,
        highlight_title_project: "Alter Wall 38",
        highlight_subtitle_project: "Neue City-Verbindung im Herzen Hamburgs",
        highlight_description_project:
          "The building forms the end piece of the new city axis: The bright entrance area opens up to approx. 1500 m² of usable space, predominantly work areas on six floors. Various forms of office organization can be realized here with different characteristics: from cellular offices to open-plan and combined offices, every company finds its home in the building at Alsterfleet.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Development",
        location: "Alter Wall 38, 20457 Hamburg; City",
        property: "1,500 m²",
        area: "14,200 m² BGF",
        zertifizierung: "",
        parcels: "",
        use_for: "Office, Gastronomy",
        acquired: "Q1 2015",
        realization: "2025",
        sale: "",
        architecture_firm: "Kunst & Herbert",
        place: "Hamburg",
        fakten: null,
        specifications_image_projects: 19795,
        slider: [25586, 25588],
        title_details_projects: "ALTER WALL 38 IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Working at the top ",
            description_repeater_details:
              'The Alter Wall 38 has been fully leased since 2023 and, upon completion, will welcome its two tenants to over 9,800 m² of office space on 9 floors as well as over 1,200 m² of restaurant space overlooking the Fleet. In the future, the "House of Parliament" will welcome the citizens of Hamburg in the open reception area on the first floor and offer the employees of the political parties and parliamentary groups a shared workplace in the heart of the city and right next to the City Hall. At lunchtime and in the evening, the old-established brewery will once again offer rustic delicacies and home-brewed beer. We warmly welcome our tenants "Haus der Bürgerschaft" and "Brauhaus Johannes Albrecht".',
            image_repeater_details: 25588,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "The Brauhaus zum Fleet ",
            description_repeater_details:
              'The brewing water is bubbling again. The so-called "Brauhaus" is committed to the craft of brewing as well as excellent food in the ground floor rooms. Almost like in the 16th century – at that time Hamburg was called the brewery house of the Hanseatic League with 600 breweries. Brewing was considered a civic art, the Alsterfleet provided the water and the Bavarians has been the role model due to their purity law.',
            image_repeater_details: 19795,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Forum for exchange ",
            description_repeater_details:
              "The building is located in the direct vicinity of the Alter Wall ensemble with its mix of working, shopping and cultural worlds. Beyond the Alter Wall ensemble, the boulevard offers green and open spaces – and a forum, which has all the prerequisites to become a lively meeting place in the city centre.",
            image_repeater_details: 19797,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Alter Wall 38-40, Hamburg (City)",
          lat: 53.5501099,
          lng: 9.989602500000046,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Alter Wall 38</title>\n<meta name="description" content="Der neue Standort der Handelskammer mit dem Campus der Hamburg School of Business Administration im Alten Wall 38-40 schafft Begegnungs- und Austauschräume." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/alter-wall-3840/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Alter Wall 38" />\n<meta property="og:description" content="Der neue Standort der Handelskammer mit dem Campus der Hamburg School of Business Administration im Alten Wall 38-40 schafft Begegnungs- und Austauschräume." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/alter-wall-3840/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-10-09T08:38:29+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2014/12/MicrosoftTeams-image-8-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1736" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/alter-wall-3840/","url":"https://www.art-invest.de/en/projekt/alter-wall-3840/","name":"Art-Invest Real Estate | Alter Wall 38","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-12-16T11:00:07+00:00","dateModified":"2023-10-09T08:38:29+00:00","description":"Der neue Standort der Handelskammer mit dem Campus der Hamburg School of Business Administration im Alten Wall 38-40 schafft Begegnungs- und Austauschräume.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/alter-wall-3840/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/alter-wall-3840/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/alter-wall-3840/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Alter Wall 38"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Alter Wall 38",
        description:
          "Der neue Standort der Handelskammer mit dem Campus der Hamburg School of Business Administration im Alten Wall 38-40 schafft Begegnungs- und Austauschräume.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/alter-wall-3840/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Alter Wall 38",
        og_description:
          "Der neue Standort der Handelskammer mit dem Campus der Hamburg School of Business Administration im Alten Wall 38-40 schafft Begegnungs- und Austauschräume.",
        og_url: "https://www.art-invest.de/en/projekt/alter-wall-3840/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-10-09T08:38:29+00:00",
        og_image: [
          {
            width: 2560,
            height: 1736,
            url: "https://www.art-invest.de/wp-content/uploads/2014/12/MicrosoftTeams-image-8-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/alter-wall-3840/",
              url: "https://www.art-invest.de/en/projekt/alter-wall-3840/",
              name: "Art-Invest Real Estate | Alter Wall 38",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-12-16T11:00:07+00:00",
              dateModified: "2023-10-09T08:38:29+00:00",
              description:
                "Der neue Standort der Handelskammer mit dem Campus der Hamburg School of Business Administration im Alten Wall 38-40 schafft Begegnungs- und Austauschräume.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/alter-wall-3840/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/alter-wall-3840/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/alter-wall-3840/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Alter Wall 38",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2014/12/MicrosoftTeams-image-8-800x800.jpg",
      place: "Hamburg",
      subtitle: "Hamburgs neue City-Verbindung",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16631",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25588",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25586",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25586",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16631",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16631",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 19500,
      date: "2021-10-22T10:08:22",
      date_gmt: "2021-10-22T08:08:22",
      guid: {
        rendered: "https://www.art-invest.de/projekt/r139-muenchen/",
      },
      modified: "2022-01-11T11:29:17",
      modified_gmt: "2022-01-11T10:29:17",
      slug: "r139-muenchen",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/r139-muenchen/",
      title: {
        rendered: "R139",
      },
      featured_media: 19359,
      template: "",
      projekt_filter: [246, 427, 249, 425, 245],
      acf: {
        highlight_image: 19367,
        highlight_title_project: "R139",
        highlight_subtitle_project:
          "Flexible Büroräume mit einzigartiger Aussicht",
        highlight_description_project:
          "The R139 office tower in the Berg am Laim district impresses with its striking location including excellent transport links. On 14 floors, the building offers flexible space designs – individual offices as well as open-plan offices and coworking spaces can be adapted to any individual need. The spaces are pleasantly bright and offer a breathtaking view of the Ostbahnhof, Munich's skyline and the Alpine panorama on the upper floors.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: {
          title: "zum Flächenangebot",
          url: "https://www.aire-mag.com/de/flaechen/r139",
          target: "_blank",
        },
        project: "Investment",
        location: "Rosenheimer Straße 139, 81671 Munich",
        property: "3,594 m²",
        area: "11,110 m²",
        zertifizierung: "",
        parcels: "123",
        use_for: "Office, Retail",
        acquired: "2019",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "München",
        fakten: null,
        specifications_image_projects: 19361,
        slider: [19363, 19365, 19361, 19359],
        title_details_projects: "R139 IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              " Dynamic and inspiring: the nearby Werksviertel",
            description_repeater_details:
              "Where Munich's nightlife was active a few years ago, one of the city's most exciting new micro-neighbourhoods, the Werksviertel, is taking shape near the R139. Perfectly connected to the existing infrastructure, an urban creative quarter is now growing on the tradition-steeped site with an innovative mix of apartments, loft offices, art and concert spaces, local supply stores and in-locations. As a symbol of this creativity, the Munich Concert Hall is also to be built in the Werksviertel – a decision with a signalling effect, which at the same time underlines the dynamism and value of the location. Well-known companies such as Deloitte, Wacker Chemie, the German Patent Office, Design Offices and KPMG have already recognized the advantages of the up-and-coming area and settled here.",
            image_repeater_details: 19363,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "In the east of Munich with excellent transport links",
            description_repeater_details:
              "The R139 benefits from excellent connections to the public transport system as well as the supra-regional road network. Due to the proximity to the Ostbahnhof – the second largest train station in Bavaria – the S-Bahn and U-Bahn along with long-distance traffic can be reached by feet. Immediately in front of the building there is also a bus stop, whereby the main train station and the airport can be reached quickly and easily. Drivers appreciate the direct connections to Munich's major ring roads and arterial roads in addition to the numerous parking spaces.",
            image_repeater_details: 19361,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Rosenheimer Straße 139, 81671 München, Deutschland",
          lat: 48.1242436,
          lng: 11.6019889,
          zoom: 14,
          place_id: "ChIJsynneIPfnUcRgfz7jReJcFk",
          name: "Rosenheimer Str. 139",
          street_number: 139,
          street_name: "Rosenheimer Straße",
          street_name_short: "Rosenheimer Str.",
          city: "München",
          state: "Bayern",
          state_short: "BY",
          post_code: 81671,
          country: "Deutschland",
          country_short: "DE",
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | R139</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/r139-muenchen/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | R139" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/r139-muenchen/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-01-11T10:29:17+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2021/10/r139-rainer-taepper-architekturfotografie-05.jpg" />\n\t<meta property="og:image:width" content="1379" />\n\t<meta property="og:image:height" content="920" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/r139-muenchen/","url":"https://www.art-invest.de/en/projekt/r139-muenchen/","name":"Art-Invest Real Estate | R139","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2021-10-22T08:08:22+00:00","dateModified":"2022-01-11T10:29:17+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/r139-muenchen/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/r139-muenchen/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/r139-muenchen/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"R139"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | R139",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/r139-muenchen/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | R139",
        og_url: "https://www.art-invest.de/en/projekt/r139-muenchen/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-01-11T10:29:17+00:00",
        og_image: [
          {
            width: 1379,
            height: 920,
            url: "https://www.art-invest.de/wp-content/uploads/2021/10/r139-rainer-taepper-architekturfotografie-05.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/r139-muenchen/",
              url: "https://www.art-invest.de/en/projekt/r139-muenchen/",
              name: "Art-Invest Real Estate | R139",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2021-10-22T08:08:22+00:00",
              dateModified: "2022-01-11T10:29:17+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/r139-muenchen/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/r139-muenchen/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/r139-muenchen/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "R139",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2021/10/r139-rainer-taepper-architekturfotografie-05-800x800.jpg",
      place: "München",
      subtitle: "Flexible Büros. Einzigartige Aussicht.",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/19500",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19359",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19361",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19365",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19363",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19359",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=19500",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=19500",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21591,
      date: "2022-08-18T11:51:12",
      date_gmt: "2022-08-18T09:51:12",
      guid: {
        rendered: "https://www.art-invest.de/projekt/frankfurter-ring/",
      },
      modified: "2022-10-25T10:59:17",
      modified_gmt: "2022-10-25T08:59:17",
      slug: "frankfurter-ring",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/frankfurter-ring/",
      title: {
        rendered: "Frankfurter Ring 150",
      },
      featured_media: 21182,
      template: "",
      projekt_filter: [246, 427, 249, 425, 245],
      acf: {
        highlight_image: 21182,
        highlight_title_project: "Frankfurter Ring 150",
        highlight_subtitle_project:
          "Vielfältiger Nutzungsmix im Münchner Norden",
        highlight_description_project:
          "In the up-and-coming north of Munich, in the district of Schwabing-Freimann, the Frankfurter Ring 150 plot, which covers more than 10,000 sqm, consists of five different buildings constructed between 1955 and 1983. Until the 1990s, the plot was used by the Franz Schneider Verlag publishing house and today represents a colorful mix of office and commercial space. The four-story office building belonging to the building complex was extensively renovated in 2016 to 2017 and is particularly impressive with its striking view over Munich. Another office building, spacious ateliers, a studio and a shed roof hall with a room height of approx. eight meters and studio windows have already attracted an attractive tenant base.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment",
        location: "Frankfurter Ring 150, 80807 Munich, Germany",
        property: "10,262 sqm",
        area: "8,600 sqm",
        zertifizierung: "",
        parcels: "80",
        use_for: "Office, Commercial",
        acquired: "2022",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "",
        fakten: null,
        specifications_image_projects: 21182,
        slider: [21182],
        title_details_projects: "Frankfurter Ring in Detail",
        details_repeater_projects: [
          {
            title_repeater_details:
              "Prime location at an innovative commercial site",
            description_repeater_details:
              "Frankfurter Ring 150 is in a prime location in the Schwabing-Freimann district, Munich's third largest district, which connects the almost rural Freimann with the vibrant Schwabing. The formerly very industrial commercial strip is currently experiencing a strong upswing due to innovative new utilization concepts and is increasingly perceived as an attractive office and commercial district. The proximity to the modern new residential development Domagkpark and the residential and commercial quarter Parkstadt Schwabing, one of the most ambitious urban development projects in Munich, are further plus points that make the office and commercial location Frankfurter Ring particularly interesting.",
            image_repeater_details: 21182,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Good accessibility by car and public transport",
            description_repeater_details:
              "Conveniently located in the north of Munich between the B 13 / Ingolstädter Straße and the A 9 freeway, the building complex is very easy to reach by car. The connection to the Munich city center, but also to the airport is optimal. A bus stop is located directly in front of the building complex, the streetcar stop Schwabing-Nord can be reached within a few minutes by foot, and the subway stop Frankfurter Ring too as a junction can be reached by foot in less than 15 minutes and guarantees convenient public transport connections at short intervals.",
            image_repeater_details: 21182,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Frankfurter Ring 150, 80807 München, Deutschland",
          lat: 48.187666,
          lng: 11.5866361,
          zoom: 14,
          place_id: "ChIJL0P7lzt0nkcRYq2dAPxcwiY",
          name: "Frankfurter Ring 150",
          street_number: 150,
          street_name: "Frankfurter Ring",
          city: "München",
          state: "Bayern",
          state_short: "BY",
          post_code: 80807,
          country: "Deutschland",
          country_short: "DE",
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Frankfurter Ring 150, Munich</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/frankfurter-ring/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Frankfurter Ring 150, Munich" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/frankfurter-ring/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-25T08:59:17+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2022/08/DJI_0301.jpg" />\n\t<meta property="og:image:width" content="1832" />\n\t<meta property="og:image:height" content="1030" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/frankfurter-ring/","url":"https://www.art-invest.de/en/projekt/frankfurter-ring/","name":"Art-Invest Real Estate | Frankfurter Ring 150, Munich","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2022-08-18T09:51:12+00:00","dateModified":"2022-10-25T08:59:17+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/frankfurter-ring/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/frankfurter-ring/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/frankfurter-ring/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Frankfurter Ring 150, Munich"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Frankfurter Ring 150, Munich",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/frankfurter-ring/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Frankfurter Ring 150, Munich",
        og_url: "https://www.art-invest.de/en/projekt/frankfurter-ring/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-25T08:59:17+00:00",
        og_image: [
          {
            width: 1832,
            height: 1030,
            url: "https://www.art-invest.de/wp-content/uploads/2022/08/DJI_0301.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/frankfurter-ring/",
              url: "https://www.art-invest.de/en/projekt/frankfurter-ring/",
              name: "Art-Invest Real Estate | Frankfurter Ring 150, Munich",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2022-08-18T09:51:12+00:00",
              dateModified: "2022-10-25T08:59:17+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/frankfurter-ring/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/frankfurter-ring/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/frankfurter-ring/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Frankfurter Ring 150, Munich",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2022/08/DJI_0301-800x800.jpg",
      place: "München",
      subtitle: "Münchner Norden – Vielfalt vereint",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21591",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21182",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21182",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21591",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21591",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },

    {
      id: 21592,
      date: "2022-06-20T15:51:42",
      date_gmt: "2022-06-20T13:51:42",
      guid: {
        rendered: "https://www.art-invest.de/projekt/coloria-erfurt/",
      },
      modified: "2023-10-17T14:08:29",
      modified_gmt: "2023-10-17T12:08:29",
      slug: "coloria-erfurt",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/coloria-erfurt/",
      title: {
        rendered: "Coloria",
      },
      featured_media: 20790,
      template: "",
      projekt_filter: [427, 252, 425, 245, 263],
      acf: {
        highlight_image: 20790,
        highlight_title_project: "Coloria",
        highlight_subtitle_project: "Erholung im Grünen",
        highlight_description_project:
          "With Coloria in Erfurt, Art-Invest Real Estate has acquired its first project in the Thuringian state capital. The modern residential project with a commercial component is being built in the southeastern district of Daberstedt, which combines the lively character of the adjacent old town of Erfurt with the local recreation factor of the magnificent Steigerwald forest. Complementing a promising construction method, the ensemble guarantees comfortable living through short distances and high-quality furnishings.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment ",
        location:
          "Peter-Vischer-Weg 1, 3, 5,12 | Buddestraße 10-15, 99099 Erfurt, Germany",
        property: "Approx. 12,600 sqm",
        area: "Living space: 13,000 sqm, commercial space: 1,900 sqm\t",
        zertifizierung: "",
        parcels:
          "167 underground parking spaces; additional 28 outdoor parking\tspaces",
        use_for: "Residential, Commercial",
        acquired: "1st Quarter 2022",
        realization: "2nd Quarter 2024",
        sale: "",
        architecture_firm:
          "Junk & Reich Architekten BDA, Planungsgesellschaft mbH, Weimar",
        place: "",
        fakten: null,
        specifications_image_projects: 20784,
        slider: [20788, 20786, 20790, 20784, 20782],
        title_details_projects: "",
        details_repeater_projects: [
          {
            title_repeater_details:
              "Comfortable living with a view to the future",
            description_repeater_details:
              "A total of seven buildings with 155 rental apartments and nine commercial units will be built by mid-2024. In addition to six four- to six-story apartment buildings, an existing eight-story high-rise is being revitalized and supplemented with a stacked floor. Each building will be constructed to the energy efficient KfW 55 standard. The compact and well-designed floor plans are ideally suited for singles, couples and families and are oriented to the current living needs of people of all ages and life situations. The basic equipment of each apartment includes a modern fitted kitchen, underfloor heating and balcony, terrace, or loggia. The area is complemented by quiet, landscaped courtyards with play areas for children and places for socializing and recreation. All apartments are accessible barrier-free via elevators; outdoor and underground parking spaces with charging points for electric cars complete the ensemble.",
            image_repeater_details: 20784,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Short distances in the neighborhood",
            description_repeater_details:
              'The Coloria already convinces with well thought-out supply offers on its own property. The existing building will include a daycare center with 69 places and a bakery with an outdoor terrace. Along the street "Am Schwemmbach", a medical center with a pharmacy is planned to ensure short distances for future tenants. The direct surroundings offer easy access to recreational areas, school, and sports facilities. The high-quality range of workplaces completes the excellent infrastructure in the immediate vicinity.',
            image_repeater_details: 20782,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Buddestraße 10-15, 99099 Erfurt, Deutschland",
          lat: 50.9627737,
          lng: 11.0505901,
          zoom: 14,
          place_id:
            "EiZCdWRkZXN0cmHDn2UgMTAsIDk5MDk5IEVyZnVydCwgR2VybWFueSJQEk4KNAoyCaUgKv3McqRHEV-owIAMo-EnGh4LEO7B7qEBGhQKEgmrsYoyOg2kRxEwF8nIxI4gHAwQCioUChIJx1CkXsxypEcRmJgoXJ48gso",
          name: "Buddestraße 10",
          street_number: 10,
          street_name: "Buddestraße",
          city: "Erfurt",
          city_short: "EF",
          state: "Thüringen",
          state_short: "TH",
          post_code: 99099,
          country: "Deutschland",
          country_short: "DE",
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Coloria, Erfurt</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/coloria-erfurt/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Coloria, Erfurt" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/coloria-erfurt/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-10-17T12:08:29+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2022/06/Visualisierung1.jpg" />\n\t<meta property="og:image:width" content="946" />\n\t<meta property="og:image:height" content="453" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/coloria-erfurt/","url":"https://www.art-invest.de/en/projekt/coloria-erfurt/","name":"Art-Invest Real Estate | Coloria, Erfurt","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2022-06-20T13:51:42+00:00","dateModified":"2023-10-17T12:08:29+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/coloria-erfurt/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/coloria-erfurt/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/coloria-erfurt/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Coloria, Erfurt"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Coloria, Erfurt",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/coloria-erfurt/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Coloria, Erfurt",
        og_url: "https://www.art-invest.de/en/projekt/coloria-erfurt/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-10-17T12:08:29+00:00",
        og_image: [
          {
            width: 946,
            height: 453,
            url: "https://www.art-invest.de/wp-content/uploads/2022/06/Visualisierung1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/coloria-erfurt/",
              url: "https://www.art-invest.de/en/projekt/coloria-erfurt/",
              name: "Art-Invest Real Estate | Coloria, Erfurt",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2022-06-20T13:51:42+00:00",
              dateModified: "2023-10-17T12:08:29+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/coloria-erfurt/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/coloria-erfurt/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/coloria-erfurt/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Coloria, Erfurt",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2022/06/Visualisierung1-800x453.jpg",
      place: "Erfurt",
      subtitle: "Erholung im Grünen",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21592",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20782",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20784",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20790",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20786",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20788",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20790",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21592",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21592",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 17104,
      date: "2020-08-26T08:10:03",
      date_gmt: "2020-08-26T08:10:03",
      guid: {
        rendered: "https://www.art-invest.de/projekt/q11-leben-am-fluss/",
      },
      modified: "2020-08-27T11:22:54",
      modified_gmt: "2020-08-27T09:22:54",
      slug: "q11-leben-am-fluss",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/q11-leben-am-fluss/",
      title: {
        rendered: "Q11 – Leben am Fluss",
      },
      featured_media: 17056,
      template: "",
      projekt_filter: [246, 427, 252, 425, 245, 263],
      acf: {
        highlight_image: 17052,
        highlight_title_project: "Q11 – Leben am Fluss",
        highlight_subtitle_project: "Zwischen Fluss und Stadtzentrum",
        highlight_description_project:
          "In the Q11 residential complex, future tenants will find a home between the alpine panorama, the river and the city center. The new building, which is part of the first construction phase of a neighborhood development, guarantees cross-generational living in an excellent environment. In addition, three commercial areas on the first floor and a good connection to the city center enhance the attractiveness of the location.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location: "Rennbahnstraße 2-4, 3100 St. Pölten/Austria ",
        property: "4,300 m² ",
        area: "8,560.67 m² weighted residential space and 838.01 m² weighted office and retail space",
        zertifizierung: "",
        parcels: "9",
        use_for: "mixed-use property (mainly residential use) ",
        acquired: "2020",
        realization: "Q2 2020",
        sale: "Q3 2020",
        architecture_firm: "Maurer & Partner ZT GmbH",
        place: "St. Pölten, Austria",
        fakten: null,
        specifications_image_projects: 17054,
        slider: null,
        title_details_projects: "Q11 – Leben am Fluss in Detail",
        details_repeater_projects: [
          {
            title_repeater_details: "New building with a future",
            description_repeater_details:
              "In almost all apartments, tenants have either access to modern balconies and loggias or on the first floor gardens and terraces. In addition to the comfort of the open spaces, all residential units are designed barrier-free. In the inner courtyard of Q11, well-kept lawns and a spacious playground with seating facilities await the residents. In addition, one of the three commercial areas on the first floor is to be converted into a bakery and/or bistro. The modern facade design and the high-quality outdoor facilities complete the advantageous location of the Q11 between green spaces and the city center.",
            image_repeater_details: 17080,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Well connected with a view of the Alps",
            description_repeater_details:
              "Directly in front of the new building project is the river Traisen together with a recreation area. If the weather is fine, tenants can even see the foothills of the Alps. But the Q11 is not only convincing because of its idyllic surroundings, but also because of its location close to the city center and good connections. Both the train station and the city center with its wide range of restaurants are within walking distance.",
            image_repeater_details: 17082,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Rennbahnstraße 2-4, 3100 St. Pölten, Österreich",
          lat: 48.2073188,
          lng: 15.6340692,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Q11 – Leben am Fluss</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/q11-leben-am-fluss/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Q11 – Leben am Fluss" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/q11-leben-am-fluss/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-08-27T09:22:54+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/08/Q11_Leben_am_Fluss_Ansicht-in-Richtung-Rennbahnstrase.jpg" />\n\t<meta property="og:image:width" content="1330" />\n\t<meta property="og:image:height" content="886" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/q11-leben-am-fluss/","url":"https://www.art-invest.de/en/projekt/q11-leben-am-fluss/","name":"Art-Invest Real Estate | Q11 – Leben am Fluss","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-08-26T08:10:03+00:00","dateModified":"2020-08-27T09:22:54+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/q11-leben-am-fluss/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/q11-leben-am-fluss/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/q11-leben-am-fluss/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Q11 – Leben am Fluss"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Q11 – Leben am Fluss",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/q11-leben-am-fluss/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Q11 – Leben am Fluss",
        og_url: "https://www.art-invest.de/en/projekt/q11-leben-am-fluss/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-08-27T09:22:54+00:00",
        og_image: [
          {
            width: 1330,
            height: 886,
            url: "https://www.art-invest.de/wp-content/uploads/2020/08/Q11_Leben_am_Fluss_Ansicht-in-Richtung-Rennbahnstrase.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/q11-leben-am-fluss/",
              url: "https://www.art-invest.de/en/projekt/q11-leben-am-fluss/",
              name: "Art-Invest Real Estate | Q11 – Leben am Fluss",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-08-26T08:10:03+00:00",
              dateModified: "2020-08-27T09:22:54+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/q11-leben-am-fluss/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/q11-leben-am-fluss/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/q11-leben-am-fluss/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Q11 – Leben am Fluss",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/08/Q11_Leben_am_Fluss_Ansicht-in-Richtung-Rennbahnstrase-800x800.jpg",
      place: "St. Pölten, Austria",
      subtitle: "Zwischen Fluss und Stadtzentrum",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/17104",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/17056",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=17104",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=17104",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 18773,
      date: "2021-06-16T17:10:25",
      date_gmt: "2021-06-16T15:10:25",
      guid: {
        rendered: "https://www.art-invest.de/projekt/opern-plaza/",
      },
      modified: "2021-06-21T13:09:05",
      modified_gmt: "2021-06-21T11:09:05",
      slug: "opern-plaza",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/opern-plaza/",
      title: {
        rendered: "Opern Plaza",
      },
      featured_media: 18723,
      template: "",
      projekt_filter: [246, 248, 427, 425, 245],
      acf: {
        highlight_image: 18733,
        highlight_title_project: "Opern Plaza",
        highlight_subtitle_project: "Dammtorstraße mit neuem Gesicht",
        highlight_description_project:
          "The Opern Plaza is located in the heart of Hamburg's city center, opposite the Hamburg State Opera. Developed with the highest standards of sustainability, the commercial building offers more than 17,000 m² of modern offices as well as attractive retail space and trendy restaurant concepts on the first floor. Users as well as neighbors and passers-by benefit from the exclusive tenant mix. The property has a beautiful atrium and is located in the highly frequented Dammtorstrasse – the center of metropolitan life.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: {
          title: "zum Flächenangebot",
          url: "https://www.aire-mag.com/de/flaechen/opern-plaza",
          target: "_blank",
        },
        project: "Investment (existing property)",
        location: "BID Dammtorstraße ",
        property: "2,203 m²",
        area: "17,256 m² (rental space)",
        zertifizierung: "",
        parcels: "54",
        use_for: "Offie, Retail, Catering",
        acquired: "2021",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Hamburg",
        fakten: null,
        specifications_image_projects: 18729,
        slider: null,
        title_details_projects: "OPERN PLAZA IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Highest standards of sustainability",
            description_repeater_details:
              "The ten-story Opern Plaza building, which has been awarded Gold certification by the DGNB, plays a key role in shaping the cityscape of the redesigned Dammtorstrasse. Particular importance was attached to the sustainable use of the rental space. The existing property is located in a prime city center location and is a preferred contact point for many user groups due to the wide range of offers as well as numerous parking spaces in the three basement levels.",
            image_repeater_details: 18731,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Fantastic location in the middle of the city",
            description_repeater_details:
              "Dammtorstrasse marks the gateway to Hamburg's city center. In the immediate vicinity of the Dammtor train station, Gänsemarkt and Stephansplatz, it is easily accessible thanks to ideal transport links. The location offers a wide range of employment opportunities: In the immediate vicinity you will find renowned cultural venues, cafés and restaurants, as well as a wide selection of stores. Additionally, the Außenalster lake is only a few meters away - probably the most popular recreation area in the Hanseatic city for walkers and joggers.",
            image_repeater_details: 18725,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Dammtorstraße, Hamburg, Deutschland",
          lat: 53.5570539,
          lng: 9.988409299999999,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Opern Plaza</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/opern-plaza/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Opern Plaza" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/opern-plaza/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-06-21T11:09:05+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2021/06/HH_Opern-Plaza_Aussenansicht_1.jpg" />\n\t<meta property="og:image:width" content="1200" />\n\t<meta property="og:image:height" content="1092" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/opern-plaza/","url":"https://www.art-invest.de/en/projekt/opern-plaza/","name":"Art-Invest Real Estate | Opern Plaza","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2021-06-16T15:10:25+00:00","dateModified":"2021-06-21T11:09:05+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/opern-plaza/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/opern-plaza/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/opern-plaza/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Opern Plaza"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Opern Plaza",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/opern-plaza/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Opern Plaza",
        og_url: "https://www.art-invest.de/en/projekt/opern-plaza/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-06-21T11:09:05+00:00",
        og_image: [
          {
            width: 1200,
            height: 1092,
            url: "https://www.art-invest.de/wp-content/uploads/2021/06/HH_Opern-Plaza_Aussenansicht_1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/opern-plaza/",
              url: "https://www.art-invest.de/en/projekt/opern-plaza/",
              name: "Art-Invest Real Estate | Opern Plaza",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2021-06-16T15:10:25+00:00",
              dateModified: "2021-06-21T11:09:05+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/opern-plaza/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/opern-plaza/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/opern-plaza/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Opern Plaza",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2021/06/HH_Opern-Plaza_Aussenansicht_1-800x800.jpg",
      place: "Hamburg",
      subtitle: "Dammtorstraße mit neuem Gesicht",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/18773",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18723",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=18773",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=18773",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 19498,
      date: "2021-10-22T09:49:00",
      date_gmt: "2021-10-22T07:49:00",
      guid: {
        rendered: "https://www.art-invest.de/projekt/hohe1/",
      },
      modified: "2022-01-11T11:29:00",
      modified_gmt: "2022-01-11T10:29:00",
      slug: "hohe1",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/hohe1/",
      title: {
        rendered: "Hohe1",
      },
      featured_media: 19355,
      template: "",
      projekt_filter: [246, 427, 249, 425],
      acf: {
        highlight_image: 19353,
        highlight_title_project: "Hohe1",
        highlight_subtitle_project: "Flexible Büroräume",
        highlight_description_project:
          "Art-Invest Real Estate has invested in the Hohe1, another major city project in an attractive location: The seminal district of Steinhausen-Zamdorf is currently enjoying a significant upgrade thanks to many new settlements. Between prestigious new construction projects, such as the Bavaria Towers, and established developments, such as the SZ-Tower, the property offers a wide range of opportunities due to its flexible space design – quiet individual offices as well as open-plan concepts and coworking spaces.",
        highlight_logo_project: 19351,
        website_projects: "",
        external_projectpage: "",
        available_space: {
          title: "zum Flächenangebot",
          url: "https://www.aire-mag.com/de/flaechen/hohe1",
          target: "_blank",
        },
        project: "Investment",
        location: "Hohenlindenerstraße 1+2, 81677 Munich",
        property: "7,039 m²",
        area: "11,808 m²",
        zertifizierung: "",
        parcels: "150",
        use_for: "Office, Catering",
        acquired: "2019",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "München",
        fakten: null,
        specifications_image_projects: 19353,
        slider: [19355, 19353],
        title_details_projects: "HOHE1 IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Magnificent view over Munich and the Alps",
            description_repeater_details:
              "The 8-storey building convinces with flexible floor plans and practically divided office spaces that can be used individually. Tenants enjoy a prestigious entrance and a spacious roof terrace accessible to all users. From here and from the upper floors, the unique view over the roofs of Munich to the Alps is a special highlight. Well-known companies such as Samsung, Giesecke+Devrient, Süddeutsche Zeitung and Thyssenkrupp already recognized the advantages of the location and have settled in the immediate neighbourhood.",
            image_repeater_details: 19355,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Perfect transport links in an attractive district",
            description_repeater_details:
              'This well-known first class location in Munich\'s East offers perfect transportation links to the A94 freeway and the Mittlerer Ring. From here, all of Munich\'s important spots can be reached quickly. The public transportation system also leaves nothing to be desired: The "Riedenburger Straße" stop on line 19 is directly in front of the office building, with which the "Leuchtenbergring" S-Bahn station can be reached in just five minutes. Thus, anyone wishing to visit Munich city center or the trade fair is not far away.',
            image_repeater_details: 19353,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Hohenlindener Straße 1, 81677 München, Deutschland",
          lat: 48.1368952,
          lng: 11.6251466,
          zoom: 14,
          place_id: "ChIJXQfKCGd1nkcRxsVMMksXRYs",
          name: "Hohenlindener Str. 1",
          street_number: 1,
          street_name: "Hohenlindener Straße",
          street_name_short: "Hohenlindener Str.",
          city: "München",
          state: "Bayern",
          state_short: "BY",
          post_code: 81677,
          country: "Deutschland",
          country_short: "DE",
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Hohe1</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/hohe1/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Hohe1" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/hohe1/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-01-11T10:29:00+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2021/10/HL1_Ansicht_1.jpg" />\n\t<meta property="og:image:width" content="1225" />\n\t<meta property="og:image:height" content="920" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/hohe1/","url":"https://www.art-invest.de/en/projekt/hohe1/","name":"Art-Invest Real Estate | Hohe1","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2021-10-22T07:49:00+00:00","dateModified":"2022-01-11T10:29:00+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/hohe1/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/hohe1/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/hohe1/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Hohe1"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Hohe1",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/hohe1/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Hohe1",
        og_url: "https://www.art-invest.de/en/projekt/hohe1/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-01-11T10:29:00+00:00",
        og_image: [
          {
            width: 1225,
            height: 920,
            url: "https://www.art-invest.de/wp-content/uploads/2021/10/HL1_Ansicht_1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/hohe1/",
              url: "https://www.art-invest.de/en/projekt/hohe1/",
              name: "Art-Invest Real Estate | Hohe1",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2021-10-22T07:49:00+00:00",
              dateModified: "2022-01-11T10:29:00+00:00",
              breadcrumb: {
                "@id": "https://www.art-invest.de/en/projekt/hohe1/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/hohe1/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/hohe1/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Hohe1",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2021/10/HL1_Ansicht_1-800x800.jpg",
      place: "München",
      subtitle: "Flexible Büroräume",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/19498",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19353",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19355",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19355",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=19498",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=19498",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16868,
      date: "2018-08-10T16:26:48",
      date_gmt: "2018-08-10T14:26:48",
      guid: {
        rendered: "https://www.art-invest.de/projekt/hotel-maison-messmer/",
      },
      modified: "2020-07-15T11:07:05",
      modified_gmt: "2020-07-15T11:07:05",
      slug: "hotel-maison-messmer",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/hotel-maison-messmer/",
      title: {
        rendered: "Hotel Maison Messmer",
      },
      featured_media: 16870,
      template: "",
      projekt_filter: [251, 427, 425, 263],
      acf: {
        highlight_image: 13862,
        highlight_title_project: "Hotel Maison Messmer",
        highlight_subtitle_project: "Hochkarätiges Ensemble im Kurpark",
        highlight_description_project:
          'In 1834, the original building of today\'s Dorint Hotel Maison Messmer was built directly at the Kurpark Baden-Baden. The building, which was renovated in 2001, is one of the first and best addresses in the spa and cultural city. Acquired for the "Hotel-Manage to Core-Fund", the building is currently being renovated and modernized.',
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location: "Werderstraße 1, 76530 Baden-Baden",
        property: "3,871 m²",
        area: "",
        zertifizierung: "",
        parcels: "64",
        use_for: "Hotel",
        acquired: "Q3 2017",
        realization: "Renovation of rooms and floors are planned for 2018/2019",
        sale: "",
        architecture_firm: "",
        place: "Baden-Baden",
        fakten: [
          {
            bezeichnung: "Design",
            wert: "Wolfgang Altenhofen (1834) – Upgrade will be done by Designer House",
            anchor: "",
          },
        ],
        specifications_image_projects: 7836,
        slider: null,
        title_details_projects: "HOTEL MAISON MESSMER IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Traditional house",
            description_repeater_details:
              'The original hotel was built in 1834 as a summer residence for German regents and was the preferred accommodation for aristocrats, authors and artists. The "Dorint Hotel Maison Messmer" still impresses with its historical appearance, combined with its modern interior design. The impressive painters\' hall is worthy to emphasize.',
            image_repeater_details: 16869,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Relax like in ancient Rome",
            description_repeater_details:
              "The 800 m² spa with Roman design elements is covered by an impressive glass dome. A large pool and numerous offers for relaxation provide an incomparable atmosphere of well-being. A special highlight is the 240 m² penthouse suite with roof terrace and incomparable view of Baden-Baden.",
            image_repeater_details: 7844,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Werderstraße 1, 76530 Baden-Baden, Deutschland",
          lat: 48.7595158,
          lng: 8.236864500000024,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Hotel Maison Messmer</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/hotel-maison-messmer/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Hotel Maison Messmer" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/hotel-maison-messmer/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-15T11:07:05+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2018/08/088_DH_Baden-Baden_FotosBurwitz_Pocha_außen-Tag10-Bearbeitet-1.jpg" />\n\t<meta property="og:image:width" content="2000" />\n\t<meta property="og:image:height" content="1624" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/hotel-maison-messmer/","url":"https://www.art-invest.de/en/projekt/hotel-maison-messmer/","name":"Art-Invest Real Estate | Hotel Maison Messmer","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2018-08-10T14:26:48+00:00","dateModified":"2020-07-15T11:07:05+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/hotel-maison-messmer/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/hotel-maison-messmer/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/hotel-maison-messmer/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Hotel Maison Messmer"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Hotel Maison Messmer",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/hotel-maison-messmer/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Hotel Maison Messmer",
        og_url: "https://www.art-invest.de/en/projekt/hotel-maison-messmer/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-15T11:07:05+00:00",
        og_image: [
          {
            width: 2000,
            height: 1624,
            url: "https://www.art-invest.de/wp-content/uploads/2018/08/088_DH_Baden-Baden_FotosBurwitz_Pocha_außen-Tag10-Bearbeitet-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/hotel-maison-messmer/",
              url: "https://www.art-invest.de/en/projekt/hotel-maison-messmer/",
              name: "Art-Invest Real Estate | Hotel Maison Messmer",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2018-08-10T14:26:48+00:00",
              dateModified: "2020-07-15T11:07:05+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/hotel-maison-messmer/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/hotel-maison-messmer/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/hotel-maison-messmer/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Hotel Maison Messmer",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2018/08/088_DH_Baden-Baden_FotosBurwitz_Pocha_außen-Tag10-Bearbeitet-1-800x800.jpg",
      place: "Baden-Baden",
      subtitle: "Hochkarätiges Ensemble im Kurpark",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16868",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16870",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16868",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16868",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21766,
      date: "2022-10-10T16:32:41",
      date_gmt: "2022-10-10T14:32:41",
      guid: {
        rendered: "https://www.art-invest.de/projekt/richartz-koeln/",
      },
      modified: "2022-11-08T08:53:26",
      modified_gmt: "2022-11-08T07:53:26",
      slug: "richartz-koeln",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/richartz-koeln/",
      title: {
        rendered: "Restaurant Richartz",
      },
      featured_media: 21546,
      template: "",
      projekt_filter: [246, 247, 427, 425, 245],
      acf: {
        highlight_image: 21558,
        highlight_title_project: "Restaurant Richartz",
        highlight_subtitle_project: "Großes Entwicklungspotenzial",
        highlight_description_project:
          "In the immediate vicinity of the cathedral and thus in the heart of Cologne, the Richartz offers sufficient space for offices and business premises on four floors plus a staggered floor. The current total of 3,828 sqm has already been occupied by renowned tenants for many years. The eye-catching corner building with its rounded top was built in 1953, extensively refurbished in the 1980s and still catches the eye when passing by. With a view to the future, the property also offers great potential for urban development, as an increase in the building's height is not ruled out.\r\n\r\n&nbsp;",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Development",
        location:
          "Minoritenstraße / corner Hohe Straße, 50667 Cologne, Germany",
        property: "800 sqm",
        area: "3,828 sqm",
        zertifizierung: "",
        parcels: "",
        use_for: "Office and commercial building",
        acquired: "01.01.2022",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "",
        fakten: null,
        specifications_image_projects: 21544,
        slider: [21546, 21548, 21550, 21552, 21554],
        title_details_projects: "Richartz in Detail",
        details_repeater_projects: [
          {
            title_repeater_details:
              "Central location directly in the pedestrian zone",
            description_repeater_details:
              "The direct location to Hohe Straße - Cologne's main shopping street and one of the busiest shopping streets in Germany - makes the Richartz an attractive property with high visibility, especially for retail and gastronomy. The area around Minoritenstrasse offers a varied range of restaurants in the immediate vicinity that attracts a large audience. The property has a high leasing quality: Currently, the building is 90% fully leased. The last two store spaces are currently attracting a great deal of interest from potential tenants due to their attractive location.",
            image_repeater_details: 21542,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "In the heart of Cologne, in a heavenly neighborhood",
            description_repeater_details:
              "Not only Cologne Cathedral, the city's best-known landmark, is located in the immediate vicinity of the building. The Minorite Church and the last resting place of Adolf Kolping are also only a stone's throw away and, as a tourist magnet, attract additional passers-by to the immediate vicinity of the property. The subway stops Appelhofplatz and Hauptbahnhof (main station) are within walking distance and thus allow easy access. Drivers can also use the parking garage Hohestraße in the immediate vicinity and reach the Richartz in just a few steps.",
            image_repeater_details: 21550,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Minoritenstraße 2-4, 50667 Köln, Deutschland",
          lat: 50.9392454,
          lng: 6.955839799999999,
          zoom: 14,
          place_id: "ChIJe7rIx68lv0cR8aNwF8VahWo",
          name: "Minoritenstraße 2-4",
          street_number: "2-4",
          street_name: "Minoritenstraße",
          city: "Köln",
          state: "Nordrhein-Westfalen",
          state_short: "NRW",
          post_code: 50667,
          country: "Deutschland",
          country_short: "DE",
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Richartz, Köln</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/richartz-koeln/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Richartz, Köln" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/richartz-koeln/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-11-08T07:53:26+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2022/10/ssf_2208_RICHARTZ_01-1.jpg" />\n\t<meta property="og:image:width" content="2500" />\n\t<meta property="og:image:height" content="1786" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/richartz-koeln/","url":"https://www.art-invest.de/en/projekt/richartz-koeln/","name":"Art-Invest Real Estate | Richartz, Köln","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2022-10-10T14:32:41+00:00","dateModified":"2022-11-08T07:53:26+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/richartz-koeln/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/richartz-koeln/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/richartz-koeln/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Richartz, Köln"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Richartz, Köln",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/richartz-koeln/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Richartz, Köln",
        og_url: "https://www.art-invest.de/en/projekt/richartz-koeln/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-11-08T07:53:26+00:00",
        og_image: [
          {
            width: 2500,
            height: 1786,
            url: "https://www.art-invest.de/wp-content/uploads/2022/10/ssf_2208_RICHARTZ_01-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/richartz-koeln/",
              url: "https://www.art-invest.de/en/projekt/richartz-koeln/",
              name: "Art-Invest Real Estate | Richartz, Köln",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2022-10-10T14:32:41+00:00",
              dateModified: "2022-11-08T07:53:26+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/richartz-koeln/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/richartz-koeln/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/richartz-koeln/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Richartz, Köln",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2022/10/ssf_2208_RICHARTZ_01-1-800x800.jpg",
      place: "Köln",
      subtitle: "Großes Entwicklungspotenzial",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21766",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21554",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21552",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21550",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21548",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21546",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21546",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21766",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21766",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16877,
      date: "2014-02-11T12:00:15",
      date_gmt: "2014-02-11T11:00:15",
      guid: {
        rendered: "https://www.art-invest.de/projekt/cbd/",
      },
      modified: "2021-11-04T17:57:18",
      modified_gmt: "2021-11-04T16:57:18",
      slug: "cbd",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/cbd/",
      title: {
        rendered: "CBD",
      },
      featured_media: 16878,
      template: "",
      projekt_filter: [246, 427, 425, 255],
      acf: {
        highlight_image: 16881,
        highlight_title_project: "CBD",
        highlight_subtitle_project: "Arbeitswelt von morgen",
        highlight_description_project:
          "Between Taunus and Altem Römer, three buildings with representative views are presented on Frankfurter Strasse in the heart of south Eschborn. In addition, there is still potential for over 30,000 m² of new office space.",
        highlight_logo_project: null,
        website_projects: {
          title: "www.cbd-eschborn.de",
          url: "http://www.cbd-eschborn.de/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "http://www.cbd-eschborn.de/",
          target: "_blank",
        },
        available_space: [""],
        project: "Investment, Development",
        location: "Alfred-Herrhausen-Allee 10, 65760 Eschborn",
        property: "approx. 20,563 m²",
        area: "19,160 m² (existing rental space)",
        zertifizierung: "",
        parcels: "680 (531 underground car park, 149 outside)",
        use_for: "Office",
        acquired: "Q1 2015",
        realization: "",
        sale: "2017-2019",
        architecture_firm: "",
        place: "Eschborn",
        fakten: null,
        specifications_image_projects: 16880,
        slider: null,
        title_details_projects: "CBD IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "High conditions",
            description_repeater_details:
              "A ceiling height of at least 2.80 m ensures plenty of free space and an excellent room climate. Efficient surfaces as well as the lighting systems, floor coverings and partition walls complement the ideal conditions for successful work. Thanks to the variable floor plans, all companies find a home here – on a total of approx. 20,000 m² of state-of-the-art floor space.",
            image_repeater_details: 16880,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Space for wishes",
            description_repeater_details:
              "Are you looking for a modern office property that suits your company and represents it optimally? Welcome to the CBD Eschborn! Determine the architecture, function and design for your new location yourself. At CBD everything is tailor-made for you. Depending on the requirement profile, the most diverse utilisation concepts can be realized. Rental units or buildings from 1.500 up to 30.000 m² can be realized.",
            image_repeater_details: 14046,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Favourable location",
            description_repeater_details:
              "Eschborn, perfectly located between the metropolis of Frankfurt and the Taunus recreational area, is an attractive office location in the Rhine-Main region. In Eschborn South ­– the economically stronger part of Eschborn – the CBD Eschborn is being developed. Various well-known companies in the immediate vicinity are counting on the versatility of this location – and the very advantageous trade tax rate of 330%.\r\n\r\n&nbsp;",
            image_repeater_details: 14047,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Alfred-Herrhausen-Allee 10, 65760 Eschborn",
          lat: 50.13383899999999,
          lng: 8.573401999999987,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | CBD</title>\n<meta name="description" content="Zwischen Taunus und Altem Römer präsentieren sich an der Frankfurter Straße im Eschborner Gewerbegebiet fünf Gebäude mit repräsentativen Aussichten." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/cbd/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | CBD" />\n<meta property="og:description" content="Zwischen Taunus und Altem Römer präsentieren sich an der Frankfurter Straße im Eschborner Gewerbegebiet fünf Gebäude mit repräsentativen Aussichten." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/cbd/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T16:57:18+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2014/02/CBD-Eschborn-02-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1792" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/cbd/","url":"https://www.art-invest.de/en/projekt/cbd/","name":"Art-Invest Real Estate | CBD","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-02-11T11:00:15+00:00","dateModified":"2021-11-04T16:57:18+00:00","description":"Zwischen Taunus und Altem Römer präsentieren sich an der Frankfurter Straße im Eschborner Gewerbegebiet fünf Gebäude mit repräsentativen Aussichten.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/cbd/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/cbd/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/cbd/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"CBD"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | CBD",
        description:
          "Zwischen Taunus und Altem Römer präsentieren sich an der Frankfurter Straße im Eschborner Gewerbegebiet fünf Gebäude mit repräsentativen Aussichten.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/cbd/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | CBD",
        og_description:
          "Zwischen Taunus und Altem Römer präsentieren sich an der Frankfurter Straße im Eschborner Gewerbegebiet fünf Gebäude mit repräsentativen Aussichten.",
        og_url: "https://www.art-invest.de/en/projekt/cbd/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T16:57:18+00:00",
        og_image: [
          {
            width: 2560,
            height: 1792,
            url: "https://www.art-invest.de/wp-content/uploads/2014/02/CBD-Eschborn-02-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/cbd/",
              url: "https://www.art-invest.de/en/projekt/cbd/",
              name: "Art-Invest Real Estate | CBD",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-02-11T11:00:15+00:00",
              dateModified: "2021-11-04T16:57:18+00:00",
              description:
                "Zwischen Taunus und Altem Römer präsentieren sich an der Frankfurter Straße im Eschborner Gewerbegebiet fünf Gebäude mit repräsentativen Aussichten.",
              breadcrumb: {
                "@id": "https://www.art-invest.de/en/projekt/cbd/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/cbd/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/cbd/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "CBD",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2014/02/CBD-Eschborn-02-1-scaled.jpg",
      place: "Eschborn",
      subtitle: "Arbeitswelt von morgen",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16877",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16878",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16877",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16877",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21170,
      date: "2022-07-27T14:54:40",
      date_gmt: "2022-07-27T12:54:40",
      guid: {
        rendered: "https://www.art-invest.de/projekt/sackville-house/",
      },
      modified: "2022-08-03T11:37:35",
      modified_gmt: "2022-08-03T09:37:35",
      slug: "sackville-house",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/sackville-house/",
      title: {
        rendered: "Sackville House",
      },
      featured_media: 21089,
      template: "",
      projekt_filter: [246, 427, 425, 262],
      acf: {
        highlight_image: 21101,
        highlight_title_project: "Sackville House",
        highlight_subtitle_project: "Exklusivität in Mayfair",
        highlight_description_project:
          "Located in the popular West End, Sackville House is a stunning example of typical London architecture. Gorgeous Portland stone and timeless red brick form an attractive corner facade that stretches for 45 meters through the prestigious streets of Mayfair. Situated between glamorous Bond Street and vibrant Piccadilly Circus, the building shares its exclusive zip code with some of the UK's best-known institutions, such as the Royal Academy and Fortnum &amp; Mason. With Sackville House, Art-Invest Real Estate has acquired a real trophy in its British portfolio.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Refurbishment / Extension",
        location: "London (Mayfair / West End)",
        property: "530 sqm",
        area: "3,041 sqm",
        zertifizierung: "",
        parcels: "0",
        use_for: "Office, Retail",
        acquired: "2021",
        realization: "",
        sale: "",
        architecture_firm: "George John Skipper",
        place: "",
        fakten: null,
        specifications_image_projects: 21087,
        slider: [21089, 21087, 21085],
        title_details_projects: "Sackville House in Detail",
        details_repeater_projects: [
          {
            title_repeater_details: "Historical landmark with a future",
            description_repeater_details:
              "Designed in 1931 by prominent British architect George John Skipper, Sackville House is a building steeped in history. It is classified by Historic England as a Grade II listed building, designating it a building of special architectural or historic interest and warranting every effort to preserve it. A branch of the famous British bank Lloyds Banking Group has occupied the ground floor since the 1930s. Other tenants include a tailor with a Royal Warrant, recognizing them as a supplier of goods to the Royal Family. The view from the roof perfectly captures London’s past, present and future, with landmarks such as the Houses of Parliament and the London Eye instantly recognizable.",
            image_repeater_details: 21085,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Positioned for success",
            description_repeater_details:
              "Sackville House fronts onto the world-famous Piccadilly and one road away from Regent Street, nestled amongst some of London’s most famous shops and restaurants. The building is just a few minutes‘ walk from the thriving theatre district and the urban oasis of Green Park. Tenants and visitors alike benefit from every amenity they could wish for on their doorstep, as well as the excellent connections to the London Underground.",
            image_repeater_details: 21089,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "40 Piccadilly, London W1J 0DR, Vereinigtes Königreich",
          lat: 51.5090518,
          lng: -0.1375711,
          zoom: 14,
          place_id: "ChIJhxTqhdYEdkgR94mMMH0kJ88",
          name: "40 Piccadilly",
          street_number: 40,
          street_name: "Piccadilly",
          city: "London",
          state: "England",
          post_code: "W1J 0DR",
          country: "Vereinigtes Königreich",
          country_short: "GB",
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Sackville House</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/sackville-house/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Sackville House" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/sackville-house/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-08-03T09:37:35+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2022/07/SVH.jpg" />\n\t<meta property="og:image:width" content="1549" />\n\t<meta property="og:image:height" content="1032" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/sackville-house/","url":"https://www.art-invest.de/en/projekt/sackville-house/","name":"Art-Invest Real Estate | Sackville House","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2022-07-27T12:54:40+00:00","dateModified":"2022-08-03T09:37:35+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/sackville-house/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/sackville-house/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/sackville-house/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Sackville House"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Sackville House",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/sackville-house/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Sackville House",
        og_url: "https://www.art-invest.de/en/projekt/sackville-house/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-08-03T09:37:35+00:00",
        og_image: [
          {
            width: 1549,
            height: 1032,
            url: "https://www.art-invest.de/wp-content/uploads/2022/07/SVH.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/sackville-house/",
              url: "https://www.art-invest.de/en/projekt/sackville-house/",
              name: "Art-Invest Real Estate | Sackville House",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2022-07-27T12:54:40+00:00",
              dateModified: "2022-08-03T09:37:35+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/sackville-house/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/sackville-house/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/sackville-house/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Sackville House",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2022/07/SVH-800x800.jpg",
      place: "London",
      subtitle: "Exklusivität in Mayfair",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21170",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21085",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21087",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21089",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21089",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21170",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21170",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16861,
      date: "2020-01-17T17:10:15",
      date_gmt: "2020-01-17T16:10:15",
      guid: {
        rendered:
          "https://www.art-invest.de/projekt/ibis-styles-hotel-stuttgart/",
      },
      modified: "2023-09-14T10:11:12",
      modified_gmt: "2023-09-14T08:11:12",
      slug: "ibis-styles-hotel-stuttgart",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/ibis-styles-hotel-stuttgart/",
      title: {
        rendered: "Premier Inn",
      },
      featured_media: 25483,
      template: "",
      projekt_filter: [251, 427, 425, 259],
      acf: {
        highlight_image: 25492,
        highlight_title_project: "Premier Inn",
        highlight_subtitle_project: " Premier Inn Stuttgart",
        highlight_description_project:
          "Extensively renovated, the Premier Inn Bad Cannstatt shines in the oldest and busiest district of Bad Cannstatt in an attractive location by the mineral baths and spa gardens. The modernized economy hotel features 156 spacious comfort rooms, underground parking and a hotel restaurant with a spacious outdoor area. Around the clock, the bar with a variety of coffee specialties and drinks invites you to linger in a relaxed atmosphere.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment",
        location: "Teinacher Straße 20, 70372 Stuttgart Bad Cannstatt",
        property: "2,219 m²",
        area: "11,713 m²",
        zertifizierung: "",
        parcels: "78",
        use_for: "Hotel, Gastronomy",
        acquired: "Q3 2018",
        realization: "built in 1993 / renovated in 2013",
        sale: "",
        architecture_firm: "",
        place: "",
        fakten: null,
        specifications_image_projects: 16862,
        slider: [25486, 25488, 25490, 25494, 25496, 25498],
        title_details_projects: "IBIS STYLES HOTEL STUTTGART IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "High quality of stay, also for families",
            description_repeater_details:
              "At the Ibis Styles Hotel, service comes first. The hotel has spacious rooms, some with four beds, and offers families and leisure tourists comfortable accommodation in Stuttgart. The location is perfect: There is a direct connection to well-known event locations, such as the Cannstatter Wasen festival grounds or the Mercedes Benz Arena, and the cultural offerings are versatile and attractive.",
            image_repeater_details: 14229,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Attractive concept meets advantageous micro location",
            description_repeater_details:
              "The city is profiting from the growing demand of the tourism and business segment. Well-known companies such as Mahle, Daimler and EnBW are located in the immediate vicinity of the hotel.",
            image_repeater_details: 14025,
            video: "",
            "anchor-link": "",
          },
        ],
        map: null,
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Premier Inn Stuttgart</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/ibis-styles-hotel-stuttgart/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Premier Inn Stuttgart" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/ibis-styles-hotel-stuttgart/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-09-14T08:11:12+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/01/STUBAD_External_View_5-rt2-kl.jpg" />\n\t<meta property="og:image:width" content="2048" />\n\t<meta property="og:image:height" content="1365" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/ibis-styles-hotel-stuttgart/","url":"https://www.art-invest.de/en/projekt/ibis-styles-hotel-stuttgart/","name":"Art-Invest Real Estate | Premier Inn Stuttgart","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-01-17T16:10:15+00:00","dateModified":"2023-09-14T08:11:12+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/ibis-styles-hotel-stuttgart/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/ibis-styles-hotel-stuttgart/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/ibis-styles-hotel-stuttgart/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Premier Inn Stuttgart"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Premier Inn Stuttgart",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/ibis-styles-hotel-stuttgart/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Premier Inn Stuttgart",
        og_url:
          "https://www.art-invest.de/en/projekt/ibis-styles-hotel-stuttgart/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-09-14T08:11:12+00:00",
        og_image: [
          {
            width: 2048,
            height: 1365,
            url: "https://www.art-invest.de/wp-content/uploads/2020/01/STUBAD_External_View_5-rt2-kl.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/ibis-styles-hotel-stuttgart/",
              url: "https://www.art-invest.de/en/projekt/ibis-styles-hotel-stuttgart/",
              name: "Art-Invest Real Estate | Premier Inn Stuttgart",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-01-17T16:10:15+00:00",
              dateModified: "2023-09-14T08:11:12+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/ibis-styles-hotel-stuttgart/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/ibis-styles-hotel-stuttgart/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/ibis-styles-hotel-stuttgart/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Premier Inn Stuttgart",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/01/STUBAD_External_View_5-rt2-kl-800x800.jpg",
      place: "Stuttgart",
      subtitle: "In neuer Fassade",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16861",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25498",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25496",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25494",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25490",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25488",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25486",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25483",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16861",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16861",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16679,
      date: "2017-07-21T17:30:21",
      date_gmt: "2017-07-21T15:30:21",
      guid: {
        rendered: "https://www.art-invest.de/projekt/malkastenstrasse/",
      },
      modified: "2020-07-03T13:20:34",
      modified_gmt: "2020-07-03T13:20:34",
      slug: "malkastenstrasse",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/malkastenstrasse/",
      title: {
        rendered: "Malkastenstraße",
      },
      featured_media: 16681,
      template: "",
      projekt_filter: [246, 427, 425, 257],
      acf: {
        highlight_image: 13962,
        highlight_title_project: "Malkastenstraße",
        highlight_subtitle_project: "Stadtvilla mit Zukunft",
        highlight_description_project:
          "A unique historical building structure in one of the city's most attractive residential and office addresses – this is what Malkastenstraße in the north of Dusseldorf's city centre offers. The project is the ideal combination of a listed villa and functional annex. This is what makes the building, which offers high-quality office space on approx. 1,842 m², stand out.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "long-term Investment",
        location:
          "Malkastenstraße 21, 40211 Dusseldorf; inner city, Pempelforter Straße",
        property: "approx. 1,180 m²",
        area: "approx. 1,840 m²",
        zertifizierung: "",
        parcels: "12 parking slots",
        use_for: "Office",
        acquired: "Q1 2017",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Düsseldorf",
        fakten: null,
        specifications_image_projects: 16680,
        slider: null,
        title_details_projects: "MALKASTENSTRAßE IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "History meets modernity",
            description_repeater_details:
              "The Malkastenstraße is a listed property from 1912 and has a special urban charm thanks to its unique historical building structure.",
            image_repeater_details: 16680,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Attractive address",
            description_repeater_details:
              "While the adjacent Pempelforter Strasse represents a main traffic axis, Malkastenstrasse is one of the most attractive residential and office addresses. Located directly at the Hofgarten and Malkastenpark, the property offers proximity to parks and green spaces despite its central location.",
            image_repeater_details: 4257,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Malkastenstraße 21, 40211 Düsseldorf, Deutschland",
          lat: 51.23109320199008,
          lng: 6.7896099989502545,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Malkastenstraße</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/malkastenstrasse/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Malkastenstraße" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/malkastenstrasse/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-03T13:20:34+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2017/07/Malkastenstr21_Duesseldorf_20170310_21_Hi_klein-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1706" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/malkastenstrasse/","url":"https://www.art-invest.de/en/projekt/malkastenstrasse/","name":"Art-Invest Real Estate | Malkastenstraße","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2017-07-21T15:30:21+00:00","dateModified":"2020-07-03T13:20:34+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/malkastenstrasse/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/malkastenstrasse/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/malkastenstrasse/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Malkastenstraße"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Malkastenstraße",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/malkastenstrasse/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Malkastenstraße",
        og_url: "https://www.art-invest.de/en/projekt/malkastenstrasse/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-03T13:20:34+00:00",
        og_image: [
          {
            width: 2560,
            height: 1706,
            url: "https://www.art-invest.de/wp-content/uploads/2017/07/Malkastenstr21_Duesseldorf_20170310_21_Hi_klein-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/malkastenstrasse/",
              url: "https://www.art-invest.de/en/projekt/malkastenstrasse/",
              name: "Art-Invest Real Estate | Malkastenstraße",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2017-07-21T15:30:21+00:00",
              dateModified: "2020-07-03T13:20:34+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/malkastenstrasse/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/malkastenstrasse/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/malkastenstrasse/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Malkastenstraße",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2017/07/Malkastenstr21_Duesseldorf_20170310_21_Hi_klein-1-scaled.jpg",
      place: "Düsseldorf",
      subtitle: "Stadtvilla mit Zukunft",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16679",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16681",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16679",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16679",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16703,
      date: "2018-07-20T12:06:47",
      date_gmt: "2018-07-20T10:06:47",
      guid: {
        rendered: "https://www.art-invest.de/projekt/maritim-hotel/",
      },
      modified: "2020-07-03T13:22:12",
      modified_gmt: "2020-07-03T13:22:12",
      slug: "maritim-hotel",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/maritim-hotel/",
      title: {
        rendered: "Maritim Hotel",
      },
      featured_media: 14089,
      template: "",
      projekt_filter: [247, 251, 427, 425],
      acf: {
        highlight_image: 16709,
        highlight_title_project: "Maritim Hotel",
        highlight_subtitle_project: "Moderne trifft Klassik",
        highlight_description_project:
          "Since its construction at the end of the 80s, the Maritim Hotel has been one of the most renowned locations in Cologne. The city centre location and architectural features are the best conditions for upgrading the hotel and making it more attractive in the coming years.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location: "Heumarkt 20, 50667 Cologne; city centre",
        property: "9,501 m²",
        area: "54,700 m²",
        zertifizierung: "",
        parcels: "540",
        use_for: "Hotel",
        acquired: "Q2 2018",
        realization: "",
        sale: "",
        architecture_firm: "Prof. Kraemer Sieverts & Partner GmbH",
        place: "Köln",
        fakten: null,
        specifications_image_projects: 16706,
        slider: null,
        title_details_projects: "MARITIM HOTEL IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Reviving tradition",
            description_repeater_details:
              "Between 1904 and 1940 the Central Market Hall, the city's wholesale market, stood on the Maritim site. Today, the two wings and the glass atrium of the Maritim are architecturally reminiscent of the hall of that time. In order to revive the hotel and create new, attractive points of attraction, there are long-term optimization possibilities such as the installation of a new market hall in the atrium or the redesign of the conference rooms.",
            image_repeater_details: 16704,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Central city centre location",
            description_repeater_details:
              "The Maritim Hotel is located in Cologne's historic old town, in the immediate vicinity of the Heumarkt, and is therefore easily accessible for pedestrians and overnight guests. Cologne's main train station, the Rhine promenade with museums, as well as the well-known shopping street Schildergasse are only a few minutes' walk away.",
            image_repeater_details: 14089,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Popular event location",
            description_repeater_details:
              "In addition to more than 450 rooms and four restaurants, the Maritim has a large conference area with 22 rooms and a hall that can hold up to 3,400 people. For this reason, the hotel is one of the most popular event locations in Cologne.",
            image_repeater_details: 16707,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Heumarkt 20, 50667 Köln, Deutschland",
          lat: 50.9353393,
          lng: 6.961348300000054,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Maritim Hotel</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/maritim-hotel/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Maritim Hotel" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/maritim-hotel/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-03T13:22:12+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2018/07/CGN_Maritim_Hotel_Au·enansicht-1.jpg" />\n\t<meta property="og:image:width" content="1600" />\n\t<meta property="og:image:height" content="1028" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/maritim-hotel/","url":"https://www.art-invest.de/en/projekt/maritim-hotel/","name":"Art-Invest Real Estate | Maritim Hotel","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2018-07-20T10:06:47+00:00","dateModified":"2020-07-03T13:22:12+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/maritim-hotel/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/maritim-hotel/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/maritim-hotel/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Maritim Hotel"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Maritim Hotel",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/maritim-hotel/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Maritim Hotel",
        og_url: "https://www.art-invest.de/en/projekt/maritim-hotel/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-03T13:22:12+00:00",
        og_image: [
          {
            width: 1600,
            height: 1028,
            url: "https://www.art-invest.de/wp-content/uploads/2018/07/CGN_Maritim_Hotel_Au·enansicht-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/maritim-hotel/",
              url: "https://www.art-invest.de/en/projekt/maritim-hotel/",
              name: "Art-Invest Real Estate | Maritim Hotel",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2018-07-20T10:06:47+00:00",
              dateModified: "2020-07-03T13:22:12+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/maritim-hotel/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/maritim-hotel/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/maritim-hotel/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Maritim Hotel",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2018/07/CGN_Maritim_Hotel_Au·enansicht-1-800x800.jpg",
      place: "Köln",
      subtitle: "Moderne trifft Klassik",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16703",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14089",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16703",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16703",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16695,
      date: "2020-01-27T13:27:33",
      date_gmt: "2020-01-27T12:27:33",
      guid: {
        rendered: "https://www.art-invest.de/projekt/kennedydamm/",
      },
      modified: "2020-07-03T13:22:38",
      modified_gmt: "2020-07-03T13:22:38",
      slug: "kennedydamm",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/kennedydamm/",
      title: {
        rendered: "Kennedydamm",
      },
      featured_media: 16697,
      template: "",
      projekt_filter: [246, 427, 425, 257],
      acf: {
        highlight_image: 16697,
        highlight_title_project: "Kennedydamm",
        highlight_subtitle_project: "Büros mit neuer Handschrift",
        highlight_description_project:
          "The property on the popular Kennedydamm shows its high potential through a proven premium location and comfortable working environments.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location: "Kennedydamm 15-17, 40476 Dusseldorf",
        property: "7,851 m²",
        area: "13,973.50 m²",
        zertifizierung: "",
        parcels: "199",
        use_for: "Office",
        acquired: "Q3 2019",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Düsseldorf",
        fakten: null,
        specifications_image_projects: 13072,
        slider: null,
        title_details_projects: "KENNEDYDAMM IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Exposed location with high visibility",
            description_repeater_details:
              "The office submarket on Kennedydamm was created in the 1960s and 70s as Dusseldorf's first office relief location. The favourable location north of the city centre and close to the airport was one of the decisive factors at that time and convinced leading companies such as IBM Germany or the automotive group Mitsubishi. Even today, Kennedydamm is still one of the most important entry roads into the city for commuters from Krefeld, the Lower Rhine and the Ruhr area and is growing steadily. Due to the excellent infrastructure with a balanced mix of usabilities and good public transport connections, well-known companies such as L'Oreal, McKinsey and Hilton continue to choose a location in Derendorf.\r\n\r\nIn an exposed location, directly at the transition from the residential area to the Kennedydamm business district, the property has excellent visibility. In addition, the office building can be approached directly from the north and south thanks to a turning loop at the same level.",
            image_repeater_details: 16696,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Well thought-out architecture for high working comfort",
            description_repeater_details:
              "The property consists of two buildings with separate, representative main entrances. Due to the unusual floor plan of parallel staggered and interconnected building parts in the form of a transom, the building runs at a slight angle along the street. The elongated bodies loosen up the facade for the views of passing observers and also have veritable advantages for the resident tenant IT.NRW. The slender building bodies with their large window fronts offer ideal working environments: bright rooms with daylight incidence. In addition to an auditorium that can be used for events, the tenants also have access to the extensive roof terrace at Kennedydamm 17.",
            image_repeater_details: 13439,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Kennedydamm 15-17, Düsseldorf, Deutschland",
          lat: 51.2449591,
          lng: 6.772808599999999,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Kennedydamm</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/kennedydamm/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Kennedydamm" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/kennedydamm/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-03T13:22:38+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/03/DUS_Kennedydamm_Auﬂenansicht_Vogelperspektive_seitlich2-Kopie-1024x576.jpg" />\n\t<meta property="og:image:width" content="1024" />\n\t<meta property="og:image:height" content="576" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/kennedydamm/","url":"https://www.art-invest.de/en/projekt/kennedydamm/","name":"Art-Invest Real Estate | Kennedydamm","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-01-27T12:27:33+00:00","dateModified":"2020-07-03T13:22:38+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/kennedydamm/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/kennedydamm/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/kennedydamm/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Kennedydamm"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Kennedydamm",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/kennedydamm/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Kennedydamm",
        og_url: "https://www.art-invest.de/en/projekt/kennedydamm/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-03T13:22:38+00:00",
        og_image: [
          {
            width: 1024,
            height: 576,
            url: "https://www.art-invest.de/wp-content/uploads/2020/03/DUS_Kennedydamm_Auﬂenansicht_Vogelperspektive_seitlich2-Kopie-1024x576.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/kennedydamm/",
              url: "https://www.art-invest.de/en/projekt/kennedydamm/",
              name: "Art-Invest Real Estate | Kennedydamm",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-01-27T12:27:33+00:00",
              dateModified: "2020-07-03T13:22:38+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/kennedydamm/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/kennedydamm/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/kennedydamm/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Kennedydamm",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/03/DUS_Kennedydamm_Auﬂenansicht_Vogelperspektive_seitlich2-Kopie-1024x576-800x576.jpg",
      place: "Düsseldorf",
      subtitle: "Büros mit neuer Handschrift",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16695",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16697",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16695",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16695",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 18095,
      date: "2021-01-28T12:09:35",
      date_gmt: "2021-01-28T11:09:35",
      guid: {
        rendered: "https://www.art-invest.de/projekt/kap-12-duesseldorf/",
      },
      modified: "2021-01-28T13:57:24",
      modified_gmt: "2021-01-28T12:57:24",
      slug: "kap-12-duesseldorf",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/kap-12-duesseldorf/",
      title: {
        rendered: "KAP 12",
      },
      featured_media: 18086,
      template: "",
      projekt_filter: [246, 427, 425, 257],
      acf: {
        highlight_image: null,
        highlight_title_project: "KAP 12",
        highlight_subtitle_project: "Konstant seit 1959",
        highlight_description_project:
          "Built in 1959 KAP 12 has been an integral part of Dusseldorf's city center for half a century now. The striking property at Konrad-Adenauer-Platz 12, in the direct vicinity of the main train station, is being extensively renovated and converted. The project continuese to shape the cityscape of the metropolis on the Rhine. The investment is well equipped for the future thanks to its mix of uses, unbeatable location factors and proximity to the pulsating city center with its famous Königsallee shopping mile.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: {
          title: "zum Flächenangebot",
          url: "https://www.aire-mag.com/de/flaechen/kap12",
          target: "_blank",
        },
        project: "Investment",
        location: "Konrad-Adenauer-Platz 12, 40210 Dusseldorf",
        property: "860 sqm",
        area: "5,763 sqm",
        zertifizierung: "",
        parcels: "18",
        use_for: "Office, Catering",
        acquired: "Q4/2018",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Düsseldorf",
        fakten: null,
        specifications_image_projects: 18092,
        slider: null,
        title_details_projects: "KAP 12 IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              "Elaborate refurbishment for modern working environments",
            description_repeater_details:
              "With KAP 12, Art-Invest Real Estate is investing in another prime location project in a major German city. In the middle of the lively center of the state capital, the ensemble offers an attractive mix of uses on a total of 5,763 sqm and seven floors. The commercial building mainly houses offices, but also gastronomic facilities. Attractive usable spaces for future working worlds are being created in the complex at the hub of Dusseldorf.",
            image_repeater_details: 18094,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Directly in Dusseldorf with perfect transportation possibilities",
            description_repeater_details:
              "KAP 12 benefits from an excellent infrastructure with ideal public transportation. Located right next to Dusseldorf's main train station, tenants and users can reach the property quickly and easily by public transport. Thanks to a Turkish restaurant and a Greek café directly in the building as well as numerous restaurants and extensive shopping facilities in the immediate vicinity, no wishes remain unfulfilled.",
            image_repeater_details: 18090,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Konrad-Adenauer-Platz 12, 40210 Düsseldorf, Deutschland",
          lat: 51.2199979,
          lng: 6.7909852,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | KAP 12</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/kap-12-duesseldorf/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | KAP 12" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/kap-12-duesseldorf/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-01-28T12:57:24+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2021/01/DUS_KAP12_Aussenaufnahme_Hauptansicht_Frontal_Daemmerung.jpg" />\n\t<meta property="og:image:width" content="2500" />\n\t<meta property="og:image:height" content="2000" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/kap-12-duesseldorf/","url":"https://www.art-invest.de/en/projekt/kap-12-duesseldorf/","name":"Art-Invest Real Estate | KAP 12","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2021-01-28T11:09:35+00:00","dateModified":"2021-01-28T12:57:24+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/kap-12-duesseldorf/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/kap-12-duesseldorf/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/kap-12-duesseldorf/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"KAP 12"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | KAP 12",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/kap-12-duesseldorf/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | KAP 12",
        og_url: "https://www.art-invest.de/en/projekt/kap-12-duesseldorf/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-01-28T12:57:24+00:00",
        og_image: [
          {
            width: 2500,
            height: 2000,
            url: "https://www.art-invest.de/wp-content/uploads/2021/01/DUS_KAP12_Aussenaufnahme_Hauptansicht_Frontal_Daemmerung.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/kap-12-duesseldorf/",
              url: "https://www.art-invest.de/en/projekt/kap-12-duesseldorf/",
              name: "Art-Invest Real Estate | KAP 12",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2021-01-28T11:09:35+00:00",
              dateModified: "2021-01-28T12:57:24+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/kap-12-duesseldorf/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/kap-12-duesseldorf/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/kap-12-duesseldorf/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "KAP 12",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2021/01/DUS_KAP12_Aussenaufnahme_Hauptansicht_Frontal_Daemmerung-800x800.jpg",
      place: "Düsseldorf",
      subtitle: "Konstant seit 1959",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/18095",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18086",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=18095",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=18095",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 18066,
      date: "2021-01-20T11:37:23",
      date_gmt: "2021-01-20T10:37:23",
      guid: {
        rendered: "https://www.art-invest.de/projekt/victoria-center/",
      },
      modified: "2021-01-20T17:29:49",
      modified_gmt: "2021-01-20T16:29:49",
      slug: "victoria-center",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/victoria-center/",
      title: {
        rendered: "Victoria Center",
      },
      featured_media: 18057,
      template: "",
      projekt_filter: [250, 254, 427, 425, 245, 256],
      acf: {
        highlight_image: 18065,
        highlight_title_project: "Victoria Center",
        highlight_subtitle_project: "Lokales Versorgungszentrum",
        highlight_description_project:
          "The Victoria Center in Berlin's district Rummelsburg offers more than 10,000 square meters of shopping facilities and services for everyday needs. Centrally located in the east of the capital, the local supply center impresses neighbours and users with a broadly diversified tenant mix. This makes the Victoria Center a sought-after contact point with offerings ranging from grocery stores and retail to fitness and gastronomy.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment ",
        location: "Marktstraße 6, 10317 Berlin",
        property: "12,875 sqm",
        area: "13,718 sqm (rental space)",
        zertifizierung: "",
        parcels: "610",
        use_for: "Local Supply, Fitness, Retail, Catering, Parking",
        acquired: "18.12.2020",
        realization: "2001",
        sale: "",
        architecture_firm: "",
        place: "Berlin",
        fakten: [
          {
            bezeichnung: "Floors",
            wert: "Component 1: basement, ground floor + 3 floors parking garage, component 2: (fitness) on 2 floors ",
            anchor: "",
          },
        ],
        specifications_image_projects: null,
        slider: null,
        title_details_projects: "VICTORIA CENTER IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Shopping at a popular location",
            description_repeater_details:
              "With the acquisition of the local shopping center in the historic Victoriastadt district, Art-Invest Real Estate has another property in a sought-after location close to the city center. With a diverse range of offers on a generous area of over 13,000 square meters as well as a three-story parking garage, no wishes remain unfulfilled. Kaufland, Holmes Place and Apcoa as tenants attract a wide variety of user groups by offering a comprehensive and flexible shopping experience. The property's drawing power is rounded off by an Asian restaurant, an optician, a travel agency and a florist.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "On the pulse of time",
            description_repeater_details:
              "The Victoria Center is a popular attraction due to its location near Frankfurter Allee and directly at the Ostkreuz train station. In the middle of a mixed commercial and residential area, it is equally easy to reach by private and public transport. Users of the local shopping center can additionally take advantage of an attractive environment in the neighbouring Friedrichshain.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Marktstraße 6, 10317 Berlin, Deutschland",
          lat: 52.5035803,
          lng: 13.4734615,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Victoria Center</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/victoria-center/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Victoria Center" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/victoria-center/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-01-20T16:29:49+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2021/01/Victoria-Center.jpg" />\n\t<meta property="og:image:width" content="1159" />\n\t<meta property="og:image:height" content="515" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/victoria-center/","url":"https://www.art-invest.de/en/projekt/victoria-center/","name":"Art-Invest Real Estate | Victoria Center","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2021-01-20T10:37:23+00:00","dateModified":"2021-01-20T16:29:49+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/victoria-center/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/victoria-center/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/victoria-center/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Victoria Center"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Victoria Center",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/victoria-center/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Victoria Center",
        og_url: "https://www.art-invest.de/en/projekt/victoria-center/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-01-20T16:29:49+00:00",
        og_image: [
          {
            width: 1159,
            height: 515,
            url: "https://www.art-invest.de/wp-content/uploads/2021/01/Victoria-Center.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/victoria-center/",
              url: "https://www.art-invest.de/en/projekt/victoria-center/",
              name: "Art-Invest Real Estate | Victoria Center",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2021-01-20T10:37:23+00:00",
              dateModified: "2021-01-20T16:29:49+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/victoria-center/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/victoria-center/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/victoria-center/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Victoria Center",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2021/01/Victoria-Center-800x515.jpg",
      place: "Berlin",
      subtitle: "Lokales Versorgungszentrum",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/18066",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18057",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=18066",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=18066",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16710,
      date: "2020-04-07T14:27:30",
      date_gmt: "2020-04-07T14:27:30",
      guid: {
        rendered: "https://www.art-invest.de/projekt/hotel-lindley-lindenberg/",
      },
      modified: "2020-08-25T13:10:46",
      modified_gmt: "2020-08-25T13:10:46",
      slug: "hotel-lindley-lindenberg",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/hotel-lindley-lindenberg/",
      title: {
        rendered: "Hotel Lindley Lindenberg",
      },
      featured_media: 14565,
      template: "",
      projekt_filter: [251, 427, 425, 255],
      acf: {
        highlight_image: 14577,
        highlight_title_project: "Hotel Lindley Lindenberg",
        highlight_subtitle_project: "Zauberkiste mit Geschichte",
        highlight_description_project:
          "Frankfurt's Ostend will receive another architectural jewel: Since July 2019, the Hotel Lindley Lindenberg is inspiring guests with a successful combination of design and functionality. The modern exterior facade of generous glass surfaces and cast-iron elements picks up the character of the industrially influenced East of Frankfurt. 100 rooms and multifunctional common areas on seven floors enrich the location.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "",
        location: "Lindleystraße 17, 60314 Frankfurt",
        property: "1,311 m²",
        area: "4,340 m²",
        zertifizierung: "",
        parcels: "28",
        use_for: "Hotel",
        acquired: "Q4 2019",
        realization: "Q2 2019",
        sale: "",
        architecture_firm: "Franken und Exitecture Architekten",
        place: "Frankfurt",
        fakten: null,
        specifications_image_projects: 14579,
        slider: null,
        title_details_projects: "HOTEL LINDLEY LINDENBERG IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              '"Collaborative Living" as a future-oriented concept',
            description_repeater_details:
              "The glazed front gives a first glimpse of the advanced concept. The Hotel Lindley Lindenberg not only provides a feel-good location for tourists, but also offers a co-working space for long-term guests and business travellers. Compact rooms and vertical, two-storey common areas fulfil the desire for individuality and community in equal measure. The object symbiotically combines the advantages of a hotel and residential unit, thus reacting to a dynamic reality of life. Guests of the hotel benefit from a roof terrace, the hotel's own herb garden and a wide range of fitness and catering facilities.",
            image_repeater_details: 14575,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Industrial charm in the trendy East of Frankfurt",
            description_repeater_details:
              "Frankfurt's Ostend is blossoming. The former working-class district is home to exciting construction projects, the Osthafen (East Harbour), rich in tradition, and the impressive ECB headquarters. The Hotel Lindley Lindenberg interprets the industrial charm of its surroundings and completes the now first-class infrastructure of trendy gastronomy, extensive riverside facilities and optimal connections to local and long-distance transport.",
            image_repeater_details: 14567,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address:
            "Lindleystraße 17, Bornheim/Ostend 60314 Frankfurt am Main, Deutschland",
          lat: 50.1125132,
          lng: 8.7182978,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Hotel Lindley Lindenberg</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/hotel-lindley-lindenberg/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Hotel Lindley Lindenberg" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/hotel-lindley-lindenberg/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-08-25T13:10:46+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/04/0_Facade-Kopie.jpg" />\n\t<meta property="og:image:width" content="1566" />\n\t<meta property="og:image:height" content="2560" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/hotel-lindley-lindenberg/","url":"https://www.art-invest.de/en/projekt/hotel-lindley-lindenberg/","name":"Art-Invest Real Estate | Hotel Lindley Lindenberg","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-04-07T14:27:30+00:00","dateModified":"2020-08-25T13:10:46+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/hotel-lindley-lindenberg/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/hotel-lindley-lindenberg/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/hotel-lindley-lindenberg/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Hotel Lindley Lindenberg"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Hotel Lindley Lindenberg",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/hotel-lindley-lindenberg/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Hotel Lindley Lindenberg",
        og_url:
          "https://www.art-invest.de/en/projekt/hotel-lindley-lindenberg/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-08-25T13:10:46+00:00",
        og_image: [
          {
            width: 1566,
            height: 2560,
            url: "https://www.art-invest.de/wp-content/uploads/2020/04/0_Facade-Kopie.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/hotel-lindley-lindenberg/",
              url: "https://www.art-invest.de/en/projekt/hotel-lindley-lindenberg/",
              name: "Art-Invest Real Estate | Hotel Lindley Lindenberg",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-04-07T14:27:30+00:00",
              dateModified: "2020-08-25T13:10:46+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/hotel-lindley-lindenberg/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/hotel-lindley-lindenberg/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/hotel-lindley-lindenberg/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Hotel Lindley Lindenberg",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/04/0_Facade-Kopie-800x800.jpg",
      place: "Frankfurt",
      subtitle: "Zauberkiste mit Geschichte",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16710",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14565",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16710",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16710",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 17029,
      date: "2020-08-17T15:12:02",
      date_gmt: "2020-08-17T15:12:02",
      guid: {
        rendered:
          "https://www.art-invest.de/projekt/leonardo-royal-hotel-berlin-alexanderplatz/",
      },
      modified: "2020-09-02T09:31:45",
      modified_gmt: "2020-09-02T07:31:45",
      slug: "leonardo-royal-hotel-berlin-alexanderplatz",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/leonardo-royal-hotel-berlin-alexanderplatz/",
      title: {
        rendered: "Leonardo Royal Hotel",
      },
      featured_media: 17006,
      template: "",
      projekt_filter: [250, 251, 254, 427, 425, 256],
      acf: {
        highlight_image: 17117,
        highlight_title_project: "Leonardo Royal Hotel",
        highlight_subtitle_project: "Hotel hinter historischer Fassade",
        highlight_description_project:
          "The Leonardo Royal Hotel welcomes its guests in the former headquarters of the Federal Police. In the middle of the capital, the hotel offers all the requirements of an attractive hotel with its well-thought-out floor plan, ideal size and central location. In addition, comfortable rooms and a variety of services leave nothing to be desired. Built in 1956, the building was completely renovated in 2009 and converted into a 4-star superior hotel, whose facade, lobby and staircase are also listed buildings.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location: "Otto-Braun-Str. 90, 10249 Berlin",
        property: "6,837 m²",
        area: "18,500 m² ",
        zertifizierung: "",
        parcels: "58 in- and outdoor parking spaces",
        use_for: "Hotel ",
        acquired: "Q3 2020",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Berlin",
        fakten: [
          {
            bezeichnung: "Built in",
            wert: "1956 / Completely renovated in 2009",
            anchor: "",
          },
        ],
        specifications_image_projects: null,
        slider: [17113, 17111],
        title_details_projects: "Leonardo Royal Hotel Alexanderplatz IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "High-quality multifunctionality",
            description_repeater_details:
              "Under the Leonardo Royal brand, the former administration building houses an area of around 18,500 m² on seven floors. Both the spacious, light-flooded lobby with high ceilings and harmonious lighting concept and the 346 rooms impress with their friendly colours and clear design language. There are also eleven conference rooms with an event area of approx. 1,000 m² available. The quality of stay is completed by a restaurant, a bar and a fitness and sauna area with a spectacular view over the city. In 2020/2021, the hotel's public areas and guest rooms will be extensively renovated to bring the hotel up to the standards of modern business and leisure travellers.",
            image_repeater_details: 17111,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Feel good in the middle of the city",
            description_repeater_details:
              "Although the Leonardo Royal Hotel is located in the centre of Berlin and close to the popular Prenzlauer Berg district, guests relax on the quiet terrace or in the green courtyard with seating and lounge furniture. The hotel is conveniently located just a few minutes' walk from the Alexanderplatz interchange and offers 58 underground and outdoor parking spaces. The Volkspark Friedrichshain, large shopping centres, the television tower and the famous Museum Island are within walking distance.",
            image_repeater_details: 17113,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address:
            "Leonardo Royal Hotel Berlin Alexanderplatz, Otto-Braun-Straße 90, 10249 Berlin, Deutschland",
          lat: 52.52747,
          lng: 13.42339,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Leonardo Royal Hotel Alexanderplatz</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/leonardo-royal-hotel-berlin-alexanderplatz/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Leonardo Royal Hotel Alexanderplatz" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/leonardo-royal-hotel-berlin-alexanderplatz/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-09-02T07:31:45+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/08/Außenansicht-Leonardo-Royal-Berlin-Alexanderplatz-c-Leonardo-Hotels-Central-Europe.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1700" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/leonardo-royal-hotel-berlin-alexanderplatz/","url":"https://www.art-invest.de/en/projekt/leonardo-royal-hotel-berlin-alexanderplatz/","name":"Art-Invest Real Estate | Leonardo Royal Hotel Alexanderplatz","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-08-17T15:12:02+00:00","dateModified":"2020-09-02T07:31:45+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/leonardo-royal-hotel-berlin-alexanderplatz/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/leonardo-royal-hotel-berlin-alexanderplatz/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/leonardo-royal-hotel-berlin-alexanderplatz/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Leonardo Royal Hotel Alexanderplatz"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Leonardo Royal Hotel Alexanderplatz",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/leonardo-royal-hotel-berlin-alexanderplatz/",
        og_locale: "en_US",
        og_type: "article",
        og_title:
          "Art-Invest Real Estate | Leonardo Royal Hotel Alexanderplatz",
        og_url:
          "https://www.art-invest.de/en/projekt/leonardo-royal-hotel-berlin-alexanderplatz/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-09-02T07:31:45+00:00",
        og_image: [
          {
            width: 2560,
            height: 1700,
            url: "https://www.art-invest.de/wp-content/uploads/2020/08/Außenansicht-Leonardo-Royal-Berlin-Alexanderplatz-c-Leonardo-Hotels-Central-Europe.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/leonardo-royal-hotel-berlin-alexanderplatz/",
              url: "https://www.art-invest.de/en/projekt/leonardo-royal-hotel-berlin-alexanderplatz/",
              name: "Art-Invest Real Estate | Leonardo Royal Hotel Alexanderplatz",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-08-17T15:12:02+00:00",
              dateModified: "2020-09-02T07:31:45+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/leonardo-royal-hotel-berlin-alexanderplatz/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/leonardo-royal-hotel-berlin-alexanderplatz/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/leonardo-royal-hotel-berlin-alexanderplatz/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Leonardo Royal Hotel Alexanderplatz",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/08/Außenansicht-Leonardo-Royal-Berlin-Alexanderplatz-c-Leonardo-Hotels-Central-Europe-800x800.jpg",
      place: "Berlin Alexanderplatz",
      subtitle: "Hotel hinter historischer Fassade",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/17029",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/17111",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/17113",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/17006",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=17029",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=17029",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },

    {
      id: 16672,
      date: "2019-10-07T11:41:16",
      date_gmt: "2019-10-07T09:41:16",
      guid: {
        rendered: "https://www.art-invest.de/projekt/hallesches-ufer/",
      },
      modified: "2023-07-21T09:16:34",
      modified_gmt: "2023-07-21T07:16:34",
      slug: "die-macherei-berlin-kreuzberg",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/die-macherei-berlin-kreuzberg/",
      title: {
        rendered: "Die Macherei Berlin-Kreuzberg",
      },
      featured_media: 19218,
      template: "",
      projekt_filter: [246, 427, 425, 245, 256],
      acf: {
        highlight_image: 19226,
        highlight_title_project: "Die Macherei Berlin-Kreuzberg",
        highlight_subtitle_project: "Stadtquartier in Mitte",
        highlight_description_project:
          "New start in the Macherei Berlin-Kreuzberg: In the heart of Berlin, in the immediate vicinity of Potsdamer Platz, a lively area is being developed with office space, co-working, fitness, local food supply and stores for daily needs.",
        highlight_logo_project: null,
        website_projects: {
          title: "www.die-macherei-kreuzberg.de",
          url: "https://www.die-macherei-kreuzberg.de/",
          target: "",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://www.die-macherei-kreuzberg.de/",
          target: "_blank",
        },
        available_space: [""],
        project: "Development, Re-Development existing property (Tower)",
        location: "Hallesches Ufer 40-60, 10963 Berlin",
        property: "31,302 sqm",
        area: "Office approx. 44,000 sqm, gastronomy and retail approx. 6,000 sqm",
        zertifizierung: "",
        parcels: "approx. 150 underground car park, approx. 500 bicycle racks",
        use_for: "Office, Co-Working, Gastronomy, Retail, Fitness",
        acquired: "Q4 2017",
        realization: "2024 (M40, M60); 2026 (M50)",
        sale: "",
        architecture_firm:
          "ROBERT NEUN, sauerbruch hutton, Eike Becker_Architekten",
        place: "Berlin",
        fakten: null,
        specifications_image_projects: 19224,
        slider: [19218, 19224, 19222, 19226, 19216, 25196, 25198],
        title_details_projects: "DIE MACHEREI BERLIN-KREUZBERG IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              "From an administrative location to a striking city centre ",
            description_repeater_details:
              "A neighborhood that is experiencing noticeable upgrades: The Macherei Berlin-Kreuzberg construction project will give the former administrative site a whole new look. Where the Postscheckamt once caught the eye, working worlds are forming an open quarter on three building plots, located between Potsdamer Platz and Park am Gleisdreieck.",
            image_repeater_details: 19226,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Attractive field of tension in a prime inner-city location ",
            description_repeater_details:
              "The architecturally trend-setting project in the central downtown location is interesting in many ways. It creates attractive space for working, shopping, playing sports, enjoying and learning.\r\n\r\nFuture users of the quarter will also benefit from an outstanding infrastructure with excellent public transport connections.",
            image_repeater_details: 19220,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Hallesches Ufer 40-60, 10963 Berlin, Deutschland",
          lat: 52.50002000000001,
          lng: 13.38471,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Die Macherei Berlin-Kreuzberg</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/die-macherei-berlin-kreuzberg/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Die Macherei Berlin-Kreuzberg" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/die-macherei-berlin-kreuzberg/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-07-21T07:16:34+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2019/10/ARTINVEST_Kreuzberg-Macherei_View-15_Aerial-Sun_AS-min-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="2048" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/die-macherei-berlin-kreuzberg/","url":"https://www.art-invest.de/en/projekt/die-macherei-berlin-kreuzberg/","name":"Art-Invest Real Estate | Die Macherei Berlin-Kreuzberg","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2019-10-07T09:41:16+00:00","dateModified":"2023-07-21T07:16:34+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/die-macherei-berlin-kreuzberg/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/die-macherei-berlin-kreuzberg/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/die-macherei-berlin-kreuzberg/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Die Macherei Berlin-Kreuzberg"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Die Macherei Berlin-Kreuzberg",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/die-macherei-berlin-kreuzberg/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Die Macherei Berlin-Kreuzberg",
        og_url:
          "https://www.art-invest.de/en/projekt/die-macherei-berlin-kreuzberg/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-07-21T07:16:34+00:00",
        og_image: [
          {
            width: 2560,
            height: 2048,
            url: "https://www.art-invest.de/wp-content/uploads/2019/10/ARTINVEST_Kreuzberg-Macherei_View-15_Aerial-Sun_AS-min-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/die-macherei-berlin-kreuzberg/",
              url: "https://www.art-invest.de/en/projekt/die-macherei-berlin-kreuzberg/",
              name: "Art-Invest Real Estate | Die Macherei Berlin-Kreuzberg",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2019-10-07T09:41:16+00:00",
              dateModified: "2023-07-21T07:16:34+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/die-macherei-berlin-kreuzberg/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/die-macherei-berlin-kreuzberg/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/die-macherei-berlin-kreuzberg/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Die Macherei Berlin-Kreuzberg",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2019/10/ARTINVEST_Kreuzberg-Macherei_View-15_Aerial-Sun_AS-min-800x800.jpg",
      place: "Berlin",
      subtitle: "Stadtquartier in Mitte ",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16672",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25198",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25196",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19216",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19226",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19222",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19224",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19218",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19218",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16672",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16672",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16819,
      date: "2014-07-17T12:00:39",
      date_gmt: "2014-07-17T10:00:39",
      guid: {
        rendered: "https://www.art-invest.de/projekt/nikko-hotel/",
      },
      modified: "2023-07-10T09:53:44",
      modified_gmt: "2023-07-10T07:53:44",
      slug: "clayton-hotel",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/clayton-hotel/",
      title: {
        rendered: "Clayton Hotel",
      },
      featured_media: 23481,
      template: "",
      projekt_filter: [246, 251, 427, 425, 245, 257],
      acf: {
        highlight_image: 25117,
        highlight_title_project: "Clayton Hotel",
        highlight_subtitle_project: "Haus der aufgehenden Sonne",
        highlight_description_project:
          "Japan's capital in Germany is Dusseldorf. More than 9,000 Japanese live in the city and create East Asian flair, more than 350 companies have their headquarters on the Rhine. The 4-star Clayton Hotel in Dusseldorf is the first address for business visitors from Nippon and all over the world. In January 2023 the Nikko Hotel has been rebranded as Clayton Hotel.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project:
          "Investment, Increase in value through complete renovation of the guest rooms and public areas",
        location: "Immermannstraße 41, 40210 Dusseldorf; city centre",
        property: "9,031 m²",
        area: "34,043 m² BGF / 393 guest rooms + 8,761 m² office and retail space",
        zertifizierung: "",
        parcels: "550 underground parking spaces",
        use_for: "4-Sterne Business Hotel, Office, Retail",
        acquired: "Q4 2016",
        realization: "1978",
        sale: "",
        architecture_firm: "",
        place: "Düsseldorf",
        fakten: null,
        specifications_image_projects: 16825,
        slider: [25117, 16822],
        title_details_projects: "CLAYTON HOTEL IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Haus der aufgehenden Sonne",
            description_repeater_details:
              "The district around Immermannstraße is also known in Dusseldorf as Little Tokyo. The Clayton Hotel is creating a home on 34,043 m² GFA in 393 rooms, specially designed to reflect the Japanese way of life and etiquette. In the restaurant, an expert in the field of Kaiseki cuisine is at work, while Reiki masters are waiting in the spa area. The property on the 9,031 m² site also includes 8,761 m² of office and retail space.",
            image_repeater_details: 25117,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Konnichiwa Dusseldorf",
            description_repeater_details:
              "The hotel is centrally located in the city centre between the main railway station and Königsallee. The Kö-Bogen, the old town and the Rhine promenade are only a few minutes’ walk away. The banking district is in the neighbourhood and by car or train you can reach Dusseldorf airport in only 10 minutes. The underground car park has space for 550 underground parking spaces – the rule to follow is: always hand over and accept business cards with both hands.",
            image_repeater_details: 16822,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Immermannstraße 41, Düsseldorf, Deutschland",
          lat: 51.22276,
          lng: 6.789089999999987,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Clayton Hotel</title>\n<meta name="description" content="Das Nikko Hotel in Düsseldorf schafft auf 34.043 m² in 386 Zimmern eine Heimat speziell abgestimmt auf japanische Lebensart und Etikette." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/clayton-hotel/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Clayton Hotel" />\n<meta property="og:description" content="Das Nikko Hotel in Düsseldorf schafft auf 34.043 m² in 386 Zimmern eine Heimat speziell abgestimmt auf japanische Lebensart und Etikette." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/clayton-hotel/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-07-10T07:53:44+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2014/07/ssf_1906_Art-Invest-Nikko_23-3.jpg" />\n\t<meta property="og:image:width" content="2500" />\n\t<meta property="og:image:height" content="1732" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/clayton-hotel/","url":"https://www.art-invest.de/en/projekt/clayton-hotel/","name":"Art-Invest Real Estate | Clayton Hotel","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-07-17T10:00:39+00:00","dateModified":"2023-07-10T07:53:44+00:00","description":"Das Nikko Hotel in Düsseldorf schafft auf 34.043 m² in 386 Zimmern eine Heimat speziell abgestimmt auf japanische Lebensart und Etikette.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/clayton-hotel/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/clayton-hotel/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/clayton-hotel/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Clayton Hotel"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Clayton Hotel",
        description:
          "Das Nikko Hotel in Düsseldorf schafft auf 34.043 m² in 386 Zimmern eine Heimat speziell abgestimmt auf japanische Lebensart und Etikette.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/clayton-hotel/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Clayton Hotel",
        og_description:
          "Das Nikko Hotel in Düsseldorf schafft auf 34.043 m² in 386 Zimmern eine Heimat speziell abgestimmt auf japanische Lebensart und Etikette.",
        og_url: "https://www.art-invest.de/en/projekt/clayton-hotel/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-07-10T07:53:44+00:00",
        og_image: [
          {
            width: 2500,
            height: 1732,
            url: "https://www.art-invest.de/wp-content/uploads/2014/07/ssf_1906_Art-Invest-Nikko_23-3.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/clayton-hotel/",
              url: "https://www.art-invest.de/en/projekt/clayton-hotel/",
              name: "Art-Invest Real Estate | Clayton Hotel",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-07-17T10:00:39+00:00",
              dateModified: "2023-07-10T07:53:44+00:00",
              description:
                "Das Nikko Hotel in Düsseldorf schafft auf 34.043 m² in 386 Zimmern eine Heimat speziell abgestimmt auf japanische Lebensart und Etikette.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/clayton-hotel/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/clayton-hotel/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/clayton-hotel/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Clayton Hotel",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2014/07/ssf_1906_Art-Invest-Nikko_23-3-800x800.jpg",
      place: "Düsseldorf",
      subtitle: "Haus der aufgehenden Sonne",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16819",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16822",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25117",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/23481",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16819",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16819",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16864,
      date: "2019-05-07T15:03:17",
      date_gmt: "2019-05-07T13:03:17",
      guid: {
        rendered: "https://www.art-invest.de/projekt/admi-ahoi/",
      },
      modified: "2023-07-17T09:42:46",
      modified_gmt: "2023-07-17T07:42:46",
      slug: "admi-ahoi",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/admi-ahoi/",
      title: {
        rendered: "ADMI AHOI",
      },
      featured_media: 16866,
      template: "",
      projekt_filter: [246, 248, 427, 425, 245],
      acf: {
        highlight_image: 25150,
        highlight_title_project: "ADMI AHOI",
        highlight_subtitle_project: "Wo die Reeder “Moin, Moin” sagten”",
        highlight_description_project:
          "You can't get more port flair than that. The Admiralitätsstraße could be on the synonym list for shipping. Its location is historic: known as the Shipowners' Mile, it owes its name to the Admiralty, an authority that was established in 1623 to regulate shipping traffic and trade.",
        highlight_logo_project: null,
        website_projects: {
          title: "www.admi-ahoi.de",
          url: "https://admi-ahoi.de/",
          target: "",
        },
        external_projectpage: {
          title: "www.admi-ahoi.de",
          url: "https://admi-ahoi.de/",
          target: "",
        },
        available_space: [""],
        project: "Development",
        location: "Admiralitätstraße 59/60, 20459 Hamburg",
        property: "1,645 m²",
        area: "9,600 m²",
        zertifizierung: "",
        parcels: "78",
        use_for: "Office, Residential",
        acquired: "Q1 2016",
        realization:
          "Admiraliätstraße 60: Q2 2020,   Admiralitätstraße 59: Q1 2024",
        sale: "",
        architecture_firm: "AGN Leusmann",
        place: "Hamburg",
        fakten: null,
        specifications_image_projects: 16865,
        slider: [25128, 25130],
        title_details_projects: "ADMI AHOI IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              "ADMI AHOI: Ready for the future after extensive refurbishment",
            description_repeater_details:
              "The office building ensemble ADMI AHOI – an alliance of names from the historic location of the building and the international sailors' salute – represents the connection of Fleetinsel to the port of Hamburg. Built in 1987, the property was consistently developed and after a revitalisation of the facade design, it was completely upgraded. The two twin buildings were connected via an underground car park. In addition, the staggered storeys have been increased to a total of seven floors and a unique roof terrace has been added, providing a fascinating panoramic view of the dimensions of the container port and the sensational architecture of the Elbphilharmonie. The interior can be adapted to the tenant’s needs, which offers users the greatest possible flexibility. The entire building was provided with high-quality materials and impresses with its Nordic-minimalist design, which is friendly and radiates lightness.",
            image_repeater_details: 25148,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "The Elbphilharmonie Concert Hall close enough to touch",
            description_repeater_details:
              "The Fleetinsel quarter, surrounded by water, lives from its special atmosphere. It is located between the Inner Alster and the Elbe, Rödingsmarkt and Michel, the landmark of the Hanseatic city. As a centre for numerous galleries, creative shops, different restaurants and nice cafés, the Admiralitätsstraße is not only popular with shipping people, but also an attraction for tourists interested in art and culture. Here, at the gateway to the world, excursions to the modern HafenCity, the Elbphilharmonie and the Speicherstadt are started. The inner city of Germany's second largest metropolis is also within walking distance.",
            image_repeater_details: 25149,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Admiralitätstraße 59/60, 20459 Hamburg, Deutschland",
          lat: 53.5476193,
          lng: 9.983660099999952,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | ADMI AHOI</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/admi-ahoi/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | ADMI AHOI" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/admi-ahoi/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-07-17T07:42:46+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2019/05/Finale_Bemusterung_OD_Fassade-Kopie-1-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1810" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/admi-ahoi/","url":"https://www.art-invest.de/en/projekt/admi-ahoi/","name":"Art-Invest Real Estate | ADMI AHOI","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2019-05-07T13:03:17+00:00","dateModified":"2023-07-17T07:42:46+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/admi-ahoi/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/admi-ahoi/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/admi-ahoi/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"ADMI AHOI"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | ADMI AHOI",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/admi-ahoi/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | ADMI AHOI",
        og_url: "https://www.art-invest.de/en/projekt/admi-ahoi/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-07-17T07:42:46+00:00",
        og_image: [
          {
            width: 2560,
            height: 1810,
            url: "https://www.art-invest.de/wp-content/uploads/2019/05/Finale_Bemusterung_OD_Fassade-Kopie-1-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/admi-ahoi/",
              url: "https://www.art-invest.de/en/projekt/admi-ahoi/",
              name: "Art-Invest Real Estate | ADMI AHOI",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2019-05-07T13:03:17+00:00",
              dateModified: "2023-07-17T07:42:46+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/admi-ahoi/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/admi-ahoi/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/admi-ahoi/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "ADMI AHOI",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2019/05/Finale_Bemusterung_OD_Fassade-Kopie-1-1-scaled.jpg",
      place: "Hamburg",
      subtitle: "Wo die Reeder “Moin, Moin” sagten",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16864",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25130",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25128",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16866",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16864",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16864",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16893,
      date: "2018-01-19T15:57:59",
      date_gmt: "2018-01-19T14:57:59",
      guid: {
        rendered: "https://www.art-invest.de/projekt/palais-am-bundesrat/",
      },
      modified: "2020-07-15T12:37:33",
      modified_gmt: "2020-07-15T12:37:33",
      slug: "palais-am-bundesrat",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/palais-am-bundesrat/",
      title: {
        rendered: "Palais am Bundesrat",
      },
      featured_media: 16895,
      template: "",
      projekt_filter: [246, 427, 425, 245, 256],
      acf: {
        highlight_image: 16895,
        highlight_title_project: "Palais am Bundesrat",
        highlight_subtitle_project: "Neue Adresse zum Arbeiten und Einkaufen",
        highlight_description_project:
          "In a historical location in the heart of Berlin, the prestigious Palais am Bundesrat is located on Leipziger Platz. With a total area of approx. 5,000 m², this impressive property offers space for offices, apartments and retail.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Existing properties",
        location: "Leipziger Platz 11, 10117 Berlin; Palais am Bundesrat",
        property: "approx. 805 m²",
        area: "5,033 m²",
        zertifizierung: "",
        parcels: "27",
        use_for: "Office, Living, Retail",
        acquired: "Q3 2017",
        realization: "2001",
        sale: "",
        architecture_firm: "",
        place: "Berlin",
        fakten: [
          {
            bezeichnung: "Design",
            wert: "Prof. Walter A. Noebel",
            anchor: "",
          },
        ],
        specifications_image_projects: 4968,
        slider: null,
        title_details_projects: "PALAIS AM BUNDESRAT IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Historical significance",
            description_repeater_details:
              "The octagonal square (octagon) of Leipziger Platz forms a double square with the Potsdamer Platz. Already at the beginning of the 20th century, the location was considered as one of the most important centres in Europe and a symbol for the metropolis of Berlin.",
            image_repeater_details: 4977,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Tradition meets modernity",
            description_repeater_details:
              "Leipziger Platz still enjoys an excellent reputation today as a central and prestigious office and retail location. One of the outstanding properties at Leipziger Platz is the Palais am Bundesrat. The 10-storey building made of reinforced concrete with a natural stone facade houses numerous offices and shops.",
            image_repeater_details: 16894,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Prominent surroundings",
            description_repeater_details:
              "The neighborhood at this historical place is very impressive: In addition to the Federal Council, other political institutions such as the Canadian Embassy and the Federal Ministry of Finance are in the immediate vicinity of the Palais. Opposite the property is also the city's largest shopping centre – the Mall of Berlin.",
            image_repeater_details: 4973,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Leipziger Platz 11, 10117, Berlin, Deutschland",
          lat: 52.50948899999999,
          lng: 13.37984460000007,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Palais am Bundesrat</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/palais-am-bundesrat/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Palais am Bundesrat" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/palais-am-bundesrat/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-15T12:37:33+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2018/01/Leipziger-Platz-750-1.jpg" />\n\t<meta property="og:image:width" content="750" />\n\t<meta property="og:image:height" content="750" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/palais-am-bundesrat/","url":"https://www.art-invest.de/en/projekt/palais-am-bundesrat/","name":"Art-Invest Real Estate | Palais am Bundesrat","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2018-01-19T14:57:59+00:00","dateModified":"2020-07-15T12:37:33+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/palais-am-bundesrat/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/palais-am-bundesrat/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/palais-am-bundesrat/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Palais am Bundesrat"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Palais am Bundesrat",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/palais-am-bundesrat/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Palais am Bundesrat",
        og_url: "https://www.art-invest.de/en/projekt/palais-am-bundesrat/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-15T12:37:33+00:00",
        og_image: [
          {
            width: 750,
            height: 750,
            url: "https://www.art-invest.de/wp-content/uploads/2018/01/Leipziger-Platz-750-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/palais-am-bundesrat/",
              url: "https://www.art-invest.de/en/projekt/palais-am-bundesrat/",
              name: "Art-Invest Real Estate | Palais am Bundesrat",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2018-01-19T14:57:59+00:00",
              dateModified: "2020-07-15T12:37:33+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/palais-am-bundesrat/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/palais-am-bundesrat/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/palais-am-bundesrat/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Palais am Bundesrat",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2018/01/Leipziger-Platz-750-1.jpg",
      place: "Berlin",
      subtitle: "Neue Adresse zum Arbeiten",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16893",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16895",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16893",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16893",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16640,
      date: "2015-07-14T12:00:15",
      date_gmt: "2015-07-14T10:00:15",
      guid: {
        rendered: "https://www.art-invest.de/projekt/nove/",
      },
      modified: "2021-11-04T18:03:33",
      modified_gmt: "2021-11-04T17:03:33",
      slug: "nove",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/nove/",
      title: {
        rendered: "NOVE",
      },
      featured_media: 16642,
      template: "",
      projekt_filter: [246, 426, 249, 425],
      acf: {
        highlight_image: 16647,
        highlight_title_project: "NOVE",
        highlight_subtitle_project: "Ein Turm fürs Leben",
        highlight_description_project:
          "With NOVE, the Italian architect and designer Antonio Citterio caused a sensation in Munich –the plans for the elegant office ensemble: NOVE was created on the last vacant lot in Arnulfpark by his multidisciplinary Milan office.",
        highlight_logo_project: 16646,
        website_projects: {
          title: "www.nove.de",
          url: "http://www.nove.de/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "http://www.nove.de/",
          target: "_blank",
        },
        available_space: [""],
        project: "Development",
        location:
          "Luise-Ulrich-Straße / Lilli-Palmer-Straße, 80636 Munich; Arnulfpark directly next to the Mercedes Center",
        property: "7,330 m²",
        area: "27,500 m²",
        zertifizierung: "",
        parcels: "430",
        use_for: "Office, Gastronomy",
        acquired: "2013",
        realization: "2016",
        sale: "",
        architecture_firm: "Citterio (Mailand)",
        place: "München",
        fakten: null,
        specifications_image_projects: 16641,
        slider: null,
        title_details_projects: "NOVE IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Ein Turm fürs Leben",
            description_repeater_details:
              '"The goal of architecture is life. If you don’t create life forget it", is the philosophy of Citterio, who celebrated his first successes as a designer long before he completed his studies in architecture. Thus, on the 7,300 m² building site on Luise-Ullrich-Straße, corner of Lilli-Palmer-Straße, a complex was created that combines architecture and design with Italian elegance on a gross floor area of around 27,500 m².',
            image_repeater_details: 16644,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "The last element ",
            description_repeater_details:
              "The NOVE completes Arnulfpark. In recent years, a window into the future of urban life has opened on the site of the former freight depot.\r\n\r\nOn 185,000 m² of gross building land, innovative architecture for commercial, residential and cultural purposes has been created in recent years. In the NOVE, approx. 27,500 m² of floor space is distributed over six standard floors, a 23 m high atrium and a nine-storey high-rise wing on Luise-Ullrich-Strasse. The facade lifts NOVE out of its surroundings: gold-bronze aluminium frames adorn the windows and give the building a striking, three-dimensional structure.",
            image_repeater_details: 14051,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Trip to the foothills of the Alps ",
            description_repeater_details:
              "From the roof terraces on the sixth floor the view extends far into the foothills of the Alps. In addition to the apparently floating lounge bridges between the building sections, the green roof is a picturesque platform for exchange or time out. The Italian palazzo is an urbanistic model for NOVE: in the centre of the ensemble are two inner courtyards for conferences in a protected open space. In total, the ensemble provides space for more than 1,300 workplaces - each with a perfect connection. The suburban railway station Donnersbergerbrücke is located in Arnulfpark, the main station is within walking distance and the driveway to Mittlerer Ring is on the next street corner. There are 430 parking spaces on the site.",
            image_repeater_details: 16645,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "A sustainable budget ",
            description_repeater_details:
              "NOVE is designed as a green building. A certification according to LEED Gold is planned. With its sustainable and efficient construction, the NOVE presents itself at the highest level of current technology. Of course, the new building also meets the requirements for energy-efficient building operation.",
            image_repeater_details: 16643,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Luise-Ulrich-Straße/Lilli-Palmer-Straße, 80636 München",
          lat: 48.14436269999999,
          lng: 11.53712870000004,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | NOVE</title>\n<meta name="description" content="Auf rund 7.300 m2 Baugrund wächst an der Luise-Ullrich-Straße ein Bürokomplex, der Architektur und Design mit italienischer Eleganz verbindet." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/nove/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | NOVE" />\n<meta property="og:description" content="Auf rund 7.300 m2 Baugrund wächst an der Luise-Ullrich-Straße ein Bürokomplex, der Architektur und Design mit italienischer Eleganz verbindet." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/nove/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T17:03:33+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2015/07/nove_citterio_rainer_taepper_architekturfotografie-17-2-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="2414" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/nove/","url":"https://www.art-invest.de/en/projekt/nove/","name":"Art-Invest Real Estate | NOVE","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2015-07-14T10:00:15+00:00","dateModified":"2021-11-04T17:03:33+00:00","description":"Auf rund 7.300 m2 Baugrund wächst an der Luise-Ullrich-Straße ein Bürokomplex, der Architektur und Design mit italienischer Eleganz verbindet.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/nove/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/nove/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/nove/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"NOVE"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | NOVE",
        description:
          "Auf rund 7.300 m2 Baugrund wächst an der Luise-Ullrich-Straße ein Bürokomplex, der Architektur und Design mit italienischer Eleganz verbindet.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/nove/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | NOVE",
        og_description:
          "Auf rund 7.300 m2 Baugrund wächst an der Luise-Ullrich-Straße ein Bürokomplex, der Architektur und Design mit italienischer Eleganz verbindet.",
        og_url: "https://www.art-invest.de/en/projekt/nove/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T17:03:33+00:00",
        og_image: [
          {
            width: 2560,
            height: 2414,
            url: "https://www.art-invest.de/wp-content/uploads/2015/07/nove_citterio_rainer_taepper_architekturfotografie-17-2-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/nove/",
              url: "https://www.art-invest.de/en/projekt/nove/",
              name: "Art-Invest Real Estate | NOVE",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2015-07-14T10:00:15+00:00",
              dateModified: "2021-11-04T17:03:33+00:00",
              description:
                "Auf rund 7.300 m2 Baugrund wächst an der Luise-Ullrich-Straße ein Bürokomplex, der Architektur und Design mit italienischer Eleganz verbindet.",
              breadcrumb: {
                "@id": "https://www.art-invest.de/en/projekt/nove/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/nove/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/nove/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "NOVE",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2015/07/nove_citterio_rainer_taepper_architekturfotografie-17-2-scaled-800x800.jpg",
      place: "München",
      subtitle: "Ein Turm fürs Leben ",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16640",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16642",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16640",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16640",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16891,
      date: "2020-01-17T17:00:26",
      date_gmt: "2020-01-17T16:00:26",
      guid: {
        rendered:
          "https://www.art-invest.de/projekt/ibis-styles-hotel-adagio-access-kiel/",
      },
      modified: "2023-09-18T12:11:13",
      modified_gmt: "2023-09-18T10:11:13",
      slug: "ibis-styles-hotel-adagio-access-kiel",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/ibis-styles-hotel-adagio-access-kiel/",
      title: {
        rendered: "Adagio Access(ibis Styles)",
      },
      featured_media: 16892,
      template: "",
      projekt_filter: [251, 427, 425, 263],
      acf: {
        highlight_image: 16892,
        highlight_title_project: "Adagio Access Kiel",
        highlight_subtitle_project: "In der Welthauptstadt des Segelsports",
        highlight_description_project:
          "For the new Ibis Styles in Kiel, which opens its doors in conjunction with the Adagio Hotel, there could be no better location than on the edge of the old town and in direct proximity to the boat harbor - the city's maritime gateway.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment",
        location: "Holstenbrücke 28, 24103 Kiel",
        property: "4.811 m²",
        area: "5.962 m²",
        zertifizierung: "",
        parcels: "26",
        use_for: "Hotel, Gastronomie",
        acquired: "Q4 2018",
        realization: "Q3 2021",
        sale: "",
        architecture_firm: "Schnittger Architekten & Partner ",
        place: "Kiel",
        fakten: null,
        specifications_image_projects: 24731,
        slider: [16892, 25523, 25525, 25527],
        title_details_projects:
          "IBIS STYLES HOTEL / ADAGIO ACCESS KIEL IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              "Affordable comfort in sophisticated architecture",
            description_repeater_details:
              'An undulating clinker facade and the strikingly protruding window surrounds emphasize the high-quality character of the Ibis Styles Hotel. The appealing architecture is the result of an urban planning competition and fits into a successful urban development. A total of 238 rooms in different categories are available to hotel guests. Particularly spacious rooms but also studios and two-room apartments in the Aparthotel Adagio offer ideal accommodation for longer stays. Another special feature is the popular hotel restaurant "Mike\'s Urban Pub", which is also open to external guests and provides evening animation of the hotel.',
            image_repeater_details: 24731,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Excellent micro-location for business people and tourists",
            description_repeater_details:
              "The hotel complex is located at the Holstenbrücke in the inner-city, dynamically growing Booshafen quarter, which has been experiencing an upgrade for several years due to the structural reorganization. Close to the fjord and within sight of the Schwedenkai, the special charm of the city surrounded by water becomes tangible. To further enhance the quality of stay, the restoration of the water connection between the boat harbor and Kleiner Kiel is planned. With the immediate proximity to the main train station and to versatile shopping and strolling possibilities, business people and leisure tourists will find an ideal starting point for their visit to Kiel.",
            image_repeater_details: 14109,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Holstenbrücke 28, 24103 Kiel, Deutschland",
          lat: 54.32088359999999,
          lng: 10.1376872,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | ibis Styles Hotel / Adagio Access Kiel</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/ibis-styles-hotel-adagio-access-kiel/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | ibis Styles Hotel / Adagio Access Kiel" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/ibis-styles-hotel-adagio-access-kiel/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-09-18T10:11:13+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/03/Bildschirmfoto-2020-01-17-um-12.27.49-Kopie.jpg" />\n\t<meta property="og:image:width" content="2308" />\n\t<meta property="og:image:height" content="1230" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/ibis-styles-hotel-adagio-access-kiel/","url":"https://www.art-invest.de/en/projekt/ibis-styles-hotel-adagio-access-kiel/","name":"Art-Invest Real Estate | ibis Styles Hotel / Adagio Access Kiel","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-01-17T16:00:26+00:00","dateModified":"2023-09-18T10:11:13+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/ibis-styles-hotel-adagio-access-kiel/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/ibis-styles-hotel-adagio-access-kiel/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/ibis-styles-hotel-adagio-access-kiel/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"ibis Styles Hotel / Adagio Access Kiel"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title:
          "Art-Invest Real Estate | ibis Styles Hotel / Adagio Access Kiel",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/ibis-styles-hotel-adagio-access-kiel/",
        og_locale: "en_US",
        og_type: "article",
        og_title:
          "Art-Invest Real Estate | ibis Styles Hotel / Adagio Access Kiel",
        og_url:
          "https://www.art-invest.de/en/projekt/ibis-styles-hotel-adagio-access-kiel/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-09-18T10:11:13+00:00",
        og_image: [
          {
            width: 2308,
            height: 1230,
            url: "https://www.art-invest.de/wp-content/uploads/2020/03/Bildschirmfoto-2020-01-17-um-12.27.49-Kopie.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/ibis-styles-hotel-adagio-access-kiel/",
              url: "https://www.art-invest.de/en/projekt/ibis-styles-hotel-adagio-access-kiel/",
              name: "Art-Invest Real Estate | ibis Styles Hotel / Adagio Access Kiel",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-01-17T16:00:26+00:00",
              dateModified: "2023-09-18T10:11:13+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/ibis-styles-hotel-adagio-access-kiel/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/ibis-styles-hotel-adagio-access-kiel/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/ibis-styles-hotel-adagio-access-kiel/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Adagio Access Kiel",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/03/Bildschirmfoto-2020-01-17-um-12.27.49-Kopie-800x800.jpg",
      place: "Kiel",
      subtitle: "Welthauptstadt des Segelns",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16891",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25527",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25525",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25523",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16892",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16892",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16891",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16891",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21694,
      date: "2014-02-15T12:00:11",
      date_gmt: "2014-02-15T11:00:11",
      guid: {
        rendered: "https://www.art-invest.de/projekt/rilano-hotel/",
      },
      modified: "2022-10-27T10:37:39",
      modified_gmt: "2022-10-27T08:37:39",
      slug: "rilano-hotel",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/rilano-hotel/",
      title: {
        rendered: "Rilano Hotel",
      },
      featured_media: 21696,
      template: "",
      projekt_filter: [251, 427, 249, 425],
      acf: {
        highlight_image: 21696,
        highlight_title_project: "Rilano Hotel",
        highlight_subtitle_project: "Eine Location mit Glücksfaktor",
        highlight_description_project:
          "The Rilano Hotels Munich are among the top addresses in one of the first high-tech locations. The hotels currently have more than 228 rooms and modern conference rooms - the influx of various companies such as Microsoft and Arri not only increases the hipness factor in Parkstadt, but also the demand for beds.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment",
        location:
          "Domagkstrasse 26, 80807 Munich; centrally located in the up-and-coming Parkstadt Schwabing submarket",
        property: "6,400 sqm",
        area: "18,700 sqm",
        zertifizierung: "",
        parcels: "120",
        use_for: "Hotel, parking",
        acquired: "2016",
        realization: "Year of construction: 1972 / 2009",
        sale: "",
        architecture_firm: "",
        place: "München",
        fakten: null,
        specifications_image_projects: 21698,
        slider: [21696, 21695],
        title_details_projects: "RILANO HOTEL IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Munich freedoms",
            description_repeater_details:
              "A perfect connection of the Parkstadt opens up all freedoms for visitors. The ring road network of the city and the central highways. The hotels have parking spaces for 120 automobiles. By car, you can reach the city center in 10 minutes. The Franz-Josef-Strauß airport is about 20 minutes away. The Nordfriedhof and Alte Heide subway stops are within walking distance and connect the Parkstadt with the public transportation network.",
            image_repeater_details: 21696,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "At home in the Bauhaus",
            description_repeater_details:
              "Wilhelm Wagenfeld, Marcel Breuer, Walter Gropius - the street names around the hotels in Parkstadt Schwabing follow a program. The demand for a location that is supposed to combine modern functionality and timeless design like no other is reflected in the names of various great Bauhaus architects.",
            image_repeater_details: 21695,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Domagkstraße 26, München",
          lat: 48.1833925,
          lng: 11.59375220000004,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Rilano Hotel</title>\n<meta name="description" content="Das Parkstadt Hotel München zählt mit über 228 Zimmern und seinen modernen Konferenzräumen zu den ersten Adressen an einem der ersten High-Tech-Standorte." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/rilano-hotel/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Rilano Hotel" />\n<meta property="og:description" content="Das Parkstadt Hotel München zählt mit über 228 Zimmern und seinen modernen Konferenzräumen zu den ersten Adressen an einem der ersten High-Tech-Standorte." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/rilano-hotel/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-27T08:37:39+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2017/01/Muenchen_Parkstadt_Hotel_2-1.jpg" />\n\t<meta property="og:image:width" content="2400" />\n\t<meta property="og:image:height" content="1596" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/rilano-hotel/","url":"https://www.art-invest.de/en/projekt/rilano-hotel/","name":"Art-Invest Real Estate | Rilano Hotel","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-02-15T11:00:11+00:00","dateModified":"2022-10-27T08:37:39+00:00","description":"Das Parkstadt Hotel München zählt mit über 228 Zimmern und seinen modernen Konferenzräumen zu den ersten Adressen an einem der ersten High-Tech-Standorte.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/rilano-hotel/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/rilano-hotel/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/rilano-hotel/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Rilano Hotel"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Rilano Hotel",
        description:
          "Das Parkstadt Hotel München zählt mit über 228 Zimmern und seinen modernen Konferenzräumen zu den ersten Adressen an einem der ersten High-Tech-Standorte.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/rilano-hotel/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Rilano Hotel",
        og_description:
          "Das Parkstadt Hotel München zählt mit über 228 Zimmern und seinen modernen Konferenzräumen zu den ersten Adressen an einem der ersten High-Tech-Standorte.",
        og_url: "https://www.art-invest.de/en/projekt/rilano-hotel/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-27T08:37:39+00:00",
        og_image: [
          {
            width: 2400,
            height: 1596,
            url: "https://www.art-invest.de/wp-content/uploads/2017/01/Muenchen_Parkstadt_Hotel_2-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/rilano-hotel/",
              url: "https://www.art-invest.de/en/projekt/rilano-hotel/",
              name: "Art-Invest Real Estate | Rilano Hotel",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-02-15T11:00:11+00:00",
              dateModified: "2022-10-27T08:37:39+00:00",
              description:
                "Das Parkstadt Hotel München zählt mit über 228 Zimmern und seinen modernen Konferenzräumen zu den ersten Adressen an einem der ersten High-Tech-Standorte.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/rilano-hotel/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/rilano-hotel/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/rilano-hotel/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Rilano Hotel",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2017/01/Muenchen_Parkstadt_Hotel_2-1.jpg",
      place: "München",
      subtitle: "Eine Location mit Glücksfaktor",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21694",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21695",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21696",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21696",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21694",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21694",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21598,
      date: "2014-09-23T12:00:52",
      date_gmt: "2014-09-23T10:00:52",
      guid: {
        rendered: "https://www.art-invest.de/projekt/domkontor/",
      },
      modified: "2022-10-25T09:55:54",
      modified_gmt: "2022-10-25T07:55:54",
      slug: "domkontor",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/domkontor/",
      title: {
        rendered: "D10",
      },
      featured_media: 14090,
      template: "",
      projekt_filter: [246, 426, 248, 425, 245],
      acf: {
        highlight_image: 13972,
        highlight_title_project: "D10",
        highlight_subtitle_project: "Hanseatische Offenheit",
        highlight_description_project:
          "If Kontore, with its mix of business and warehouse space, was the answer to the Hanseatic working world at the turn of the century, then Domkontor provides a contemporary equivalent. The building is an intelligent combination of old and new, an adaptation of historic office space to the requirements of modern office and retail environments.",
        highlight_logo_project: 13441,
        website_projects: {
          title: "www.d-10.de",
          url: "http://www.d-10.de/",
          target: "_blank",
        },
        external_projectpage: "",
        available_space: [""],
        project: "Refurbishment, new construction",
        location: "Domstraße 10, 20095 Hamburg; Neustadt, Germany",
        property: "1,039 sqm",
        area: "6,674 sqm",
        zertifizierung: "",
        parcels: "18",
        use_for: "Office, Retail",
        acquired: "Q3 2012",
        realization: "Q4 2014",
        sale: "Sold to SEB Investment GmbH",
        architecture_firm: "MSM Meyer Schmitz-Morkramer Rhein GmbH",
        place: "Hamburg",
        fakten: null,
        specifications_image_projects: 13440,
        slider: [21599, 14090],
        title_details_projects: "D10 IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Hanseatische Offenheit",
            description_repeater_details:
              "The mix of two classic, listed facades and the modern glass front sets the framework for seven floors of modern offices and retail space - a total of 6,300 sqm. Plenty of natural light, sound and sun protection provide the setting for a pleasant working atmosphere - and anyone stepping out onto the approx. 200 sqm roof terrace on the 7th floor will find themselves in the spectacular company of a magnificent view of the Domplatz.",
            image_repeater_details: 2921,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "All roads lead to the destination",
            description_repeater_details:
              "The Domkontor on the Domplatz topographically connects not only history and the future, but also, due to its location, the city center, and the port. Returning Hamburg to the Elbe is a motif of current urban development, but due to the excellent connections by subway, bus and individual transport, all routes from Domplatz lead quickly to all destinations in the Hamburg metropolitan area.",
            image_repeater_details: 21599,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "The Catholic heritage",
            description_repeater_details:
              "The Domplatz is Hamburg's primeval land. This is where the Catholic bishops celebrated mass in the Mariendom until Martin Luther arrived - and Hamburg's citizens quickly embraced the Reformation. The extraterritorial cathedral grounds in the heart of the city were a thorn in the side of the Protestant councillors. After Napoléon had transferred the cathedral to the city in 1806, nothing stood in the way of its demolition - and the neighboring tower of the Protestant St. Peter's Church henceforth had sole air sovereignty.",
            image_repeater_details: 14090,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Domstraße 10, Hamburg-Neustadt",
          lat: 53.54926,
          lng: 9.995400000000018,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | D10</title>\n<meta name="description" content="Das Domkontor ist eine Verbindung aus Alt und Neu, eine Adaption historischer Kontorflächen an die Anforderungen der moderner Office- und Retailumgebung." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/domkontor/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | D10" />\n<meta property="og:description" content="Das Domkontor ist eine Verbindung aus Alt und Neu, eine Adaption historischer Kontorflächen an die Anforderungen der moderner Office- und Retailumgebung." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/domkontor/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-25T07:55:54+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2014/09/161219_Domkontor_Hamburg_Teaser_neu-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="2560" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/domkontor/","url":"https://www.art-invest.de/en/projekt/domkontor/","name":"Art-Invest Real Estate | D10","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-09-23T10:00:52+00:00","dateModified":"2022-10-25T07:55:54+00:00","description":"Das Domkontor ist eine Verbindung aus Alt und Neu, eine Adaption historischer Kontorflächen an die Anforderungen der moderner Office- und Retailumgebung.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/domkontor/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/domkontor/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/domkontor/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"D10"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | D10",
        description:
          "Das Domkontor ist eine Verbindung aus Alt und Neu, eine Adaption historischer Kontorflächen an die Anforderungen der moderner Office- und Retailumgebung.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/domkontor/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | D10",
        og_description:
          "Das Domkontor ist eine Verbindung aus Alt und Neu, eine Adaption historischer Kontorflächen an die Anforderungen der moderner Office- und Retailumgebung.",
        og_url: "https://www.art-invest.de/en/projekt/domkontor/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-25T07:55:54+00:00",
        og_image: [
          {
            width: 2560,
            height: 2560,
            url: "https://www.art-invest.de/wp-content/uploads/2014/09/161219_Domkontor_Hamburg_Teaser_neu-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/domkontor/",
              url: "https://www.art-invest.de/en/projekt/domkontor/",
              name: "Art-Invest Real Estate | D10",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-09-23T10:00:52+00:00",
              dateModified: "2022-10-25T07:55:54+00:00",
              description:
                "Das Domkontor ist eine Verbindung aus Alt und Neu, eine Adaption historischer Kontorflächen an die Anforderungen der moderner Office- und Retailumgebung.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/domkontor/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/domkontor/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/domkontor/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "D10",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2014/09/161219_Domkontor_Hamburg_Teaser_neu-1-scaled.jpg",
      place: "Hamburg",
      subtitle: "Hanseatische Offenheit",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21598",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14090",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21599",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14090",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21598",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21598",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21615,
      date: "2014-06-25T12:00:13",
      date_gmt: "2014-06-25T10:00:13",
      guid: {
        rendered: "https://www.art-invest.de/projekt/bb-hotel-portfolio/",
      },
      modified: "2023-05-17T14:42:54",
      modified_gmt: "2023-05-17T12:42:54",
      slug: "bb-hotel-portfolio",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/bb-hotel-portfolio/",
      title: {
        rendered: "B&B Hotel Portfolio",
      },
      featured_media: 24252,
      template: "",
      projekt_filter: [247, 251, 427, 425, 256, 263],
      acf: {
        highlight_image: 24252,
        highlight_title_project: "B&B Hotel Portfolio",
        highlight_subtitle_project: "Die Heimat des Erfolgs",
        highlight_description_project:
          "B&amp;B Hotels conquer the European map of budget hotels. The group is successfully expanding in German medium-sized and large cities and metropolitan regions - with locations in Berlin, Cologne-Messe, Ludwigshafen, Mainz, Neu-Ulm, Nuremberg, Paderborn, Passau, Rosenheim, Weil am Rhein and Wiesbaden, Art-Invest is creating new addresses.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "11 existing properties",
        location:
          " Berlin, Cologne-Messe, Ludwigshafen, Mainz, Neu-Ulm, Nuremberg, Paderborn, Passau, Rosenheim, Weil am Rhein and Wiesbaden",
        property: "",
        area: "Total 36.908 sqm / 1,248 guest rooms",
        zertifizierung: "",
        parcels: "394 (underground parking) spaces in total",
        use_for: "2*-Budget-Hotels",
        acquired: "Q3 2015 / Q2 2016",
        realization: "2013-2016",
        sale: "",
        architecture_firm: "KULAS Architekten PartGmbB",
        place: "Various locations",
        fakten: null,
        specifications_image_projects: 24081,
        slider: [24077, 24075, 24079, 24081, 24087, 24253],
        title_details_projects: "B&B HOTEL PORTFOLIO IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Die Heimat des Erfolgs",
            description_repeater_details:
              "The strategic home of budget hotels are locations close to the city center with excellent transport links. The quick accessibility of restaurants, airports and the most prominent sights is of great importance for the choice of location. Central remains everywhere: an excellent price-performance ratio with two stars.",
            image_repeater_details: 24075,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "The objects of success",
            description_repeater_details:
              'The profile of the development projects ranges from "flagship" to "fine": At Berlin\'s Tiergarten, Art-Invest is developing Germany\'s largest B&amp;B Hotel with 185 beds. In Passau, the modernized B&amp;B Hotel with 84 beds is providing valuable stimulus for urban development. The B&amp;B hotel portfolio, which was built between 2013 and 2016, comprises a total of 1027 rooms on 30,868 sqm of gross floor space across Germany.',
            image_repeater_details: 24253,
            video: "",
            "anchor-link": "",
          },
        ],
        map: null,
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | B&amp;B Hotel Portfolio</title>\n<meta name="description" content="B&amp;B Hotels erobern die europäische Landkarte der Budget-Hotels. Die Gruppe expandiert erfolgreich in deutschen Mittel- und Großstädten und Metropolregionen." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/bb-hotel-portfolio/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | B&amp;B Hotel Portfolio" />\n<meta property="og:description" content="B&amp;B Hotels erobern die europäische Landkarte der Budget-Hotels. Die Gruppe expandiert erfolgreich in deutschen Mittel- und Großstädten und Metropolregionen." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/bb-hotel-portfolio/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-05-17T12:42:54+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2014/06/4_BB-Mainz-1.jpg" />\n\t<meta property="og:image:width" content="2416" />\n\t<meta property="og:image:height" content="1600" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/bb-hotel-portfolio/","url":"https://www.art-invest.de/en/projekt/bb-hotel-portfolio/","name":"Art-Invest Real Estate | B&B Hotel Portfolio","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-06-25T10:00:13+00:00","dateModified":"2023-05-17T12:42:54+00:00","description":"B&B Hotels erobern die europäische Landkarte der Budget-Hotels. Die Gruppe expandiert erfolgreich in deutschen Mittel- und Großstädten und Metropolregionen.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/bb-hotel-portfolio/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/bb-hotel-portfolio/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/bb-hotel-portfolio/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"B&#038;B Hotel Portfolio"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | B&B Hotel Portfolio",
        description:
          "B&B Hotels erobern die europäische Landkarte der Budget-Hotels. Die Gruppe expandiert erfolgreich in deutschen Mittel- und Großstädten und Metropolregionen.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/bb-hotel-portfolio/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | B&B Hotel Portfolio",
        og_description:
          "B&B Hotels erobern die europäische Landkarte der Budget-Hotels. Die Gruppe expandiert erfolgreich in deutschen Mittel- und Großstädten und Metropolregionen.",
        og_url: "https://www.art-invest.de/en/projekt/bb-hotel-portfolio/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-05-17T12:42:54+00:00",
        og_image: [
          {
            width: 2416,
            height: 1600,
            url: "https://www.art-invest.de/wp-content/uploads/2014/06/4_BB-Mainz-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/bb-hotel-portfolio/",
              url: "https://www.art-invest.de/en/projekt/bb-hotel-portfolio/",
              name: "Art-Invest Real Estate | B&B Hotel Portfolio",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-06-25T10:00:13+00:00",
              dateModified: "2023-05-17T12:42:54+00:00",
              description:
                "B&B Hotels erobern die europäische Landkarte der Budget-Hotels. Die Gruppe expandiert erfolgreich in deutschen Mittel- und Großstädten und Metropolregionen.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/bb-hotel-portfolio/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/bb-hotel-portfolio/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/bb-hotel-portfolio/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "B&B Hotel Portfolio",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2014/06/4_BB-Mainz-1-800x800.jpg",
      place: "Various locations",
      subtitle: "Die Heimat des Erfolgs",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21615",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/24253",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/24087",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/24081",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/24079",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/24075",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/24077",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/24252",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21615",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21615",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21704,
      date: "2015-03-25T12:00:55",
      date_gmt: "2015-03-25T11:00:55",
      guid: {
        rendered: "https://www.art-invest.de/projekt/p11/",
      },
      modified: "2022-10-27T11:06:38",
      modified_gmt: "2022-10-27T09:06:38",
      slug: "p11",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/p11/",
      title: {
        rendered: "P11",
      },
      featured_media: 21705,
      template: "",
      projekt_filter: [246, 427, 249, 425],
      acf: {
        highlight_image: 21707,
        highlight_title_project: "P11",
        highlight_subtitle_project: "Flexibler Raum im ersten Bezirk",
        highlight_description_project:
          "The office property at Prinzregentenstrasse 11 is located in the middle of the city center on one of Munich's most magnificent streets between the Old Town, the Isar River and the English Garden.",
        highlight_logo_project: 21706,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment / RAB-Fonds",
        location:
          "Prinzregentenstrasse 11, 80538 Munich, Germany; located in the middle of the city center on one of Munich's boulevards between the Old Town and the Isar River and the English Garden",
        property: "780 sqm",
        area: "2,900 sqm",
        zertifizierung: "",
        parcels: "19",
        use_for: "Office",
        acquired: "2015",
        realization: "Year of construction: 1950, core renovation: 2003",
        sale: "",
        architecture_firm: "",
        place: "München",
        fakten: null,
        specifications_image_projects: 21705,
        slider: [21705],
        title_details_projects: "P11 IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Flexibler Raum im ersten Bezirk",
            description_repeater_details:
              "The building impresses with its L-shape and 2,900 sqm of high-quality floor space on five floors. The floor plans are flexible, and the interiors can be designed in a modular fashion for any type of modern working environment.",
            image_repeater_details: 21705,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Confusingly beautiful",
            description_repeater_details:
              "Munich or Paris? Paris or Munich? The old town quarter around the P11 is certainly one of the most beautiful districts of the Bavarian capital. In terms of architectural substance, people tend to confuse it with Paris - only the Métro is not to be found in the first district.",
            image_repeater_details: 21707,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "The wave in the house",
            description_repeater_details:
              "The legendary Eisbach wave breaks just around the corner from P11. However, those who want to take on sporting challenges without detours will find the ideal training refuge in the P11 fitness room - and 19 parking spaces to quickly leave the building if necessary. Last but not least, the P11 is ideally connected via the bus stop directly in front of the building.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Prinzregentenstraße 11, 81673 München",
          lat: 48.14216,
          lng: 11.59394999999995,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | P11</title>\n<meta name="description" content="Das Büroobjekt in der Prinzregentenstraße 11 liegt inmitten des Zentrums an einer der Prachtstraßen Münchens zwischen Altstadt, Isar und Englischem Garten." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/p11/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | P11" />\n<meta property="og:description" content="Das Büroobjekt in der Prinzregentenstraße 11 liegt inmitten des Zentrums an einer der Prachtstraßen Münchens zwischen Altstadt, Isar und Englischem Garten." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/p11/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-27T09:06:38+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/MUC_Prinzregentenstrasse_Aussenansicht_02_TEASER-1-1.jpg" />\n\t<meta property="og:image:width" content="2000" />\n\t<meta property="og:image:height" content="2000" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/p11/","url":"https://www.art-invest.de/en/projekt/p11/","name":"Art-Invest Real Estate | P11","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2015-03-25T11:00:55+00:00","dateModified":"2022-10-27T09:06:38+00:00","description":"Das Büroobjekt in der Prinzregentenstraße 11 liegt inmitten des Zentrums an einer der Prachtstraßen Münchens zwischen Altstadt, Isar und Englischem Garten.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/p11/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/p11/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/p11/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"P11"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | P11",
        description:
          "Das Büroobjekt in der Prinzregentenstraße 11 liegt inmitten des Zentrums an einer der Prachtstraßen Münchens zwischen Altstadt, Isar und Englischem Garten.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/p11/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | P11",
        og_description:
          "Das Büroobjekt in der Prinzregentenstraße 11 liegt inmitten des Zentrums an einer der Prachtstraßen Münchens zwischen Altstadt, Isar und Englischem Garten.",
        og_url: "https://www.art-invest.de/en/projekt/p11/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-27T09:06:38+00:00",
        og_image: [
          {
            width: 2000,
            height: 2000,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/MUC_Prinzregentenstrasse_Aussenansicht_02_TEASER-1-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/p11/",
              url: "https://www.art-invest.de/en/projekt/p11/",
              name: "Art-Invest Real Estate | P11",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2015-03-25T11:00:55+00:00",
              dateModified: "2022-10-27T09:06:38+00:00",
              description:
                "Das Büroobjekt in der Prinzregentenstraße 11 liegt inmitten des Zentrums an einer der Prachtstraßen Münchens zwischen Altstadt, Isar und Englischem Garten.",
              breadcrumb: {
                "@id": "https://www.art-invest.de/en/projekt/p11/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/p11/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/p11/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "P11",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/MUC_Prinzregentenstrasse_Aussenansicht_02_TEASER-1-1.jpg",
      place: "München",
      subtitle: "Flexibler Raum im ersten Bezirk",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21704",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21705",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21705",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21704",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21704",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },

    {
      id: 16595,
      date: "2019-02-13T11:41:35",
      date_gmt: "2019-02-13T10:41:35",
      guid: {
        rendered: "https://www.art-invest.de/projekt/moxy-cologne-airport/",
      },
      modified: "2023-04-06T10:11:53",
      modified_gmt: "2023-04-06T08:11:53",
      slug: "moxy-cologne-airport",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/moxy-cologne-airport/",
      title: {
        rendered: "Moxy Cologne Airport",
      },
      featured_media: 23475,
      template: "",
      projekt_filter: [247, 251, 427, 425],
      acf: {
        highlight_image: 23473,
        highlight_title_project: "Moxy Cologne Airport",
        highlight_subtitle_project: "Lifestyle-Hotel in fünfeckiger Kubatur",
        highlight_description_project:
          "A modern Moxy Hotel is being built in the inland area of Cologne-Bonn Airport. The building form of the lifestyle hotel captivates with its futuristic, pentagonal cubature, which is based on the original planning of the airport.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment, Development",
        location: "Kennedystraße, 51147 Cologne",
        property: "4,000 m²",
        area: "10,000 m²",
        zertifizierung: "",
        parcels: "",
        use_for: "Hotel",
        acquired: "Q4 2018",
        realization: "Q2 2021",
        sale: "",
        architecture_firm: "JSWD Architekten",
        place: "Köln",
        fakten: null,
        specifications_image_projects: 23473,
        slider: [
          23475, 23471, 23473, 20907, 20905, 23459, 23461, 23463, 20885, 20887,
          20889, 23465, 20893, 20895, 20897, 20899, 20901, 23469,
        ],
        title_details_projects: "MOXY COLOGNE AIRPORT IM DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              "Trendsetting building in the middle of the Konrad Adenauer Airport",
            description_repeater_details:
              'Moxy Cologne Airport will open in 2021 in the direct terminal location of Konrad Adenauer Airport with around 250 rooms and five conference rooms. The "Moxy" brand is part of the brand portfolio of the world\'s largest hotel chain Marriott and focuses on the modern business guest. A highlight will be the top, fifth floor, which will offer a fantastic 360-degree view of the airport grounds and tarmac through generous glass surfaces. In addition to the sensational roof terrace and lobby, this floor also houses an invitingly designed restaurant, which will be a popular meeting place not only for house guests but also for public visitors. The main focus of the gastronomic offer is modern and regional dishes.',
            image_repeater_details: 23475,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Floor plan and facade in the style of the terminal",
            description_repeater_details:
              "The Moxy Hotel impresses with its first-class architecture in an urban airport location. The building cubature in the shape of a pentagon and the avant-garde facade, which is based on the formal language of the terminal built in 1970 by Professor Schneider v. Esleben, are impressive. The hotel, which has a rental area of approx. 10,000 sqm, will attract guests from all over the world with its young, high-quality furnishings, high technical standards and an elaborately landscaped inner courtyard.",
            image_repeater_details: 23467,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "",
          lat: 50.87866894342994,
          lng: 7.1175312995910645,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Moxy Cologne Airport</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/moxy-cologne-airport/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Moxy Cologne Airport" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/moxy-cologne-airport/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-04-06T08:11:53+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2019/02/ssf_2206_moxy-cgn_51-2.jpg" />\n\t<meta property="og:image:width" content="2500" />\n\t<meta property="og:image:height" content="2000" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/moxy-cologne-airport/","url":"https://www.art-invest.de/en/projekt/moxy-cologne-airport/","name":"Art-Invest Real Estate | Moxy Cologne Airport","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2019-02-13T10:41:35+00:00","dateModified":"2023-04-06T08:11:53+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/moxy-cologne-airport/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/moxy-cologne-airport/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/moxy-cologne-airport/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Moxy Cologne Airport"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Moxy Cologne Airport",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/moxy-cologne-airport/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Moxy Cologne Airport",
        og_url: "https://www.art-invest.de/en/projekt/moxy-cologne-airport/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-04-06T08:11:53+00:00",
        og_image: [
          {
            width: 2500,
            height: 2000,
            url: "https://www.art-invest.de/wp-content/uploads/2019/02/ssf_2206_moxy-cgn_51-2.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/moxy-cologne-airport/",
              url: "https://www.art-invest.de/en/projekt/moxy-cologne-airport/",
              name: "Art-Invest Real Estate | Moxy Cologne Airport",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2019-02-13T10:41:35+00:00",
              dateModified: "2023-04-06T08:11:53+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/moxy-cologne-airport/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/moxy-cologne-airport/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/moxy-cologne-airport/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Moxy Cologne Airport",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2019/02/ssf_2206_moxy-cgn_51-2-800x800.jpg",
      place: "Köln",
      subtitle: "Fünfeckiges Lifestyle-Hotel",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16595",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/23469",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20901",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20899",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20897",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20895",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20893",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/23465",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20889",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20887",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20885",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/23463",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/23461",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/23459",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20905",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/20907",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/23473",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/23471",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/23475",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/23475",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16595",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16595",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16750,
      date: "2019-07-19T11:32:36",
      date_gmt: "2019-07-19T09:32:36",
      guid: {
        rendered: "https://www.art-invest.de/projekt/walzstahlhaus/",
      },
      modified: "2023-07-10T13:46:10",
      modified_gmt: "2023-07-10T11:46:10",
      slug: "walzstahlhaus",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/walzstahlhaus/",
      title: {
        rendered: "Walzstahlhaus",
      },
      featured_media: 16752,
      template: "",
      projekt_filter: [246, 427, 425, 257],
      acf: {
        highlight_image: 16752,
        highlight_title_project: "Walzstahlhaus",
        highlight_subtitle_project:
          "Von der Geschichte geprägt: Das Walz Stahlhaus",
        highlight_description_project:
          "An office building with charm. Built between 1938 and 1940 according to the designs of architects Heinrich Rosskotten and Karl Wach, the Walzstahlhaus, which is a listed building, immediately catches the eye.",
        highlight_logo_project: null,
        website_projects: {
          title: "www.walzstahlhaus.de",
          url: "https://www.walzstahlhaus.de/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://www.walzstahlhaus.de/",
          target: "_blank",
        },
        available_space: {
          title: "www.walzstahlhaus.de",
          url: "https://www.walzstahlhaus.de/",
          target: "_blank",
        },
        project: "Refurbishment",
        location: "Kasernenstraße 36, 40213 Dusseldorf",
        property: "2,132 m²",
        area: "10,800 m²",
        zertifizierung: "",
        parcels: "25",
        use_for: "Office, Fitness",
        acquired: "Q4 2018",
        realization: "Q1 2026",
        sale: "",
        architecture_firm: "",
        place: "Düsseldorf",
        fakten: null,
        specifications_image_projects: 10915,
        slider: null,
        title_details_projects: "WALZSTAHLHAUS IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Listed elements adorn the property",
            description_repeater_details:
              "Statues enthroned on consoles, designed by the Düsseldorf sculptor Erich Kuhn, decorate the neoclassical property. The portal shows a monumentalized pillar construction spanning two storeys. Five console heads are attached to the southern axis of the building, each marking a new floor. In the representative building, which also impresses with its listed building components on the inside, the AOK insurance company uses office space of more than 10,000 m². A comprehensive revitalization is planned for the building - the building application for this was submitted in February 2023. The start of the full refurbishment is planned from Q4 2024 after the existing tenant has moved out. In the course of the renovation work, the building will be sustainably refurbished in terms of energy and equipped with smart technologies. The office floors will be refurbished from the core, while individual landmarked room structures and building components will be preserved. The result will be high-quality boutique offices offering generous interior design and state-of-the-art digital infrastructure. The office spaces will be equipped with mechanical ventilation and heating/cooling ceiling sails. Both DGNB certification (gold) and EU taxonomy compliance are being sought.",
            image_repeater_details: 10911,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "In good company with the Königsallee",
            description_repeater_details:
              "Close to the famous Königsallee, the Walzstahlhaus is located in the popular Düsseldorf banking district. The quarter benefits from an excellent infrastructure with ideal transport connections. Versatile restaurants, nice cafés and numerous shopping facilities are in the immediate vicinity.",
            image_repeater_details: 16751,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "",
          lat: 51.22040443791654,
          lng: 6.775628767459125,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Walzstahlhaus</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/walzstahlhaus/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Walzstahlhaus" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/walzstahlhaus/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-07-10T11:46:10+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2019/07/DUS_Walzstahlhaus_Außenaufnahmen_Hauptansicht_Eingang-frontal-Kopie-2.jpg" />\n\t<meta property="og:image:width" content="2500" />\n\t<meta property="og:image:height" content="2000" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/walzstahlhaus/","url":"https://www.art-invest.de/en/projekt/walzstahlhaus/","name":"Art-Invest Real Estate | Walzstahlhaus","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2019-07-19T09:32:36+00:00","dateModified":"2023-07-10T11:46:10+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/walzstahlhaus/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/walzstahlhaus/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/walzstahlhaus/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Walzstahlhaus"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Walzstahlhaus",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/walzstahlhaus/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Walzstahlhaus",
        og_url: "https://www.art-invest.de/en/projekt/walzstahlhaus/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-07-10T11:46:10+00:00",
        og_image: [
          {
            width: 2500,
            height: 2000,
            url: "https://www.art-invest.de/wp-content/uploads/2019/07/DUS_Walzstahlhaus_Außenaufnahmen_Hauptansicht_Eingang-frontal-Kopie-2.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/walzstahlhaus/",
              url: "https://www.art-invest.de/en/projekt/walzstahlhaus/",
              name: "Art-Invest Real Estate | Walzstahlhaus",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2019-07-19T09:32:36+00:00",
              dateModified: "2023-07-10T11:46:10+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/walzstahlhaus/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/walzstahlhaus/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/walzstahlhaus/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Walzstahlhaus",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2019/07/DUS_Walzstahlhaus_Außenaufnahmen_Hauptansicht_Eingang-frontal-Kopie-2.jpg",
      place: "Düsseldorf",
      subtitle: "Das historische Walz Stahlhaus",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16750",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16752",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16750",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16750",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16689,
      date: "2017-03-01T12:19:48",
      date_gmt: "2017-03-01T11:19:48",
      guid: {
        rendered: "https://www.art-invest.de/projekt/wolkenbuegel/",
      },
      modified: "2023-08-31T14:00:19",
      modified_gmt: "2023-08-31T12:00:19",
      slug: "wolkenbuegel",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/wolkenbuegel/",
      title: {
        rendered: "Wolkenbügel",
      },
      featured_media: 16690,
      template: "",
      projekt_filter: [246, 427, 425, 257],
      acf: {
        highlight_image: 16690,
        highlight_title_project: "Wolkenbügel",
        highlight_subtitle_project: "Wahrzeichen im Düsseldorfer Hafen",
        highlight_description_project:
          "The port of Dusseldorf has transformed itself from a trading centre to a reloading point for ideas. David Chipperfield, Frank Gehry and Renzo Piano are among the star architects whose buildings extend the formal language of architecture – thus creating a home for creativity: the Media Harbour. The Wolkenbügel is the extraordinary landmark at its southern end.",
        highlight_logo_project: 25355,
        website_projects: {
          title: "www.wolkenbuegel.de",
          url: "http://www.wolkenbuegel.de",
          target: "",
        },
        external_projectpage: "",
        available_space: [""],
        project: "Investment",
        location: "Franziusstr. 5 / Am Handelshafen 2-4, 40221 Dusseldorf",
        property: "2,946 m²",
        area: "approx. 7,290 m²",
        zertifizierung: "",
        parcels: "130",
        use_for: "Office, Event",
        acquired: "Q4 2016",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Düsseldorf",
        fakten: null,
        specifications_image_projects: 13406,
        slider: null,
        title_details_projects: "WOLKENBÜGEL IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Room in suspension",
            description_repeater_details:
              "In 1926 the Wolkenbügel caused a sensation at the Great Berlin Art Exhibition. With his design, the Russian sky stormer, graphic artist and architect El Lissitzy (1890-1941) created a radical building. As a counter-design to the New York skyscrapers, he discovered the floating horizontal. Wansleben Architekten (Cologne) realized the bold concept around 80 years later at the turn of the millennium. The result: a 35-metre long, crane-like cantilevered bridge girder, which connects the most modern office and event areas on 7,293 m² in a self-supporting manner.",
            image_repeater_details: 13405,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Anchorage for media",
            description_repeater_details:
              "In times of structural change, Dusseldorf's commercial port threatened to silt-up. But the city, which carries the anchor in the city coat of arms, created a way to transfer the shipping heritage into a digital future with the vision of the Media Harbour. The port advanced to become a rolemodel district, which today is home to media, communication, advertising and gastronomy. The 2,964 m² site at the commercial port 2-4 is part of this vision, which is embodied outstandingly by the Wolkenbügel consisting of a bridge girder, an event hall and the listed pump house, which has been converted into an office building.",
            image_repeater_details: 3914,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Quickly at the quay edge",
            description_repeater_details:
              'The Media Harbor has excellent connections by tram, bus and individual transport. It takes fifteen Minutes by train from the main railway station to the Media Harbour, and the Rhine railway runs every ten minutes to the new tram stations "Speditionsstraße" and "Medienhafen, Kesselstraße".',
            image_repeater_details: 3915,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Am Handelshafen, 40221 Düsseldorf, Deutschland",
          lat: 51.21406764820869,
          lng: 6.750481088330048,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Wolkenbügel</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/wolkenbuegel/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Wolkenbügel" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/wolkenbuegel/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-08-31T12:00:19+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2017/03/Wolkenbuegel_Duesseldorf_12-1.jpg" />\n\t<meta property="og:image:width" content="1920" />\n\t<meta property="og:image:height" content="1280" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/wolkenbuegel/","url":"https://www.art-invest.de/en/projekt/wolkenbuegel/","name":"Art-Invest Real Estate | Wolkenbügel","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2017-03-01T11:19:48+00:00","dateModified":"2023-08-31T12:00:19+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/wolkenbuegel/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/wolkenbuegel/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/wolkenbuegel/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Wolkenbügel"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Wolkenbügel",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/wolkenbuegel/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Wolkenbügel",
        og_url: "https://www.art-invest.de/en/projekt/wolkenbuegel/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-08-31T12:00:19+00:00",
        og_image: [
          {
            width: 1920,
            height: 1280,
            url: "https://www.art-invest.de/wp-content/uploads/2017/03/Wolkenbuegel_Duesseldorf_12-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/wolkenbuegel/",
              url: "https://www.art-invest.de/en/projekt/wolkenbuegel/",
              name: "Art-Invest Real Estate | Wolkenbügel",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2017-03-01T11:19:48+00:00",
              dateModified: "2023-08-31T12:00:19+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/wolkenbuegel/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/wolkenbuegel/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/wolkenbuegel/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Wolkenbügel",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2017/03/Wolkenbuegel_Duesseldorf_12-1.jpg",
      place: "Düsseldorf",
      subtitle: "Wahrzeichen im Düsseldorfer Hafen",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16689",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16690",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16689",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16689",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16871,
      date: "2019-04-17T09:44:31",
      date_gmt: "2019-04-17T07:44:31",
      guid: {
        rendered: "https://www.art-invest.de/projekt/marriott-hotel/",
      },
      modified: "2020-07-15T11:09:52",
      modified_gmt: "2020-07-15T11:09:52",
      slug: "marriott-hotel",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/marriott-hotel/",
      title: {
        rendered: "Marriott Bonn Hotel",
      },
      featured_media: 16873,
      template: "",
      projekt_filter: [251, 427, 425, 263],
      acf: {
        highlight_image: 16873,
        highlight_title_project: "Marriott Bonn Hotel",
        highlight_subtitle_project: "Neu definiert: Das Marriott Bonn Hotel",
        highlight_description_project:
          "Konrad Adenauer, Herbert Wehner, Kurt Georg Kiesinger, Willy Brandt, Helmut Schmidt – a historical wind is blowing through the Marriott Hotel in Bonn. The whole building is shaped by the political spirit of the times; each of the 17 floors has the individual signature of a personality who wrote history. The spirit of the former government is noticeable on every floor.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location: "Platz der Vereinten Nationen 4, Bonn",
        property: "10,043 m²",
        area: "35,995 m²",
        zertifizierung: "",
        parcels: "",
        use_for: "Hotel",
        acquired: "Q4 2018",
        realization: "Q2 2016",
        sale: "",
        architecture_firm: "",
        place: "Bonn",
        fakten: [
          {
            bezeichnung: "Image source",
            wert: "Invite Group GmbH",
            anchor: "",
          },
          {
            bezeichnung: "",
            wert: "",
            anchor: "",
          },
        ],
        specifications_image_projects: 16874,
        slider: null,
        title_details_projects: "MARRIOTT BONN HOTEL IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              "Panoramic view from Bonn to the Siebengebirge",
            description_repeater_details:
              "The elegant suites of the Marriott Bonn Hotel are eye-catching with their impressing political images, their enormous spaciousness and the unmistakable panoramic view of the Rhine or the government quarter. The two 110 m² presidential suites, named after Richard von Weizsäcker and Walter Scheel, are located on the 16th floor and offer the highest level of comfort. The modern architecture, the pleasant spa and fitness area as well as the neighbouring GOP Varieté Theatre are extra specials for many international guests.",
            image_repeater_details: 16875,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Culinary delights above the roofs of Bonn",
            description_repeater_details:
              "The exquisite Konrad's Restaurant on the 17th floor owes its name to the first Chancellor of the Federal Republic of Germany. Floor-to-ceiling windows, an inviting interior and the spacious terrace create a friendly atmosphere. Connoisseurs appreciate not only the special food at Konrad's and trendy drinks at the Skybar, but also the unforgettable view across the city limits to the Siebengebirge.",
            image_repeater_details: 16872,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "The former federal capital as a cultural location",
            description_repeater_details:
              "Bonn's government quarter is a very special place for culture lovers. Idyllically located on the banks of the Rhine, tourists appreciate the ideal starting point for exploring numerous sights. In only a few minutes you can reach the birthplace of Beethoven, the Bundeskunsthalle, the former Bundestag and various ministries on foot. Business travelers benefit from the direct connection to the World Conference Center as well as the nearby UN Campus and surrounding large corporations.",
            image_repeater_details: 14110,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Karl-Carstens-Straße 14, 53113 Bonn, Deutschland",
          lat: 50.71951350983641,
          lng: 7.121930334640524,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Marriott Bonn Hotel</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/marriott-hotel/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Marriott Bonn Hotel" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/marriott-hotel/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-15T11:09:52+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2019/04/ssf_1905_Art-Invest-Marriott_34-2.jpg" />\n\t<meta property="og:image:width" content="2500" />\n\t<meta property="og:image:height" content="1448" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/marriott-hotel/","url":"https://www.art-invest.de/en/projekt/marriott-hotel/","name":"Art-Invest Real Estate | Marriott Bonn Hotel","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2019-04-17T07:44:31+00:00","dateModified":"2020-07-15T11:09:52+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/marriott-hotel/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/marriott-hotel/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/marriott-hotel/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Marriott Bonn Hotel"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Marriott Bonn Hotel",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/marriott-hotel/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Marriott Bonn Hotel",
        og_url: "https://www.art-invest.de/en/projekt/marriott-hotel/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-15T11:09:52+00:00",
        og_image: [
          {
            width: 2500,
            height: 1448,
            url: "https://www.art-invest.de/wp-content/uploads/2019/04/ssf_1905_Art-Invest-Marriott_34-2.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/marriott-hotel/",
              url: "https://www.art-invest.de/en/projekt/marriott-hotel/",
              name: "Art-Invest Real Estate | Marriott Bonn Hotel",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2019-04-17T07:44:31+00:00",
              dateModified: "2020-07-15T11:09:52+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/marriott-hotel/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/marriott-hotel/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/marriott-hotel/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Marriott Bonn Hotel",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2019/04/ssf_1905_Art-Invest-Marriott_34-2.jpg",
      place: "Bonn",
      subtitle: "Marriott Bonn. Neu definiert.",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16871",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16873",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16871",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16871",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16782,
      date: "2018-08-27T11:51:09",
      date_gmt: "2018-08-27T09:51:09",
      guid: {
        rendered: "https://www.art-invest.de/projekt/sz-tower/",
      },
      modified: "2020-07-07T12:25:47",
      modified_gmt: "2020-07-07T12:25:47",
      slug: "sz-tower",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/sz-tower/",
      title: {
        rendered: "SZ Tower",
      },
      featured_media: 16784,
      template: "",
      projekt_filter: [246, 427, 249, 425],
      acf: {
        highlight_image: 16784,
        highlight_title_project: "SZ Tower",
        highlight_subtitle_project: "Moderner Wahrzeichen-Turm",
        highlight_description_project:
          "With a height of 103 m and a unique glass facade, the office complex in the east of Munich impresses with its sustainable construction.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location: "Munich (Zamdorf), Hultschinerstraße 8",
        property: "approx. 21,490 m²",
        area: "approx. 62,240 m² BGF",
        zertifizierung: "",
        parcels: "525 ",
        use_for: "Office",
        acquired: "Q1 2018",
        realization: "2008",
        sale: "",
        architecture_firm: "GKK Architekten",
        place: "München",
        fakten: null,
        specifications_image_projects: 7956,
        slider: null,
        title_details_projects: "SZ TOWER IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Refined premium property",
            description_repeater_details:
              "The complex consists of an office tower with 28 upper floors, 3 basement floors and a 6-storey low-rise building. Both parts of the building are connected by a spectacular, light-flooded atrium, which is used as a representative entrance to all areas. From a distance, the particularly high-quality projecting and standing back glass elements of the facade make the tower look like a cut crystal. A spacious forecourt with natural stone paving and seating welcomes visitors.",
            image_repeater_details: 7958,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Working environment to the highest standards",
            description_repeater_details:
              "As an office building, the SZ Tower convinces with innovative and sustainable technological solutions and is certified according to LEED Gold Standard. Its own canteen, a day-care centre for children including outdoor facilities and sufficient parking space contribute to the feel-good factor at work.",
            image_repeater_details: 7954,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Emerging Munich East",
            description_repeater_details:
              "The SZ Tower is located in the middle of the Steinhausen-Zamdorf industrial estate, which is currently changing and experiencing an upgrade due to many new settlements. The building is easily accessible via a direct link to the A94 motorway and benefits from the Berg am Laim suburban train station, which is within walking distance. The Ostbahnhof (East station) and the trade fair centre can also be reached in a few minutes.",
            image_repeater_details: 7960,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Hultschiner Str. 8, 81677 München, Deutschland",
          lat: 48.1374391,
          lng: 11.634554200000025,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | SZ Tower</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/sz-tower/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | SZ Tower" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/sz-tower/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-07T12:25:47+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2018/08/bnpMue_0813-3.jpg" />\n\t<meta property="og:image:width" content="1920" />\n\t<meta property="og:image:height" content="1351" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/sz-tower/","url":"https://www.art-invest.de/en/projekt/sz-tower/","name":"Art-Invest Real Estate | SZ Tower","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2018-08-27T09:51:09+00:00","dateModified":"2020-07-07T12:25:47+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/sz-tower/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/sz-tower/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/sz-tower/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"SZ Tower"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | SZ Tower",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/sz-tower/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | SZ Tower",
        og_url: "https://www.art-invest.de/en/projekt/sz-tower/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-07T12:25:47+00:00",
        og_image: [
          {
            width: 1920,
            height: 1351,
            url: "https://www.art-invest.de/wp-content/uploads/2018/08/bnpMue_0813-3.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/sz-tower/",
              url: "https://www.art-invest.de/en/projekt/sz-tower/",
              name: "Art-Invest Real Estate | SZ Tower",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2018-08-27T09:51:09+00:00",
              dateModified: "2020-07-07T12:25:47+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/sz-tower/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/sz-tower/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/sz-tower/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "SZ Tower",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2018/08/bnpMue_0813-3-800x800.jpg",
      place: "München",
      subtitle: "Moderner Wahrzeichen-Turm",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16782",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16784",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16782",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16782",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16888,
      date: "2018-12-03T16:00:39",
      date_gmt: "2018-12-03T15:00:39",
      guid: {
        rendered: "https://www.art-invest.de/projekt/haus-der-seefahrt/",
      },
      modified: "2020-07-15T11:41:01",
      modified_gmt: "2020-07-15T11:41:01",
      slug: "haus-der-seefahrt",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/haus-der-seefahrt/",
      title: {
        rendered: "Haus der Seefahrt",
      },
      featured_media: 16890,
      template: "",
      projekt_filter: [246, 248, 427, 425],
      acf: {
        highlight_image: 8536,
        highlight_title_project: "Haus der Seefahrt",
        highlight_subtitle_project: "Opulentes Gebäude mit Jugendstilfassade",
        highlight_description_project:
          "The listed office building is located on Nikolaifleet in the middle of cafés and traditional Hanseatic restaurants.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location: "Hohe Brücke 1 / Deichstraße 51, 20459 Hamburg",
        property: "530 m² ",
        area: "3,300 m²  (rental space)",
        zertifizierung: "",
        parcels: "",
        use_for: "Office",
        acquired: "Q4, 2018",
        realization: "",
        sale: "",
        architecture_firm: "Edgar Foßhag / Georg Schelpps",
        place: "Hamburg",
        fakten: [
          {
            bezeichnung: "Built in",
            wert: "1909/1910",
            anchor: "",
          },
        ],
        specifications_image_projects: 8538,
        slider: null,
        title_details_projects: "HAUS DER SEEFAHRT IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Corner building on Nikolaifleet",
            description_repeater_details:
              "The Haus der Seefahrt is located at the confluence of the Nikolaifleet and the Hamburg inland port. It is located directly opposite the former service and residential building of the crane attendant and is in the best company of historical half-timbered houses with baroque facades. Here are some of the oldest buildings in the city, which has not been destroyed in the great fire in 1842.",
            image_repeater_details: 8538,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Listed art nouveau facade",
            description_repeater_details:
              "The impressive Kontorhaus remained undamaged during the war and is a listed building. It captivates with its sandstone facade with the Art Nouveau ornaments typical of the beginning of the 20th century, which show swans, sea animals and a crocodile. A statue of Hammonia, symbolic figure of the city of Hamburg, is also prominently positioned on a building projection, accompanied by a lion with a flag over its shoulder. It was extensively renovated in 1991 and 2012.",
            image_repeater_details: 16890,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Eight floors of office space",
            description_repeater_details:
              "Today the Haus der Seefahrt is used as an office building. On eight floors, including the basement, it offers 3,300 m² rental space.",
            image_repeater_details: 16889,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Hohe Brücke 1, Hamburg, Deutschland",
          lat: 53.5450746,
          lng: 9.986861699999963,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Haus der Seefahrt</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/haus-der-seefahrt/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Haus der Seefahrt" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/haus-der-seefahrt/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-15T11:41:01+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2018/12/Haus-der-Seefahrt-15-1-1024x683.jpg" />\n\t<meta property="og:image:width" content="1024" />\n\t<meta property="og:image:height" content="683" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/haus-der-seefahrt/","url":"https://www.art-invest.de/en/projekt/haus-der-seefahrt/","name":"Art-Invest Real Estate | Haus der Seefahrt","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2018-12-03T15:00:39+00:00","dateModified":"2020-07-15T11:41:01+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/haus-der-seefahrt/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/haus-der-seefahrt/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/haus-der-seefahrt/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Haus der Seefahrt"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Haus der Seefahrt",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/haus-der-seefahrt/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Haus der Seefahrt",
        og_url: "https://www.art-invest.de/en/projekt/haus-der-seefahrt/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-15T11:41:01+00:00",
        og_image: [
          {
            width: 1024,
            height: 683,
            url: "https://www.art-invest.de/wp-content/uploads/2018/12/Haus-der-Seefahrt-15-1-1024x683.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/haus-der-seefahrt/",
              url: "https://www.art-invest.de/en/projekt/haus-der-seefahrt/",
              name: "Art-Invest Real Estate | Haus der Seefahrt",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2018-12-03T15:00:39+00:00",
              dateModified: "2020-07-15T11:41:01+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/haus-der-seefahrt/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/haus-der-seefahrt/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/haus-der-seefahrt/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Haus der Seefahrt",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2018/12/Haus-der-Seefahrt-15-1-800x800.jpg",
      place: "Hamburg",
      subtitle: "Opulenter Jugendstilbau",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16888",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16890",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16888",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16888",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16897,
      date: "2018-09-25T12:51:12",
      date_gmt: "2018-09-25T10:51:12",
      guid: {
        rendered: "https://www.art-invest.de/projekt/kb-12/",
      },
      modified: "2020-07-15T12:52:46",
      modified_gmt: "2020-07-15T12:52:46",
      slug: "kb-12",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/kb-12/",
      title: {
        rendered: "KB12",
      },
      featured_media: 16898,
      template: "",
      projekt_filter: [246, 427, 425, 263],
      acf: {
        highlight_image: 16898,
        highlight_title_project: "KB12",
        highlight_subtitle_project: "Arbeiten in einem zentralen Hub",
        highlight_description_project:
          "The open and bright office property is located in a top location at the central hub of Karlsruhe.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location: "Bahnhofplatz 12, 76137 Karlsruhe",
        property: "approx. 3,570 m²",
        area: "10,707 m² ",
        zertifizierung: "",
        parcels: "95",
        use_for: "Office",
        acquired: "Q1 2018",
        realization: "Q2 2019",
        sale: "",
        architecture_firm: "baurmann.dürr Architekten (Revitalisierung)",
        place: "Karlsruhe",
        fakten: null,
        specifications_image_projects: 13424,
        slider: null,
        title_details_projects: "KB12 IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Modern working in bright rooms",
            description_repeater_details:
              "A spacious bright atrium, an open entrance area and a flexible room structure: the barrier-free property offers a pleasant working environment with modern and friendly conditions on seven floors. The top floor offers an in-house catering concept, while a café has been rented on the ground floor. The view over Karlsruhe from the top floor is well worth seeing.",
            image_repeater_details: 8111,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Centrally located",
            description_repeater_details:
              "The building is centrally located directly opposite Karlsruhe's main railway station and benefits from excellent public transport connections. The building also has an underground car park. Hotels, cafés and restaurants are within walking distance.",
            image_repeater_details: 8105,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Bahnhofplatz 12, Karlsruhe, Deutschland",
          lat: 48.99448,
          lng: 8.398720000000026,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | KB12</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/kb-12/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | KB12" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/kb-12/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-15T12:52:46+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2018/09/ai_bhfpl_02-1.jpg" />\n\t<meta property="og:image:width" content="1200" />\n\t<meta property="og:image:height" content="801" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/kb-12/","url":"https://www.art-invest.de/en/projekt/kb-12/","name":"Art-Invest Real Estate | KB12","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2018-09-25T10:51:12+00:00","dateModified":"2020-07-15T12:52:46+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/kb-12/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/kb-12/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/kb-12/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"KB12"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | KB12",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/kb-12/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | KB12",
        og_url: "https://www.art-invest.de/en/projekt/kb-12/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-15T12:52:46+00:00",
        og_image: [
          {
            width: 1200,
            height: 801,
            url: "https://www.art-invest.de/wp-content/uploads/2018/09/ai_bhfpl_02-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/kb-12/",
              url: "https://www.art-invest.de/en/projekt/kb-12/",
              name: "Art-Invest Real Estate | KB12",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2018-09-25T10:51:12+00:00",
              dateModified: "2020-07-15T12:52:46+00:00",
              breadcrumb: {
                "@id": "https://www.art-invest.de/en/projekt/kb-12/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/kb-12/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/kb-12/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "KB12",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2018/09/ai_bhfpl_02-1-800x800.jpg",
      place: "Karlsruhe",
      subtitle: "Arbeiten in einem zentralen Hub",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16897",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16898",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16897",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16897",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16713,
      date: "2017-11-07T16:59:16",
      date_gmt: "2017-11-07T15:59:16",
      guid: {
        rendered: "https://www.art-invest.de/projekt/enggasse/",
      },
      modified: "2020-07-03T13:23:34",
      modified_gmt: "2020-07-03T13:23:34",
      slug: "enggasse",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/enggasse/",
      title: {
        rendered: "Enggasse",
      },
      featured_media: 16714,
      template: "",
      projekt_filter: [246, 247, 426, 425],
      acf: {
        highlight_image: 16717,
        highlight_title_project: "Enggasse",
        highlight_subtitle_project: "Gebäude der Wiederaufbauphase",
        highlight_description_project:
          "The real estate investment company Art-Invest Real Estate has its Cologne headquarter in a real collector's item. In the glamorous 1960s, closed and open workplaces in combination with retreats enabled modern working environments in the middle of the vivid city centre.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Refurbishment",
        location:
          "Enggasse 3, 50668 Cologne; city centre, Tunisstraße / Enggasse",
        property: "approx. 1,500 m²",
        area: "Office space: 6,000 m²",
        zertifizierung: "",
        parcels: "7 parking slots",
        use_for: "Office",
        acquired: "Q3 2015",
        realization: "01 2017",
        sale: "",
        architecture_firm: "",
        place: "Köln",
        fakten: [
          {
            bezeichnung: "Design",
            wert: "Lepel und Lepel",
            anchor: "",
          },
        ],
        specifications_image_projects: 14867,
        slider: null,
        title_details_projects: "ENGGASSE IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Gebäude der Wiederaufbauphase",
            description_repeater_details:
              "Enggasse is a listed building from the 1950s, which has always been a part of Cologne's banking district and still expresses the formal appeal of the Wilhelminian and neo-classical periods.",
            image_repeater_details: 14867,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Modernity meets old walls",
            description_repeater_details:
              "In close consultation with the monument conservation authorities, the premises were modernized. Today, the new floor plan gives mid-century flair to every detail: room-high doors and glass partitions framed by stainless steel meet materials such as marble, walnut and brass.",
            image_repeater_details: 16716,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Love in every detail",
            description_repeater_details:
              "The interior design of the offices is introduced by the stylish entrance area, which skilfully captures the era of the 60s. As a link between the in- and outside, the wide window sill picks up on the parapet height of the facade and translates it into a continuous design element in all rooms. Not to be forgotten: the roof terrace with its impressive view of the cathedral.",
            image_repeater_details: 16715,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Enggasse 3, Köln, Deutschland",
          lat: 50.94305,
          lng: 6.952178900000035,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Enggasse</title>\n<meta name="description" content="Am Alten Wall entstehen hinter der historischen Fassade 12.000 m² Fläche für Kunst, Kultur und Konsum, sowie 18.000 m² Raum für modernes Arbeiten." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/enggasse/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Enggasse" />\n<meta property="og:description" content="Am Alten Wall entstehen hinter der historischen Fassade 12.000 m² Fläche für Kunst, Kultur und Konsum, sowie 18.000 m² Raum für modernes Arbeiten." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/enggasse/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-03T13:23:34+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2017/11/sts_1708_AI-Enggasse_006-1.jpg" />\n\t<meta property="og:image:width" content="1500" />\n\t<meta property="og:image:height" content="938" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/enggasse/","url":"https://www.art-invest.de/en/projekt/enggasse/","name":"Art-Invest Real Estate | Enggasse","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2017-11-07T15:59:16+00:00","dateModified":"2020-07-03T13:23:34+00:00","description":"Am Alten Wall entstehen hinter der historischen Fassade 12.000 m² Fläche für Kunst, Kultur und Konsum, sowie 18.000 m² Raum für modernes Arbeiten.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/enggasse/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/enggasse/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/enggasse/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Enggasse"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Enggasse",
        description:
          "Am Alten Wall entstehen hinter der historischen Fassade 12.000 m² Fläche für Kunst, Kultur und Konsum, sowie 18.000 m² Raum für modernes Arbeiten.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/enggasse/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Enggasse",
        og_description:
          "Am Alten Wall entstehen hinter der historischen Fassade 12.000 m² Fläche für Kunst, Kultur und Konsum, sowie 18.000 m² Raum für modernes Arbeiten.",
        og_url: "https://www.art-invest.de/en/projekt/enggasse/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-03T13:23:34+00:00",
        og_image: [
          {
            width: 1500,
            height: 938,
            url: "https://www.art-invest.de/wp-content/uploads/2017/11/sts_1708_AI-Enggasse_006-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/enggasse/",
              url: "https://www.art-invest.de/en/projekt/enggasse/",
              name: "Art-Invest Real Estate | Enggasse",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2017-11-07T15:59:16+00:00",
              dateModified: "2020-07-03T13:23:34+00:00",
              description:
                "Am Alten Wall entstehen hinter der historischen Fassade 12.000 m² Fläche für Kunst, Kultur und Konsum, sowie 18.000 m² Raum für modernes Arbeiten.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/enggasse/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/enggasse/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/enggasse/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Enggasse",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2017/11/sts_1708_AI-Enggasse_006-1-800x800.jpg",
      place: "Köln",
      subtitle: "Gebäude der Wiederaufbauphase",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16713",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16714",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16713",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16713",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },

    {
      id: 16776,
      date: "2018-01-12T17:20:51",
      date_gmt: "2018-01-12T16:20:51",
      guid: {
        rendered: "https://www.art-invest.de/projekt/westenhellweg/",
      },
      modified: "2020-07-07T12:20:07",
      modified_gmt: "2020-07-07T12:20:07",
      slug: "westenhellweg",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/westenhellweg/",
      title: {
        rendered: "Westenhellweg",
      },
      featured_media: 16777,
      template: "",
      projekt_filter: [427, 425, 245, 258],
      acf: {
        highlight_image: 16777,
        highlight_title_project: "Westenhellweg",
        highlight_subtitle_project: "Immer beschäftigt",
        highlight_description_project:
          "On Dortmund's most popular shopping street, Westenhellweg, Art-Invest Real Estate has acquired a 12,200 m² commercial building. The long-term main tenants of the mixed-use property include H&amp;M and Lush. With this purchase, Art-Invest Real Estate is strengthening its portfolio of inner-city retail properties with value-added potential.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location: "Westenhellweg 11-13, Dortmund; city centre",
        property: "",
        area: "12,200 m²",
        zertifizierung: "",
        parcels: "130 underground parking spaces",
        use_for: "Retail, Gastronomy, Office, Living, Practise",
        acquired: "Q4 2017",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Dortmund",
        fakten: [
          {
            bezeichnung: "Built in",
            wert: "1977",
            anchor: "",
          },
        ],
        specifications_image_projects: 16777,
        slider: null,
        title_details_projects: "WESTENHELLWEG IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "One of the most popular shopping streets",
            description_repeater_details:
              "Westenhellweg in Dortmund is one of the ten most frequented shopping streets in Germany – and has been for several years. By upgrading the quality of stay in the adjacent areas (Kampstraße and Netanya Square) by the City of Dortmund, a pleasant shopping experience will also be ensured in the future.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Identifying potential",
            description_repeater_details:
              "With this investment, Art-Invest Real Estate strengthens its managed fund, which focuses on investments in inner-city retail properties. Due to the Corso-Passage, which runs through the entire building, the property has enormous potential for value creation. The use of retail, gastronomy, office, medical practices and apartments guarantee a diverse and sustainable mix.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Historical all along the line",
            description_repeater_details:
              "The name Hellweg is translated as light and wide path. In Dortmund this is a more than 5,000 year old street from pre-Roman Germanic times. Hellweg was already the most important street in Dortmund at that time and led from the historic east gate to the west gate.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Westenhellweg 11-13, Dortmund, Deutschland",
          lat: 51.5143942,
          lng: 7.4650733999999375,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Westenhellweg</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/westenhellweg/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Westenhellweg" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/westenhellweg/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-07T12:20:07+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2018/01/Westenhellweg_11-13_Dortmund-1.jpg" />\n\t<meta property="og:image:width" content="1523" />\n\t<meta property="og:image:height" content="1093" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/westenhellweg/","url":"https://www.art-invest.de/en/projekt/westenhellweg/","name":"Art-Invest Real Estate | Westenhellweg","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2018-01-12T16:20:51+00:00","dateModified":"2020-07-07T12:20:07+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/westenhellweg/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/westenhellweg/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/westenhellweg/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Westenhellweg"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Westenhellweg",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/westenhellweg/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Westenhellweg",
        og_url: "https://www.art-invest.de/en/projekt/westenhellweg/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-07T12:20:07+00:00",
        og_image: [
          {
            width: 1523,
            height: 1093,
            url: "https://www.art-invest.de/wp-content/uploads/2018/01/Westenhellweg_11-13_Dortmund-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/westenhellweg/",
              url: "https://www.art-invest.de/en/projekt/westenhellweg/",
              name: "Art-Invest Real Estate | Westenhellweg",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2018-01-12T16:20:51+00:00",
              dateModified: "2020-07-07T12:20:07+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/westenhellweg/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/westenhellweg/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/westenhellweg/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Westenhellweg",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2018/01/Westenhellweg_11-13_Dortmund-1-800x800.jpg",
      place: "Dortmund",
      subtitle: "Immer beschäftigt",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16776",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16777",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16776",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16776",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },

    {
      id: 16698,
      date: "2014-10-30T12:00:19",
      date_gmt: "2014-10-30T11:00:19",
      guid: {
        rendered: "https://www.art-invest.de/projekt/goerttwiete/",
      },
      modified: "2021-11-04T18:04:53",
      modified_gmt: "2021-11-04T17:04:53",
      slug: "goerttwiete",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/goerttwiete/",
      title: {
        rendered: "Gørttwiete",
      },
      featured_media: 16700,
      template: "",
      projekt_filter: [246, 426, 248, 425],
      acf: {
        highlight_image: 16700,
        highlight_title_project: "Gørttwiete",
        highlight_subtitle_project: "Eine Collage aus Alt und Neu",
        highlight_description_project:
          "The result of a six-storey combination of classic Kontorhaus and new glass building is 1,240 m² of state-of-the-art office space. Just around the corner from Rödingsmarkt, directly in downtown Hamburg.",
        highlight_logo_project: null,
        website_projects: {
          title: "www.goerttwiete.de",
          url: "http://www.goerttwiete.de/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "http://www.goerttwiete.de/",
          target: "_blank",
        },
        available_space: [""],
        project: "Refurbishment, New Building",
        location: "Görttwiete 16, 20459 Hamburg; Neustadt",
        property: "204 m²",
        area: "1,635 m² BGF",
        zertifizierung: "",
        parcels: "",
        use_for: "Office",
        acquired: "Q4 2013",
        realization: "Q2 2017",
        sale: "Q3 2018",
        architecture_firm: "MSM Meyer Schmitz-Morkramer Rhein GmbH",
        place: "Hamburg",
        fakten: null,
        specifications_image_projects: 16701,
        slider: null,
        title_details_projects: "GØRTTWIETE IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Eine Collage aus Alt und Neu",
            description_repeater_details:
              "The facades contrast with clinker brick and glass, but in the rooms of Görttwiete the transitions are fluid. The listed clinker brick building expands with the modern glass building to form a captivating building ensemble in which you can change from old to new on all floors.",
            image_repeater_details: 14100,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "On foot from yesterday to today",
            description_repeater_details:
              "The staircase connects old and new buildings: Just a short time ago, one was still standing with both feet in the old building and the merchant's history, now one finds oneself on the verge of the Next Big Thing in the new building. On the ground floor, its glass structure takes up the escape of the historic Görttwiete path, which used to connect Rödingsmarkt and Hopfenmarkt.",
            image_repeater_details: 14101,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Floor plan for modern working",
            description_repeater_details:
              "The office areas and corridors on the standard floors can be flexibly designed to meet all requirements of future-oriented working in different office structures. All floors in the new building are barrier-free. In each rental unit a sanitary core is optionally available and can be implemented –equipped with high-quality ceramics and natural stone. In addition, modern facilities for the construction of small kitchens can be found on all floors.",
            image_repeater_details: 16699,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "görttwiete, hamburg, deutschland",
          lat: 53.54775789529603,
          lng: 9.987779259681702,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Gørttwiete</title>\n<meta name="description" content="Das Resultat einer sechsstöckigen Verbindung aus klassischem Kontorhaus und gläsernem Neubau sind 1.240 m² modernste Büroflächen." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/goerttwiete/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Gørttwiete" />\n<meta property="og:description" content="Das Resultat einer sechsstöckigen Verbindung aus klassischem Kontorhaus und gläsernem Neubau sind 1.240 m² modernste Büroflächen." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/goerttwiete/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T17:04:53+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/KHHII_A_020_TEASER-1.jpg" />\n\t<meta property="og:image:width" content="1500" />\n\t<meta property="og:image:height" content="1500" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/goerttwiete/","url":"https://www.art-invest.de/en/projekt/goerttwiete/","name":"Art-Invest Real Estate | Gørttwiete","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-10-30T11:00:19+00:00","dateModified":"2021-11-04T17:04:53+00:00","description":"Das Resultat einer sechsstöckigen Verbindung aus klassischem Kontorhaus und gläsernem Neubau sind 1.240 m² modernste Büroflächen.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/goerttwiete/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/goerttwiete/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/goerttwiete/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Gørttwiete"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Gørttwiete",
        description:
          "Das Resultat einer sechsstöckigen Verbindung aus klassischem Kontorhaus und gläsernem Neubau sind 1.240 m² modernste Büroflächen.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/goerttwiete/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Gørttwiete",
        og_description:
          "Das Resultat einer sechsstöckigen Verbindung aus klassischem Kontorhaus und gläsernem Neubau sind 1.240 m² modernste Büroflächen.",
        og_url: "https://www.art-invest.de/en/projekt/goerttwiete/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T17:04:53+00:00",
        og_image: [
          {
            width: 1500,
            height: 1500,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/KHHII_A_020_TEASER-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/goerttwiete/",
              url: "https://www.art-invest.de/en/projekt/goerttwiete/",
              name: "Art-Invest Real Estate | Gørttwiete",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-10-30T11:00:19+00:00",
              dateModified: "2021-11-04T17:04:53+00:00",
              description:
                "Das Resultat einer sechsstöckigen Verbindung aus klassischem Kontorhaus und gläsernem Neubau sind 1.240 m² modernste Büroflächen.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/goerttwiete/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/goerttwiete/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/goerttwiete/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Gørttwiete",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/KHHII_A_020_TEASER-1.jpg",
      place: "Hamburg",
      subtitle: "Eine Collage aus Alt und Neu",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16698",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16700",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16698",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16698",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16691,
      date: "2019-10-15T17:24:05",
      date_gmt: "2019-10-15T15:24:05",
      guid: {
        rendered: "https://www.art-invest.de/projekt/iu/",
      },
      modified: "2021-11-04T18:09:25",
      modified_gmt: "2021-11-04T17:09:25",
      slug: "iu",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/iu/",
      title: {
        rendered: "IU - Idyllisch Urban",
      },
      featured_media: 14013,
      template: "",
      projekt_filter: [427, 252, 425, 261],
      acf: {
        highlight_image: 14013,
        highlight_title_project: "IU – idyllisch_urban",
        highlight_subtitle_project: "Wohnprojekt, das Freiräume schafft",
        highlight_description_project:
          "Five buildings surrounded by a generous park landscape ­­­– that's IU (idyllic_urban). A place of retreat in the middle of Vienna, directly on the Danube Canal and opposite the famous Vienna Prater, the project promises the highest quality of life as one of the largest residential quarters in the city. Extensive green and open spaces successfully meet the advantages of the nearby city centre. The result is an attractive combination of high-quality living space, modern architecture, urbanity and tranquility.",
        highlight_logo_project: 16693,
        website_projects: {
          title: "www.i-u.wien",
          url: "https://i-u.wien/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://i-u.wien/",
          target: "_blank",
        },
        available_space: [""],
        project: "Investment",
        location: "Wehleweg 5, 7, 9 & Drorygasse 4, 4a, 1030 Vienna",
        property: "11,604 m²",
        area: "25,592  m²",
        zertifizierung: "",
        parcels: "242",
        use_for: "Living",
        acquired: "Q1 2018",
        realization: "Q4 2019",
        sale: "",
        architecture_firm:
          "Roger Karré, HNP-Architekten, Blaich + Delugan, Freimüller Söllinger",
        place: "Vienna",
        fakten: null,
        specifications_image_projects: 16692,
        slider: null,
        title_details_projects: "IU - IDYLLISCH_URBAN IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              "Well thought-out residential construction with exceptional standards",
            description_repeater_details:
              "The new district, which offers all the facilities for daily needs within a ten-minute walk, is made up of almost 400 residential units of various sizes, which are ideally tailored to the respective needs. A kindergarten, playgrounds and a food market are part of the residential area. Thus IU develops into an idyllic meeting place, which remains consistently car-free. Nevertheless, vehicles can be accommodated: The underground car park provides 242 parking spaces and there are also about 1,600 bicycle racks available for future residents.",
            image_repeater_details: 14013,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "In the middle of the city and yet surrounded by green",
            description_repeater_details:
              "The new residential quarter scores with its design versatility: individual buildings designed by renowned architectural firms are embedded in a green landscape that accounts for two-thirds of the total area. Alternating, carefully coordinated forms create a harmonious picture and create a balanced feeling of freedom and comfort. Charming places can be found everywhere, inviting you to linger. A park open to the public will provide additional recreational value.",
            image_repeater_details: 16692,
            video: "",
            "anchor-link": "",
          },
        ],
        map: null,
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | IU – idyllisch_urban</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/iu/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | IU – idyllisch_urban" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/iu/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T17:09:25+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2019/10/Wien_Das_Ensemble_Außenansicht_Visu_01-Kopie-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1440" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/iu/","url":"https://www.art-invest.de/en/projekt/iu/","name":"Art-Invest Real Estate | IU – idyllisch_urban","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2019-10-15T15:24:05+00:00","dateModified":"2021-11-04T17:09:25+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/iu/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/iu/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/iu/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"IU – idyllisch_urban"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | IU – idyllisch_urban",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/iu/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | IU – idyllisch_urban",
        og_url: "https://www.art-invest.de/en/projekt/iu/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T17:09:25+00:00",
        og_image: [
          {
            width: 2560,
            height: 1440,
            url: "https://www.art-invest.de/wp-content/uploads/2019/10/Wien_Das_Ensemble_Außenansicht_Visu_01-Kopie-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/iu/",
              url: "https://www.art-invest.de/en/projekt/iu/",
              name: "Art-Invest Real Estate | IU – idyllisch_urban",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2019-10-15T15:24:05+00:00",
              dateModified: "2021-11-04T17:09:25+00:00",
              breadcrumb: {
                "@id": "https://www.art-invest.de/en/projekt/iu/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/iu/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/iu/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "IU – idyllisch_urban",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2019/10/Wien_Das_Ensemble_Außenansicht_Visu_01-Kopie-1-scaled.jpg",
      place: "Vienna",
      subtitle: "Wohnprojekt, das Freiräume schafft",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16691",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14013",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16691",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16691",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16608,
      date: "2014-08-11T12:00:26",
      date_gmt: "2014-08-11T10:00:26",
      guid: {
        rendered: "https://www.art-invest.de/projekt/fabfive/",
      },
      modified: "2021-11-04T18:05:39",
      modified_gmt: "2021-11-04T17:05:39",
      slug: "fabfive",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/fabfive/",
      title: {
        rendered: "FabFive",
      },
      featured_media: 16609,
      template: "",
      projekt_filter: [246, 248, 245],
      acf: {
        highlight_image: 16609,
        highlight_title_project: "FabFive",
        highlight_subtitle_project: "Eine Fassade, die sich selbst faltet",
        highlight_description_project:
          "The Alsterblick is very popular in Hamburg. The Fab Five in the Grosse Bleichen 5 with its folded window facade brings the Alster closer to the house and offers spectacular views of Jungfernstieg and the Binnenalster.",
        highlight_logo_project: 16610,
        website_projects: {
          title: "www.fab-5.de",
          url: "https://fab-5.de/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://fab-5.de/",
          target: "_blank",
        },
        available_space: [""],
        project: "Investment",
        location: "Große Bleichen 5, 20354 Hamburg",
        property: "",
        area: "4,200 m²",
        zertifizierung: "",
        parcels: "",
        use_for: "Office, Retail",
        acquired: "",
        realization: "2017",
        sale: "not for sale",
        architecture_firm: "Art-Invest und Fischötter Architekten Hamburg",
        place: "Hamburg",
        fakten: null,
        specifications_image_projects: 16609,
        slider: null,
        title_details_projects: "FABFIVE IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Eine Fassade, die sich selbst faltet",
            description_repeater_details:
              "All windows on the office floors are extended by five degrees in the direction of Jungfernstieg, giving the facade its characteristic basic shape. In the busy flow of the prominent shopping and office mile Grosse Bleichen, the building stands out with 44 light-coloured facade elements and approx. 4,000 m² of prime rental space.",
            image_repeater_details: 14102,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Dolce Vita ante Portas ",
            description_repeater_details:
              "Around Grosse Bleichen 5, the life of the city pulsates elegantly and appetisingly. Culinary creations and luxurious offers attract thousands of people every day to the city, the Rathausmarkt, Neuer Wall and of course to Hamburg's Passagenviertel. The Hanseatic Quarter is one of a dozen honourable arcades.",
            image_repeater_details: 14103,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Under water to the city",
            description_repeater_details:
              "The Jungfernstieg stop is just around the corner. The first stop in Germany to be built under water has connected the city centre with the entire urban area since 1931. It takes two minutes to get to the main train station or half an hour to the airport. The metro bus lines, the StadtRAD stations and the Alster ships complete the truly global transport network, which is used by more than 100,000 people every day.",
            image_repeater_details: 16592,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Große Bleichen 5, Hamburg, Deutschland",
          lat: 53.55335459999999,
          lng: 9.990851600000042,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | FabFive</title>\n<meta name="description" content="Die Großen Bleichen 5 rücken mit ihrer gefalteten Fensterfassade die Alster näher ans Haus und eröffnen den Mitarbeitern so spektakuläre Blickachsen." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/fabfive/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | FabFive" />\n<meta property="og:description" content="Die Großen Bleichen 5 rücken mit ihrer gefalteten Fensterfassade die Alster näher ans Haus und eröffnen den Mitarbeitern so spektakuläre Blickachsen." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/fabfive/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T17:05:39+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2014/08/GrBl_P1_View_V21-Kopie-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="2560" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/fabfive/","url":"https://www.art-invest.de/en/projekt/fabfive/","name":"Art-Invest Real Estate | FabFive","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-08-11T10:00:26+00:00","dateModified":"2021-11-04T17:05:39+00:00","description":"Die Großen Bleichen 5 rücken mit ihrer gefalteten Fensterfassade die Alster näher ans Haus und eröffnen den Mitarbeitern so spektakuläre Blickachsen.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/fabfive/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/fabfive/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/fabfive/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"FabFive"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | FabFive",
        description:
          "Die Großen Bleichen 5 rücken mit ihrer gefalteten Fensterfassade die Alster näher ans Haus und eröffnen den Mitarbeitern so spektakuläre Blickachsen.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/fabfive/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | FabFive",
        og_description:
          "Die Großen Bleichen 5 rücken mit ihrer gefalteten Fensterfassade die Alster näher ans Haus und eröffnen den Mitarbeitern so spektakuläre Blickachsen.",
        og_url: "https://www.art-invest.de/en/projekt/fabfive/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T17:05:39+00:00",
        og_image: [
          {
            width: 2560,
            height: 2560,
            url: "https://www.art-invest.de/wp-content/uploads/2014/08/GrBl_P1_View_V21-Kopie-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/fabfive/",
              url: "https://www.art-invest.de/en/projekt/fabfive/",
              name: "Art-Invest Real Estate | FabFive",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-08-11T10:00:26+00:00",
              dateModified: "2021-11-04T17:05:39+00:00",
              description:
                "Die Großen Bleichen 5 rücken mit ihrer gefalteten Fensterfassade die Alster näher ans Haus und eröffnen den Mitarbeitern so spektakuläre Blickachsen.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/fabfive/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/fabfive/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/fabfive/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "FabFive",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2014/08/GrBl_P1_View_V21-Kopie-1-scaled-800x800.jpg",
      place: "Hamburg",
      subtitle: "Eine Fassade, die sich selbst faltet",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16608",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16609",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16608",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16608",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16816,
      date: "2013-11-29T12:00:17",
      date_gmt: "2013-11-29T11:00:17",
      guid: {
        rendered: "https://www.art-invest.de/projekt/city-carre/",
      },
      modified: "2022-08-03T09:32:29",
      modified_gmt: "2022-08-03T07:32:29",
      slug: "city-carre",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/city-carre/",
      title: {
        rendered: "EASTON HOUSE",
      },
      featured_media: 14790,
      template: "",
      projekt_filter: [246, 427, 425, 245, 256],
      acf: {
        highlight_image: 14789,
        highlight_title_project: "EASTON HOUSE",
        highlight_subtitle_project: "Büros für die Zukunft",
        highlight_description_project:
          "Amid exciting urbanity and in close proximity to Berlin's most popular trendy neighborhoods, EASTON HOUSE forms an atmospheric center that radiates far into its surroundings. Since its acquisition in 2016 as City Carré, a comprehensive refurbishment has been realized: The approx. 46,000 SQM total area was upgraded to a state-of-the-art working environment for New Work requirements. Today, it offers modern offices and co-working spaces with 2,000 workstations.",
        highlight_logo_project: 16818,
        website_projects: {
          title: "www.eastonhouse.de",
          url: "http://eastonhouse.de/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "http://eastonhouse.de/",
          target: "_blank",
        },
        available_space: {
          title: "zum Flächenangebot",
          url: "https://www.aire-mag.com/de/flaechen/easton-house",
          target: "_blank",
        },
        project: "Refurbishment",
        location: "Koppenstr. 93 / Lange Str. 31-32, 10243 Berlin, Germany.",
        property: "approx. 10,500 sqm",
        area: "approx. 46,000 sqm",
        zertifizierung: "",
        parcels: "410 (Underground)",
        use_for: "Office, Retail",
        acquired: "Q3 2016",
        realization: "1996",
        sale: "",
        architecture_firm: "Architekten Fischer + Fischer BDA",
        place: "Berlin",
        fakten: null,
        specifications_image_projects: 14790,
        slider: null,
        title_details_projects: "EASTON HOUSE IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Atrium for Friedrichshain",
            description_repeater_details:
              "In principle, domes promise special spatial experiences. The EASTON HOUSE Berlin is no exception: the glass skylight spans 26 meters over the cylindrical atrium - creating a bright place for meetings and exchange in Berlin's young trendy neighborhood. In the future, the complex will comprise a total of approx. 46,000 SQM of flexible space for working, shopping and gastronomy. Five atriums form the anchor points of the ensemble with a floor area of approx. 10,500 SQM.",
            image_repeater_details: 14789,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Urban Junction",
            description_repeater_details:
              "For modern tenants and creative minds, mobility is paramount. Numerous suburban trains connect EASTON HOUSE at Ostbahnhof with all points of the city: it is only two stops to Alexanderplatz and about 15 minutes to the main train station. There are many ICE direct connections to other metropolitan regions in Germany. The new airport BER can be reached by cab as well as with a direct S-Bahn connection in about 28 minutes.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Lange Str. 31, 10243 Berlin, Deutschland",
          lat: 52.5125196,
          lng: 13.432655299999965,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | EASTON HOUSE</title>\n<meta name="description" content="Das City Carré Komplex in Friedrichshain beherbergt moderne Arbeitswelten, Einzelhandelsflächen und ein 4-Sterne-Hotel - alles direkt am Ostbahnhof." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/city-carre/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | EASTON HOUSE" />\n<meta property="og:description" content="Das City Carré Komplex in Friedrichshain beherbergt moderne Arbeitswelten, Einzelhandelsflächen und ein 4-Sterne-Hotel - alles direkt am Ostbahnhof." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/city-carre/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-08-03T07:32:29+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2018/10/EASTON_HOUSE_Berlin-1.jpg" />\n\t<meta property="og:image:width" content="2000" />\n\t<meta property="og:image:height" content="1132" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/city-carre/","url":"https://www.art-invest.de/en/projekt/city-carre/","name":"Art-Invest Real Estate | EASTON HOUSE","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2013-11-29T11:00:17+00:00","dateModified":"2022-08-03T07:32:29+00:00","description":"Das City Carré Komplex in Friedrichshain beherbergt moderne Arbeitswelten, Einzelhandelsflächen und ein 4-Sterne-Hotel - alles direkt am Ostbahnhof.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/city-carre/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/city-carre/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/city-carre/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"EASTON HOUSE"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | EASTON HOUSE",
        description:
          "Das City Carré Komplex in Friedrichshain beherbergt moderne Arbeitswelten, Einzelhandelsflächen und ein 4-Sterne-Hotel - alles direkt am Ostbahnhof.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/city-carre/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | EASTON HOUSE",
        og_description:
          "Das City Carré Komplex in Friedrichshain beherbergt moderne Arbeitswelten, Einzelhandelsflächen und ein 4-Sterne-Hotel - alles direkt am Ostbahnhof.",
        og_url: "https://www.art-invest.de/en/projekt/city-carre/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-08-03T07:32:29+00:00",
        og_image: [
          {
            width: 2000,
            height: 1132,
            url: "https://www.art-invest.de/wp-content/uploads/2018/10/EASTON_HOUSE_Berlin-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/city-carre/",
              url: "https://www.art-invest.de/en/projekt/city-carre/",
              name: "Art-Invest Real Estate | EASTON HOUSE",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2013-11-29T11:00:17+00:00",
              dateModified: "2022-08-03T07:32:29+00:00",
              description:
                "Das City Carré Komplex in Friedrichshain beherbergt moderne Arbeitswelten, Einzelhandelsflächen und ein 4-Sterne-Hotel - alles direkt am Ostbahnhof.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/city-carre/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/city-carre/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/city-carre/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "EASTON HOUSE",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2018/10/EASTON_HOUSE_Berlin-1-800x800.jpg",
      place: "Berlin",
      subtitle: "Büros für die Zukunft",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16816",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14790",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16816",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16816",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16578,
      date: "2014-10-07T12:00:19",
      date_gmt: "2014-10-07T10:00:19",
      guid: {
        rendered: "https://www.art-invest.de/projekt/52hi/",
      },
      modified: "2021-11-04T17:52:45",
      modified_gmt: "2021-11-04T16:52:45",
      slug: "52hi",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/52hi/",
      title: {
        rendered: "52HI",
      },
      featured_media: 16580,
      template: "",
      projekt_filter: [247, 427, 425, 245],
      acf: {
        highlight_image: 16584,
        highlight_title_project: "52HI",
        highlight_subtitle_project: "Fenster zur Welt",
        highlight_description_project:
          "Trade has an ancient tradition at Hohe Straße 52. As Cardo Maximus, it flowed into the Forum of Roman Cologne, the central market and trading place - an ideal address for the construction of an innovative department store.",
        highlight_logo_project: 16583,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Development",
        location:
          "Hohe Straße 52, 50667 Cologne; City Centre Cologne (pedestrian zone)",
        property: "850 m²",
        area: "3,500 m²",
        zertifizierung: "",
        parcels: "",
        use_for: "Retail",
        acquired: "December 2013",
        realization: "Q4 2018",
        sale: "",
        architecture_firm: "",
        place: "Köln",
        fakten: [
          {
            bezeichnung: "Entwurf",
            wert: "Kuehn Malvezzi",
            anchor: "",
          },
        ],
        specifications_image_projects: 16582,
        slider: null,
        title_details_projects: "52HI IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Fenster zur Welt",
            description_repeater_details:
              "See and be seen: An all-round storefront with a total length of 65 metres flanks the 52HI. The classic urban commercial building with base, central zone and attic storey provides the inspiration for the facade, which highlights the building with its 8-metre high showcase-like display windows. From 2018, four floors with approx. 3,500 m² of retail space will open here.",
            image_repeater_details: 16581,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "On the most prominent corner",
            description_repeater_details:
              "The four-storey building is located in the centre of Cologne. The corner location of Schildergasse and Hohe Strasse creates retail space with high visibility and a high number of passers-by. The two shopping streets are among the most frequented in whole Germany.",
            image_repeater_details: 16579,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "52HI Making of Film.",
            description_repeater_details:
              "Experience now the full fascination of the impressive architecture and the particularly long shop window, which becomes a show stage on the most prominent corner in Cologne city centre. And what can you expect at 52HI? Experience it for yourself.\r\n<h3></h3>\r\n&nbsp;",
            image_repeater_details: null,
            video: "https://player.vimeo.com/video/313401403",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Hohe Straße 52, Köln, Deutschland",
          lat: 50.9362648,
          lng: 6.956344800000011,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | 52HI</title>\n<meta name="description" content="Das innovative Kaufhaus setzt die lange Tradition des Handels in der Hohen Straße 52 in Köln fort, am zentralen antiken Markt- und Handelsplatz." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/52hi/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | 52HI" />\n<meta property="og:description" content="Das innovative Kaufhaus setzt die lange Tradition des Handels in der Hohen Straße 52 in Köln fort, am zentralen antiken Markt- und Handelsplatz." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/52hi/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T16:52:45+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2014/10/ssf1908_ArtInvest-52HI_19-2.jpg" />\n\t<meta property="og:image:width" content="2500" />\n\t<meta property="og:image:height" content="2000" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/52hi/","url":"https://www.art-invest.de/en/projekt/52hi/","name":"Art-Invest Real Estate | 52HI","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-10-07T10:00:19+00:00","dateModified":"2021-11-04T16:52:45+00:00","description":"Das innovative Kaufhaus setzt die lange Tradition des Handels in der Hohen Straße 52 in Köln fort, am zentralen antiken Markt- und Handelsplatz.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/52hi/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/52hi/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/52hi/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"52HI"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | 52HI",
        description:
          "Das innovative Kaufhaus setzt die lange Tradition des Handels in der Hohen Straße 52 in Köln fort, am zentralen antiken Markt- und Handelsplatz.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/52hi/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | 52HI",
        og_description:
          "Das innovative Kaufhaus setzt die lange Tradition des Handels in der Hohen Straße 52 in Köln fort, am zentralen antiken Markt- und Handelsplatz.",
        og_url: "https://www.art-invest.de/en/projekt/52hi/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T16:52:45+00:00",
        og_image: [
          {
            width: 2500,
            height: 2000,
            url: "https://www.art-invest.de/wp-content/uploads/2014/10/ssf1908_ArtInvest-52HI_19-2.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/52hi/",
              url: "https://www.art-invest.de/en/projekt/52hi/",
              name: "Art-Invest Real Estate | 52HI",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-10-07T10:00:19+00:00",
              dateModified: "2021-11-04T16:52:45+00:00",
              description:
                "Das innovative Kaufhaus setzt die lange Tradition des Handels in der Hohen Straße 52 in Köln fort, am zentralen antiken Markt- und Handelsplatz.",
              breadcrumb: {
                "@id": "https://www.art-invest.de/en/projekt/52hi/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/52hi/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/52hi/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "52HI",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2014/10/ssf1908_ArtInvest-52HI_19-2-800x800.jpg",
      place: "Köln",
      subtitle: "Fenster zur Welt",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16578",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16580",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16578",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16578",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21600,
      date: "2013-12-24T12:00:21",
      date_gmt: "2013-12-24T11:00:21",
      guid: {
        rendered:
          "https://www.art-invest.de/projekt/motel-one-am-alexanderplatz/",
      },
      modified: "2022-10-20T10:58:54",
      modified_gmt: "2022-10-20T08:58:54",
      slug: "motel-one-am-alexanderplatz",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/motel-one-am-alexanderplatz/",
      title: {
        rendered: "Motel One am Alexanderplatz",
      },
      featured_media: 21601,
      template: "",
      projekt_filter: [426, 251, 425, 256],
      acf: {
        highlight_image: 21601,
        highlight_title_project: "Motel One am Alexanderplatz",
        highlight_subtitle_project: "Der Eine am Alex",
        highlight_description_project:
          "Europe's largest Motel One is being built on Europe's largest square. Berlin's Alexanderplatz is a perfect location for the German hotel operator to realize its high demands on product and design in the budget hotel segment against the international backdrop of the design and creative metropolis of Berlin.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project:
          "Mezzanine investment, development of the world's largest Motel One hotel",
        location:
          "Rathausstr. 3-5, 10178 Berlin; directly at Alexanderplatz, Germany",
        property: "2,533 sqm",
        area: "20,904 sqm hotel, 708 rooms / 4,492 sqm retail, office and other space",
        zertifizierung: "",
        parcels: "",
        use_for: "Budget hotel",
        acquired: "Q3 2014",
        realization: "",
        sale: "Q4 2017",
        architecture_firm: "",
        place: "Berlin",
        fakten: null,
        specifications_image_projects: 5420,
        slider: [21601],
        title_details_projects: "MOTEL ONE AM ALEXANDERPLATZ IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Der Eine am Alex",
            description_repeater_details:
              "On 19 floors of the Berlin address there is room for approx. 20,904 sqm and 708 rooms - each committed to the Motel One philosophy in chic design, high-quality equipment at an attractive price. All, of course, in a central location. The building also has space for 4,492 sqm of retail, offices and other uses.",
            image_repeater_details: 5422,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Made in Europe",
            description_repeater_details:
              'Berlin\'s Alexanderplatz crystallizes the entire drama of German and European history. In honor of the Russian tsar, the Prussian king christened the nameless parade ground Alexander in 1805. As "Alex" it was to reflect the splendor and misery of upheaval, revolution and dictatorship in the centuries that followed. Today, the world meets at the "Alex" - among other things under the world clock.',
            image_repeater_details: 5425,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Rathausstraße 3-5 , Berlin, Deutschland",
          lat: 52.5188741,
          lng: 13.410917299999937,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Motel One am Alexanderplatz</title>\n<meta name="description" content="Am größten Platz Europas, dem Berliner Alexanderplatz, entsteht das größte Motel One Europas. Auf 19 Geschossen ist Raum für ca. 20.904 m² und 708 Zimmer." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/motel-one-am-alexanderplatz/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Motel One am Alexanderplatz" />\n<meta property="og:description" content="Am größten Platz Europas, dem Berliner Alexanderplatz, entsteht das größte Motel One Europas. Auf 19 Geschossen ist Raum für ca. 20.904 m² und 708 Zimmer." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/motel-one-am-alexanderplatz/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-20T08:58:54+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2018/03/Motel_One_Frontansicht-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1707" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/motel-one-am-alexanderplatz/","url":"https://www.art-invest.de/en/projekt/motel-one-am-alexanderplatz/","name":"Art-Invest Real Estate | Motel One am Alexanderplatz","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2013-12-24T11:00:21+00:00","dateModified":"2022-10-20T08:58:54+00:00","description":"Am größten Platz Europas, dem Berliner Alexanderplatz, entsteht das größte Motel One Europas. Auf 19 Geschossen ist Raum für ca. 20.904 m² und 708 Zimmer.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/motel-one-am-alexanderplatz/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/motel-one-am-alexanderplatz/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/motel-one-am-alexanderplatz/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Motel One am Alexanderplatz"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Motel One am Alexanderplatz",
        description:
          "Am größten Platz Europas, dem Berliner Alexanderplatz, entsteht das größte Motel One Europas. Auf 19 Geschossen ist Raum für ca. 20.904 m² und 708 Zimmer.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/motel-one-am-alexanderplatz/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Motel One am Alexanderplatz",
        og_description:
          "Am größten Platz Europas, dem Berliner Alexanderplatz, entsteht das größte Motel One Europas. Auf 19 Geschossen ist Raum für ca. 20.904 m² und 708 Zimmer.",
        og_url:
          "https://www.art-invest.de/en/projekt/motel-one-am-alexanderplatz/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-20T08:58:54+00:00",
        og_image: [
          {
            width: 2560,
            height: 1707,
            url: "https://www.art-invest.de/wp-content/uploads/2018/03/Motel_One_Frontansicht-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/motel-one-am-alexanderplatz/",
              url: "https://www.art-invest.de/en/projekt/motel-one-am-alexanderplatz/",
              name: "Art-Invest Real Estate | Motel One am Alexanderplatz",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2013-12-24T11:00:21+00:00",
              dateModified: "2022-10-20T08:58:54+00:00",
              description:
                "Am größten Platz Europas, dem Berliner Alexanderplatz, entsteht das größte Motel One Europas. Auf 19 Geschossen ist Raum für ca. 20.904 m² und 708 Zimmer.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/motel-one-am-alexanderplatz/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/motel-one-am-alexanderplatz/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/motel-one-am-alexanderplatz/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Motel One am Alexanderplatz",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2018/03/Motel_One_Frontansicht-1-scaled-800x800.jpg",
      place: "Berlin",
      subtitle: "Der Eine am Alex",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21600",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21601",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21601",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21600",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21600",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21689,
      date: "2020-01-17T17:30:00",
      date_gmt: "2020-01-17T16:30:00",
      guid: {
        rendered:
          "https://www.art-invest.de/projekt/ibis-styles-hotel-bayreuth/",
      },
      modified: "2022-10-27T10:21:22",
      modified_gmt: "2022-10-27T08:21:22",
      slug: "ibis-styles-hotel-bayreuth",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/ibis-styles-hotel-bayreuth/",
      title: {
        rendered: "ibis Styles Hotel",
      },
      featured_media: 21690,
      template: "",
      projekt_filter: [251, 427, 425, 263],
      acf: {
        highlight_image: 21690,
        highlight_title_project: "ibis Styles Hotel",
        highlight_subtitle_project: "Ausgezeichnete Hotelkombination",
        highlight_description_project:
          "A new hotel will open in the heart of Bayreuth in early 2020 - a successful combination of the comfort class Ibis Styles- and the more affordable Ibis Budget variant. The building has 180 state-of-the-art rooms, of which 96 are Ibis Styles and 84 Ibis Budget. The address benefits not only business travelers, but also the numerous leisure travelers who want to take advantage of the city's cultural offerings.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment",
        location: "Bürgerreuther Straße 2, 95444 Bayreuth, Germany",
        property: "3,923 sqm",
        area: "5,400 sqm",
        zertifizierung: "",
        parcels: "68",
        use_for: "Hotel, gastronomy",
        acquired: "Q4 2018",
        realization: "Q4 2019",
        sale: "",
        architecture_firm: "Marggraf Architektur",
        place: "",
        fakten: null,
        specifications_image_projects: 21690,
        slider: [21690],
        title_details_projects: "ibis Styles Hotel Bayreuth in Detail",
        details_repeater_projects: [
          {
            title_repeater_details: "Between Upper Franconia and Africa",
            description_repeater_details:
              "With its colorful facade elements, the hotel, which as a doublebrand project appeals to a broad target group, looks inviting even from afar. The demand for a creative, eye-catching design is evident on every floor. The hotel interior was created with reference to the African Studies Center of the city of Bayreuth: Fascinating images and African-style design tell stories about the exciting continent. As a result, the hotel bears an unmistakable signature and exudes a warm feel-good atmosphere from the very first moment.",
            image_repeater_details: 21690,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Ideal base for city travelers and culture buffs",
            description_repeater_details:
              "With its direct proximity to the main train station, the city center and the university, the forward-looking Ibis Doublebrand hotel is in an excellent micro-location. For culture and opera enthusiasts, the address is very convenient: The coveted annual Bayreuth Festival and the Richard Wagner Museum are just a few minutes away.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Bürgerreuther Straße 2, 95444 Bayreuth, Deutschland",
          lat: 49.9504547,
          lng: 11.5791203,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | ibis Styles Hotel Bayreuth</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/ibis-styles-hotel-bayreuth/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | ibis Styles Hotel Bayreuth" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/ibis-styles-hotel-bayreuth/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-27T08:21:22+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/03/Ibis_Styles_und_Ibis_Budget_Bayreuth-Kopie.jpg" />\n\t<meta property="og:image:width" content="1500" />\n\t<meta property="og:image:height" content="845" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/ibis-styles-hotel-bayreuth/","url":"https://www.art-invest.de/en/projekt/ibis-styles-hotel-bayreuth/","name":"Art-Invest Real Estate | ibis Styles Hotel Bayreuth","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-01-17T16:30:00+00:00","dateModified":"2022-10-27T08:21:22+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/ibis-styles-hotel-bayreuth/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/ibis-styles-hotel-bayreuth/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/ibis-styles-hotel-bayreuth/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"ibis Styles Hotel Bayreuth"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | ibis Styles Hotel Bayreuth",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/ibis-styles-hotel-bayreuth/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | ibis Styles Hotel Bayreuth",
        og_url:
          "https://www.art-invest.de/en/projekt/ibis-styles-hotel-bayreuth/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-27T08:21:22+00:00",
        og_image: [
          {
            width: 1500,
            height: 845,
            url: "https://www.art-invest.de/wp-content/uploads/2020/03/Ibis_Styles_und_Ibis_Budget_Bayreuth-Kopie.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/ibis-styles-hotel-bayreuth/",
              url: "https://www.art-invest.de/en/projekt/ibis-styles-hotel-bayreuth/",
              name: "Art-Invest Real Estate | ibis Styles Hotel",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-01-17T16:30:00+00:00",
              dateModified: "2022-10-27T08:21:22+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/ibis-styles-hotel-bayreuth/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/ibis-styles-hotel-bayreuth/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/ibis-styles-hotel-bayreuth/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "ibis Styles Hotel Bayreuth",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/03/Ibis_Styles_und_Ibis_Budget_Bayreuth-Kopie-800x800.jpg",
      place: "Bayreuth",
      subtitle: "Ausgezeichnete Hotelkombination",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21689",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21690",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21690",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21689",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21689",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16978,
      date: "2020-07-28T15:10:48",
      date_gmt: "2020-07-28T15:10:48",
      guid: {
        rendered: "https://www.art-invest.de/projekt/premier-inn/",
      },
      modified: "2020-07-30T08:31:17",
      modified_gmt: "2020-07-30T08:31:17",
      slug: "premier-inn",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/premier-inn/",
      title: {
        rendered: "Premier Inn",
      },
      featured_media: 16965,
      template: "",
      projekt_filter: [250, 251, 254, 427, 249, 425],
      acf: {
        highlight_image: 16975,
        highlight_title_project: "Premier Inn",
        highlight_subtitle_project: "Eine Oase der Ruhe",
        highlight_description_project:
          "The Premier Inn is conveniently located in Munich and offers relaxation in a modern atmosphere. The hotel meets the high standards of contemporary travel with comfortable rooms and generates numerous demand due to its fast connection to Munich Airport. As a result of a planned rebranding as one of the few Premier Inn hotels in Germany, the quality of the hotel will be further enhanced.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment in an existing property with new branding",
        location: "Freisinger Straße 94, 85445 Schwaig/Oberding",
        property: "8,005 m²",
        area: "5,859 m²",
        zertifizierung: "",
        parcels: "80 outdoor parking slots",
        use_for: "Hotel",
        acquired: "Q3 2020",
        realization: "2008",
        sale: "",
        architecture_firm: "",
        place: "München",
        fakten: [
          {
            bezeichnung: "Tenant",
            wert: "Premier Inn Hotel GmbH",
            anchor: "",
          },
        ],
        specifications_image_projects: 16965,
        slider: null,
        title_details_projects: "Premier Inn in Detail",
        details_repeater_projects: [
          {
            title_repeater_details: "Rebranding for success",
            description_repeater_details:
              "The Premier Inn Hotel near Munich serves the requirements of numerous travel occasions. A fresh colour concept, friendly interior design elements as well as up-to-date equipment meet the needs of the guests completely. 178 air-conditioned and barrier-free rooms as well as four conference rooms with an area of around 170 m² offer sufficient space for effective meetings. In addition, travellers relax in the breakfast area and at the bar. The hotel's own parking lot with 80 outside parking spaces completes a carefree hotel experience.",
            image_repeater_details: 16963,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Ideal starting point for successful days",
            description_repeater_details:
              "Thanks to the proximity to Munich Airport and excellent motorway connections, hotel guests can easily commute between business appointments, meetings and relaxation. Furthermore, the Premier Inn is also suitable for trade fair visitors and tourists due to its facilities and location. In addition, a selected range of gastronomy is available for guests in the direct vicinity.",
            image_repeater_details: 16961,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Freisinger Straße 94, Schwaig 85445 Oberding, Deutschland",
          lat: 48.3451397,
          lng: 11.831796,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Premier Inn</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/premier-inn/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Premier Inn" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/premier-inn/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-30T08:31:17+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/07/Premier-Inn-Muenchen-Auﬂenansicht.jpg" />\n\t<meta property="og:image:width" content="1331" />\n\t<meta property="og:image:height" content="886" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/premier-inn/","url":"https://www.art-invest.de/en/projekt/premier-inn/","name":"Art-Invest Real Estate | Premier Inn","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-07-28T15:10:48+00:00","dateModified":"2020-07-30T08:31:17+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/premier-inn/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/premier-inn/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/premier-inn/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Premier Inn"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Premier Inn",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/premier-inn/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Premier Inn",
        og_url: "https://www.art-invest.de/en/projekt/premier-inn/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-30T08:31:17+00:00",
        og_image: [
          {
            width: 1331,
            height: 886,
            url: "https://www.art-invest.de/wp-content/uploads/2020/07/Premier-Inn-Muenchen-Auﬂenansicht.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/premier-inn/",
              url: "https://www.art-invest.de/en/projekt/premier-inn/",
              name: "Art-Invest Real Estate | Premier Inn",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-07-28T15:10:48+00:00",
              dateModified: "2020-07-30T08:31:17+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/premier-inn/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/premier-inn/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/premier-inn/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Premier Inn",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/07/Premier-Inn-Muenchen-Auﬂenansicht-800x800.jpg",
      place: "München",
      subtitle: "Eine Oase der Ruhe",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16978",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16965",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16978",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16978",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16611,
      date: "2014-08-26T12:00:22",
      date_gmt: "2014-08-26T10:00:22",
      guid: {
        rendered: "https://www.art-invest.de/projekt/haller-haus/",
      },
      modified: "2020-07-03T13:24:36",
      modified_gmt: "2020-07-03T13:24:36",
      slug: "haller-haus",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/haller-haus/",
      title: {
        rendered: "Haller Haus",
      },
      featured_media: 16612,
      template: "",
      projekt_filter: [246, 248, 245],
      acf: {
        highlight_image: 8818,
        highlight_title_project: "Haller Haus",
        highlight_subtitle_project: "Hanseatische Architektur",
        highlight_description_project:
          "Commerzbank is one of the most beautiful bank buildings that architect Martin Haller bequeathed to his native city – today the Bankpalast is being modernized with great attention to detail for the banking of tomorrow.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location: "Jungfernstieg 22-24, 20354 Hamburg",
        property: "",
        area: "5,700 m²",
        zertifizierung: "",
        parcels: "",
        use_for: "Office, Retail, Bank",
        acquired: "",
        realization: "2019",
        sale: "not for sale",
        architecture_firm: "Art-Invest und LH Architekten, Hamburg",
        place: "Hamburg",
        fakten: null,
        specifications_image_projects: 8818,
        slider: null,
        title_details_projects: "HALLER HAUS IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Entrance to the staircase ",
            description_repeater_details:
              "The magnificent two-storey Kassensaal in the centre of the building is a manifestation of the imperial era. In future, employees and customers will be able to access the Kassensaal with the adjacent office and conference areas through a ground-level main portal via a generous flight of stairs.",
            image_repeater_details: 16649,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Hanseatische Architektur",
            description_repeater_details:
              "In 1899, when it was built, people still shook their heads at how a bank building could be built so far away from the stock exchange. But Martin Haller's initiative for the Dresdner Bank led to the building of a branch on the prestigious Binnenalster. Compared to the ostentatious overstatement of the neighbouring Hof-Hotel in Hamburg, the building is being constructed with a noble reserve. From a distance, it even adapted to the cornice lines of the new town hall without wanting to outdo it – after all, he was its architect.",
            image_repeater_details: 14104,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Central in the Alsterfoyer ",
            description_repeater_details:
              'The Haller Haus is located directly in the vestibule to the Alster. It gives Hamburg its special personality and the unmistakable face of Hamburg city centre – and one of the reasons why the Hanseatic city is also called "the most beautiful city in the world". 86 million day-visitors and 12 million overnight-stays per year speak for themselves.',
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Jungfernstieg 22-24, Hamburg, Deutschland",
          lat: 53.553318,
          lng: 9.991425499999991,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Haller Haus</title>\n<meta name="description" content="Der Bankpalast im Stile der Neorenaissance zählt zu den schönsten Bankgebäuden Hamburgs. Nun wird das Haus an der Alster mit Liebe zum Detail modernisiert." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/haller-haus/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Haller Haus" />\n<meta property="og:description" content="Der Bankpalast im Stile der Neorenaissance zählt zu den schönsten Bankgebäuden Hamburgs. Nun wird das Haus an der Alster mit Liebe zum Detail modernisiert." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/haller-haus/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-03T13:24:36+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2014/08/GrBl_P10_Ansicht-JFS_V7-Kopie-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1707" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/haller-haus/","url":"https://www.art-invest.de/en/projekt/haller-haus/","name":"Art-Invest Real Estate | Haller Haus","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-08-26T10:00:22+00:00","dateModified":"2020-07-03T13:24:36+00:00","description":"Der Bankpalast im Stile der Neorenaissance zählt zu den schönsten Bankgebäuden Hamburgs. Nun wird das Haus an der Alster mit Liebe zum Detail modernisiert.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/haller-haus/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/haller-haus/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/haller-haus/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Haller Haus"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Haller Haus",
        description:
          "Der Bankpalast im Stile der Neorenaissance zählt zu den schönsten Bankgebäuden Hamburgs. Nun wird das Haus an der Alster mit Liebe zum Detail modernisiert.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/haller-haus/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Haller Haus",
        og_description:
          "Der Bankpalast im Stile der Neorenaissance zählt zu den schönsten Bankgebäuden Hamburgs. Nun wird das Haus an der Alster mit Liebe zum Detail modernisiert.",
        og_url: "https://www.art-invest.de/en/projekt/haller-haus/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-03T13:24:36+00:00",
        og_image: [
          {
            width: 2560,
            height: 1707,
            url: "https://www.art-invest.de/wp-content/uploads/2014/08/GrBl_P10_Ansicht-JFS_V7-Kopie-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/haller-haus/",
              url: "https://www.art-invest.de/en/projekt/haller-haus/",
              name: "Art-Invest Real Estate | Haller Haus",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-08-26T10:00:22+00:00",
              dateModified: "2020-07-03T13:24:36+00:00",
              description:
                "Der Bankpalast im Stile der Neorenaissance zählt zu den schönsten Bankgebäuden Hamburgs. Nun wird das Haus an der Alster mit Liebe zum Detail modernisiert.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/haller-haus/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/haller-haus/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/haller-haus/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Haller Haus",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.dbz.de/imgs/1/7/5/1/4/8/2/9916e67b536ee40f.jpg",
      place: "Hamburg",
      subtitle: "Hanseatische Architektur ",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16611",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16612",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16611",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16611",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16907,
      date: "2017-03-01T11:36:01",
      date_gmt: "2017-03-01T10:36:01",
      guid: {
        rendered: "https://www.art-invest.de/projekt/bismarckplatz/",
      },
      modified: "2020-07-15T13:14:53",
      modified_gmt: "2020-07-15T13:14:53",
      slug: "bismarckplatz",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/bismarckplatz/",
      title: {
        rendered: "Bismarckplatz",
      },
      featured_media: 14021,
      template: "",
      projekt_filter: [246, 427, 425, 258],
      acf: {
        highlight_image: 14019,
        highlight_title_project: "Bismarckplatz",
        highlight_subtitle_project: "Platz mitten in der Essener Innenstadt",
        highlight_description_project:
          "Otto Fürst von Bismarck represents one of the most prestigious addresses in Essen: the listed building of the railway direction has been completely renovated and will open new office space on 17,711 m² in the middle of the city centre at Bismarckplatz.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Long-term Investment",
        location: "Bismarckplatz 1, 45128 Essen",
        property: "5,685 m²",
        area: "approx. 17,700 m²",
        zertifizierung: "",
        parcels: "297 parking spaces",
        use_for: "Office",
        acquired: "Januar 2017",
        realization: "1895 / 1950 / 2010",
        sale: "",
        architecture_firm: "",
        place: "Essen",
        fakten: null,
        specifications_image_projects: 16909,
        slider: null,
        title_details_projects: "BISMARCKPLATZ IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Royal working environments",
            description_repeater_details:
              "The service building of the Royal Railway Directorate in Essen was built in 1895 on Bismarckplatz and was completely renovated in 2010. In the course of the refurbishment work, the facades and the cross vaulting on the lower floors were modernized, a new spacious foyer was built and isolated individual offices were combined to form bright open-plan offices. While the glass front facade is reminiscent of the war-damaged central gable, the statue of Essen's first honorary citizen underlines Bismarck's services to the Ruhr industry.",
            image_repeater_details: 14020,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "License to steam",
            description_repeater_details:
              "The first iron-clad railway in Germany was laid south of Essen in 1828 – and certainly not in Nuremberg. Only the fact that the pioneer railway was never granted a steam licence by the local railway company secured Nuremberg's place in history as the cradle of the railway. For fear of a \"speed frenzy\", the Essen authorities initially only allowed Germany's first railway to use the proven horsepower.",
            image_repeater_details: 14021,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Excellent connection",
            description_repeater_details:
              "The direction of the Railway is located in a central city centre location in Essen's southern district with excellent public and private transport connections. The underground station Bismarckplatz is only five minutes away, the A40 motorway connects Bismarckplatz with the city and the entire Ruhr area. There are 297 parking spaces in the underground car park. The location around Bismarckplatz is one of Essen's preferred office locations, alongside the city centre, and is now undergoing comprehensive revitalisation.",
            image_repeater_details: 14022,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Bismarckplatz 1, 45128, Essen, Deutschland",
          lat: 51.44857810000001,
          lng: 7.00676210000006,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Bismarckplatz</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/bismarckplatz/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Bismarckplatz" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/bismarckplatz/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-15T13:14:53+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2017/03/Bismarckplatz1_Essen_03-1.jpg" />\n\t<meta property="og:image:width" content="1920" />\n\t<meta property="og:image:height" content="1280" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/bismarckplatz/","url":"https://www.art-invest.de/en/projekt/bismarckplatz/","name":"Art-Invest Real Estate | Bismarckplatz","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2017-03-01T10:36:01+00:00","dateModified":"2020-07-15T13:14:53+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/bismarckplatz/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/bismarckplatz/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/bismarckplatz/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Bismarckplatz"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Bismarckplatz",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/bismarckplatz/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Bismarckplatz",
        og_url: "https://www.art-invest.de/en/projekt/bismarckplatz/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-15T13:14:53+00:00",
        og_image: [
          {
            width: 1920,
            height: 1280,
            url: "https://www.art-invest.de/wp-content/uploads/2017/03/Bismarckplatz1_Essen_03-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/bismarckplatz/",
              url: "https://www.art-invest.de/en/projekt/bismarckplatz/",
              name: "Art-Invest Real Estate | Bismarckplatz",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2017-03-01T10:36:01+00:00",
              dateModified: "2020-07-15T13:14:53+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/bismarckplatz/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/bismarckplatz/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/bismarckplatz/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Bismarckplatz",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2017/03/Bismarckplatz1_Essen_03-1.jpg",
      place: "Essen",
      subtitle: "Zentraler Platz in Essen",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16907",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14021",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16907",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16907",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },

    {
      id: 16648,
      date: "2014-08-15T12:00:27",
      date_gmt: "2014-08-15T10:00:27",
      guid: {
        rendered: "https://www.art-invest.de/projekt/haus-am-stieg/",
      },
      modified: "2020-07-03T13:25:29",
      modified_gmt: "2020-07-03T13:25:29",
      slug: "haus-am-stieg",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/haus-am-stieg/",
      title: {
        rendered: "Haus am Stieg",
      },
      featured_media: 16649,
      template: "",
      projekt_filter: [246, 248],
      acf: {
        highlight_image: 16649,
        highlight_title_project: "Haus am Stieg",
        highlight_subtitle_project: "Ikone im neuen Glanz",
        highlight_description_project:
          "Various phoenixes grew out of the ashes of Hamburg's Great Fire – including the corner building in the Alsterfoyer at Jungfernstieg and Grosse Bleichen. It is one of the few impressive post-fire buildings in the city centre, whose rental space is now being modernised and restructured for workspace and retail.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Asset Management",
        location: "Große Bleichen 1, 20354 Hamburg",
        property: "",
        area: "2,000 m²",
        zertifizierung: "",
        parcels: "",
        use_for: "Office, Retail",
        acquired: "",
        realization: "2019",
        sale: "not for sale",
        architecture_firm: "Art-Invest und LH Architekten, Hamburg",
        place: "Hamburg",
        fakten: null,
        specifications_image_projects: 16649,
        slider: null,
        title_details_projects: "HAUS AM STIEG IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Ikone im neuen Glanz",
            description_repeater_details:
              "The architectural icon, built between 1842 and 1844 according to designs by Peter Hermann Fersenfeldt, remains an extensive proof of how the Hanseats retained their sense of style and elegance beyond the fire disaster. Today, behind the Italian early Renaissance facade, there are about 2,262 m² of the city's most beautiful workspaces – light and modular rooms with spectacular views of the Jungfernstieg and Alster basin.",
            image_repeater_details: 14104,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "The Architect ",
            description_repeater_details:
              "Hermann Peter Fersenfeldt (1786-1853) was one of the closest collaborators of the architect of Alexis de Chateauneuf, who had set himself a milestone in Hamburg's architectural history with the Alster Arcades. Together with Chateauneuf, Fersenfeldt also designed the construction of the later main church of St. Petri.",
            image_repeater_details: 14106,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "See and be seen ",
            description_repeater_details:
              "The Jungfernstieg was and still is the city's first climb. In the past it was the marriage market for virgins, because here on the solid ground of Hamburg's first completely paved street, it was a place to stroll uninhibitedly. While in the 18th century everyone was looking for the love of their life, today the Jungfernstieg is a boulevard for other adorable objects – it is one of the most frequented shopping boulevards in the city.",
            image_repeater_details: 16592,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Große Bleichen 1, Hamburg, Deutschland",
          lat: 53.5535613,
          lng: 9.991266200000041,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Haus am Stieg</title>\n<meta name="description" content="Das Eckgebäude am Jungfernstieg und den Großen Bleichen ist eines der wenigen Nachbrandgebäude der Innenstadt, dessen Mietflächen heute modernisiert werden." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/haus-am-stieg/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Haus am Stieg" />\n<meta property="og:description" content="Das Eckgebäude am Jungfernstieg und den Großen Bleichen ist eines der wenigen Nachbrandgebäude der Innenstadt, dessen Mietflächen heute modernisiert werden." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/haus-am-stieg/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-03T13:25:29+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2014/08/GrBl_P3_Ecke-Jungfernstieg_V8-Kopie-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1440" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/haus-am-stieg/","url":"https://www.art-invest.de/en/projekt/haus-am-stieg/","name":"Art-Invest Real Estate | Haus am Stieg","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-08-15T10:00:27+00:00","dateModified":"2020-07-03T13:25:29+00:00","description":"Das Eckgebäude am Jungfernstieg und den Großen Bleichen ist eines der wenigen Nachbrandgebäude der Innenstadt, dessen Mietflächen heute modernisiert werden.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/haus-am-stieg/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/haus-am-stieg/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/haus-am-stieg/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Haus am Stieg"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Haus am Stieg",
        description:
          "Das Eckgebäude am Jungfernstieg und den Großen Bleichen ist eines der wenigen Nachbrandgebäude der Innenstadt, dessen Mietflächen heute modernisiert werden.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/haus-am-stieg/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Haus am Stieg",
        og_description:
          "Das Eckgebäude am Jungfernstieg und den Großen Bleichen ist eines der wenigen Nachbrandgebäude der Innenstadt, dessen Mietflächen heute modernisiert werden.",
        og_url: "https://www.art-invest.de/en/projekt/haus-am-stieg/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-03T13:25:29+00:00",
        og_image: [
          {
            width: 2560,
            height: 1440,
            url: "https://www.art-invest.de/wp-content/uploads/2014/08/GrBl_P3_Ecke-Jungfernstieg_V8-Kopie-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/haus-am-stieg/",
              url: "https://www.art-invest.de/en/projekt/haus-am-stieg/",
              name: "Art-Invest Real Estate | Haus am Stieg",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-08-15T10:00:27+00:00",
              dateModified: "2020-07-03T13:25:29+00:00",
              description:
                "Das Eckgebäude am Jungfernstieg und den Großen Bleichen ist eines der wenigen Nachbrandgebäude der Innenstadt, dessen Mietflächen heute modernisiert werden.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/haus-am-stieg/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/haus-am-stieg/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/haus-am-stieg/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Haus am Stieg",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2014/08/GrBl_P3_Ecke-Jungfernstieg_V8-Kopie-1-scaled-800x800.jpg",
      place: "Hamburg",
      subtitle: "Ikone im neuen Glanz",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16648",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16649",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16648",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16648",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16832,
      date: "2014-01-28T12:00:06",
      date_gmt: "2014-01-28T11:00:06",
      guid: {
        rendered: "https://www.art-invest.de/projekt/immermannhof/",
      },
      modified: "2023-08-28T09:56:31",
      modified_gmt: "2023-08-28T07:56:31",
      slug: "immermannhof",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/immermannhof/",
      title: {
        rendered: "Immermannhof",
      },
      featured_media: 25341,
      template: "",
      projekt_filter: [246, 427, 425, 245, 257],
      acf: {
        highlight_image: 25341,
        highlight_title_project: "Immermanhof",
        highlight_subtitle_project: "Vorhang auf für die neue Innenstadt",
        highlight_description_project:
          "The six-storey office and commercial building is located directly opposite Dusseldorf's main railway station. The building forms the prelude to Immermannstraße, the axis between Dusseldorf Central Station and the sophisticated Kö-Bogen.",
        highlight_logo_project: 13302,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Long-term Investment",
        location: "Immermannstraße 65a-d, 40212 Dusseldorf; city centre",
        property: "approx. 5,920 m²",
        area: "approx. 22,100 m²",
        zertifizierung: "",
        parcels: "286",
        use_for: "Office and Retail",
        acquired: "Q3 2015",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Düsseldorf",
        fakten: [
          {
            bezeichnung: "",
            wert: "",
            anchor: "",
          },
        ],
        specifications_image_projects: 25339,
        slider: [25335, 25337, 25339, 25341],
        title_details_projects: "IMMERMANNHOF IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Vorhang auf für die neue Innenstadt",
            description_repeater_details:
              "During his lifetime Karl Leberecht Immermann (1796-1840) felt most at home on the stage in Dusseldorf. Temporarily, the lawyer, writer and playwright even took over the management of the theatre, which is within walking distance of the Immermannhof. With the inner city concept South-East, Düsseldorf is now upgrading this part of the city – as a modern stage for living and working.",
            image_repeater_details: 25335,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "The Court",
            description_repeater_details:
              "The building has a total lettable space of approx. 22,106 m², of which approx. 18,400 m² is office space and approx. 3,100 m² is retail space. Furthermore, 286 parking spaces are available in the building's own underground car park.",
            image_repeater_details: 25337,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Immermannstraße 65a-d, 40212 Düsseldorf",
          lat: 51.22148,
          lng: 6.792850000000044,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Immermannhof</title>\n<meta name="description" content="Das sechsgeschossige Büro- und Geschäftshaus liegt direkt gegenüber des Düsseldorfer Hauptbahnhofs und bildet den Auftakt der Immermannstraße." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/immermannhof/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Immermannhof" />\n<meta property="og:description" content="Das sechsgeschossige Büro- und Geschäftshaus liegt direkt gegenüber des Düsseldorfer Hauptbahnhofs und bildet den Auftakt der Immermannstraße." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/immermannhof/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-08-28T07:56:31+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2014/01/Bild4.jpg" />\n\t<meta property="og:image:width" content="2475" />\n\t<meta property="og:image:height" content="1650" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/immermannhof/","url":"https://www.art-invest.de/en/projekt/immermannhof/","name":"Art-Invest Real Estate | Immermannhof","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-01-28T11:00:06+00:00","dateModified":"2023-08-28T07:56:31+00:00","description":"Das sechsgeschossige Büro- und Geschäftshaus liegt direkt gegenüber des Düsseldorfer Hauptbahnhofs und bildet den Auftakt der Immermannstraße.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/immermannhof/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/immermannhof/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/immermannhof/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Immermannhof"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Immermannhof",
        description:
          "Das sechsgeschossige Büro- und Geschäftshaus liegt direkt gegenüber des Düsseldorfer Hauptbahnhofs und bildet den Auftakt der Immermannstraße.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/immermannhof/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Immermannhof",
        og_description:
          "Das sechsgeschossige Büro- und Geschäftshaus liegt direkt gegenüber des Düsseldorfer Hauptbahnhofs und bildet den Auftakt der Immermannstraße.",
        og_url: "https://www.art-invest.de/en/projekt/immermannhof/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-08-28T07:56:31+00:00",
        og_image: [
          {
            width: 2475,
            height: 1650,
            url: "https://www.art-invest.de/wp-content/uploads/2014/01/Bild4.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/immermannhof/",
              url: "https://www.art-invest.de/en/projekt/immermannhof/",
              name: "Art-Invest Real Estate | Immermannhof",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-01-28T11:00:06+00:00",
              dateModified: "2023-08-28T07:56:31+00:00",
              description:
                "Das sechsgeschossige Büro- und Geschäftshaus liegt direkt gegenüber des Düsseldorfer Hauptbahnhofs und bildet den Auftakt der Immermannstraße.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/immermannhof/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/immermannhof/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/immermannhof/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Immermannhof",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2014/01/Bild4-800x800.jpg",
      place: "Düsseldorf",
      subtitle: "Vorhang auf für die neue Innenstadt",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16832",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25341",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25339",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25337",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25335",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25341",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16832",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16832",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16688,
      date: "2020-04-06T12:27:18",
      date_gmt: "2020-04-06T12:27:18",
      guid: {
        rendered: "https://www.art-invest.de/projekt/the-metropolitan/",
      },
      modified: "2021-11-04T18:10:04",
      modified_gmt: "2021-11-04T17:10:04",
      slug: "the-metropolitan",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/the-metropolitan/",
      title: {
        rendered: "The Metropolitan",
      },
      featured_media: 14504,
      template: "",
      projekt_filter: [427, 252, 425, 245, 261],
      acf: {
        highlight_image: 14508,
        highlight_title_project: "The Metropolitan",
        highlight_subtitle_project: "Hoch hinaus: Das Metropolitan",
        highlight_description_project:
          'The Quartier Belvedere in Vienna is growing. Now it is enriched by one more attraction: "The Metropolitan" is a modern high-rise residential building with commercial space, which is visually captivating with its elaborate architecture and differently designed facades. By 2021, 370 individually designed residential units will be realized on 19 upper floors.',
        highlight_logo_project: null,
        website_projects: {
          title: "www.the-metropolitan.at",
          url: "https://www.the-metropolitan.at/",
          target: "",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://www.the-metropolitan.at/",
          target: "_blank",
        },
        available_space: [""],
        project: "Investment",
        location: "Karl-Popper-Straße 5, 1100 Vienna",
        property: "18,602 m²",
        area: "2,947 m²",
        zertifizierung: "",
        parcels: "114",
        use_for: "Living, side use: Retail",
        acquired: "Q1 2020",
        realization: "Q4 2021",
        sale: "",
        architecture_firm: "Delugan Meissl Associated Architects",
        place: "Vienna",
        fakten: null,
        specifications_image_projects: 14506,
        slider: [19127, 19129, 19131, 19125, 19123, 19121, 19119],
        title_details_projects: "THE METROPOLITAN IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              "Excellent living and leisure facilities under one roof",
            description_repeater_details:
              "Due to the design of the 60-meter high building – two narrow sides and two main facades – The Metropolitan appears elegant at first glance. In addition, the residential project convinces with its intelligent space and usage concept: All apartments have excellent fittings and a balcony. The future residents will also enjoy an indoor and semi-public outdoor fitness area as well as a co-working area, a kitchen lounge and a roof terrace for exclusive use. On the ground floor, there are restaurants and retail spaces.",
            image_repeater_details: 14508,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Varied and central: best location in the Sonnwendviertel",
            description_repeater_details:
              "The young Sonnwendviertel, which is located very centrally between the Vienna Central Station and the city, benefits from a fantastic infrastructure. Hotels, cafés, restaurants, offices and public facilities are being built around the central station. All shopping facilities are in the immediate vicinity. The neighbouring, newly laid out Helmut-Zilk-Park – one of the largest and most beautiful gardens in Vienna with around 70,000 sqm – offers a variety of relaxation moments and longer walks.",
            image_repeater_details: 14504,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Karl-Popper-Straße 5, 1100 Wien, Österreich",
          lat: 48.1836594,
          lng: 16.3810534,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | The Metropolitan</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/the-metropolitan/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | The Metropolitan" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/the-metropolitan/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T17:10:04+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/04/Metropolitan_Wien_BlickGleise.jpg" />\n\t<meta property="og:image:width" content="654" />\n\t<meta property="og:image:height" content="886" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/the-metropolitan/","url":"https://www.art-invest.de/en/projekt/the-metropolitan/","name":"Art-Invest Real Estate | The Metropolitan","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-04-06T12:27:18+00:00","dateModified":"2021-11-04T17:10:04+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/the-metropolitan/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/the-metropolitan/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/the-metropolitan/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"The Metropolitan"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | The Metropolitan",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/the-metropolitan/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | The Metropolitan",
        og_url: "https://www.art-invest.de/en/projekt/the-metropolitan/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T17:10:04+00:00",
        og_image: [
          {
            width: 654,
            height: 886,
            url: "https://www.art-invest.de/wp-content/uploads/2020/04/Metropolitan_Wien_BlickGleise.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/the-metropolitan/",
              url: "https://www.art-invest.de/en/projekt/the-metropolitan/",
              name: "Art-Invest Real Estate | The Metropolitan",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-04-06T12:27:18+00:00",
              dateModified: "2021-11-04T17:10:04+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/the-metropolitan/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/the-metropolitan/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/the-metropolitan/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "The Metropolitan",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/04/Metropolitan_Wien_BlickGleise-654x800.jpg",
      place: "Vienna",
      subtitle: "Hoch hinaus: Das Metropolitan",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16688",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19119",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19121",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19123",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19125",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19131",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19129",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/19127",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14504",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16688",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16688",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16918,
      date: "2019-03-07T09:26:29",
      date_gmt: "2019-03-07T08:26:29",
      guid: {
        rendered: "https://www.art-invest.de/projekt/markt-1/",
      },
      modified: "2023-08-14T09:29:00",
      modified_gmt: "2023-08-14T07:29:00",
      slug: "markt-1",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/markt-1/",
      title: {
        rendered: "Markt 1",
      },
      featured_media: 14032,
      template: "",
      projekt_filter: [246, 427, 425, 245],
      acf: {
        highlight_image: 25239,
        highlight_title_project: "Markt 1",
        highlight_subtitle_project: "Bürogebäude mitten in der Stadt",
        highlight_description_project:
          "This striking property is in a premium location on Essen's most frequented shopping street.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Development in Existence",
        location: "Kettwiger Straße 47/Markt 1/Kennedyplatz 1, Essen",
        property: "3,628 m²",
        area: "12.407 m²",
        zertifizierung: "",
        parcels: "",
        use_for: "Retail, Office",
        acquired: "Q4 2018",
        realization: "2024",
        sale: "",
        architecture_firm: "Deveny & Partner GbR",
        place: "Essen",
        fakten: null,
        specifications_image_projects: 16919,
        slider: null,
        title_details_projects: "MARKT 1 IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Established and well-known property",
            description_repeater_details:
              "The large corner building from the 80s is centrally located in Essen's pedestrian zone at the popular hub between Markt and Kennedyplatz. The neo-Gothic town hall stood here until 1964, when Markt 1 became the economic and political centre of Essen. In 1963 the town hall was sold to the Wertheim department store group. The department store that had been built there was demolished in the mid-1980s and replaced by the current commercial building. Today's Markt 1 immediately catches the eye due to its continuous shop window fronts, flexible floor plan design and exposed location.",
            image_repeater_details: 14033,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Versatile use",
            description_repeater_details:
              "With 9,900 m² of floor space, distributed over five upper floors and two basement floors, the property offers generous space for retailers. The tenants include a clothing company, two large telecommunications companies and three restaurants. There are also offices on the upper floors.",
            image_repeater_details: 14032,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "",
          lat: 51.456795827781576,
          lng: 7.012409174274467,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Markt 1</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/markt-1/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Markt 1" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/markt-1/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-08-14T07:29:00+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2019/03/ssf_1901_ART-Invest-Kennedyplatz_03-2.jpg" />\n\t<meta property="og:image:width" content="2500" />\n\t<meta property="og:image:height" content="2000" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/markt-1/","url":"https://www.art-invest.de/en/projekt/markt-1/","name":"Art-Invest Real Estate | Markt 1","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2019-03-07T08:26:29+00:00","dateModified":"2023-08-14T07:29:00+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/markt-1/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/markt-1/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/markt-1/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Markt 1"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Markt 1",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/markt-1/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Markt 1",
        og_url: "https://www.art-invest.de/en/projekt/markt-1/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-08-14T07:29:00+00:00",
        og_image: [
          {
            width: 2500,
            height: 2000,
            url: "https://www.art-invest.de/wp-content/uploads/2019/03/ssf_1901_ART-Invest-Kennedyplatz_03-2.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/markt-1/",
              url: "https://www.art-invest.de/en/projekt/markt-1/",
              name: "Art-Invest Real Estate | Markt 1",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2019-03-07T08:26:29+00:00",
              dateModified: "2023-08-14T07:29:00+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/markt-1/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/markt-1/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/markt-1/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Markt 1",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2019/03/ssf_1901_ART-Invest-Kennedyplatz_03-2.jpg",
      place: "Essen",
      subtitle: "Bürogebäude mitten in der Stadt",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16918",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14032",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16918",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16918",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16797,
      date: "2020-04-06T12:25:16",
      date_gmt: "2020-04-06T12:25:16",
      guid: {
        rendered: "https://www.art-invest.de/projekt/kai-100/",
      },
      modified: "2022-10-11T09:24:31",
      modified_gmt: "2022-10-11T07:24:31",
      slug: "donaukai",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/donaukai/",
      title: {
        rendered: "Donaukai",
      },
      featured_media: 18554,
      template: "",
      projekt_filter: [246, 427, 252, 425, 245, 261],
      acf: {
        highlight_image: 14233,
        highlight_title_project: "Donaukai",
        highlight_subtitle_project: "Wohnen am Ufer der Donau",
        highlight_description_project:
          "Located directly on the Danube, in the immediate vicinity of the Danube Island and not far from the Augarten, the modern residential property Donaukai is a place of peace and relaxation.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment",
        location: "Handelskai 98–100, 1200 Vienna",
        property: "30,254 m²",
        area: "6,736 m²",
        zertifizierung: "",
        parcels: "242",
        use_for: "Living, Retail, Office",
        acquired: "Q4 2019",
        realization: "Q1 2022",
        sale: "",
        architecture_firm:
          "GERNER GERNER PLUS (architekten gerner und partner zt gmbh)",
        place: "Vienna",
        fakten: null,
        specifications_image_projects: 14555,
        slider: [
          18554, 18556, 18558, 18572, 18570, 18568, 18566, 18564, 18562, 18560,
        ],
        title_details_projects: "DONAUKAI IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Green oasis",
            description_repeater_details:
              'Each of the 402 bright and thoughtfully designed 1-3 room apartments is equipped with a high-quality built-in kitchen. They also have inviting open spaces such as a loggia, a balcony, a private garden or a roof terrace. The possibility of "urban gardening" on the roof of the residential buildings brings the residents together and gives a sense of community. Three green inner courtyards invite residents to relax and linger, while families with children feel at home in the playgrounds.',
            image_repeater_details: 14246,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Attractive residential building with design versatility",
            description_repeater_details:
              "The residential complex consists of five connected buildings. In addition to the residential units on the upper floors, the ground floor offers space for business premises. Offices are located on the first floor. With around 240 own underground parking spaces and 580 bicycle stands, the building project is tailored to the needs of its tenants and residents. In the middle of Vienna's 20th district, in the vivid business district not far from the Millennium Tower, there are excellent transport connections and local amenities. At the same time, the future residents will enjoy nature in the immediate vicinity.",
            image_repeater_details: 14258,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Handelskai 98, 1200 Wien, Österreich",
          lat: 48.2403899,
          lng: 16.3868459,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Donaukai</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/donaukai/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Donaukai" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/donaukai/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-11T07:24:31+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/04/20200928_cam-01_final_AERIAL-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2397" />\n\t<meta property="og:image:height" content="2560" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/donaukai/","url":"https://www.art-invest.de/en/projekt/donaukai/","name":"Art-Invest Real Estate | Donaukai","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-04-06T12:25:16+00:00","dateModified":"2022-10-11T07:24:31+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/donaukai/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/donaukai/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/donaukai/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Donaukai"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Donaukai",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/donaukai/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Donaukai",
        og_url: "https://www.art-invest.de/en/projekt/donaukai/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-11T07:24:31+00:00",
        og_image: [
          {
            width: 2397,
            height: 2560,
            url: "https://www.art-invest.de/wp-content/uploads/2020/04/20200928_cam-01_final_AERIAL-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/donaukai/",
              url: "https://www.art-invest.de/en/projekt/donaukai/",
              name: "Art-Invest Real Estate | Donaukai",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-04-06T12:25:16+00:00",
              dateModified: "2022-10-11T07:24:31+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/donaukai/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/donaukai/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/donaukai/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Donaukai",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/04/20200928_cam-01_final_AERIAL-1-800x800.jpg",
      place: "Vienna",
      subtitle: "Wohnen am Ufer der Donau",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16797",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18560",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18562",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18564",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18566",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18568",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18570",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18572",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18558",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18556",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18554",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18554",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16797",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16797",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16213,
      date: "2018-03-14T16:07:26",
      date_gmt: "2018-03-14T15:07:26",
      guid: {
        rendered: "https://www.art-invest.de/projekt/millennium-tower/",
      },
      modified: "2020-06-16T19:26:08",
      modified_gmt: "2020-06-16T19:26:08",
      slug: "millennium-tower",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/millennium-tower/",
      title: {
        rendered: "Millennium Tower",
      },
      featured_media: 16215,
      template: "",
      projekt_filter: [246, 251, 427, 425, 245, 261],
      acf: {
        highlight_image: 5199,
        highlight_title_project: "Millennium Tower",
        highlight_subtitle_project:
          "Ein Wahrzeichen, das seinem Namen alle Ehre macht",
        highlight_description_project:
          "More than 40,000 m² over 50 floors and 202 metres in height – these are the impressive facts of the Millennium Tower in Vienna. The acquisition of the second highest office building in Vienna marks Art-Invest’s entry into the Austrian market.",
        highlight_logo_project: 13401,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment ",
        location: "Vienna (Austria), Handelskai 94-96 ",
        property: "2,767 m²",
        area: "40,000 m²",
        zertifizierung: "",
        parcels: "497",
        use_for: "Office, Retail, Hotel",
        acquired: "Q4 2017",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Vienna",
        fakten: [
          {
            bezeichnung: "Design",
            wert: "Gustav Peichl, Boris Podrecca und Rudolf F. Weber",
            anchor: "",
          },
        ],
        specifications_image_projects: 5198,
        slider: [16214, 16375],
        title_details_projects: "MILLENNIUM TOWER IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Impressive numbers, unique architecture",
            description_repeater_details:
              "The second highest office building in Austria is not only impressive in terms of its figures. Two glazed cylinders characterise the unique architecture and is a real eye-catcher. All floors offer a unique view of Vienna and the Danube, which lies at the foot of the building.",
            image_repeater_details: 5199,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Versatile Uses",
            description_repeater_details:
              "Flexible floor plans for office use, the adjoining shopping and entertainment centre Millennium City, a comprehensive range of shopping facilities in the direct vicinity and numerous gastronomies offers characterise the Millennium Tower. In connection with a strategically favourable traffic junction, the Millennium Tower forms an ideal office location.",
            image_repeater_details: 16214,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "First project in Austria",
            description_repeater_details:
              "The acquisition of the Millennium Tower also marks the market entry of Art-Invest in Austria. As a stable investment location with a focus on office, retail, hotel with all yield and risk profiles, the metropolitan areas of Vienna, Innsbruck and Salzburg offer further investment potential.",
            image_repeater_details: 5198,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Millennium Tower Movie",
            description_repeater_details: "",
            image_repeater_details: 5199,
            video: "https://player.vimeo.com/video/400521768",
            "anchor-link": "",
          },
        ],
        map: null,
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Millennium Tower</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/millennium-tower/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Millennium Tower" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/millennium-tower/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-06-16T19:26:08+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2017/11/Millennium_Tower_Wien-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1708" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/millennium-tower/","url":"https://www.art-invest.de/en/projekt/millennium-tower/","name":"Art-Invest Real Estate | Millennium Tower","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2018-03-14T15:07:26+00:00","dateModified":"2020-06-16T19:26:08+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/millennium-tower/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/millennium-tower/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/millennium-tower/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Millennium Tower"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Millennium Tower",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/millennium-tower/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Millennium Tower",
        og_url: "https://www.art-invest.de/en/projekt/millennium-tower/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-06-16T19:26:08+00:00",
        og_image: [
          {
            width: 2560,
            height: 1708,
            url: "https://www.art-invest.de/wp-content/uploads/2017/11/Millennium_Tower_Wien-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/millennium-tower/",
              url: "https://www.art-invest.de/en/projekt/millennium-tower/",
              name: "Art-Invest Real Estate | Millennium Tower",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2018-03-14T15:07:26+00:00",
              dateModified: "2020-06-16T19:26:08+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/millennium-tower/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/millennium-tower/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/millennium-tower/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Millennium Tower",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2017/11/Millennium_Tower_Wien-1-scaled-800x800.jpg",
      place: "Vienna",
      subtitle: "Ein Wahrzeichen, das begeistert",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16213",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16375",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16214",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16215",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16213",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16213",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21654,
      date: "2014-02-19T12:00:56",
      date_gmt: "2014-02-19T11:00:56",
      guid: {
        rendered:
          "https://www.art-invest.de/projekt/dorint-kongresshotel-mannheim/",
      },
      modified: "2023-11-17T13:11:53",
      modified_gmt: "2023-11-17T12:11:53",
      slug: "dorint-kongresshotel-mannheim",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/dorint-kongresshotel-mannheim/",
      title: {
        rendered: "Dorint Kongresshotel",
      },
      featured_media: 21655,
      template: "",
      projekt_filter: [251, 427, 425, 263],
      acf: {
        highlight_image: 21655,
        highlight_title_project: "Dorint Kongresshotel",
        highlight_subtitle_project: "Treffen der Besten",
        highlight_description_project:
          "People meet in Mannheim. The city of squares is a sought-after congress location both nationally and internationally. With 287 modern rooms, the 4-star Dorint Kongresshotel not only creates high-quality retreats and overnight accommodations, but also has excellent rooms for conferencing itself.",
        highlight_logo_project: null,
        website_projects: [""],
        external_projectpage: null,
        available_space: [""],
        project:
          "Investment / Value enhancement by improving operating results through complete renovation of the room product and modernization of public areas, as well as expansion of Mannheim as a congress location",
        location:
          "Friedrichsring 6, 68161 Mannheim; direct connection to the m:con congress center at Rosengarten",
        property: "4,014 sqm",
        area: "16,250 sqm / 287 guest rooms, restaurant with bar, 13\tconference rooms as well as wellness area",
        zertifizierung: "",
        parcels: "215 underground parking spaces",
        use_for: "4-* congress hotel",
        acquired: "Q3 2016",
        realization: "1996",
        sale: "",
        architecture_firm: "",
        place: "Mannheim",
        fakten: null,
        specifications_image_projects: 10608,
        slider: [0],
        title_details_projects: "DORINT KONGRESSHOTEL IM DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Treffen der Besten",
            description_repeater_details:
              "Mannheim is the place to meet - for scientific congresses and conferences, symposia and discussion forums. From Germany's largest regional consumer trade fair to high-profile events in the nearby SAP Arena, the conference business in the Rhine-Neckar metropolis is enjoying a highly positive development.",
            image_repeater_details: 21655,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Transportation hub Mannheim",
            description_repeater_details:
              "The university city lies in the slipstream of excellent national and international transport connections. From the congress hotel, it is only 30 minutes by train and cab to Frankfurt Airport. The main train station is seven minutes away and, as an ICE-TGV junction, offers around 185 train connections daily.\r\n\r\nFive highways in the immediate vicinity provide optimum access to the European highway network - and there are 215 parking spaces in the underground garage.",
            image_repeater_details: 10608,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "The art of the conference",
            description_repeater_details:
              "Free exchange of ideas or goal-oriented meeting? Guests will find room for every form of professional exchange in thirteen state-of-the-art conference rooms: For meetings, negotiations, seminars or workshops, the house with 16,250 sqm GFA is the ideal address - and if the conference threatens to fail, there is always the strategic retreat to the rose garden, the restaurant or the hotel bar.",
            image_repeater_details: 10621,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Friedrichsring 6, Mannheim, Deutschland",
          lat: 49.48620789999999,
          lng: 8.476288899999986,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Dorint Kongresshotel</title>\n<meta name="description" content="Das 4-Sterne Dorint Kongresshotel schafft mit 287 modern ausgestatteten Zimmern hochwertige Übernachtungsräume und bietet exzellente Räume zum Konferieren." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/dorint-kongresshotel-mannheim/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Dorint Kongresshotel" />\n<meta property="og:description" content="Das 4-Sterne Dorint Kongresshotel schafft mit 287 modern ausgestatteten Zimmern hochwertige Übernachtungsräume und bietet exzellente Räume zum Konferieren." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/dorint-kongresshotel-mannheim/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-11-17T12:11:53+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2017/01/DMA_2-1.jpg" />\n\t<meta property="og:image:width" content="2500" />\n\t<meta property="og:image:height" content="1714" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/dorint-kongresshotel-mannheim/","url":"https://www.art-invest.de/en/projekt/dorint-kongresshotel-mannheim/","name":"Art-Invest Real Estate | Dorint Kongresshotel","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-02-19T11:00:56+00:00","dateModified":"2023-11-17T12:11:53+00:00","description":"Das 4-Sterne Dorint Kongresshotel schafft mit 287 modern ausgestatteten Zimmern hochwertige Übernachtungsräume und bietet exzellente Räume zum Konferieren.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/dorint-kongresshotel-mannheim/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/dorint-kongresshotel-mannheim/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/dorint-kongresshotel-mannheim/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Dorint Kongresshotel"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Dorint Kongresshotel",
        description:
          "Das 4-Sterne Dorint Kongresshotel schafft mit 287 modern ausgestatteten Zimmern hochwertige Übernachtungsräume und bietet exzellente Räume zum Konferieren.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/dorint-kongresshotel-mannheim/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Dorint Kongresshotel",
        og_description:
          "Das 4-Sterne Dorint Kongresshotel schafft mit 287 modern ausgestatteten Zimmern hochwertige Übernachtungsräume und bietet exzellente Räume zum Konferieren.",
        og_url:
          "https://www.art-invest.de/en/projekt/dorint-kongresshotel-mannheim/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-11-17T12:11:53+00:00",
        og_image: [
          {
            width: 2500,
            height: 1714,
            url: "https://www.art-invest.de/wp-content/uploads/2017/01/DMA_2-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/dorint-kongresshotel-mannheim/",
              url: "https://www.art-invest.de/en/projekt/dorint-kongresshotel-mannheim/",
              name: "Art-Invest Real Estate | Dorint Kongresshotel",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-02-19T11:00:56+00:00",
              dateModified: "2023-11-17T12:11:53+00:00",
              description:
                "Das 4-Sterne Dorint Kongresshotel schafft mit 287 modern ausgestatteten Zimmern hochwertige Übernachtungsräume und bietet exzellente Räume zum Konferieren.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/dorint-kongresshotel-mannheim/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/dorint-kongresshotel-mannheim/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/dorint-kongresshotel-mannheim/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Dorint Kongresshotel",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2017/01/DMA_2-1.jpg",
      place: "Mannheim",
      subtitle: "Treffen der Besten",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21654",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/0",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21655",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21654",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21654",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21602,
      date: "2013-08-20T12:00:34",
      date_gmt: "2013-08-20T10:00:34",
      guid: {
        rendered: "https://www.art-invest.de/projekt/gutleutstrasse/",
      },
      modified: "2022-10-20T11:09:00",
      modified_gmt: "2022-10-20T09:09:00",
      slug: "gutleutstrasse",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/gutleutstrasse/",
      title: {
        rendered: "Gutleutstraße",
      },
      featured_media: 14230,
      template: "",
      projekt_filter: [427, 425, 255, 253],
      acf: {
        highlight_image: 14035,
        highlight_title_project: "Gutleutstraße",
        highlight_subtitle_project: "Hochleistungsrechenzentrum",
        highlight_description_project:
          "The state-of-the-art data center in Frankfurt's Gutleutviertel district has direct access to the world's largest Internet hubs DE CIX and ECIX. The facility, with approximately 10.600 sqm of floor space, provides customers direct access to high-performance connections to cloud and network providers.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment",
        location: "Gutleutstraße 310, 60327 Frankfurt, Germany",
        property: "Approx. 20,160 sqm",
        area: "Approx. 10,600 sqm",
        zertifizierung: "",
        parcels: "42",
        use_for: "Data Center",
        acquired: "July 2016",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Frankfurt",
        fakten: null,
        specifications_image_projects: 21603,
        slider: [14035, 14230],
        title_details_projects: "GUTLEUTSTRASSE IM DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Efficient data transit",
            description_repeater_details:
              "In addition to 42 car spaces, the data center has a wide range of global peering and interconnection options that reduce overall IP transit costs and increase network performance and speed for end-to-end connections.",
            image_repeater_details: 14230,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Efficient data energy",
            description_repeater_details:
              "The facility, which covers a site area of 20,155 sqm on the northern bank of the Main River, is designed for highly efficient energy use. The consistent separation of hot and cold air flows allows for efficient and effective cooling. Continuous monitoring provides information on the efficiency of energy savings.",
            image_repeater_details: 14035,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Gutleutstraße 310, 60327, Frankfurt am Main, Deutschland",
          lat: 50.0967506,
          lng: 8.644020100000034,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Gutleutstraße</title>\n<meta name="description" content="Das Datencenter hat direkten Zugang zu den weltweit größten Internet-Knotenpunkten und eröffnet Hochleistungsverbindungen zu Cloud-/Netzwerkanbietern." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/gutleutstrasse/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Gutleutstraße" />\n<meta property="og:description" content="Das Datencenter hat direkten Zugang zu den weltweit größten Internet-Knotenpunkten und eröffnet Hochleistungsverbindungen zu Cloud-/Netzwerkanbietern." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/gutleutstrasse/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-20T09:09:00+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2013/02/Gutleutstrasse_Frankfurt-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1920" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/gutleutstrasse/","url":"https://www.art-invest.de/en/projekt/gutleutstrasse/","name":"Art-Invest Real Estate | Gutleutstraße","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2013-08-20T10:00:34+00:00","dateModified":"2022-10-20T09:09:00+00:00","description":"Das Datencenter hat direkten Zugang zu den weltweit größten Internet-Knotenpunkten und eröffnet Hochleistungsverbindungen zu Cloud-/Netzwerkanbietern.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/gutleutstrasse/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/gutleutstrasse/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/gutleutstrasse/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Gutleutstraße"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Gutleutstraße",
        description:
          "Das Datencenter hat direkten Zugang zu den weltweit größten Internet-Knotenpunkten und eröffnet Hochleistungsverbindungen zu Cloud-/Netzwerkanbietern.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/gutleutstrasse/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Gutleutstraße",
        og_description:
          "Das Datencenter hat direkten Zugang zu den weltweit größten Internet-Knotenpunkten und eröffnet Hochleistungsverbindungen zu Cloud-/Netzwerkanbietern.",
        og_url: "https://www.art-invest.de/en/projekt/gutleutstrasse/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-20T09:09:00+00:00",
        og_image: [
          {
            width: 2560,
            height: 1920,
            url: "https://www.art-invest.de/wp-content/uploads/2013/02/Gutleutstrasse_Frankfurt-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/gutleutstrasse/",
              url: "https://www.art-invest.de/en/projekt/gutleutstrasse/",
              name: "Art-Invest Real Estate | Gutleutstraße",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2013-08-20T10:00:34+00:00",
              dateModified: "2022-10-20T09:09:00+00:00",
              description:
                "Das Datencenter hat direkten Zugang zu den weltweit größten Internet-Knotenpunkten und eröffnet Hochleistungsverbindungen zu Cloud-/Netzwerkanbietern.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/gutleutstrasse/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/gutleutstrasse/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/gutleutstrasse/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Gutleutstraße",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2013/02/Gutleutstrasse_Frankfurt-1-scaled.jpg",
      place: "Frankfurt",
      subtitle: "Hochleistungsrechenzentrum",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21602",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14230",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14035",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14230",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21602",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21602",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16854,
      date: "2019-07-16T12:04:26",
      date_gmt: "2019-07-16T10:04:26",
      guid: {
        rendered: "https://www.art-invest.de/projekt/prizeotel/",
      },
      modified: "2020-07-14T11:48:01",
      modified_gmt: "2020-07-14T11:48:01",
      slug: "prizeotel",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/prizeotel/",
      title: {
        rendered: "Prizeotel",
      },
      featured_media: 16855,
      template: "",
      projekt_filter: [251, 427, 425, 263],
      acf: {
        highlight_image: 14036,
        highlight_title_project: "Prizeotel",
        highlight_subtitle_project: "Extravagantes Hoteldesign",
        highlight_description_project:
          "The handwriting of the world-famous New York interior designer Karim Rashid consistently runs through the entire hotel: his style is appealing. The relaxed atmosphere of the Prizeotel is underlined by the open bar and breakfast area and a modern room furnishing.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location: "Theodor-Heuss-Allee 12, 28215 Bremen",
        property: "2,246 m²",
        area: "3,800 m²",
        zertifizierung: "",
        parcels: "42",
        use_for: "Hotel",
        acquired: "Q3 2018",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Bremen",
        fakten: [
          {
            bezeichnung: "Interior Designer",
            wert: "Karim Rashid",
            anchor: "",
          },
        ],
        specifications_image_projects: 16856,
        slider: null,
        title_details_projects: "PRIZEOTEL IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: '"Digipop" – pop art meets digitalization',
            description_repeater_details:
              "With his playful approach, designer Karim Rashid, who has received numerous awards for his work, creates unusual furniture and organic forms that create a futuristic atmosphere and attract trendsetters. The Prizeotel brand's special demand for technology and uncomplicated service is extremely user-oriented.",
            image_repeater_details: 14038,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "High quality and best value for money in the middle of Bremen",
            description_repeater_details:
              "In the course of the purchase, the building was modernized and the lobby was extensively renovated. The five-storey budget hotel impresses with its distinctive lifestyle character. It is located in an exposed micro-location, surrounded by numerous cafés, restaurants, food and fashion shops. The railway station and the historic Übersee-Museum are also within walking distance. Many business people and city travellers think that the Prizeotel is the ideal location for an unforgettable stay in Bremen.",
            image_repeater_details: 14037,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "",
          lat: 53.085944480438556,
          lng: 8.812401520901517,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Prizeotel</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/prizeotel/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Prizeotel" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/prizeotel/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-14T11:48:01+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2019/07/ssf_1908_ArtInvest-Prizeotel_01-2.jpg" />\n\t<meta property="og:image:width" content="2500" />\n\t<meta property="og:image:height" content="1534" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/prizeotel/","url":"https://www.art-invest.de/en/projekt/prizeotel/","name":"Art-Invest Real Estate | Prizeotel","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2019-07-16T10:04:26+00:00","dateModified":"2020-07-14T11:48:01+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/prizeotel/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/prizeotel/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/prizeotel/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Prizeotel"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Prizeotel",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/prizeotel/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Prizeotel",
        og_url: "https://www.art-invest.de/en/projekt/prizeotel/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-14T11:48:01+00:00",
        og_image: [
          {
            width: 2500,
            height: 1534,
            url: "https://www.art-invest.de/wp-content/uploads/2019/07/ssf_1908_ArtInvest-Prizeotel_01-2.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/prizeotel/",
              url: "https://www.art-invest.de/en/projekt/prizeotel/",
              name: "Art-Invest Real Estate | Prizeotel",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2019-07-16T10:04:26+00:00",
              dateModified: "2020-07-14T11:48:01+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/prizeotel/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/prizeotel/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/prizeotel/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Prizeotel",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2019/07/ssf_1908_ArtInvest-Prizeotel_01-2.jpg",
      place: "Bremen",
      subtitle: "Extravagantes Hoteldesign",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16854",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16855",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16854",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16854",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16748,
      date: "2019-10-17T17:11:00",
      date_gmt: "2019-10-17T15:11:00",
      guid: {
        rendered: "https://www.art-invest.de/projekt/listhaus/",
      },
      modified: "2023-07-13T09:31:12",
      modified_gmt: "2023-07-13T07:31:12",
      slug: "listhaus",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/listhaus/",
      title: {
        rendered: "Listhaus",
      },
      featured_media: 16749,
      template: "",
      projekt_filter: [246, 427, 425, 245, 263],
      acf: {
        highlight_image: 16749,
        highlight_title_project: "Listhaus",
        highlight_subtitle_project: "Moderne Flächen in bester Lage",
        highlight_description_project:
          "The Listhaus is centrally located in the city centre in the immediate vicinity of Leipzig's main railway station. The high-quality building comprises a total of 39,000 m² of floor space for offices, apartments and retail.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: {
          title: "zum Flächenangebot",
          url: "https://www.aire-mag.com/de/flaechen/listhaus",
          target: "_blank",
        },
        project: "Existing property",
        location: "Friedrich-List-Platz 1–2, 04103 Leipzig ",
        property: "approx. 14,000 m² ",
        area: "39,000 m²",
        zertifizierung: "",
        parcels: "59 outdoor parking slots, 15 visitor parking ",
        use_for: "Office, Retail, Living",
        acquired: "Q2 2019",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Leipzig",
        fakten: [
          {
            bezeichnung: "Built in",
            wert: "1933 / 1998",
            anchor: "",
          },
          {
            bezeichnung: "Design",
            wert: "Tchoban Voss",
            anchor: "",
          },
        ],
        specifications_image_projects: 11478,
        slider: null,
        title_details_projects: "LISTHAUS IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Modern and flexible space",
            description_repeater_details:
              "The Listhaus is one of the largest office buildings in Leipzig in terms of floor space and offers modern and bright work surfaces with a clear room height of 3 metres on approx. 34,500 m². All office spaces can be flexibly designed as separate or group offices, thus enabling a high quality of space and stay.",
            image_repeater_details: 16749,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Historical old building meets modern architecture",
            description_repeater_details:
              "The six-storey building complex consists of a renovated old building and an adjoining new office building dating from 1998. The historical facade of the old building, which was built in 1933, is a listed building and forms an exciting contrast to the timeless facade of the new building, which sets modern accents with coated silver elements in aluminium.",
            image_repeater_details: 11478,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Central location",
            description_repeater_details:
              "The Listhaus is centrally located in the Graphisches Viertel in the city centre and has very good connections to public transport and the mainline railway network. Leipzig's main railway station can be reached on foot within 5 minutes.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
        ],
        map: null,
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Listhaus</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/listhaus/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Listhaus" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/listhaus/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-07-13T07:31:12+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2019/10/180406_JLL_Listhaus_65-1-Kopie-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="2298" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/listhaus/","url":"https://www.art-invest.de/en/projekt/listhaus/","name":"Art-Invest Real Estate | Listhaus","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2019-10-17T15:11:00+00:00","dateModified":"2023-07-13T07:31:12+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/listhaus/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/listhaus/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/listhaus/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Listhaus"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Listhaus",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/listhaus/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Listhaus",
        og_url: "https://www.art-invest.de/en/projekt/listhaus/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-07-13T07:31:12+00:00",
        og_image: [
          {
            width: 2560,
            height: 2298,
            url: "https://www.art-invest.de/wp-content/uploads/2019/10/180406_JLL_Listhaus_65-1-Kopie-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/listhaus/",
              url: "https://www.art-invest.de/en/projekt/listhaus/",
              name: "Art-Invest Real Estate | Listhaus",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2019-10-17T15:11:00+00:00",
              dateModified: "2023-07-13T07:31:12+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/listhaus/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/listhaus/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/listhaus/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Listhaus",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2019/10/180406_JLL_Listhaus_65-1-Kopie-1-scaled.jpg",
      place: "Leipzig",
      subtitle: "Moderne Flächen in bester Lage",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16748",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16749",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16748",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16748",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },

    {
      id: 16589,
      date: "2014-08-12T12:00:59",
      date_gmt: "2014-08-12T10:00:59",
      guid: {
        rendered: "https://www.art-invest.de/projekt/top-three/",
      },
      modified: "2020-07-03T13:30:36",
      modified_gmt: "2020-07-03T13:30:36",
      slug: "top-three",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/top-three/",
      title: {
        rendered: "Top Three",
      },
      featured_media: 16590,
      template: "",
      projekt_filter: [246, 248, 245],
      acf: {
        highlight_image: 16592,
        highlight_title_project: "Top Three",
        highlight_subtitle_project: "Im Fluss der Großen Bleichen",
        highlight_description_project:
          "Two base storeys lift the house at Grosse Bleichen 3 out of the urban flow between Jungfernstieg and Poststraße. The Top Three combines generous retail space and a bright working environment to create a top address in Hamburg's Alsterfoyer.",
        highlight_logo_project: 16593,
        website_projects: "",
        external_projectpage: null,
        available_space: {
          title: "zum Flächenangebot",
          url: "https://www.aire-mag.com/de/flaechen/topthree",
          target: "_blank",
        },
        project: "Investment",
        location: "Große Bleichen 3, 20354 Hamburg",
        property: "",
        area: "3,500 m²",
        zertifizierung: "",
        parcels: "",
        use_for: "Office, Retail",
        acquired: "",
        realization: "2018",
        sale: "not for sale",
        architecture_firm: "Art-Invest und LH Architekten, Hamburg",
        place: "Hamburg",
        fakten: null,
        specifications_image_projects: 14102,
        slider: null,
        title_details_projects: "TOP THREE IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Im Fluss der Großen Bleichen",
            description_repeater_details:
              "The house with the classy natural stone facade shows the floor heights of its historic neighbour - and thus creates an elegant hinge to the nearby Inner Alster. Floor-to-ceiling windows on the upper floors let in plenty of natural light and offer magnificent views of the urban hustle and bustle.",
            image_repeater_details: 16590,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "In the nature of the location ",
            description_repeater_details:
              "To be seen corresponds to the nature of the Top Three's location on the best running paths in the city. The Jungfernstieg from Alsterhaus to Alsterfleet is the most highly frequented shopping area in the City-West. The Metrobus line 5 is one of many connections at Jungfernstieg that quickly connects the Top Three with any destination in the Hamburg metropolitan area.",
            image_repeater_details: 16609,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Top Three in life ",
            description_repeater_details:
              "The Alster is only three steps away. Not only does it provide the backdrop for strollers or a competition arena for triathletes, it also gives Hamburg a unique quality of life – that is why the Hanseatic city occupies third place in the world in this category in 2016. Additionally there are countless exquisite shopping and gastronomy offers around the Top Three.",
            image_repeater_details: 14102,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Große Bleichen 3, Hamburg, Deutschland",
          lat: 53.55334999999999,
          lng: 9.990520899999979,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Top Three</title>\n<meta name="description" content="Das Top Three verbindet großzügige Retailflächen und lichte Arbeitswelten zu einer Top-Adresse im Hamburger Alsterfoyer, direkt gelegen am Jungfernstieg." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/top-three/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Top Three" />\n<meta property="og:description" content="Das Top Three verbindet großzügige Retailflächen und lichte Arbeitswelten zu einer Top-Adresse im Hamburger Alsterfoyer, direkt gelegen am Jungfernstieg." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/top-three/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-03T13:30:36+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2014/08/GrBl_P8_View-GrBl03_V9-Kopie-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1920" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/top-three/","url":"https://www.art-invest.de/en/projekt/top-three/","name":"Art-Invest Real Estate | Top Three","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-08-12T10:00:59+00:00","dateModified":"2020-07-03T13:30:36+00:00","description":"Das Top Three verbindet großzügige Retailflächen und lichte Arbeitswelten zu einer Top-Adresse im Hamburger Alsterfoyer, direkt gelegen am Jungfernstieg.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/top-three/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/top-three/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/top-three/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Top Three"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Top Three",
        description:
          "Das Top Three verbindet großzügige Retailflächen und lichte Arbeitswelten zu einer Top-Adresse im Hamburger Alsterfoyer, direkt gelegen am Jungfernstieg.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/top-three/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Top Three",
        og_description:
          "Das Top Three verbindet großzügige Retailflächen und lichte Arbeitswelten zu einer Top-Adresse im Hamburger Alsterfoyer, direkt gelegen am Jungfernstieg.",
        og_url: "https://www.art-invest.de/en/projekt/top-three/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-03T13:30:36+00:00",
        og_image: [
          {
            width: 2560,
            height: 1920,
            url: "https://www.art-invest.de/wp-content/uploads/2014/08/GrBl_P8_View-GrBl03_V9-Kopie-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/top-three/",
              url: "https://www.art-invest.de/en/projekt/top-three/",
              name: "Art-Invest Real Estate | Top Three",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-08-12T10:00:59+00:00",
              dateModified: "2020-07-03T13:30:36+00:00",
              description:
                "Das Top Three verbindet großzügige Retailflächen und lichte Arbeitswelten zu einer Top-Adresse im Hamburger Alsterfoyer, direkt gelegen am Jungfernstieg.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/top-three/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/top-three/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/top-three/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Top Three",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2014/08/GrBl_P8_View-GrBl03_V9-Kopie-1-scaled-800x800.jpg",
      place: "Hamburg",
      subtitle: "Im Fluss der Großen Bleichen",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16589",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16590",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16589",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16589",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16798,
      date: "2014-07-15T12:00:21",
      date_gmt: "2014-07-15T10:00:21",
      guid: {
        rendered: "https://www.art-invest.de/projekt/kaistrasse-5/",
      },
      modified: "2020-07-08T13:50:24",
      modified_gmt: "2020-07-08T13:50:24",
      slug: "kaistrasse-5",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/kaistrasse-5/",
      title: {
        rendered: "Kaistraße 5",
      },
      featured_media: 16800,
      template: "",
      projekt_filter: [246, 427, 425, 257],
      acf: {
        highlight_image: 16800,
        highlight_title_project: "Kaistraße 5",
        highlight_subtitle_project: "Ein Hafen für die Zukunft",
        highlight_description_project:
          "The transformation from Dusseldorf's industrial harbour to the Media Harbour is one of the most spectacular urban development projects in the state. Where once goods were unloaded from the Rhine and Ruhr rivers, there is now a modern transhipment centre for new media, start-ups and agencies – right in the middle of it is the office building at Kaistraße 5.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: {
          title: "zum Flächenangebot",
          url: "https://www.aire-mag.com/de/flaechen/kai-5",
          target: "_blank",
        },
        project: "Long-term Investment",
        location: "Kaistraße 5, 40221 Dusseldorf; Media Harbour",
        property: "approx.  2,100 m²",
        area: "approx. 9,020 m²",
        zertifizierung: "",
        parcels: "160",
        use_for: "Office",
        acquired: "Q1 2016",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Düsseldorf",
        fakten: null,
        specifications_image_projects: 16802,
        slider: null,
        title_details_projects: "KAISTRAßE 5 IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Ein Hafen für die Zukunft",
            description_repeater_details:
              "The rough harbour area has developed into a new landmark for Dusseldorf. Frank O. Gehry's Neuer Zollhof or William Alsop's Colorium skyscraper are just a few of the spectacular buildings that appear like sculptures next to the old Rhine cranes. They are structural manifestos of the new creative mile.",
            image_repeater_details: 16801,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "A courtyard to linger in",
            description_repeater_details:
              "In the centre of the five-storey office building there is a landscaped inner courtyard with water surfaces, which has an open arcade on the ground floor. The two-storey brick base with the attached three-storey glass body quotes the old harbour architecture. In addition to light-flooded rental space of approx. 9,021 m², Kaistraße 5 has 160 underground parking spaces.",
            image_repeater_details: 16799,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "A reloading point for creativity",
            description_repeater_details:
              "Dusseldorf's port is one of the most popular office locations, along with the city centre. Visitors and employees find a vibrant scene and a wide range of gastronomic offerings in the numerous restaurants, bars and clubs on the banks of the Rhine – thanks to excellent public and individual transport connections, it is easy to dock and undock here.",
            image_repeater_details: 14542,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Kaistraße 5, 40221 Düsseldorf",
          lat: 51.2141148,
          lng: 6.752822100000003,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Kaistraße 5</title>\n<meta name="description" content="Wo früher Waren gelöscht wurden, liegt heute ein moderner Umschlagplatz für Medien, Start-Ups und Agenturen - mittendrin das Bürogebäude an der Kaistraße 5." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/kaistrasse-5/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Kaistraße 5" />\n<meta property="og:description" content="Wo früher Waren gelöscht wurden, liegt heute ein moderner Umschlagplatz für Medien, Start-Ups und Agenturen - mittendrin das Bürogebäude an der Kaistraße 5." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/kaistrasse-5/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-08T13:50:24+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/Kaistrasse_Detailansicht_Hausecke_TEASER-e1480511025985-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="2560" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/kaistrasse-5/","url":"https://www.art-invest.de/en/projekt/kaistrasse-5/","name":"Art-Invest Real Estate | Kaistraße 5","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-07-15T10:00:21+00:00","dateModified":"2020-07-08T13:50:24+00:00","description":"Wo früher Waren gelöscht wurden, liegt heute ein moderner Umschlagplatz für Medien, Start-Ups und Agenturen - mittendrin das Bürogebäude an der Kaistraße 5.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/kaistrasse-5/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/kaistrasse-5/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/kaistrasse-5/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Kaistraße 5"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Kaistraße 5",
        description:
          "Wo früher Waren gelöscht wurden, liegt heute ein moderner Umschlagplatz für Medien, Start-Ups und Agenturen - mittendrin das Bürogebäude an der Kaistraße 5.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/kaistrasse-5/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Kaistraße 5",
        og_description:
          "Wo früher Waren gelöscht wurden, liegt heute ein moderner Umschlagplatz für Medien, Start-Ups und Agenturen - mittendrin das Bürogebäude an der Kaistraße 5.",
        og_url: "https://www.art-invest.de/en/projekt/kaistrasse-5/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-08T13:50:24+00:00",
        og_image: [
          {
            width: 2560,
            height: 2560,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/Kaistrasse_Detailansicht_Hausecke_TEASER-e1480511025985-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/kaistrasse-5/",
              url: "https://www.art-invest.de/en/projekt/kaistrasse-5/",
              name: "Art-Invest Real Estate | Kaistraße 5",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-07-15T10:00:21+00:00",
              dateModified: "2020-07-08T13:50:24+00:00",
              description:
                "Wo früher Waren gelöscht wurden, liegt heute ein moderner Umschlagplatz für Medien, Start-Ups und Agenturen - mittendrin das Bürogebäude an der Kaistraße 5.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/kaistrasse-5/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/kaistrasse-5/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/kaistrasse-5/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Kaistraße 5",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/Kaistrasse_Detailansicht_Hausecke_TEASER-e1480511025985-1-scaled.jpg",
      place: "Düsseldorf",
      subtitle: "Ein Hafen für die Zukunft",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16798",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16800",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16798",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16798",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16913,
      date: "2018-09-27T12:40:05",
      date_gmt: "2018-09-27T10:40:05",
      guid: {
        rendered: "https://www.art-invest.de/projekt/ca/",
      },
      modified: "2020-07-15T13:26:04",
      modified_gmt: "2020-07-15T13:26:04",
      slug: "ca",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/ca/",
      title: {
        rendered: "C&A",
      },
      featured_media: 14028,
      template: "",
      projekt_filter: [427, 425, 245, 263],
      acf: {
        highlight_image: 14028,
        highlight_title_project: "C&A",
        highlight_subtitle_project: "Attraktive Innenstadtlage",
        highlight_description_project:
          "The extensive retail property is centrally located in Hindenburgstrasse. This popular shopping street is the hub of Mönchengladbach's pedestrian zone.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location: "Hindenburgstraße 69, Mönchengladbach; city centre",
        property: "4,579 m²",
        area: "8,905 m²",
        zertifizierung: "",
        parcels: "",
        use_for: "Retail",
        acquired: "Q1 2018",
        realization: "",
        sale: "",
        architecture_firm: "BDA / Essen, E.A. Gärtner + R. Stiens",
        place: "Mönchengladbach",
        fakten: [
          {
            bezeichnung: "Built in",
            wert: "1956",
            anchor: "",
          },
          {
            bezeichnung: "Renovation",
            wert: "1994",
            anchor: "",
          },
        ],
        specifications_image_projects: 16914,
        slider: null,
        title_details_projects: "C&A IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Vivid shopping street",
            description_repeater_details:
              'As part of the most frequented shopping street in Mönchengladbach, the property is located directly opposite the shopping centre "Minto". The tenant of the six-storey building is the clothing company C&amp;A, which uses four of the floors as retail space.',
            image_repeater_details: 14029,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Shopping experience",
            description_repeater_details:
              "In the heart of the city centre, Hindenburgstraße with its wide range of department stores and retailers makes every shopping day a unique experience. The local gastronomy with its numerous cafés, bakeries and bistros ensures that even the culinary well-being is not neglected. After shopping, green parks, such as the original sculpture park at the Abteiberg Museum, invite you to linger.",
            image_repeater_details: 14030,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Perfectly connected pedestrian zone",
            description_repeater_details:
              "Due to the immediate vicinity of the main railway station as well as the excellent transport connections, Hindenburgstraße can be reached easily and quickly. The Marienhof multi-storey car park is also only five minutes' walk away.",
            image_repeater_details: 14031,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Hindenburgstraße 69, Mönchengladbach, Deutschland",
          lat: 51.1942256,
          lng: 6.436658699999953,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | C&amp;A</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/ca/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | C&amp;A" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/ca/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-15T13:26:04+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2018/09/MG_CA_Außenansicht_Eckansicht-Kopie-1-3-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1441" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/ca/","url":"https://www.art-invest.de/en/projekt/ca/","name":"Art-Invest Real Estate | C&A","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2018-09-27T10:40:05+00:00","dateModified":"2020-07-15T13:26:04+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/ca/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/ca/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/ca/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"C&#038;A"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | C&A",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/ca/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | C&A",
        og_url: "https://www.art-invest.de/en/projekt/ca/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-15T13:26:04+00:00",
        og_image: [
          {
            width: 2560,
            height: 1441,
            url: "https://www.art-invest.de/wp-content/uploads/2018/09/MG_CA_Außenansicht_Eckansicht-Kopie-1-3-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/ca/",
              url: "https://www.art-invest.de/en/projekt/ca/",
              name: "Art-Invest Real Estate | C&A",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2018-09-27T10:40:05+00:00",
              dateModified: "2020-07-15T13:26:04+00:00",
              breadcrumb: {
                "@id": "https://www.art-invest.de/en/projekt/ca/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/ca/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/ca/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "C&A",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2018/09/MG_CA_Außenansicht_Eckansicht-Kopie-1-3-scaled-800x800.jpg",
      place: "Mönchengladbach",
      subtitle: "Attraktive Innenstadtlage",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16913",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14028",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16913",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16913",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16916,
      date: "2018-02-05T15:36:05",
      date_gmt: "2018-02-05T14:36:05",
      guid: {
        rendered: "https://www.art-invest.de/projekt/hausvogteiplatz/",
      },
      modified: "2020-07-15T13:29:19",
      modified_gmt: "2020-07-15T13:29:19",
      slug: "hausvogteiplatz",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/hausvogteiplatz/",
      title: {
        rendered: "Hausvogteiplatz",
      },
      featured_media: 16917,
      template: "",
      projekt_filter: [246, 427, 425, 256],
      acf: {
        highlight_image: 16917,
        highlight_title_project: "Hausvogteiplatz",
        highlight_subtitle_project: "Exklusives Wohnen und Arbeiten",
        highlight_description_project:
          "The commercial building at Hausvogteiplatz 13 is located in the heart of Berlin's historic parliament and government district and offers more than 3,550 m² of space for offices and apartments.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Existing property",
        location: "Hausvogteiplatz 13, 10117 Berlin",
        property: "approx. 750 m²",
        area: "3,550 m²",
        zertifizierung: "",
        parcels: "34",
        use_for: "Office, Living",
        acquired: "Q3 2017",
        realization: "1999",
        sale: "",
        architecture_firm: "",
        place: "Berlin",
        fakten: [
          {
            bezeichnung: "Design",
            wert: "Czarniak & Partner, Wiesbaden; FEA Consult GmbH, Berlin",
            anchor: "",
          },
        ],
        specifications_image_projects: 5021,
        slider: null,
        title_details_projects: "HAUSVOGTEIPLATZ IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Berlin's pulsating hotspot",
            description_repeater_details:
              "The central location in the direct vicinity of the Gendarmenmarkt and the shopping mile Friedrichstrasse makes the Hausvogteiplatz particularly attractive. A unique gastronomic variety completes the picture of a vivid quarter.",
            image_repeater_details: 5024,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Between shopping dream and working environment",
            description_repeater_details:
              "In addition to the retail, which was once considered the centre of Berlin's clothing industry, numerous offices of renowned institutions characterize the scenery around Hausvogteiplatz. The Association of Research-based Pharmaceutical Companies is the main tenant of the property.",
            image_repeater_details: 5021,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Real estate with high gloss",
            description_repeater_details:
              "Whether a high-quality reinforced concrete structure, facade made of natural stone with a generous glass front or simply a prestigious new building – the attributes for the Hausvogteiplatz are versatile and document the uniqueness of the property.",
            image_repeater_details: 5027,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Hausvogteiplatz 13, 10117, Berlin, Deutschland",
          lat: 52.51296,
          lng: 13.397359999999935,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Hausvogteiplatz</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/hausvogteiplatz/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Hausvogteiplatz" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/hausvogteiplatz/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-15T13:29:19+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2018/02/DSC_6014-2-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1707" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/hausvogteiplatz/","url":"https://www.art-invest.de/en/projekt/hausvogteiplatz/","name":"Art-Invest Real Estate | Hausvogteiplatz","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2018-02-05T14:36:05+00:00","dateModified":"2020-07-15T13:29:19+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/hausvogteiplatz/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/hausvogteiplatz/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/hausvogteiplatz/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Hausvogteiplatz"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Hausvogteiplatz",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/hausvogteiplatz/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Hausvogteiplatz",
        og_url: "https://www.art-invest.de/en/projekt/hausvogteiplatz/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-15T13:29:19+00:00",
        og_image: [
          {
            width: 2560,
            height: 1707,
            url: "https://www.art-invest.de/wp-content/uploads/2018/02/DSC_6014-2-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/hausvogteiplatz/",
              url: "https://www.art-invest.de/en/projekt/hausvogteiplatz/",
              name: "Art-Invest Real Estate | Hausvogteiplatz",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2018-02-05T14:36:05+00:00",
              dateModified: "2020-07-15T13:29:19+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/hausvogteiplatz/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/hausvogteiplatz/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/hausvogteiplatz/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Hausvogteiplatz",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2018/02/DSC_6014-2-scaled-800x800.jpg",
      place: "Berlin",
      subtitle: "Exklusives Wohnen und Arbeiten",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16916",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16917",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16916",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16916",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16896,
      date: "2020-04-06T10:23:44",
      date_gmt: "2020-04-06T10:23:44",
      guid: {
        rendered: "https://www.art-invest.de/projekt/bismarckstrasse-101/",
      },
      modified: "2020-07-15T12:50:42",
      modified_gmt: "2020-07-15T12:50:42",
      slug: "bismarckstrasse-101",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/bismarckstrasse-101/",
      title: {
        rendered: "Bismarckstraße 101",
      },
      featured_media: 14476,
      template: "",
      projekt_filter: [246, 427, 425, 257],
      acf: {
        highlight_image: 14480,
        highlight_title_project: "Bismarckstraße 101",
        highlight_subtitle_project:
          "Das Bahnhofsquartier – die neue Visitenkarte Düsseldorfs",
        highlight_description_project:
          "Dusseldorf's railway station area is changing. In the middle of the trendy district, the office and commercial building at Bismarckstraße 101 is developing into an exciting multi-tenant property with a variety of uses.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment, Development",
        location: "Bismarckstraße 101, Dusseldorf",
        property: "5,400 m²",
        area: "1,395 m²",
        zertifizierung: "",
        parcels: "19",
        use_for: "Gastronomy, Office, Radiology",
        acquired: "Q1 2020",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Düsseldorf",
        fakten: null,
        specifications_image_projects: 14478,
        slider: null,
        title_details_projects: "BISMARCKSTRASSE 101 IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              "From old to new: the dynamic development of the area",
            description_repeater_details:
              "The Bahnhofquartier in Dusseldorf is changing and experiencing a noticeable revaluation: renowned hotels and modern housing estates will give the district a new face in the coming years. Only a few metres away from the station building, the office and commercial building at Bismarckstraße 101, built in 1969, is developing into an interesting property that combines offices, medical practices and gastronomy under one roof.",
            image_repeater_details: 14478,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Working in the middle of the best microlocation",
            description_repeater_details:
              'The complex renovated six-storey house is located near the city centre. Not only the railway station but also all shopping facilities are within walking distance. The urban character of the area is underlined by "Little Tokyo" – the Japanese quarter of the city. Dusseldorf\'s splendid mile "Königsallee" and the glamorous Kö-Bogen invite you to stroll and shop in the immediate vicinity.',
            image_repeater_details: 14482,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Bismarckstraße 101, Düsseldorf, Deutschland",
          lat: 51.22035049999999,
          lng: 6.790217099999998,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Bismarckstraße 101</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/bismarckstrasse-101/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Bismarckstraße 101" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/bismarckstrasse-101/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-15T12:50:42+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/04/ssf_2003_AI-Bismarckstr101_01.jpg" />\n\t<meta property="og:image:width" content="2500" />\n\t<meta property="og:image:height" content="1321" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/bismarckstrasse-101/","url":"https://www.art-invest.de/en/projekt/bismarckstrasse-101/","name":"Art-Invest Real Estate | Bismarckstraße 101","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-04-06T10:23:44+00:00","dateModified":"2020-07-15T12:50:42+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/bismarckstrasse-101/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/bismarckstrasse-101/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/bismarckstrasse-101/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Bismarckstraße 101"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Bismarckstraße 101",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/bismarckstrasse-101/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Bismarckstraße 101",
        og_url: "https://www.art-invest.de/en/projekt/bismarckstrasse-101/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-15T12:50:42+00:00",
        og_image: [
          {
            width: 2500,
            height: 1321,
            url: "https://www.art-invest.de/wp-content/uploads/2020/04/ssf_2003_AI-Bismarckstr101_01.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/bismarckstrasse-101/",
              url: "https://www.art-invest.de/en/projekt/bismarckstrasse-101/",
              name: "Art-Invest Real Estate | Bismarckstraße 101",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-04-06T10:23:44+00:00",
              dateModified: "2020-07-15T12:50:42+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/bismarckstrasse-101/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/bismarckstrasse-101/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/bismarckstrasse-101/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Bismarckstraße 101",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/04/ssf_2003_AI-Bismarckstr101_01-800x800.jpg",
      place: "Düsseldorf",
      subtitle: "Das Bahnhofsquartier: Tor zur Stadt",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16896",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14476",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16896",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16896",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16785,
      date: "2015-04-21T12:00:18",
      date_gmt: "2015-04-21T10:00:18",
      guid: {
        rendered: "https://www.art-invest.de/projekt/kaiser-wilhelm-hoefe/",
      },
      modified: "2020-07-07T12:33:41",
      modified_gmt: "2020-07-07T12:33:41",
      slug: "kaiser-wilhelm-hoefe",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/kaiser-wilhelm-hoefe/",
      title: {
        rendered: "Kaiser Wilhelm Höfe",
      },
      featured_media: 16787,
      template: "",
      projekt_filter: [246, 247, 427, 425],
      acf: {
        highlight_image: 16789,
        highlight_title_project: "Kaiser Wilhelm Höfe",
        highlight_subtitle_project: "Kaiserliche Vergangenheit",
        highlight_description_project:
          "The ensemble of four buildings forms the Kaiser Wilhelm Höfe, an office quarter around the historic Allianz office location on Cologne's Kaiser-Wilhelm-Ring. After comprehensive modernization, the existing building from 1931 is once again a top address for high-quality office space.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location:
          "Cologne; city centre; Kaiser-Wilhelm-Ring, Gladbacher Straße, Spichernstraße, Herrmann-Becker-Straße",
        property: "approx. 12,000 m²",
        area: "approx. 40,000 m²",
        zertifizierung: "",
        parcels: "approx. 340 Stück",
        use_for: "Office",
        acquired: "Q4 2014",
        realization:
          "1899-1900 (Spichernstraße 54-56), 1931-33 (Kaiser-Wilhelm-Ring 31), 1994 (Gladbacher Straße 14), Q4 2018 (Kaiser Hof)",
        sale: "",
        architecture_firm:
          "MSM Meyer Schmitz-Morkramer Rhein GmbH (Kaiser Hof), Karl Wach & Heinrich Roßkotten (Kaiser-Wilhelm-Ring 31), Friedrich Carl Heimann (Spichernstraße 54-56), HPP (Gladbacher Straße 14)",
        place: "Köln",
        fakten: null,
        specifications_image_projects: 14143,
        slider: null,
        title_details_projects: "KAISER WILHELM HÖFE IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Kaiserliche Vergangenheit",
            description_repeater_details:
              "Wilhelm I. took a first look at the Cologne Ring during a visit to the cathedral city in 1884 – the Prussian King and German Emperor gave his name to the building and Ringstrasse. Already in the Golden Twenties, the district around the Kaiser-Wilhelm-Ring developed into an important office district in Cologne. After the war, the Allianz building served as a provisional town hall and thus formed the administrative centre of Cologne – with Konrad Adenauer as Mayor.",
            image_repeater_details: 14892,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "The mixed ensemble",
            description_repeater_details:
              "In addition to the directorate of the Allianz, the ensemble consists of the listed school building on Spichernstrasse, the administrative headquarters of the Berufsgenossenschaft on Gladbacher Strasse and the high-quality project development of the Kaiser Hof on Erftstrasse.",
            image_repeater_details: 16786,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Varied bridge location",
            description_repeater_details:
              "The atmosphere is characterized by the ambience of the Kaiser-Wilhelm-Ring on the one hand and the modern Media Park with the vibrant neighbourhood of the Belgian Quarter on the other. The location on the Cologne Rings is characterized by an excellent infrastructure: gastronomy, cultural and leisure facilities, public parks, as well as good transport connections to the city centre and the greater Cologne area. After completion of the Kaiser Hof, the ensemble will have about 340 parking spaces.",
            image_repeater_details: 16788,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Kaiser-Wilhelm-Ring 31, Köln",
          lat: 50.94533999999999,
          lng: 6.941299999999956,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Kaiser Wilhelm Höfe</title>\n<meta name="description" content="Das Ensemble aus vier Gebäuden bildet die Kaiser-Wilhelm-Höfe, ein Büroquartier um den historischen Bürostandort der Allianz am Kölner Kaiser-Wilhelm-Ring." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/kaiser-wilhelm-hoefe/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Kaiser Wilhelm Höfe" />\n<meta property="og:description" content="Das Ensemble aus vier Gebäuden bildet die Kaiser-Wilhelm-Höfe, ein Büroquartier um den historischen Bürostandort der Allianz am Kölner Kaiser-Wilhelm-Ring." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/kaiser-wilhelm-hoefe/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-07T12:33:41+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/03/KH_ImmoManagerAward_1920x1084px_f_079.jpg" />\n\t<meta property="og:image:width" content="1920" />\n\t<meta property="og:image:height" content="1084" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/kaiser-wilhelm-hoefe/","url":"https://www.art-invest.de/en/projekt/kaiser-wilhelm-hoefe/","name":"Art-Invest Real Estate | Kaiser Wilhelm Höfe","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2015-04-21T10:00:18+00:00","dateModified":"2020-07-07T12:33:41+00:00","description":"Das Ensemble aus vier Gebäuden bildet die Kaiser-Wilhelm-Höfe, ein Büroquartier um den historischen Bürostandort der Allianz am Kölner Kaiser-Wilhelm-Ring.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/kaiser-wilhelm-hoefe/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/kaiser-wilhelm-hoefe/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/kaiser-wilhelm-hoefe/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Kaiser Wilhelm Höfe"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Kaiser Wilhelm Höfe",
        description:
          "Das Ensemble aus vier Gebäuden bildet die Kaiser-Wilhelm-Höfe, ein Büroquartier um den historischen Bürostandort der Allianz am Kölner Kaiser-Wilhelm-Ring.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/kaiser-wilhelm-hoefe/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Kaiser Wilhelm Höfe",
        og_description:
          "Das Ensemble aus vier Gebäuden bildet die Kaiser-Wilhelm-Höfe, ein Büroquartier um den historischen Bürostandort der Allianz am Kölner Kaiser-Wilhelm-Ring.",
        og_url: "https://www.art-invest.de/en/projekt/kaiser-wilhelm-hoefe/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-07T12:33:41+00:00",
        og_image: [
          {
            width: 1920,
            height: 1084,
            url: "https://www.art-invest.de/wp-content/uploads/2020/03/KH_ImmoManagerAward_1920x1084px_f_079.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/kaiser-wilhelm-hoefe/",
              url: "https://www.art-invest.de/en/projekt/kaiser-wilhelm-hoefe/",
              name: "Art-Invest Real Estate | Kaiser Wilhelm Höfe",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2015-04-21T10:00:18+00:00",
              dateModified: "2020-07-07T12:33:41+00:00",
              description:
                "Das Ensemble aus vier Gebäuden bildet die Kaiser-Wilhelm-Höfe, ein Büroquartier um den historischen Bürostandort der Allianz am Kölner Kaiser-Wilhelm-Ring.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/kaiser-wilhelm-hoefe/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/kaiser-wilhelm-hoefe/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/kaiser-wilhelm-hoefe/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Kaiser Wilhelm Höfe",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/03/KH_ImmoManagerAward_1920x1084px_f_079-800x800.jpg",
      place: "Köln",
      subtitle: "Kaiserliche Vergangenheit",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16785",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16787",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16785",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16785",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16882,
      date: "2013-09-24T12:00:08",
      date_gmt: "2013-09-24T10:00:08",
      guid: {
        rendered: "https://www.art-invest.de/projekt/steigenberger-hotel/",
      },
      modified: "2020-07-15T11:33:37",
      modified_gmt: "2020-07-15T11:33:37",
      slug: "steigenberger-hotel",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/steigenberger-hotel/",
      title: {
        rendered: "Steigenberger Hotel",
      },
      featured_media: 16883,
      template: "",
      projekt_filter: [251, 427, 425, 263],
      acf: {
        highlight_image: 16883,
        highlight_title_project: "Steigenberger Hotel",
        highlight_subtitle_project: "Ein traditionelles First-Class-Hotel",
        highlight_description_project:
          "The traditional hotel on Bad Homburg's Kaiser-Friedrich-Promenade combines luxurious living with 800 m² modern conference and meeting rooms. Exquisite gastronomy, a spa area and a noble fitness area complete the 5-star hotel at the top address.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project:
          "Investment incl. Negotiation of a new lease agreement and comprehensive renovation during operational business",
        location:
          "Kaiser-Friedrich-Promenade 69-75, Bad Homburg; nearby city centre",
        property: "5,186 m²",
        area: "11,785 m², 174 rooms",
        zertifizierung: "",
        parcels: "150 parking spaces in its own underground car park",
        use_for: "5*-Hotel with  generous conference rooms",
        acquired: "Q4 2013",
        realization:
          "1920 or rather 1990, renovation of rooms and public areas in 2015/2016",
        sale: "",
        architecture_firm: "",
        place: "Bad Homburg",
        fakten: [
          {
            bezeichnung: "Architecture Lph 1-4",
            wert: "KULAS Architekten Architektur",
            anchor: "",
          },
          {
            bezeichnung: "Architecture Lph 5-8 and Design of facade",
            wert: "BilleBeyeScheid Architekten",
            anchor: "",
          },
          {
            bezeichnung: "Interior design rooms",
            wert: "Designer's House Interior Architects",
            anchor: "",
          },
          {
            bezeichnung: "interior design public areas",
            wert: "Bost Interior Design",
            anchor: "",
          },
          {
            bezeichnung: "Outdoor facilities",
            wert: "BWP Endress Landschaftsarchitekten",
            anchor: "",
          },
        ],
        specifications_image_projects: 16886,
        slider: null,
        title_details_projects: "STEIGENBERGER HOTEL IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Ein traditionelles First-Class-Hotel",
            description_repeater_details:
              "The hotel from 1883 is an institution in Bad Homburg. The extensive renovation of the public areas and 174 rooms and suites lets the first address on the Kaiser-Friedrich-Promenade shine.",
            image_repeater_details: 16884,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Excellent working atmosphere",
            description_repeater_details:
              "The hotel is located in the immediate vicinity of the centre and the spa gardens with their mineral springs. On four floors with 11,785 m² of usable space, guests can expect a bright conference and meeting area in addition to spa and rooms, which can be equipped to meet all requirements. There is space for 150 cars in the hotel's own underground car park.",
            image_repeater_details: 16885,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Kaiser-Friedrich-Promenade 69-75, Bad Homburg",
          lat: 50.2260928,
          lng: 8.622318199999995,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Steigenberger Hotel</title>\n<meta name="description" content="Das traditionsreiche Hotel an der Bad Homburger Kaiser-Friedrich-Promenade kombiniert luxuriöses Wohnen mit 800 m² modernsten Konferenz- und Tagungsräumen." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/steigenberger-hotel/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Steigenberger Hotel" />\n<meta property="og:description" content="Das traditionsreiche Hotel an der Bad Homburger Kaiser-Friedrich-Promenade kombiniert luxuriöses Wohnen mit 800 m² modernsten Konferenz- und Tagungsräumen." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/steigenberger-hotel/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-15T11:33:37+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2013/09/Steigenberger_Bad-Homburg_Fassade-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1709" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/steigenberger-hotel/","url":"https://www.art-invest.de/en/projekt/steigenberger-hotel/","name":"Art-Invest Real Estate | Steigenberger Hotel","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2013-09-24T10:00:08+00:00","dateModified":"2020-07-15T11:33:37+00:00","description":"Das traditionsreiche Hotel an der Bad Homburger Kaiser-Friedrich-Promenade kombiniert luxuriöses Wohnen mit 800 m² modernsten Konferenz- und Tagungsräumen.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/steigenberger-hotel/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/steigenberger-hotel/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/steigenberger-hotel/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Steigenberger Hotel"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Steigenberger Hotel",
        description:
          "Das traditionsreiche Hotel an der Bad Homburger Kaiser-Friedrich-Promenade kombiniert luxuriöses Wohnen mit 800 m² modernsten Konferenz- und Tagungsräumen.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/steigenberger-hotel/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Steigenberger Hotel",
        og_description:
          "Das traditionsreiche Hotel an der Bad Homburger Kaiser-Friedrich-Promenade kombiniert luxuriöses Wohnen mit 800 m² modernsten Konferenz- und Tagungsräumen.",
        og_url: "https://www.art-invest.de/en/projekt/steigenberger-hotel/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-15T11:33:37+00:00",
        og_image: [
          {
            width: 2560,
            height: 1709,
            url: "https://www.art-invest.de/wp-content/uploads/2013/09/Steigenberger_Bad-Homburg_Fassade-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/steigenberger-hotel/",
              url: "https://www.art-invest.de/en/projekt/steigenberger-hotel/",
              name: "Art-Invest Real Estate | Steigenberger Hotel",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2013-09-24T10:00:08+00:00",
              dateModified: "2020-07-15T11:33:37+00:00",
              description:
                "Das traditionsreiche Hotel an der Bad Homburger Kaiser-Friedrich-Promenade kombiniert luxuriöses Wohnen mit 800 m² modernsten Konferenz- und Tagungsräumen.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/steigenberger-hotel/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/steigenberger-hotel/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/steigenberger-hotel/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Steigenberger Hotel",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2013/09/Steigenberger_Bad-Homburg_Fassade-1-scaled.jpg",
      place: "Bad Homburg",
      subtitle: "Ein traditionelles First-Class-Hotel",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16882",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16883",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16882",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16882",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16858,
      date: "2013-08-28T12:00:06",
      date_gmt: "2013-08-28T10:00:06",
      guid: {
        rendered: "https://www.art-invest.de/projekt/trakehner-buerohaus/",
      },
      modified: "2021-11-04T18:08:57",
      modified_gmt: "2021-11-04T17:08:57",
      slug: "trakehner-buerohaus",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/trakehner-buerohaus/",
      title: {
        rendered: "Trakehner Bürohaus",
      },
      featured_media: 16860,
      template: "",
      projekt_filter: [246, 427, 425, 255],
      acf: {
        highlight_image: 16859,
        highlight_title_project: "Trakehner Bürohaus",
        highlight_subtitle_project: "Gestaltbare Bürowelten",
        highlight_description_project:
          "In Frankfurt's district Hausen, there is the modernized office and service building with the East Prussian heritage in its name: Trakehner Office Building. The building with its classic-timeless facade and a 9,328 m² plot of land features a green inner courtyard – and flexible office worlds.",
        highlight_logo_project: null,
        website_projects: {
          title: "www.trakehnerbuerohaus.de",
          url: "https://www.trakehnerbuerohaus.de/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://www.trakehnerbuerohaus.de/",
          target: "_blank",
        },
        available_space: [""],
        project: "Investment",
        location: "Trakehner Str. 5,7-9, 60487 Frankfurt am Main",
        property: "9,328 m²",
        area: "approx. 12,800 m²",
        zertifizierung: "",
        parcels: "131",
        use_for: "Office and Service",
        acquired: "2016",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Frankfurt",
        fakten: null,
        specifications_image_projects: 13367,
        slider: null,
        title_details_projects: "TRAKEHNER BÜROHAUS IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Gestaltbare Bürowelten",
            description_repeater_details:
              "Approx. 12,800 m² of floor space are available in the elegant office building with its 131 parking spaces. In the combination of office and communication zones, the employees can choose between interaction and retreat on three floors.",
            image_repeater_details: 4079,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Fast network to the city",
            description_repeater_details:
              "The location is ideally connected via the underground station Industriehof. Only three stops to the prehistory of the Senckenberg Museum, four stops to the banking district or five stops to the Alte Oper. The building's own underground car park has space for more than 130 parking spaces – the building is also in the direct vicinity of the A66 and A44 motorways.",
            image_repeater_details: 4074,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Main metropolis in transition",
            description_repeater_details:
              "These are just two of many construction sites that will shape Frankfurt and its northwest for the next decade. The new Europaviertel is changing the face of the city. South of Rödelheimer Landstrasse, a completely new residential quarter is currently being built – in the immediate vicinity of the Trakehner office building. In the midst of the change, the idyllic Solmspark with its historic stock of trees and the Brentanobad is a green oasis.",
            image_repeater_details: 4076,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Trakehner Str. 5,7-9, 63487 Frankfurt am Main",
          lat: 50.12640709999999,
          lng: 8.628510099999971,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Trakehner Bürohaus</title>\n<meta name="description" content="Im Frankfurter Stadtteil Hausen steht das modernisierte Büro- und Servicegebäude mit dem ostpreußischen Erbe im Namen: Trakehner Bürohaus." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/trakehner-buerohaus/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Trakehner Bürohaus" />\n<meta property="og:description" content="Im Frankfurter Stadtteil Hausen steht das modernisierte Büro- und Servicegebäude mit dem ostpreußischen Erbe im Namen: Trakehner Bürohaus." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/trakehner-buerohaus/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T17:08:57+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2013/08/DSC4962_01-HDR-1-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1708" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/trakehner-buerohaus/","url":"https://www.art-invest.de/en/projekt/trakehner-buerohaus/","name":"Art-Invest Real Estate | Trakehner Bürohaus","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2013-08-28T10:00:06+00:00","dateModified":"2021-11-04T17:08:57+00:00","description":"Im Frankfurter Stadtteil Hausen steht das modernisierte Büro- und Servicegebäude mit dem ostpreußischen Erbe im Namen: Trakehner Bürohaus.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/trakehner-buerohaus/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/trakehner-buerohaus/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/trakehner-buerohaus/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Trakehner Bürohaus"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Trakehner Bürohaus",
        description:
          "Im Frankfurter Stadtteil Hausen steht das modernisierte Büro- und Servicegebäude mit dem ostpreußischen Erbe im Namen: Trakehner Bürohaus.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/trakehner-buerohaus/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Trakehner Bürohaus",
        og_description:
          "Im Frankfurter Stadtteil Hausen steht das modernisierte Büro- und Servicegebäude mit dem ostpreußischen Erbe im Namen: Trakehner Bürohaus.",
        og_url: "https://www.art-invest.de/en/projekt/trakehner-buerohaus/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T17:08:57+00:00",
        og_image: [
          {
            width: 2560,
            height: 1708,
            url: "https://www.art-invest.de/wp-content/uploads/2013/08/DSC4962_01-HDR-1-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/trakehner-buerohaus/",
              url: "https://www.art-invest.de/en/projekt/trakehner-buerohaus/",
              name: "Art-Invest Real Estate | Trakehner Bürohaus",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2013-08-28T10:00:06+00:00",
              dateModified: "2021-11-04T17:08:57+00:00",
              description:
                "Im Frankfurter Stadtteil Hausen steht das modernisierte Büro- und Servicegebäude mit dem ostpreußischen Erbe im Namen: Trakehner Bürohaus.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/trakehner-buerohaus/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/trakehner-buerohaus/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/trakehner-buerohaus/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Trakehner Bürohaus",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2013/08/DSC4962_01-HDR-1-1-scaled-800x800.jpg",
      place: "Frankfurt",
      subtitle: "Gestaltbare Bürowelten",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16858",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16860",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16858",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16858",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21709,
      date: "2014-05-20T12:00:36",
      date_gmt: "2014-05-20T10:00:36",
      guid: {
        rendered: "https://www.art-invest.de/projekt/implerhoefe/",
      },
      modified: "2022-10-27T11:11:04",
      modified_gmt: "2022-10-27T09:11:04",
      slug: "implerhoefe",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/implerhoefe/",
      title: {
        rendered: "Implerhöfe",
      },
      featured_media: 21711,
      template: "",
      projekt_filter: [246, 427, 249, 425, 245],
      acf: {
        highlight_image: 14874,
        highlight_title_project: "Implerhöfe",
        highlight_subtitle_project: "Das Wohngefühl im 6. Bezirk",
        highlight_description_project:
          "Among the high density of old buildings on Sendling's streets, Implerstraße 11 stands out. The geometric facade contrasts with the Art Nouveau facades on the opposite side of the street. The entrance with its modernist girder construction leads into a bright foyer.",
        highlight_logo_project: 21714,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment",
        location:
          "Implerstrasse 11, 81371 Munich, Germany; southwest of the center near Lindwurmstrasse, in the up-and-coming Sendling district",
        property: "4,500 sqm",
        area: "11,500 sqm",
        zertifizierung: "",
        parcels: "146",
        use_for: "Office, retail",
        acquired: "2015",
        realization: "Year built: 2002",
        sale: "",
        architecture_firm: "WEP Effinger Partner Architekten BDA",
        place: "Munich",
        fakten: null,
        specifications_image_projects: 21713,
        slider: [21710, 14874, 21711],
        title_details_projects: "IMPLERHÖFE IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Das Wohngefühl im 6. Bezirk",
            description_repeater_details:
              "Among the high density of old buildings on Sendling's streets, Implerstraße 11 stands out. The geometric facade contrasts with the Art Nouveau facades on the opposite side of the street. The entrance with its modernist girder construction leads into a bright foyer. In the future, the building, currently just under 9,000 sqm in size, is to be enlarged to around 13,000 sqm by a new building and is even already fully leased. After all, Sendling is coming into fashion. The good mood within the metropolis on the Isar and a lively scene are attracting more and more people to the former industrial and working-class district. The rhythm is pulsating. Not only in Sendling's wholesale market halls, which is one of Europe's largest municipal markets for food and flowers after Paris and Barcelona. Sendlingers find green retreats in the Westpark or at the legendary Flaucher, one of the most beautiful city beaches in Germany.",
            image_repeater_details: 14874,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Metropolis on the doorstep",
            description_repeater_details:
              "Thanks to the proximity to the Mittlerer Ring and the excellent public transport connections, Munich and the greater Munich area are perfectly accessible. The main train station and Marienplatz are only a few subway stops away. The trip to Franz-Josef-Strauß Airport takes only 50 minutes by train. The multitude of stores in the surrounding area provide for an ideal local supply, various restaurants for culinary variety.",
            image_repeater_details: 21712,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Light in the best tradition",
            description_repeater_details:
              'An essential premise of modern architecture is light - "a house is only habitable if it is full of light and air," Le Corbusier attested. The building in Implerstraße has both: natural light in the glass-roofed foyer and in the future approx. 13,000 sqm of flexible office space, air on the green roof terrace. Those who are hopelessly captivated by the view of the alpine panorama will find a quick escape in the building\'s own underground parking garage with 160 parking spaces in the future. Via Mittlerer Rind, one lands in the middle of the Alpine foothills after a drive of only 40 minutes.',
            image_repeater_details: 21710,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Implerstraße 11, 81371 München",
          lat: 48.1227791,
          lng: 11.548983399999997,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Implerhöfe</title>\n<meta name="description" content="In Sendlings Straßen sticht die Implerstraße 11 heraus, ein modernes Bürogebäude mit 9.000 m² Nutzfläche, zwei Einzelhandelsflächen und 700 m² Lagerraum." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/implerhoefe/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Implerhöfe" />\n<meta property="og:description" content="In Sendlings Straßen sticht die Implerstraße 11 heraus, ein modernes Bürogebäude mit 9.000 m² Nutzfläche, zwei Einzelhandelsflächen und 700 m² Lagerraum." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/implerhoefe/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-27T09:11:04+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/MUC_Implerstraße_Aussenansicht_02_TEASER-1.jpg" />\n\t<meta property="og:image:width" content="1008" />\n\t<meta property="og:image:height" content="1008" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/implerhoefe/","url":"https://www.art-invest.de/en/projekt/implerhoefe/","name":"Art-Invest Real Estate | Implerhöfe","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-05-20T10:00:36+00:00","dateModified":"2022-10-27T09:11:04+00:00","description":"In Sendlings Straßen sticht die Implerstraße 11 heraus, ein modernes Bürogebäude mit 9.000 m² Nutzfläche, zwei Einzelhandelsflächen und 700 m² Lagerraum.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/implerhoefe/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/implerhoefe/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/implerhoefe/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Implerhöfe"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Implerhöfe",
        description:
          "In Sendlings Straßen sticht die Implerstraße 11 heraus, ein modernes Bürogebäude mit 9.000 m² Nutzfläche, zwei Einzelhandelsflächen und 700 m² Lagerraum.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/implerhoefe/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Implerhöfe",
        og_description:
          "In Sendlings Straßen sticht die Implerstraße 11 heraus, ein modernes Bürogebäude mit 9.000 m² Nutzfläche, zwei Einzelhandelsflächen und 700 m² Lagerraum.",
        og_url: "https://www.art-invest.de/en/projekt/implerhoefe/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-27T09:11:04+00:00",
        og_image: [
          {
            width: 1008,
            height: 1008,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/MUC_Implerstraße_Aussenansicht_02_TEASER-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/implerhoefe/",
              url: "https://www.art-invest.de/en/projekt/implerhoefe/",
              name: "Art-Invest Real Estate | Implerhöfe",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-05-20T10:00:36+00:00",
              dateModified: "2022-10-27T09:11:04+00:00",
              description:
                "In Sendlings Straßen sticht die Implerstraße 11 heraus, ein modernes Bürogebäude mit 9.000 m² Nutzfläche, zwei Einzelhandelsflächen und 700 m² Lagerraum.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/implerhoefe/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/implerhoefe/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/implerhoefe/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Implerhöfe",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/MUC_Implerstraße_Aussenansicht_02_TEASER-1.jpg",
      place: "München",
      subtitle: "Das Wohngefühl im 6. Bezirk",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21709",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21711",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14874",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21710",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21711",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21709",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21709",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16770,
      date: "2015-03-24T12:00:51",
      date_gmt: "2015-03-24T11:00:51",
      guid: {
        rendered: "https://www.art-invest.de/projekt/trias/",
      },
      modified: "2021-04-19T10:36:14",
      modified_gmt: "2021-04-19T08:36:14",
      slug: "trias",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/trias/",
      title: {
        rendered: "TRIAS",
      },
      featured_media: 18402,
      template: "",
      projekt_filter: [246, 427, 425, 256],
      acf: {
        highlight_image: 18406,
        highlight_title_project: "TRIAS",
        highlight_subtitle_project:
          "Trias Häuser tragen zum täglichen Leben bei",
        highlight_description_project:
          "In the aspiring Berlin district between Alexanderplatz and Mediaspree, the three-part building ensemble on Holzmarktstrasse stands out as an architectural Trias. The three buildings with their striking rounded floor plans combine a usable floor space of approx. 30,000 m².",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location: "Holzmarktstraße 15 - 17, 10179 Berlin; Berlin-Mitte",
        property: "5,969 m²",
        area: "29,931 m²",
        zertifizierung: "",
        parcels: "175 underground parking spaces",
        use_for: "Office",
        acquired: "Q3 2013",
        realization: "1996",
        sale: "",
        architecture_firm:
          "Architektengemeinschaft Lucia Beiringer & Gunther Wawrik",
        place: "Berlin",
        fakten: null,
        specifications_image_projects: 18404,
        slider: [18402, 18400, 18404, 18407],
        title_details_projects: "TRIAS IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "The gateway to the east",
            description_repeater_details:
              "Designed in 1996 as a gateway to the east of Berlin at a strategically favourable location between the Spree, the suburban train line and the main traffic artery of Holzmarktstrasse, the three buildings once again provide important urban development impulses for an aspiring area.",
            image_repeater_details: 18400,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "A trend-setting triad",
            description_repeater_details:
              "The striking ground plan of the tower buildings not only gives the complex with a rental area of approx. 30,000 m² an interesting appearance in the cityscape but also guarantees the best working conditions inside. The underground car park offers space for 175 parking spaces.",
            image_repeater_details: 18402,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Holzmarktstraße 15 - 17, Berlin-Mitte",
          lat: 52.513061,
          lng: 13.423103999999967,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | TRIAS</title>\n<meta name="description" content="Das dreiteilige Gebäudeensemble an der Holzmarktstrasse in Berlin mit den markanten abgerundeten Grundrissen bieten vereint ca. 30.000 m² an Büroflächen." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/trias/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | TRIAS" />\n<meta property="og:description" content="Das dreiteilige Gebäudeensemble an der Holzmarktstrasse in Berlin mit den markanten abgerundeten Grundrissen bieten vereint ca. 30.000 m² an Büroflächen." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/trias/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-04-19T08:36:14+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2015/03/DSC_6715-Arbeitskopie-2-e1618821358367.jpg" />\n\t<meta property="og:image:width" content="3391" />\n\t<meta property="og:image:height" content="3176" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/trias/","url":"https://www.art-invest.de/en/projekt/trias/","name":"Art-Invest Real Estate | TRIAS","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2015-03-24T11:00:51+00:00","dateModified":"2021-04-19T08:36:14+00:00","description":"Das dreiteilige Gebäudeensemble an der Holzmarktstrasse in Berlin mit den markanten abgerundeten Grundrissen bieten vereint ca. 30.000 m² an Büroflächen.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/trias/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/trias/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/trias/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"TRIAS"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | TRIAS",
        description:
          "Das dreiteilige Gebäudeensemble an der Holzmarktstrasse in Berlin mit den markanten abgerundeten Grundrissen bieten vereint ca. 30.000 m² an Büroflächen.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/trias/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | TRIAS",
        og_description:
          "Das dreiteilige Gebäudeensemble an der Holzmarktstrasse in Berlin mit den markanten abgerundeten Grundrissen bieten vereint ca. 30.000 m² an Büroflächen.",
        og_url: "https://www.art-invest.de/en/projekt/trias/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-04-19T08:36:14+00:00",
        og_image: [
          {
            width: 3391,
            height: 3176,
            url: "https://www.art-invest.de/wp-content/uploads/2015/03/DSC_6715-Arbeitskopie-2-e1618821358367.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/trias/",
              url: "https://www.art-invest.de/en/projekt/trias/",
              name: "Art-Invest Real Estate | TRIAS",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2015-03-24T11:00:51+00:00",
              dateModified: "2021-04-19T08:36:14+00:00",
              description:
                "Das dreiteilige Gebäudeensemble an der Holzmarktstrasse in Berlin mit den markanten abgerundeten Grundrissen bieten vereint ca. 30.000 m² an Büroflächen.",
              breadcrumb: {
                "@id": "https://www.art-invest.de/en/projekt/trias/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/trias/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/trias/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "TRIAS",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2015/03/DSC_6715-Arbeitskopie-2-e1618821358367-800x800.jpg",
      place: "Berlin",
      subtitle: "Trias Häuser bereichern den Alltag",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16770",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18407",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18404",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18400",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18402",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18402",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16770",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16770",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },

    {
      id: 21593,
      date: "2014-06-03T12:00:37",
      date_gmt: "2014-06-03T10:00:37",
      guid: {
        rendered: "https://www.art-invest.de/projekt/palais-am-pariser-platz/",
      },
      modified: "2022-10-20T10:45:46",
      modified_gmt: "2022-10-20T08:45:46",
      slug: "palais-am-pariser-platz",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/palais-am-pariser-platz/",
      title: {
        rendered: "Palais am Pariser Platz",
      },
      featured_media: 21594,
      template: "",
      projekt_filter: [246, 427, 425, 245, 256],
      acf: {
        highlight_image: 21597,
        highlight_title_project: "Palais am Pariser Platz",
        highlight_subtitle_project: "Zeitlose Eleganz",
        highlight_description_project:
          "The Palais am Pariser Platz is located directly at the Brandenburg Gate. On seven floors, there is representative space for office, retail and gastronomy with outstanding views of the capital's first landmark.",
        highlight_logo_project: null,
        website_projects: {
          title: "www.palais-am-pariser-platz.de",
          url: "http://palais-am-pariser-platz.de/",
          target: "_blank",
        },
        external_projectpage: "",
        available_space: [""],
        project: "Investment",
        location:
          "Pariser Platz 6a, Ebertstraße 24, 10117 Berlin-Mitte, Germany",
        property: "1,657 sqm",
        area: "4,950 sqm",
        zertifizierung: "",
        parcels: "27",
        use_for: "Office, Restaurant and Retail",
        acquired: "Asset under Management since Q1 2015",
        realization: "1998",
        sale: "Q1 2019",
        architecture_firm: "Winking - Froh Architekten BDA",
        place: "Berlin",
        fakten: null,
        specifications_image_projects: 21594,
        slider: [14057],
        title_details_projects: "PALAIS AM PARISER PLATZ IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Zeitlose Eleganz",
            description_repeater_details:
              "Behind the elegant sandstone facade in the style of classical modernism, there is a rental area of approx. 4,950 m². The high-quality building fittings correspond with the prestigious location between the French Embassy and the Hotel Adlon. The roof terrace offers a phenomenal view of the hustle and bustle of Pariser Platz.\r\n\r\nAn underground garage provides space for 27 parking spaces in the heart of the Berlin Republic.",
            image_repeater_details: 14057,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Pariser Platz 6a, Ebertstraße 24, Berlin-Mitte",
          lat: 52.5173761,
          lng: 13.378480500000023,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Palais am Pariser Platz</title>\n<meta name="description" content="Das Pariser Palais bietet auf sieben Stockwerken repräsentative Flächen für Office, Retail und Gastronomie mit exzellentem Blick auf das Brandenburger Tor." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/palais-am-pariser-platz/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Palais am Pariser Platz" />\n<meta property="og:description" content="Das Pariser Palais bietet auf sieben Stockwerken repräsentative Flächen für Office, Retail und Gastronomie mit exzellentem Blick auf das Brandenburger Tor." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/palais-am-pariser-platz/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-20T08:45:46+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2018/09/Palais_Pariser_Platz_Außenansicht-1.jpg" />\n\t<meta property="og:image:width" content="750" />\n\t<meta property="og:image:height" content="750" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/palais-am-pariser-platz/","url":"https://www.art-invest.de/en/projekt/palais-am-pariser-platz/","name":"Art-Invest Real Estate | Palais am Pariser Platz","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-06-03T10:00:37+00:00","dateModified":"2022-10-20T08:45:46+00:00","description":"Das Pariser Palais bietet auf sieben Stockwerken repräsentative Flächen für Office, Retail und Gastronomie mit exzellentem Blick auf das Brandenburger Tor.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/palais-am-pariser-platz/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/palais-am-pariser-platz/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/palais-am-pariser-platz/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Palais am Pariser Platz"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Palais am Pariser Platz",
        description:
          "Das Pariser Palais bietet auf sieben Stockwerken repräsentative Flächen für Office, Retail und Gastronomie mit exzellentem Blick auf das Brandenburger Tor.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/palais-am-pariser-platz/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Palais am Pariser Platz",
        og_description:
          "Das Pariser Palais bietet auf sieben Stockwerken repräsentative Flächen für Office, Retail und Gastronomie mit exzellentem Blick auf das Brandenburger Tor.",
        og_url: "https://www.art-invest.de/en/projekt/palais-am-pariser-platz/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-20T08:45:46+00:00",
        og_image: [
          {
            width: 750,
            height: 750,
            url: "https://www.art-invest.de/wp-content/uploads/2018/09/Palais_Pariser_Platz_Außenansicht-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/palais-am-pariser-platz/",
              url: "https://www.art-invest.de/en/projekt/palais-am-pariser-platz/",
              name: "Art-Invest Real Estate | Palais am Pariser Platz",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-06-03T10:00:37+00:00",
              dateModified: "2022-10-20T08:45:46+00:00",
              description:
                "Das Pariser Palais bietet auf sieben Stockwerken repräsentative Flächen für Office, Retail und Gastronomie mit exzellentem Blick auf das Brandenburger Tor.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/palais-am-pariser-platz/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/palais-am-pariser-platz/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/palais-am-pariser-platz/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Palais am Pariser Platz",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2018/09/Palais_Pariser_Platz_Außenansicht-1.jpg",
      place: "Berlin",
      subtitle: "Zeitlose Eleganz",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21593",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14057",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21594",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21593",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21593",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16910,
      date: "2014-06-27T12:00:54",
      date_gmt: "2014-06-27T10:00:54",
      guid: {
        rendered: "https://www.art-invest.de/projekt/parkstadt-hotel-muenchen/",
      },
      modified: "2021-11-04T18:12:53",
      modified_gmt: "2021-11-04T17:12:53",
      slug: "parkstadt-hotel-muenchen",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/parkstadt-hotel-muenchen/",
      title: {
        rendered: "Parkstadt Center",
      },
      featured_media: 16912,
      template: "",
      projekt_filter: [246, 427, 249, 425, 245],
      acf: {
        highlight_image: 16912,
        highlight_title_project: "Parkstadt Center",
        highlight_subtitle_project: "Neues Stadtteilzentrum im Münchner Norden",
        highlight_description_project:
          "The Parkstadt Center in Munich has all the requirements to become a new district center in one of the youngest high-tech locations in the Isar metropolis. The real estate complex, which combines high-quality space for offices, retail, gastronomy and cars in Parkstadt Schwabing, comprises a total of approx. 12,800 m² rental space.",
        highlight_logo_project: null,
        website_projects: {
          title: "www.parkstadtcenter.de",
          url: "https://www.parkstadtcenter.de/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://www.parkstadtcenter.de/",
          target: "_blank",
        },
        available_space: {
          title: "zum Flächenangebot",
          url: "https://www.aire-mag.com/de/flaechen/parkstadt-center-schwabing",
          target: "_blank",
        },
        project: "Investment",
        location:
          "Alfred-Arndt-Str. 1, Wilhelm-Wagenfeld-Str. 4-8, 80807 Munich",
        property: "9,100 m²",
        area: "12,800 m²",
        zertifizierung: "",
        parcels: "400",
        use_for: "Office, Retail, Gastronomy, Parking",
        acquired: "2016",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "München",
        fakten: [
          {
            bezeichnung: "Built in",
            wert: "2005",
            anchor: "",
          },
        ],
        specifications_image_projects: 2736,
        slider: null,
        title_details_projects: "PARKSTADT CENTER IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Welcome to the high-tech idyll",
            description_repeater_details:
              '"Life is difficult to plan," commented architect and urban planner André Perret on his creation – Parkstadt Schwabing, a unique combination of industrial area, park, offices and apartments in Munich\'s fourth district.\r\n\r\nThe area, which was completed in 2005, has become vivid. Various world market companies such as Amazon, Osram and Microsoft found their headquarters here – and benefit from excellent connections to the Munich ring road and Franz-Josef-Strauß Airport.',
            image_repeater_details: 3386,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "New center in the north",
            description_repeater_details:
              "Two established retail chains, generous office space, conference hotels and 400 parking spaces – this is the current formula for success of the local supply centre in Parkstadt Schwabing. With the planned investments, the real estate complex develops from a local supply square into a sustainable district centre – for a total of around 12,000 employees and 20,000 residents who currently live within the 405,000 m² area of Parkstadt.",
            image_repeater_details: 16911,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Alfred-Arndt-Straße 1, München",
          lat: 48.1827637,
          lng: 11.594353500000011,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Parkstadt Center</title>\n<meta name="description" content="Insgesamt ca. 12.800 m² Mietfläche umfasst der Immobilienkomplex, der in der Parkstadt München Raum für Office, Handel, Gastro und Autos vereint." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/parkstadt-hotel-muenchen/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Parkstadt Center" />\n<meta property="og:description" content="Insgesamt ca. 12.800 m² Mietfläche umfasst der Immobilienkomplex, der in der Parkstadt München Raum für Office, Handel, Gastro und Autos vereint." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/parkstadt-hotel-muenchen/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T17:12:53+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2017/01/Muenchen_Parkstadt_Center_3-1.jpg" />\n\t<meta property="og:image:width" content="2400" />\n\t<meta property="og:image:height" content="1428" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/parkstadt-hotel-muenchen/","url":"https://www.art-invest.de/en/projekt/parkstadt-hotel-muenchen/","name":"Art-Invest Real Estate | Parkstadt Center","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-06-27T10:00:54+00:00","dateModified":"2021-11-04T17:12:53+00:00","description":"Insgesamt ca. 12.800 m² Mietfläche umfasst der Immobilienkomplex, der in der Parkstadt München Raum für Office, Handel, Gastro und Autos vereint.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/parkstadt-hotel-muenchen/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/parkstadt-hotel-muenchen/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/parkstadt-hotel-muenchen/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Parkstadt Center"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Parkstadt Center",
        description:
          "Insgesamt ca. 12.800 m² Mietfläche umfasst der Immobilienkomplex, der in der Parkstadt München Raum für Office, Handel, Gastro und Autos vereint.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/parkstadt-hotel-muenchen/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Parkstadt Center",
        og_description:
          "Insgesamt ca. 12.800 m² Mietfläche umfasst der Immobilienkomplex, der in der Parkstadt München Raum für Office, Handel, Gastro und Autos vereint.",
        og_url:
          "https://www.art-invest.de/en/projekt/parkstadt-hotel-muenchen/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T17:12:53+00:00",
        og_image: [
          {
            width: 2400,
            height: 1428,
            url: "https://www.art-invest.de/wp-content/uploads/2017/01/Muenchen_Parkstadt_Center_3-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/parkstadt-hotel-muenchen/",
              url: "https://www.art-invest.de/en/projekt/parkstadt-hotel-muenchen/",
              name: "Art-Invest Real Estate | Parkstadt Center",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-06-27T10:00:54+00:00",
              dateModified: "2021-11-04T17:12:53+00:00",
              description:
                "Insgesamt ca. 12.800 m² Mietfläche umfasst der Immobilienkomplex, der in der Parkstadt München Raum für Office, Handel, Gastro und Autos vereint.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/parkstadt-hotel-muenchen/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/parkstadt-hotel-muenchen/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/parkstadt-hotel-muenchen/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Parkstadt Center",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2017/01/Muenchen_Parkstadt_Center_3-1.jpg",
      place: "München",
      subtitle: "Im Norden Münchens vereint",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16910",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16912",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16910",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16910",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21620,
      date: "2020-01-17T17:19:24",
      date_gmt: "2020-01-17T16:19:24",
      guid: {
        rendered:
          "https://www.art-invest.de/projekt/ibis-styles-hotel-hamburg/",
      },
      modified: "2023-09-18T11:59:56",
      modified_gmt: "2023-09-18T09:59:56",
      slug: "ibis-styles-hotel-hamburg",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/ibis-styles-hotel-hamburg/",
      title: {
        rendered: "ibis Styles Hotel",
      },
      featured_media: 25515,
      template: "",
      projekt_filter: [248, 251, 427, 425],
      acf: {
        highlight_image: 25511,
        highlight_title_project: "ibis Styles Hotel",
        highlight_subtitle_project: "Ultramodernes, aber diskretes Hotel",
        highlight_description_project:
          "A future-oriented Ibis Styles Hotel is being built in Hamburg-Barmbek that meets every demand for modernity and comfort. The slender-looking, partly elevated building catches the eye from afar: with its high-quality clinker facade, the architecture underscores the lifestyle character of the progressive economy hotel.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment",
        location: "Fuhlsbüttler Straße 32-46, 22305 Hamburg, Germany",
        property: "1,571 sqm",
        area: "7,862 sqm",
        zertifizierung: "",
        parcels: "30",
        use_for: "Hotel, Gastronomy",
        acquired: "Q2 2018",
        realization: "Expected in Q4 2020",
        sale: "",
        architecture_firm: "Schenk+Waiblinger Architekten",
        place: "Hamburg",
        fakten: null,
        specifications_image_projects: 25511,
        slider: [25503, 25505, 25507, 25517],
        title_details_projects: "IBIS STYLES HOTEL HAMBURG IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Pleasure on all levels",
            description_repeater_details:
              'The Ibis Styles Hamburg opens at the beginning of 2021 with 188 rooms in different categories. Whether business people, weekenders or families - the hotel offers a perfect setting for every target group. As a special highlight, the hip restaurant "Mikes Urban Pub" will be integrated into the lobby - the gastronomy concept, which also attracts external guests very successfully, was developed by the Success Hotel Group itself. Anyone who values good quality, fresh products and a relaxed atmosphere is in exactly the right place here.',
            image_repeater_details: 14885,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Feel good atmosphere",
            description_repeater_details:
              "All five hotel floors bear a clear signature: good furnishings, beautiful design and a high level of comfort. All relevant sports events are shown on HD and large screens. In addition, the hotel has underground parking and a fitness room, which hotel guests can use free of charge.\r\n\r\nWithin walking distance of the Barmbek train station, which is just a few stops from both Hamburg city center and the airport, the hotel is in a prime micro-location. A day trip with sightseeing and a visit to the most beautiful landmarks - whether Michel, Elbphilharmonie, Speicherstadt or Landungsbrücken - can be made quite comfortably from the Ibis Styles in Barmbek.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Fuhlsbüttler Straße 32-46, 22305 Hamburg, Deutschland",
          lat: 53.58608479999999,
          lng: 10.0465963,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | ibis Styles Hotel</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/ibis-styles-hotel-hamburg/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | ibis Styles Hotel" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/ibis-styles-hotel-hamburg/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-09-18T09:59:56+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/01/ibis-styles-hamburg-barmbek-1622-Aussenansicht-1-2-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1707" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/ibis-styles-hotel-hamburg/","url":"https://www.art-invest.de/en/projekt/ibis-styles-hotel-hamburg/","name":"Art-Invest Real Estate | ibis Styles Hotel","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-01-17T16:19:24+00:00","dateModified":"2023-09-18T09:59:56+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/ibis-styles-hotel-hamburg/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/ibis-styles-hotel-hamburg/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/ibis-styles-hotel-hamburg/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"ibis Styles Hotel"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | ibis Styles Hotel",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/ibis-styles-hotel-hamburg/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | ibis Styles Hotel",
        og_url:
          "https://www.art-invest.de/en/projekt/ibis-styles-hotel-hamburg/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-09-18T09:59:56+00:00",
        og_image: [
          {
            width: 2560,
            height: 1707,
            url: "https://www.art-invest.de/wp-content/uploads/2020/01/ibis-styles-hamburg-barmbek-1622-Aussenansicht-1-2-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/ibis-styles-hotel-hamburg/",
              url: "https://www.art-invest.de/en/projekt/ibis-styles-hotel-hamburg/",
              name: "Art-Invest Real Estate | ibis Styles Hotel",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-01-17T16:19:24+00:00",
              dateModified: "2023-09-18T09:59:56+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/ibis-styles-hotel-hamburg/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/ibis-styles-hotel-hamburg/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/ibis-styles-hotel-hamburg/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "ibis Styles Hotel",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/01/ibis-styles-hamburg-barmbek-1622-Aussenansicht-1-2-800x800.jpg",
      place: "Hamburg",
      subtitle: "Ultramodernes, aber diskretes Hotel",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21620",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25517",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25507",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25505",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25503",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/25515",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21620",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21620",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16810,
      date: "2013-12-17T12:00:57",
      date_gmt: "2013-12-17T11:00:57",
      guid: {
        rendered: "https://www.art-invest.de/projekt/pullmann-hotel/",
      },
      modified: "2020-07-08T14:05:33",
      modified_gmt: "2020-07-08T14:05:33",
      slug: "pullmann-hotel",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/pullmann-hotel/",
      title: {
        rendered: "Pullman Hotel",
      },
      featured_media: 16812,
      template: "",
      projekt_filter: [247, 251, 427, 425],
      acf: {
        highlight_image: 16812,
        highlight_title_project: "Pullman Hotel",
        highlight_subtitle_project: "Vom Hotel zur Hofburg",
        highlight_description_project:
          "The hotel is one of the top addresses in Cologne. The 4-star hotel has a history of over 40 years. Built in 1972 as an InterContinental Hotel, since 2008 it is part of the Pullman brand, which once brought luxury to America.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project:
          "Off-market acquisition of a very well-known hotel in downtown Cologne; long-term investment including refurbishment",
        location: "Helenenstr. 14, Cologne; city centre",
        property: "4,524 m²",
        area: "20,544 m², 275 rooms",
        zertifizierung: "",
        parcels: "98 parking spaces in its own underground car park",
        use_for: "4* Superior Business-Hotel",
        acquired: "Q4 2015",
        realization: "1972",
        sale: "",
        architecture_firm: "",
        place: "Cologne",
        fakten: null,
        specifications_image_projects: 16815,
        slider: null,
        title_details_projects: "PULLMAN HOTEL IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Vom Hotel zur Hofburg",
            description_repeater_details:
              "When the Cologne Triumvirate, the oldest carnival society in the city, moves into the Pullman Hotel, the hotel becomes the imperial palace – and the epicentre of carnival. From here, the traditional Triumvirate of Prince, Peasant and Virgin will rule the city for six weeks.",
            image_repeater_details: 16813,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Allow me to introduce George Mortimer Pullman",
            description_repeater_details:
              "The hotel has 275 rooms and suites, 16 conference rooms and the second largest ballroom, where more than 30 carnival sessions take place. Two restaurants and a spacious spa and fitness area complete the offer. The sky lounge LAB12 on the 12th floor commemorates its namesake George Mortimer Pullman, who revolutionized American rail travel in the 19th century with his luxurious sleeping compartment.",
            image_repeater_details: 16811,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Starting point Friesenplatz",
            description_repeater_details:
              "The Friesenplatz is one of the most popular venues in the city. The underground station connects the entire city with the Friesenviertel, where the neighbourhood meets in various bars and clubs. The hotel's own underground car park with 98 parking spaces is open to the public.",
            image_repeater_details: 16815,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Helenenstraße 14, Köln, Deutschland",
          lat: 50.9401934,
          lng: 6.945730000000026,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Pullman Hotel</title>\n<meta name="description" content="Das Hotel zählt zu den ersten Adressen Kölns. Das 4-Sterne Haus wurde 1972 als InterContinental Hotel errichtet und gehört seit 2008 zur Marke Pullman." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/pullmann-hotel/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Pullman Hotel" />\n<meta property="og:description" content="Das Hotel zählt zu den ersten Adressen Kölns. Das 4-Sterne Haus wurde 1972 als InterContinental Hotel errichtet und gehört seit 2008 zur Marke Pullman." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/pullmann-hotel/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-08T14:05:33+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2013/12/Pullman-Bild-123-1-1024x768.png" />\n\t<meta property="og:image:width" content="1024" />\n\t<meta property="og:image:height" content="768" />\n\t<meta property="og:image:type" content="image/png" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/pullmann-hotel/","url":"https://www.art-invest.de/en/projekt/pullmann-hotel/","name":"Art-Invest Real Estate | Pullman Hotel","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2013-12-17T11:00:57+00:00","dateModified":"2020-07-08T14:05:33+00:00","description":"Das Hotel zählt zu den ersten Adressen Kölns. Das 4-Sterne Haus wurde 1972 als InterContinental Hotel errichtet und gehört seit 2008 zur Marke Pullman.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/pullmann-hotel/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/pullmann-hotel/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/pullmann-hotel/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Pullman Hotel"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Pullman Hotel",
        description:
          "Das Hotel zählt zu den ersten Adressen Kölns. Das 4-Sterne Haus wurde 1972 als InterContinental Hotel errichtet und gehört seit 2008 zur Marke Pullman.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/pullmann-hotel/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Pullman Hotel",
        og_description:
          "Das Hotel zählt zu den ersten Adressen Kölns. Das 4-Sterne Haus wurde 1972 als InterContinental Hotel errichtet und gehört seit 2008 zur Marke Pullman.",
        og_url: "https://www.art-invest.de/en/projekt/pullmann-hotel/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-08T14:05:33+00:00",
        og_image: [
          {
            width: 1024,
            height: 768,
            url: "https://www.art-invest.de/wp-content/uploads/2013/12/Pullman-Bild-123-1-1024x768.png",
            type: "image/png",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/pullmann-hotel/",
              url: "https://www.art-invest.de/en/projekt/pullmann-hotel/",
              name: "Art-Invest Real Estate | Pullman Hotel",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2013-12-17T11:00:57+00:00",
              dateModified: "2020-07-08T14:05:33+00:00",
              description:
                "Das Hotel zählt zu den ersten Adressen Kölns. Das 4-Sterne Haus wurde 1972 als InterContinental Hotel errichtet und gehört seit 2008 zur Marke Pullman.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/pullmann-hotel/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/pullmann-hotel/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/pullmann-hotel/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Pullman Hotel",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2013/12/Pullman-Bild-123-1-800x800.png",
      place: "Köln",
      subtitle: "Vom Hotel zur Hofburg",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16810",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16812",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16810",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16810",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21715,
      date: "2013-08-18T12:00:14",
      date_gmt: "2013-08-18T10:00:14",
      guid: {
        rendered: "https://www.art-invest.de/projekt/karstadt-bamberg/",
      },
      modified: "2022-10-27T11:15:33",
      modified_gmt: "2022-10-27T09:15:33",
      slug: "karstadt-bamberg",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/karstadt-bamberg/",
      title: {
        rendered: "Karstadt",
      },
      featured_media: 21716,
      template: "",
      projekt_filter: [246, 427, 425, 245, 263],
      acf: {
        highlight_image: 21716,
        highlight_title_project: "Karstadt",
        highlight_subtitle_project:
          "Exklusiver Einzelhandel im Herzen der Stadt",
        highlight_description_project:
          "The stylish retail property of the Belle Epoche breathes the flair of Rudolph Karstadt. On six floors and approx. 19,000 sqm, Bamberg will in future have state-of-the-art space for exclusive retail - right in the heart of the city on Grüner Markt.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment",
        location:
          "Grüner Markt 23-27, Maximiliansplatz 1a, 96047 Bamberg, Germany; central city center location on the prominent Maximiliansplatz",
        property: "4,900 sqm",
        area: "19,000 sqm",
        zertifizierung: "",
        parcels: "205",
        use_for: "Retail, office, parking",
        acquired: "2016",
        realization:
          "Year built: 1910/1929 (department store), 1969 (underground parking)",
        sale: "",
        architecture_firm: "",
        place: "Bamberg",
        fakten: null,
        specifications_image_projects: 21719,
        slider: [21716],
        title_details_projects: "KARSTADT IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Jewel of the Founding Era",
            description_repeater_details:
              "Who still knows them, the classic department stores? Bamberg's Karstadt branch is undoubtedly one of the jewels of the retail czar. The classicist building from 1910 was acquired in 2016 - and is to celebrate classic department store tradition in new splendor again in the future.",
            image_repeater_details: 21717,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Magnet in the center",
            description_repeater_details:
              "In the heart of the old town lies the Grüner Markt, Bamberg's absolute prime retail location. Various chain stores such as C&amp;A, Douglas or H&amp;M are located in the immediate vicinity. The location is an attractive business and retail location far beyond the city limits - and the own underground car park opens up space for 205 cars.",
            image_repeater_details: 21716,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Maximiliansplatz 1, 96047 Bamberg",
          lat: 49.89453959999999,
          lng: 10.889947799999959,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Karstadt</title>\n<meta name="description" content="Auf sechs Geschossen und ca. 19.000 m² finden sich in Bamberg zukünftig modernste Flächen für exklusiven Einzelhandel - im Herzen der Stadt am Grünen Markt." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/karstadt-bamberg/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Karstadt" />\n<meta property="og:description" content="Auf sechs Geschossen und ca. 19.000 m² finden sich in Bamberg zukünftig modernste Flächen für exklusiven Einzelhandel - im Herzen der Stadt am Grünen Markt." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/karstadt-bamberg/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-27T09:15:33+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/Bamberg_Karstadt_Frontansicht_TEASER-1-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1859" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/karstadt-bamberg/","url":"https://www.art-invest.de/en/projekt/karstadt-bamberg/","name":"Art-Invest Real Estate | Karstadt","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2013-08-18T10:00:14+00:00","dateModified":"2022-10-27T09:15:33+00:00","description":"Auf sechs Geschossen und ca. 19.000 m² finden sich in Bamberg zukünftig modernste Flächen für exklusiven Einzelhandel - im Herzen der Stadt am Grünen Markt.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/karstadt-bamberg/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/karstadt-bamberg/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/karstadt-bamberg/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Karstadt"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Karstadt",
        description:
          "Auf sechs Geschossen und ca. 19.000 m² finden sich in Bamberg zukünftig modernste Flächen für exklusiven Einzelhandel - im Herzen der Stadt am Grünen Markt.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/karstadt-bamberg/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Karstadt",
        og_description:
          "Auf sechs Geschossen und ca. 19.000 m² finden sich in Bamberg zukünftig modernste Flächen für exklusiven Einzelhandel - im Herzen der Stadt am Grünen Markt.",
        og_url: "https://www.art-invest.de/en/projekt/karstadt-bamberg/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-27T09:15:33+00:00",
        og_image: [
          {
            width: 2560,
            height: 1859,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/Bamberg_Karstadt_Frontansicht_TEASER-1-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/karstadt-bamberg/",
              url: "https://www.art-invest.de/en/projekt/karstadt-bamberg/",
              name: "Art-Invest Real Estate | Karstadt",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2013-08-18T10:00:14+00:00",
              dateModified: "2022-10-27T09:15:33+00:00",
              description:
                "Auf sechs Geschossen und ca. 19.000 m² finden sich in Bamberg zukünftig modernste Flächen für exklusiven Einzelhandel - im Herzen der Stadt am Grünen Markt.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/karstadt-bamberg/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/karstadt-bamberg/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/karstadt-bamberg/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Karstadt",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/Bamberg_Karstadt_Frontansicht_TEASER-1-1-scaled.jpg",
      place: "Bamberg",
      subtitle: "Exklusive Shops im Stadtzentrum",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21715",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21716",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21716",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21715",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21715",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16755,
      date: "2015-06-02T12:00:23",
      date_gmt: "2015-06-02T10:00:23",
      guid: {
        rendered: "https://www.art-invest.de/projekt/koelnturm/",
      },
      modified: "2020-07-07T11:57:05",
      modified_gmt: "2020-07-07T11:57:05",
      slug: "koelnturm",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/koelnturm/",
      title: {
        rendered: "KölnTurm & NH-Hotel",
      },
      featured_media: 16757,
      template: "",
      projekt_filter: [246, 247, 426, 425],
      acf: {
        highlight_image: 16757,
        highlight_title_project: "KölnTurm",
        highlight_subtitle_project: "Hervorragende Aussicht",
        highlight_description_project:
          "The 148 m high KölnTurm has been shaping the silhouette of the cathedral city since 2001. The highest office building in the business metropolis of Cologne is a modern icon designed by the French star architect Jean Nouvel – 27,300 m² of state-of-the-art office space rises behind the dramatic facade. Together with the NH-Hotel Köln Mediapark it forms a futuristic ensemble.",
        highlight_logo_project: 16761,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location: "Im MediaPark 8, 50670 Cologne, city centre",
        property: "1,816 m²",
        area: "approx. 27,300 m²",
        zertifizierung: "",
        parcels: "163 parking spaces",
        use_for: "Office",
        acquired: "Q3 2011",
        realization: "2001 / 2013",
        sale: "Q4 2014",
        architecture_firm: "Jean Nouvel",
        place: "Cologne",
        fakten: null,
        specifications_image_projects: 16762,
        slider: null,
        title_details_projects: "KÖLNTURM & NH-HOTEL IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Hervorragende Aussicht",
            description_repeater_details:
              "The 45 full storeys are divided into around 27,300 m² of office space and two restaurants. The restaurant on the 30th floor offers a spectacular panoramic view of the city. 163 parking spaces guarantee parking in its own underground car park.",
            image_repeater_details: 16759,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Visionary environment",
            description_repeater_details:
              "The tower plot of 1,816 m² is embedded in the urban environment of the MediaPark. The district is a collage of Manhattan, Italian campus and suburban greenery – today the MediaPark is an established office location and, along with the Rheinauhafen harbour, it is one of the most important office locations in the cathedral city. It is home to more than 250 national and international companies.",
            image_repeater_details: 16758,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Attractive areas",
            description_repeater_details:
              "The tenants include major management consultancies, law firms and IT companies from Germany and abroad. Thanks to the successful repositioning, the occupancy rate was increased to 90% before the sale. The KölnTurm was sold in 2014 – today it is fully let.",
            image_repeater_details: 16762,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Conference venue or heaven of peace?",
            description_repeater_details:
              "The 4-star business and conference hotel NH Köln-MediaPark has room for both. The MediaPark lake creates a landscape idyll in the city – and for a large part of the 217 stylish rooms and luxurious suites a great view. The conference areas are state-of-the-art rooms for meetings and presentations. 84 parking spaces in the underground car park guarantee uncomplicated arrivals and departures – unless you prefer to walk directly to the main station in 15 minutes.",
            image_repeater_details: 16760,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Im MediaPark 8, 50670 Köln",
          lat: 50.948076,
          lng: 6.943080900000041,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | KölnTurm &amp; NH-Hotel</title>\n<meta name="description" content="Der 148m hohe KölnTurm prägt seit 2001 die Silhouette der Domstadt. Hinter der futuristischen Fassade erheben sich 27.300 m² modernste Büroflächen." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/koelnturm/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | KölnTurm &amp; NH-Hotel" />\n<meta property="og:description" content="Der 148m hohe KölnTurm prägt seit 2001 die Silhouette der Domstadt. Hinter der futuristischen Fassade erheben sich 27.300 m² modernste Büroflächen." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/koelnturm/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-07T11:57:05+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/KoelnTurm_Panorama_aussen_TEASER_neu-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="2560" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/koelnturm/","url":"https://www.art-invest.de/en/projekt/koelnturm/","name":"Art-Invest Real Estate | KölnTurm & NH-Hotel","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2015-06-02T10:00:23+00:00","dateModified":"2020-07-07T11:57:05+00:00","description":"Der 148m hohe KölnTurm prägt seit 2001 die Silhouette der Domstadt. Hinter der futuristischen Fassade erheben sich 27.300 m² modernste Büroflächen.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/koelnturm/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/koelnturm/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/koelnturm/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"KölnTurm &#038; NH-Hotel"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | KölnTurm & NH-Hotel",
        description:
          "Der 148m hohe KölnTurm prägt seit 2001 die Silhouette der Domstadt. Hinter der futuristischen Fassade erheben sich 27.300 m² modernste Büroflächen.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/koelnturm/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | KölnTurm & NH-Hotel",
        og_description:
          "Der 148m hohe KölnTurm prägt seit 2001 die Silhouette der Domstadt. Hinter der futuristischen Fassade erheben sich 27.300 m² modernste Büroflächen.",
        og_url: "https://www.art-invest.de/en/projekt/koelnturm/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-07T11:57:05+00:00",
        og_image: [
          {
            width: 2560,
            height: 2560,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/KoelnTurm_Panorama_aussen_TEASER_neu-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/koelnturm/",
              url: "https://www.art-invest.de/en/projekt/koelnturm/",
              name: "Art-Invest Real Estate | KölnTurm & NH-Hotel",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2015-06-02T10:00:23+00:00",
              dateModified: "2020-07-07T11:57:05+00:00",
              description:
                "Der 148m hohe KölnTurm prägt seit 2001 die Silhouette der Domstadt. Hinter der futuristischen Fassade erheben sich 27.300 m² modernste Büroflächen.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/koelnturm/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/koelnturm/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/koelnturm/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "KölnTurm & NH-Hotel",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/KoelnTurm_Panorama_aussen_TEASER_neu-1-scaled.jpg",
      place: "Köln",
      subtitle: "Hervorragende Aussicht",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16755",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16757",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16755",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16755",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 19596,
      date: "2014-06-17T12:00:45",
      date_gmt: "2014-06-17T10:00:45",
      guid: {
        rendered: "https://www.art-invest.de/projekt/arnulfbogen/",
      },
      modified: "2022-10-25T11:10:34",
      modified_gmt: "2022-10-25T09:10:34",
      slug: "arnulfbogen",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/arnulfbogen/",
      title: {
        rendered: "Arnulfbogen",
      },
      featured_media: 21647,
      template: "",
      projekt_filter: [246, 427, 249, 425],
      acf: {
        highlight_image: 21647,
        highlight_title_project: "ARNULFBOGEN",
        highlight_subtitle_project: "Das City-Wahrzeichen am Mittleren Ring",
        highlight_description_project:
          "The ARNULFBOGEN presents itself as an imposing building on 10,300 sqm directly on Munich's Mittlerer Ring. Flanked by Arnulfstraße and Landshuter Allee, the seven-story building with its striking glass facade stands out from the flow of traffic in Munich's ninth district.",
        highlight_logo_project: 19594,
        website_projects: "",
        external_projectpage: "",
        available_space: {
          title: "zum Flächenangebot",
          url: "https://www.aire-mag.com/de/flaechen/arnulfbogen",
          target: "_blank",
        },
        project: "Investment",
        location:
          "Arnulfstraße 122-126, Landshuter Allee 4-6, 80636 Munich; prominently located directly on the Mittlerer Ring",
        property: "10,300 sqm",
        area: "25,500 sqm",
        zertifizierung: "",
        parcels: "266",
        use_for: "Office",
        acquired: "2021",
        realization:
          "Year of construction: 1997, extensive modernization in 2015 by Art-Invest Real Estate",
        sale: "",
        architecture_firm: "DMP Architekten (origin architect)",
        place: "Munich",
        fakten: null,
        specifications_image_projects: 21641,
        slider: [21637, 21639, 21631, 21633],
        title_details_projects: "ARNULFBOGEN IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Flexible spaces",
            description_repeater_details:
              "In the extremely flexible building structure, all office concepts, such as individual, combined or open-plan offices, can be realized variably on approx. 25,500 sqm of rental space. A quiet and leafy inner courtyard with amenity quality and space for a variety of activities.",
            image_repeater_details: 21639,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Excellent connectivity",
            description_repeater_details:
              "Due to its proximity to the Mittlerer Ring and the S-Bahn main line with the Donnersbergerbrücke station as well as streetcar and bus stops, the ARNULFBOGEN is optimally connected to public and individual transport.",
            image_repeater_details: 21643,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Landmarke in Neuhausen",
            description_repeater_details:
              "The main train station is only two and the Marienplatz only four S-Bahn stops away from the ARNULFBOGEN. The airport can be reached in about 40 minutes by car or S-Bahn. Numerous shopping facilities for daily needs as well as a variety of restaurants and hotels are located in the immediate vicinity.",
            image_repeater_details: 21645,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Arnulfstraße 122-126, 80636 München",
          lat: 48.1462,
          lng: 11.538360000000011,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Arnulfbogen</title>\n<meta name="description" content="Der Arnulfbogen präsentiert sich als imposantes Gebäude auf 10.300 m² Grundstücksfläche direkt an Münchens Mittleren Ring." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/arnulfbogen/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Arnulfbogen" />\n<meta property="og:description" content="Der Arnulfbogen präsentiert sich als imposantes Gebäude auf 10.300 m² Grundstücksfläche direkt an Münchens Mittleren Ring." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/arnulfbogen/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-25T09:10:34+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2014/06/arnulfbogen_header_02_web.jpg" />\n\t<meta property="og:image:width" content="2000" />\n\t<meta property="og:image:height" content="1341" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/arnulfbogen/","url":"https://www.art-invest.de/en/projekt/arnulfbogen/","name":"Art-Invest Real Estate | Arnulfbogen","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-06-17T10:00:45+00:00","dateModified":"2022-10-25T09:10:34+00:00","description":"Der Arnulfbogen präsentiert sich als imposantes Gebäude auf 10.300 m² Grundstücksfläche direkt an Münchens Mittleren Ring.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/arnulfbogen/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/arnulfbogen/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/arnulfbogen/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Arnulfbogen"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Arnulfbogen",
        description:
          "Der Arnulfbogen präsentiert sich als imposantes Gebäude auf 10.300 m² Grundstücksfläche direkt an Münchens Mittleren Ring.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/arnulfbogen/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Arnulfbogen",
        og_description:
          "Der Arnulfbogen präsentiert sich als imposantes Gebäude auf 10.300 m² Grundstücksfläche direkt an Münchens Mittleren Ring.",
        og_url: "https://www.art-invest.de/en/projekt/arnulfbogen/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-25T09:10:34+00:00",
        og_image: [
          {
            width: 2000,
            height: 1341,
            url: "https://www.art-invest.de/wp-content/uploads/2014/06/arnulfbogen_header_02_web.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/arnulfbogen/",
              url: "https://www.art-invest.de/en/projekt/arnulfbogen/",
              name: "Art-Invest Real Estate | Arnulfbogen",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-06-17T10:00:45+00:00",
              dateModified: "2022-10-25T09:10:34+00:00",
              description:
                "Der Arnulfbogen präsentiert sich als imposantes Gebäude auf 10.300 m² Grundstücksfläche direkt an Münchens Mittleren Ring.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/arnulfbogen/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/arnulfbogen/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/arnulfbogen/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Arnulfbogen",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2014/06/arnulfbogen_header_02_web-800x800.jpg",
      place: "München",
      subtitle: "Wahrzeichen am Mittleren Ring",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/19596",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21633",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21631",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21639",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21637",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21647",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=19596",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=19596",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 18054,
      date: "2020-12-22T09:41:14",
      date_gmt: "2020-12-22T08:41:14",
      guid: {
        rendered: "https://www.art-invest.de/projekt/leo139/",
      },
      modified: "2021-01-19T13:33:17",
      modified_gmt: "2021-01-19T12:33:17",
      slug: "leo139",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/leo139/",
      title: {
        rendered: "LEO139",
      },
      featured_media: 18038,
      template: "",
      projekt_filter: [246, 427, 249, 252, 425, 245],
      acf: {
        highlight_image: 18046,
        highlight_title_project: "LEO139",
        highlight_subtitle_project: "Arbeiten und Leben in Schwabing",
        highlight_description_project:
          'On the important "Leopoldstrasse" in the popular district of Schwabing, the Art-Invest Real Estate property LEO139 convinces in several ways. The office and commercial building creates a high quality of life with its very good connections and its proximity to the newly developed "Schwabinger Tor" district. Users and visitors benefit from the diverse gastronomy and the extensive local supply in the direct neighborhood. The mixed-use ensemble in the north of the Bavarian capital offers a great tenant structure with high visibility.',
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: {
          title: "zum Flächenangebot",
          url: "https://www.aire-mag.com/de/flaechen/leo139",
          target: "_blank",
        },
        project: "Investment",
        location: "Leopoldstraße 139-145, 80804 Munich",
        property: "4,622 sqm",
        area: "7,564 sqm",
        zertifizierung: "",
        parcels: "136",
        use_for: "Office, Living, Retail",
        acquired: "2020",
        realization: "1982",
        sale: "",
        architecture_firm: "",
        place: "München",
        fakten: null,
        specifications_image_projects: 18038,
        slider: null,
        title_details_projects: "LEO139 IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Fit for the future",
            description_repeater_details:
              'LEO139 comprises six above-ground floors and two basement levels, for which Art-Invest Real Estate is planning extensive measures starting in 2021, true to the "manage-to-core" approach. In addition to optimizing the common areas, the rental areas will also be upgraded. For contemporary mobility, the renovation and maintenance of the underground parking garage will take place. The future appeal of the property will be enhanced by flexible space concepts and a very quiet courtyard facing away from the street. The units are leased by the Technical University of Munich, various law firms, a wine retailer and numerous residential tenants.',
            image_repeater_details: 18041,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Attractive location in the north of Munich",
            description_repeater_details:
              "LEO139 is located on one of Munich's most important traffic axes and north of the city center in the sought-after trendy district of Schwabing. The ensemble stands out due to its convenient location. The attractiveness of the location factors is increased by the good connection to public transport as well as an excellent accessibility to the highway A9.",
            image_repeater_details: 18038,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Leopoldstraße 139-145, 80804 München, Deutschland",
          lat: 48.16939740000001,
          lng: 11.5859661,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | LEO139</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/leo139/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | LEO139" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/leo139/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-01-19T12:33:17+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2021/01/LEO139_Bild-2-Innenhof_Dez-2020.jpg" />\n\t<meta property="og:image:width" content="664" />\n\t<meta property="og:image:height" content="888" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/leo139/","url":"https://www.art-invest.de/en/projekt/leo139/","name":"Art-Invest Real Estate | LEO139","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-12-22T08:41:14+00:00","dateModified":"2021-01-19T12:33:17+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/leo139/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/leo139/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/leo139/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"LEO139"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | LEO139",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/leo139/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | LEO139",
        og_url: "https://www.art-invest.de/en/projekt/leo139/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-01-19T12:33:17+00:00",
        og_image: [
          {
            width: 664,
            height: 888,
            url: "https://www.art-invest.de/wp-content/uploads/2021/01/LEO139_Bild-2-Innenhof_Dez-2020.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/leo139/",
              url: "https://www.art-invest.de/en/projekt/leo139/",
              name: "Art-Invest Real Estate | LEO139",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-12-22T08:41:14+00:00",
              dateModified: "2021-01-19T12:33:17+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/leo139/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/leo139/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/leo139/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "LEO139",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2021/01/LEO139_Bild-2-Innenhof_Dez-2020-664x800.jpg",
      place: "München",
      subtitle: "Arbeiten und Leben in Schwabing",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/18054",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18038",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=18054",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=18054",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16626,
      date: "2018-10-16T17:39:15",
      date_gmt: "2018-10-16T15:39:15",
      guid: {
        rendered: "https://www.art-invest.de/projekt/yrds/",
      },
      modified: "2023-07-10T14:06:42",
      modified_gmt: "2023-07-10T12:06:42",
      slug: "yrds",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/yrds/",
      title: {
        rendered: "YRDS",
      },
      featured_media: 14045,
      template: "",
      projekt_filter: [246, 427, 425, 257],
      acf: {
        highlight_image: 16630,
        highlight_title_project: "Yrds",
        highlight_subtitle_project: "Neuer Befestigungspunkt im Norden",
        highlight_description_project:
          "A versatile and modern office location is being created on up to 17 floors at the northern entrance gate to the city. The 60m high building complex impresses with its highly efficient floor plans, is intended to enrich the Dusseldorf cityscape and attract attention.",
        highlight_logo_project: 16629,
        website_projects: {
          title: "www.yrds.de",
          url: "https://yrds.de/en/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://yrds.de/en/",
          target: "_blank",
        },
        available_space: [""],
        project: "Development/  Development plan procedure",
        location: "Mercedesstraße 1, 40470 Dusseldorf",
        property: "approx. 8,890 m²",
        area: "approx. 37,600 m²",
        zertifizierung: "",
        parcels: "approx. 480",
        use_for: "Office",
        acquired: "Q4 2017",
        realization: "planned from 2027",
        sale: "",
        architecture_firm: "slapa oberholz pszczulny",
        place: "Düsseldorf",
        fakten: null,
        specifications_image_projects: 16627,
        slider: null,
        title_details_projects: "YRDS IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Modern working with a view of the city",
            description_repeater_details:
              "On a total of up to 17 floors, modern office space will be created at the corner of Mercedesstrasse and Münsterstrasse. In addition to the eye-catching high-rise building, a plinth building with 8 floors will also be constructed. The impressive entrance area will become a communication zone and elegantly connects the exterior with the interior of the building. A spacious inner courtyard as the heart of the building provides a bright and friendly working atmosphere and brings together gastronomy, conferencing and offices.",
            image_repeater_details: 16628,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Top location in the north of Dusseldorf",
            description_repeater_details:
              "Especially the proximity to the airport and a direct connection via the Mörsenbroicher Ei qualify the site as an office location at the northern entrance gate of the city. The high volume of traffic in the city centre can thus be easily bypassed. Up to 480 car parking spaces will be created at the site, making travelling by car even more comfortable. The new location is also easy to reach by public transport, as the underground station Heinrichstraße is within sight.",
            image_repeater_details: 14045,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Coherent overall concept",
            description_repeater_details:
              "The complex is rounded off by an attractive range of gastronomy, which is also located in the building and offers added value for future tenants and their employees. Further opportunities for leisure activities and a balance from everyday working life are only a 15 minutes' walk away in the Derendorf district.",
            image_repeater_details: 16627,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Mercedesstraße 1, 40470 Düsseldorf, Deutschland",
          lat: 51.24951805723283,
          lng: 6.798716580178848,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | YRDS</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/yrds/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | YRDS" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/yrds/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-07-10T12:06:42+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2018/10/DUS_YRDS_Aussenansicht_Eckansicht-mit-Straße-2-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1830" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/yrds/","url":"https://www.art-invest.de/en/projekt/yrds/","name":"Art-Invest Real Estate | YRDS","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2018-10-16T15:39:15+00:00","dateModified":"2023-07-10T12:06:42+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/yrds/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/yrds/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/yrds/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"YRDS"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | YRDS",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/yrds/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | YRDS",
        og_url: "https://www.art-invest.de/en/projekt/yrds/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-07-10T12:06:42+00:00",
        og_image: [
          {
            width: 2560,
            height: 1830,
            url: "https://www.art-invest.de/wp-content/uploads/2018/10/DUS_YRDS_Aussenansicht_Eckansicht-mit-Straße-2-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/yrds/",
              url: "https://www.art-invest.de/en/projekt/yrds/",
              name: "Art-Invest Real Estate | YRDS",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2018-10-16T15:39:15+00:00",
              dateModified: "2023-07-10T12:06:42+00:00",
              breadcrumb: {
                "@id": "https://www.art-invest.de/en/projekt/yrds/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/yrds/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/yrds/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "YRDS",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2018/10/DUS_YRDS_Aussenansicht_Eckansicht-mit-Straße-2-scaled-800x800.jpg",
      place: "Düsseldorf",
      subtitle: "Neuer Befestigungspunkt im Norden",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16626",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14045",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16626",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16626",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },

    {
      id: 16850,
      date: "2018-04-06T14:12:27",
      date_gmt: "2018-04-06T12:12:27",
      guid: {
        rendered: "https://www.art-invest.de/projekt/primark-kiel/",
      },
      modified: "2020-07-14T11:48:45",
      modified_gmt: "2020-07-14T11:48:45",
      slug: "primark-kiel",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/primark-kiel/",
      title: {
        rendered: "Primark",
      },
      featured_media: 16852,
      template: "",
      projekt_filter: [426, 425, 245],
      acf: {
        highlight_image: 16852,
        highlight_title_project: "Primark",
        highlight_subtitle_project: "Einkaufserlebnis am neuen Ort",
        highlight_description_project:
          "The city centre of Kiel has received a four-storey retail building, which will catch the eye with its attractive facade architecture. In a prime location at Berliner Platz, it will be integrated into the future Kleiner Kiel Kanal promenade.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Development",
        location:
          " Andreas-Gayk-Straße 2, 24103 Kiel; Berliner Platz, city centre",
        property: "2,109 m²",
        area: "",
        zertifizierung: "",
        parcels: "",
        use_for: "Retail",
        acquired: "Q4 2017",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Kiel",
        fakten: [
          {
            bezeichnung: "Design",
            wert: "msp Architekten GmbH (Facade: Wegener Architekten BDA)",
            anchor: "",
          },
        ],
        specifications_image_projects: 16851,
        slider: null,
        title_details_projects: "PRIMARK IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Berliner Platz shines in a new look",
            description_repeater_details:
              "Following the demolition of the aging Woolworth building, a showpiece property is being built on the corner of Andreas-Gayk-Strasse and Berliner Platz, which will fit perfectly into the new cityscape. The modern exterior architecture in the interplay of concrete, aluminium and glass skilfully sets the stage for the new building's curved facade.",
            image_repeater_details: 16851,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Young fashion lures customers to the city centre",
            description_repeater_details:
              "With Primark, a modern clothing company is moving to Berliner Platz that appeals especially to the younger generation under 30. The Kiel city centre not only experiences an expansion of the shopping offer by the settlement of the international group, but also a clear increase in attractiveness.",
            image_repeater_details: 16852,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Central location at the Kiel hotspot",
            description_repeater_details:
              "The new department store is located in a prime downtown location on the emerging Kleiner Kiel Kanal promenade and Holstenstrasse, the city's most popular shopping street. Cafés, bars and restaurants are in the immediate vicinity. The Schwedenkai is also within walking distance in a few minutes.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Andreas-Gayk-Straße 2, Kiel, Deutschland",
          lat: 54.3211854,
          lng: 10.13656919999994,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Primark</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/primark-kiel/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Primark" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/primark-kiel/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-14T11:48:45+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2018/04/projekt-primark-kiel-preview-1.jpg" />\n\t<meta property="og:image:width" content="680" />\n\t<meta property="og:image:height" content="680" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/primark-kiel/","url":"https://www.art-invest.de/en/projekt/primark-kiel/","name":"Art-Invest Real Estate | Primark","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2018-04-06T12:12:27+00:00","dateModified":"2020-07-14T11:48:45+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/primark-kiel/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/primark-kiel/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/primark-kiel/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Primark"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Primark",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/primark-kiel/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Primark",
        og_url: "https://www.art-invest.de/en/projekt/primark-kiel/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-14T11:48:45+00:00",
        og_image: [
          {
            width: 680,
            height: 680,
            url: "https://www.art-invest.de/wp-content/uploads/2018/04/projekt-primark-kiel-preview-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/primark-kiel/",
              url: "https://www.art-invest.de/en/projekt/primark-kiel/",
              name: "Art-Invest Real Estate | Primark",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2018-04-06T12:12:27+00:00",
              dateModified: "2020-07-14T11:48:45+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/primark-kiel/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/primark-kiel/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/primark-kiel/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Primark",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2018/04/projekt-primark-kiel-preview-1.jpg",
      place: "Kiel",
      subtitle: "Einkaufserlebnis am neuen Ort",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16850",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16852",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16850",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16850",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21605,
      date: "2015-01-13T12:00:04",
      date_gmt: "2015-01-13T11:00:04",
      guid: {
        rendered: "https://www.art-invest.de/projekt/take-off/",
      },
      modified: "2022-10-20T11:14:12",
      modified_gmt: "2022-10-20T09:14:12",
      slug: "take-off",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/take-off/",
      title: {
        rendered: "Take-Off",
      },
      featured_media: 21607,
      template: "",
      projekt_filter: [246, 426, 249, 425],
      acf: {
        highlight_image: 21607,
        highlight_title_project: "Take-Off",
        highlight_subtitle_project: "Feng Shui as a base",
        highlight_description_project:
          'An unusual space to take off can be found in Munich\'s trade fair city of Riem. The seven-story office and retail building was built according to Feng Shui guidelines and carries the promise in its name: the "Take-Off" is an address that is as harmonious as it is dynamic, right next to the trade fair lake.',
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment / Project development",
        location:
          "Joseph-Wild-Strasse 20, 81829 Munich; Olof-Palme-Strasse; in an attractive and convenient location near Munich's New Trade Fair Centre.",
        property: "3,800 sqm",
        area: "13,000 sqm",
        zertifizierung: "",
        parcels: "118",
        use_for: "Office, Warehouse",
        acquired: "2012",
        realization: "2013",
        sale: "2013",
        architecture_firm: "Goetz Hootz Castorph Architekten",
        place: "Munich",
        fakten: null,
        specifications_image_projects: 21610,
        slider: [21606],
        title_details_projects: "TAKE-OFF IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Feng Shui as a base",
            description_repeater_details:
              "When a building opens to the east or a fountain forms the heart of a circular entrance, Feng Shui is leading the way in construction. The green roof terrace is the most obvious signal of the formative exchange between outside and inside. The entire building is committed to the principle of spatial harmony in each of its 5,642 sqm. This also includes the responsible use of energy resources, such as the use of groundwater for air conditioning.",
            image_repeater_details: 21608,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "The House by the Lake",
            description_repeater_details:
              "This modern and sustainability-certified property is located in an attractive and convenient location at Munich's New Trade Fair Centre, which expanded its buildings in 2016 and, at 200,000 sqm, will in future be half the size of the Theresienwiese. The trade fair lake in front of the door is an oasis, partly overgrown with picturesque reeds, in summer adorned by water fountains. The underground car park has parking spaces for 120 cars.",
            image_repeater_details: 21606,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Joseph-Wild-Straße 20, 81829 München, Deutschland",
          lat: 48.13561198259172,
          lng: 11.690047818554717,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Take-Off</title>\n<meta name="description" content="Das siebengeschossige Büro- und Einzelhandelsgebäude &quot;Take-Off&quot; wurde nach Feng-Shui Richtlinien gebaut und liegt so harmonisch wie dynamisch am Messe-See." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/take-off/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Take-Off" />\n<meta property="og:description" content="Das siebengeschossige Büro- und Einzelhandelsgebäude &quot;Take-Off&quot; wurde nach Feng-Shui Richtlinien gebaut und liegt so harmonisch wie dynamisch am Messe-See." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/take-off/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-20T09:14:12+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/TakeOff_Olof-Palme-Strasse-e1480419547975-1.jpg" />\n\t<meta property="og:image:width" content="1315" />\n\t<meta property="og:image:height" content="1315" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/take-off/","url":"https://www.art-invest.de/en/projekt/take-off/","name":"Art-Invest Real Estate | Take-Off","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2015-01-13T11:00:04+00:00","dateModified":"2022-10-20T09:14:12+00:00","description":"Das siebengeschossige Büro- und Einzelhandelsgebäude \\"Take-Off\\" wurde nach Feng-Shui Richtlinien gebaut und liegt so harmonisch wie dynamisch am Messe-See.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/take-off/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/take-off/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/take-off/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Take-Off"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Take-Off",
        description:
          'Das siebengeschossige Büro- und Einzelhandelsgebäude "Take-Off" wurde nach Feng-Shui Richtlinien gebaut und liegt so harmonisch wie dynamisch am Messe-See.',
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/take-off/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Take-Off",
        og_description:
          'Das siebengeschossige Büro- und Einzelhandelsgebäude "Take-Off" wurde nach Feng-Shui Richtlinien gebaut und liegt so harmonisch wie dynamisch am Messe-See.',
        og_url: "https://www.art-invest.de/en/projekt/take-off/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-20T09:14:12+00:00",
        og_image: [
          {
            width: 1315,
            height: 1315,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/TakeOff_Olof-Palme-Strasse-e1480419547975-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/take-off/",
              url: "https://www.art-invest.de/en/projekt/take-off/",
              name: "Art-Invest Real Estate | Take-Off",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2015-01-13T11:00:04+00:00",
              dateModified: "2022-10-20T09:14:12+00:00",
              description:
                'Das siebengeschossige Büro- und Einzelhandelsgebäude "Take-Off" wurde nach Feng-Shui Richtlinien gebaut und liegt so harmonisch wie dynamisch am Messe-See.',
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/take-off/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/take-off/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/take-off/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Take-Off",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/TakeOff_Olof-Palme-Strasse-e1480419547975-1.jpg",
      place: "München",
      subtitle: "Feng Shui as a base",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21605",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21606",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21607",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21605",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21605",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21611,
      date: "2014-12-30T12:00:51",
      date_gmt: "2014-12-30T11:00:51",
      guid: {
        rendered: "https://www.art-invest.de/projekt/carre-fuerther-freiheit/",
      },
      modified: "2022-10-20T11:23:50",
      modified_gmt: "2022-10-20T09:23:50",
      slug: "carre-fuerther-freiheit",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/carre-fuerther-freiheit/",
      title: {
        rendered: "CARRÉ Fürther Freiheit",
      },
      featured_media: 21612,
      template: "",
      projekt_filter: [246, 426, 425, 245, 263],
      acf: {
        highlight_image: 21612,
        highlight_title_project: "CARRÉ Fürther Freiheit",
        highlight_subtitle_project: "Einkaufen in lockerer Atmosphäre",
        highlight_description_project:
          "The former department store is transformed into a modern commercial building with a bright and timeless natural stone facade that integrates into the surrounding inner-city structure - a bridge between modern architecture and the city's historical roots.",
        highlight_logo_project: 21614,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment",
        location:
          "Fürther Freiheit 8-10, Gustav-Schickedanz-Strasse 2, 90762 Fürth; downtown location north of the main train station, prominent corner location directly on Fürther Freiheit.",
        property: "6,600 sqm",
        area: "16,700 sqm",
        zertifizierung: "",
        parcels: "333",
        use_for: "Office, Retail, Medical Office, Parking",
        acquired: "2014",
        realization: "Year built: 1977, Extensive refurbishments 2016",
        sale: "",
        architecture_firm: "",
        place: "Fürth",
        fakten: null,
        specifications_image_projects: 21613,
        slider: [21612],
        title_details_projects: "CARRÉ FÜRTHER FREIHEIT IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Einkaufen in lockerer Atmosphäre",
            description_repeater_details:
              "In the future, high glass windows on the first and second floor will guide the light and the customers' views onto the entrance facade. A total of 600 sqm of window frontage around the building provide a pleasantly light atmosphere on the 15,000 sqm of floor space.",
            image_repeater_details: 21613,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Flexible freedom",
            description_repeater_details:
              "The CARRÉ Fürther Freiheit offers 10,600 sqm of retail space. In addition to 700 sqm of office, services such as doctor and fitness find flexible room on 3,200 sqm. The parking garage will be expanded to 333 spaces with the renovation.",
            image_repeater_details: 21612,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address:
            "Fürther Freiheit 8-10, Gustav-Schickedanz-Straße 2, 90762 Fürth",
          lat: 49.47144,
          lng: 10.990959999999973,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | CARRÉ Fürther Freiheit</title>\n<meta name="description" content="Aus dem ehemaligen Kaufhaus wird ein modernes Geschäftshaus mit heller Natursteinfassade, das auf 16.700 m² Einzelhandel, Office und Dienstleistung bietet." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/carre-fuerther-freiheit/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | CARRÉ Fürther Freiheit" />\n<meta property="og:description" content="Aus dem ehemaligen Kaufhaus wird ein modernes Geschäftshaus mit heller Natursteinfassade, das auf 16.700 m² Einzelhandel, Office und Dienstleistung bietet." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/carre-fuerther-freiheit/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-20T09:23:50+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2014/12/Carre-Fuerth-Nacht-9-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1773" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/carre-fuerther-freiheit/","url":"https://www.art-invest.de/en/projekt/carre-fuerther-freiheit/","name":"Art-Invest Real Estate | CARRÉ Fürther Freiheit","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-12-30T11:00:51+00:00","dateModified":"2022-10-20T09:23:50+00:00","description":"Aus dem ehemaligen Kaufhaus wird ein modernes Geschäftshaus mit heller Natursteinfassade, das auf 16.700 m² Einzelhandel, Office und Dienstleistung bietet.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/carre-fuerther-freiheit/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/carre-fuerther-freiheit/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/carre-fuerther-freiheit/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"CARRÉ Fürther Freiheit"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | CARRÉ Fürther Freiheit",
        description:
          "Aus dem ehemaligen Kaufhaus wird ein modernes Geschäftshaus mit heller Natursteinfassade, das auf 16.700 m² Einzelhandel, Office und Dienstleistung bietet.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/carre-fuerther-freiheit/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | CARRÉ Fürther Freiheit",
        og_description:
          "Aus dem ehemaligen Kaufhaus wird ein modernes Geschäftshaus mit heller Natursteinfassade, das auf 16.700 m² Einzelhandel, Office und Dienstleistung bietet.",
        og_url: "https://www.art-invest.de/en/projekt/carre-fuerther-freiheit/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-20T09:23:50+00:00",
        og_image: [
          {
            width: 2560,
            height: 1773,
            url: "https://www.art-invest.de/wp-content/uploads/2014/12/Carre-Fuerth-Nacht-9-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/carre-fuerther-freiheit/",
              url: "https://www.art-invest.de/en/projekt/carre-fuerther-freiheit/",
              name: "Art-Invest Real Estate | CARRÉ Fürther Freiheit",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-12-30T11:00:51+00:00",
              dateModified: "2022-10-20T09:23:50+00:00",
              description:
                "Aus dem ehemaligen Kaufhaus wird ein modernes Geschäftshaus mit heller Natursteinfassade, das auf 16.700 m² Einzelhandel, Office und Dienstleistung bietet.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/carre-fuerther-freiheit/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/carre-fuerther-freiheit/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/carre-fuerther-freiheit/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "CARRÉ Fürther Freiheit",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2014/12/Carre-Fuerth-Nacht-9-1-scaled-800x800.jpg",
      place: "Fürth",
      subtitle: "Einkaufen in lockerer Atmosphäre",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21611",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21612",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21612",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21611",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21611",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16904,
      date: "2019-03-07T11:03:31",
      date_gmt: "2019-03-07T10:03:31",
      guid: {
        rendered: "https://www.art-invest.de/projekt/adlerstrasse/",
      },
      modified: "2023-08-31T14:02:11",
      modified_gmt: "2023-08-31T12:02:11",
      slug: "wehrhahn_spitze",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/wehrhahn_spitze/",
      title: {
        rendered: "Wehrhahn Spitze",
      },
      featured_media: 16906,
      template: "",
      projekt_filter: [246, 427, 425, 257],
      acf: {
        highlight_image: 16905,
        highlight_title_project: "Wehrhahn Spitze",
        highlight_subtitle_project: "Hochwertige Büroimmobilie",
        highlight_description_project:
          "The tenants of the building benefit from the good infrastructure and the versatility of the urban district.",
        highlight_logo_project: 25345,
        website_projects: "",
        external_projectpage: "",
        available_space: {
          title: "zum Flächenangebot",
          url: "https://www.aire-mag.com/de/flaechen/wehrhahn_spitze",
          target: "_blank",
        },
        project: "Investment",
        location: "Adlerstraße 72-74 / Schirmerstraße 71, 40211 Dusseldorf",
        property: "2,661 m²",
        area: "approx. 9,511 m²",
        zertifizierung: "",
        parcels: "",
        use_for: "Office",
        acquired: "Q3 2018",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Düsseldorf",
        fakten: null,
        specifications_image_projects: 9039,
        slider: null,
        title_details_projects: "WEHRHAHN SPITZE IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              "Three-winged office building in new splendor",
            description_repeater_details:
              "The property, which is centrally located in Düsseldorf at the corner of Adlerstrasse and Schirmerstrasse, was acquired in the summer of 2018 and has been fully refurbished and strategically repositioned on the market. The office building, which was built in 1987, catches the eye with its special shape: three wings, each with seven floors, are grouped around a beautiful inner courtyard on an area of 2,661 m². Architecturally, the building offers classic brick elements connected by large glass facades. The property has office space on 8,775 m² of rental space. A total of 164 parking spaces are available to employees on two floors.",
            image_repeater_details: 9039,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Versatilely appealing: Pempelfort",
            description_repeater_details:
              "Pempelfort is a popular, cosmopolitan and multifaceted district of Dusseldorf, bordering both the Rhine and the city centre and known for its cultural institutions and historical buildings, such as the Schloss Jägerhof. The tenants of the office building enjoy a wide range of leisure options with numerous gastronomic facilities, various shopping facilities and large parks in the surrounding area.",
            image_repeater_details: 9041,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "",
          lat: 51.23001818626793,
          lng: 6.795614760079957,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Wehrhahn Spitze</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/wehrhahn_spitze/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Wehrhahn Spitze" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/wehrhahn_spitze/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2023-08-31T12:02:11+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2019/03/ssf_1901_ART-Invest-Schirmerstraße_04-2.jpg" />\n\t<meta property="og:image:width" content="2500" />\n\t<meta property="og:image:height" content="1786" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/wehrhahn_spitze/","url":"https://www.art-invest.de/en/projekt/wehrhahn_spitze/","name":"Art-Invest Real Estate | Wehrhahn Spitze","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2019-03-07T10:03:31+00:00","dateModified":"2023-08-31T12:02:11+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/wehrhahn_spitze/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/wehrhahn_spitze/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/wehrhahn_spitze/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Wehrhahn Spitze"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Wehrhahn Spitze",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/wehrhahn_spitze/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Wehrhahn Spitze",
        og_url: "https://www.art-invest.de/en/projekt/wehrhahn_spitze/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2023-08-31T12:02:11+00:00",
        og_image: [
          {
            width: 2500,
            height: 1786,
            url: "https://www.art-invest.de/wp-content/uploads/2019/03/ssf_1901_ART-Invest-Schirmerstraße_04-2.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/wehrhahn_spitze/",
              url: "https://www.art-invest.de/en/projekt/wehrhahn_spitze/",
              name: "Art-Invest Real Estate | Wehrhahn Spitze",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2019-03-07T10:03:31+00:00",
              dateModified: "2023-08-31T12:02:11+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/wehrhahn_spitze/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/wehrhahn_spitze/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/wehrhahn_spitze/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Wehrhahn Spitze",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2019/03/ssf_1901_ART-Invest-Schirmerstraße_04-2.jpg",
      place: "Düsseldorf",
      subtitle: "Hochwertige Büroimmobilie",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16904",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16906",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16904",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16904",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16793,
      date: "2013-10-14T12:00:08",
      date_gmt: "2013-10-14T10:00:08",
      guid: {
        rendered: "https://www.art-invest.de/projekt/le-meridien-parkhotel/",
      },
      modified: "2020-07-08T13:31:20",
      modified_gmt: "2020-07-08T13:31:20",
      slug: "le-meridien-parkhotel",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/le-meridien-parkhotel/",
      title: {
        rendered: "Le Méridien Parkhotel",
      },
      featured_media: 14543,
      template: "",
      projekt_filter: [426, 251, 425, 255],
      acf: {
        highlight_image: 14543,
        highlight_title_project: "Le Méridien Parkhotel",
        highlight_subtitle_project: "Mythos trifft Moderne",
        highlight_description_project:
          "The Belle Époque is again a guest at Frankfurt's traditional hotel Le Méridien Parkhotel. The completely modernized institution cultivates first-class hotel services in 300 rooms and suites – for the highest demands of both new and old school. Whoever stays at the Wiesenhüttenplatz breathes the historical flair of the turn of the century – distinguished with a very modern 5-star rating.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project:
          "Acquisition from property insolvency, Restructuring, Renovation",
        location:
          "Wiesenhüttenplatz 28-38, 60329 Frankfurt am Main; directly at the main station",
        property: "4,405 m²",
        area: "18,580 m², 300 rooms",
        zertifizierung: "",
        parcels:
          "54 outdoor and underground parking spaces in its own underground car park",
        use_for: "5*-Business Hotel",
        acquired: "Q1 2015",
        realization: "",
        sale: "Q4 2017",
        architecture_firm: "",
        place: "Frankfurt",
        fakten: [
          {
            bezeichnung: "Built in",
            wert: "1905 or rather 1970",
            anchor: "",
          },
          {
            bezeichnung: "Completion",
            wert: "2017",
            anchor: "",
          },
          {
            bezeichnung: "Interior Design",
            wert: "Designer’s House GmbH",
            anchor: "",
          },
        ],
        specifications_image_projects: 14544,
        slider: null,
        title_details_projects: "LE MÉRIDIEN PARKHOTEL IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Mythos trifft Moderne",
            description_repeater_details:
              "Under the roof of the historic old building, modern design and historical heritage from more than 100 years of grand hotel business contrast with each other. 77 of the 300 hotel rooms and suites are located in the historic palace and are designed in the Art Nouveau style of the Belle Époque. The modern business area has conference rooms with the newest equipment in addition to other rooms.",
            image_repeater_details: 16794,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Sophisticated hotel in central location",
            description_repeater_details:
              "In the pulsating district of the railway station, the hotel is so centrally located and at the same time so isolated – just around the corner from Frankfurt Central Station is the Wiesenhüttenplatz, an urban idyll in the heart of the city. From here, the sights are within walking distance, same as the trade fair grounds and the banking district. In only 15 minutes you are at the airport and a little later in the air.",
            image_repeater_details: 14543,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Equipment à la carte",
            description_repeater_details:
              "In addition to a spacious conference area with twelve ultra-modern conference rooms, the hotel offers a bar, a modern fitness and wellness area, an underground car park and a first-class restaurant with an outdoor terrace on an area of 18,500 m². Paul Bocuse revolutionized the culinary map of the Republic from here, when he made nouvelle cuisine palatable to the Germans with the legendary Truffle Soup au Président Giscard D'Estaing.",
            image_repeater_details: 16795,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Wiesenhüttenplatz 28-38, Frankfurt am Main",
          lat: 50.10558,
          lng: 8.666600000000017,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Le Méridien Parkhotel</title>\n<meta name="description" content="Das La Méridien kultiviert in 300 Zimmern und Suiten erstklassige Hotellerie - ausgezeichnet mit einem sehr modernen 5-Sterne Prädikat." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/le-meridien-parkhotel/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Le Méridien Parkhotel" />\n<meta property="og:description" content="Das La Méridien kultiviert in 300 Zimmern und Suiten erstklassige Hotellerie - ausgezeichnet mit einem sehr modernen 5-Sterne Prädikat." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/le-meridien-parkhotel/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-08T13:31:20+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/FFM_Le_Meridien_aussen_TEASER-1.jpg" />\n\t<meta property="og:image:width" content="994" />\n\t<meta property="og:image:height" content="994" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/le-meridien-parkhotel/","url":"https://www.art-invest.de/en/projekt/le-meridien-parkhotel/","name":"Art-Invest Real Estate | Le Méridien Parkhotel","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2013-10-14T10:00:08+00:00","dateModified":"2020-07-08T13:31:20+00:00","description":"Das La Méridien kultiviert in 300 Zimmern und Suiten erstklassige Hotellerie - ausgezeichnet mit einem sehr modernen 5-Sterne Prädikat.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/le-meridien-parkhotel/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/le-meridien-parkhotel/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/le-meridien-parkhotel/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Le Méridien Parkhotel"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Le Méridien Parkhotel",
        description:
          "Das La Méridien kultiviert in 300 Zimmern und Suiten erstklassige Hotellerie - ausgezeichnet mit einem sehr modernen 5-Sterne Prädikat.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/le-meridien-parkhotel/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Le Méridien Parkhotel",
        og_description:
          "Das La Méridien kultiviert in 300 Zimmern und Suiten erstklassige Hotellerie - ausgezeichnet mit einem sehr modernen 5-Sterne Prädikat.",
        og_url: "https://www.art-invest.de/en/projekt/le-meridien-parkhotel/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-08T13:31:20+00:00",
        og_image: [
          {
            width: 994,
            height: 994,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/FFM_Le_Meridien_aussen_TEASER-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/le-meridien-parkhotel/",
              url: "https://www.art-invest.de/en/projekt/le-meridien-parkhotel/",
              name: "Art-Invest Real Estate | Le Méridien Parkhotel",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2013-10-14T10:00:08+00:00",
              dateModified: "2020-07-08T13:31:20+00:00",
              description:
                "Das La Méridien kultiviert in 300 Zimmern und Suiten erstklassige Hotellerie - ausgezeichnet mit einem sehr modernen 5-Sterne Prädikat.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/le-meridien-parkhotel/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/le-meridien-parkhotel/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/le-meridien-parkhotel/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Le Méridien Parkhotel",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/FFM_Le_Meridien_aussen_TEASER-1.jpg",
      place: "Frankfurt",
      subtitle: "Mythos trifft Moderne",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16793",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14543",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16793",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16793",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16826,
      date: "2015-04-07T12:00:22",
      date_gmt: "2015-04-07T10:00:22",
      guid: {
        rendered: "https://www.art-invest.de/projekt/trianon/",
      },
      modified: "2021-11-04T18:13:19",
      modified_gmt: "2021-11-04T17:13:19",
      slug: "trianon",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/trianon/",
      title: {
        rendered: "Trianon",
      },
      featured_media: 16827,
      template: "",
      projekt_filter: [246, 426, 425, 255],
      acf: {
        highlight_image: 16827,
        highlight_title_project: "Trianon",
        highlight_subtitle_project: "Der Diamant von Frankfurt",
        highlight_description_project:
          "The Trianon skyscraper spirals 47 floors into the Frankfurt sky – and with 186 meters it is the sixth tallest office building in Germany. In 1990, the urban planner and architect Albert Speer provided the design for the spectacular building, which is not only architecturally outstanding but also functional.",
        highlight_logo_project: null,
        website_projects: {
          title: "www.trianon-frankfurt.de",
          url: "http://trianon-frankfurt.de/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "http://trianon-frankfurt.de/",
          target: "_blank",
        },
        available_space: [""],
        project: "Refurbishment and Lobby Refurbishment",
        location: "Mainzer Landstrasse 16, 60325 Frankfurt am Main",
        property: "7,153 m²",
        area: "approx. 66,000 m²",
        zertifizierung: "",
        parcels: "588",
        use_for: "Office, Service",
        acquired: "2012",
        realization: "Built in 1993 - Lobby Refurbishment in 2014",
        sale: "2015",
        architecture_firm:
          "Design Architekten HPP, Novotny Mähner Assoz. - Lobby Refurbishment Hollin + Radoske Architekten",
        place: "Frankfurt",
        fakten: null,
        specifications_image_projects: 16830,
        slider: null,
        title_details_projects: "TRIANON IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Der Diamant von Frankfurt",
            description_repeater_details:
              "On the property of 7,137 m², three triangular areas of different sizes join together to form the layout of the Trianon. They form the three-sided, prismatic structure, of which the corners are accentuated by towers. The diamond, an inverted glass pyramid on the roof, provides the sculptural building block that makes the building an icon.",
            image_repeater_details: 16829,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Amidst global players",
            description_repeater_details:
              "The Trianon is one of the top business addresses in the banking district – numerous national and international headquarters of various financial institutions find their address here. The twin towers of the Deutsche Bank are the closest neighbors, the Alte Oper is only a few minutes' walk away. The connection via public and private transport and 588 parking spaces make Mainzer Landstraße 16 an excellently accessible address.",
            image_repeater_details: 16828,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Working in a triangle",
            description_repeater_details:
              "The unique, triangular floor plan gives the building its special appearance on the outside and allows maximum space efficiency on the inside. Every business finds the right space on the standard floors of approx. 1,350 m²: from representative individual offices with a view to modern and flexible combination offices to communicative open-space offices. In addition, the Trianon sets standards for sustainability, energy efficiency and indoor climate on each of its 66,000 m² of floor space.",
            image_repeater_details: 14547,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Mainzer Landstrasse 16, 60325 Frnkfurt am Main",
          lat: 50.1124174,
          lng: 8.666874099999973,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Trianon</title>\n<meta name="description" content="Das Trianon-Hochhaus schraubt sich 47 Stockwerke in den Frankfurter Himmel - und ist mit seinen 186 Metern das sechsthöchste Bürogebäude in Deutschland." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/trianon/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Trianon" />\n<meta property="og:description" content="Das Trianon-Hochhaus schraubt sich 47 Stockwerke in den Frankfurter Himmel - und ist mit seinen 186 Metern das sechsthöchste Bürogebäude in Deutschland." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/trianon/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T17:13:19+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/FFM_Trianon_Frontansicht_Teaser-e1479814589346-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="2560" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/trianon/","url":"https://www.art-invest.de/en/projekt/trianon/","name":"Art-Invest Real Estate | Trianon","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2015-04-07T10:00:22+00:00","dateModified":"2021-11-04T17:13:19+00:00","description":"Das Trianon-Hochhaus schraubt sich 47 Stockwerke in den Frankfurter Himmel - und ist mit seinen 186 Metern das sechsthöchste Bürogebäude in Deutschland.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/trianon/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/trianon/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/trianon/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Trianon"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Trianon",
        description:
          "Das Trianon-Hochhaus schraubt sich 47 Stockwerke in den Frankfurter Himmel - und ist mit seinen 186 Metern das sechsthöchste Bürogebäude in Deutschland.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/trianon/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Trianon",
        og_description:
          "Das Trianon-Hochhaus schraubt sich 47 Stockwerke in den Frankfurter Himmel - und ist mit seinen 186 Metern das sechsthöchste Bürogebäude in Deutschland.",
        og_url: "https://www.art-invest.de/en/projekt/trianon/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T17:13:19+00:00",
        og_image: [
          {
            width: 2560,
            height: 2560,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/FFM_Trianon_Frontansicht_Teaser-e1479814589346-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/trianon/",
              url: "https://www.art-invest.de/en/projekt/trianon/",
              name: "Art-Invest Real Estate | Trianon",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2015-04-07T10:00:22+00:00",
              dateModified: "2021-11-04T17:13:19+00:00",
              description:
                "Das Trianon-Hochhaus schraubt sich 47 Stockwerke in den Frankfurter Himmel - und ist mit seinen 186 Metern das sechsthöchste Bürogebäude in Deutschland.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/trianon/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/trianon/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/trianon/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Trianon",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/FFM_Trianon_Frontansicht_Teaser-e1479814589346-1-scaled.jpg",
      place: "Frankfurt",
      subtitle: "Der Diamant von Frankfurt",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16826",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16827",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16826",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16826",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21622,
      date: "2014-03-11T12:00:03",
      date_gmt: "2014-03-11T11:00:03",
      guid: {
        rendered: "https://www.art-invest.de/projekt/helmut-schmidt-haus/",
      },
      modified: "2022-10-20T11:46:12",
      modified_gmt: "2022-10-20T09:46:12",
      slug: "helmut-schmidt-haus",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/helmut-schmidt-haus/",
      title: {
        rendered: "Helmut-Schmidt-Haus",
      },
      featured_media: 14553,
      template: "",
      projekt_filter: [246, 426, 248, 425, 245],
      acf: {
        highlight_image: 14553,
        highlight_title_project: "Helmut-Schmidt-Haus",
        highlight_subtitle_project: "Das Haus in den Schlagzeilen",
        highlight_description_project:
          "How do you modernize an opinion leader? In the Helmut Schmidt House, the former Pressehaus, at times as many as three news magazines delivered the headlines that moved the entire country. Today, the newspaper industry is in the midst of a transformation that the building at Speersort has already successfully completed.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Inventory development - Manage-To-Core",
        location: "Speersort 1, 20095 Hamburg; city center (Domplatz), Germany",
        property: "",
        area: "19,400 sqm (75% office / 17% retail / gastro / 8% warehouse)",
        zertifizierung: "",
        parcels: "70",
        use_for: "Office, Restaurant, Retail, Warehouse",
        acquired: "Q1 2013",
        realization: "",
        sale: "Buyer: SwissRe",
        architecture_firm: "LH-Architekten / Matthias-Arndt Architekten",
        place: "Hamburg",
        fakten: null,
        specifications_image_projects: 14552,
        slider: [14552, 14553],
        title_details_projects: "HELMUT-SCHMIDT-HAUS IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Das Haus in den Schlagzeilen",
            description_repeater_details:
              "In harmony with the historic buildings, the arcade gallery facing the street was closed and new space was created. In addition to a high-quality extension of the office space, the entrance areas, staircases and elevator systems were upgraded through new design. Today, the spacious roof terrace offers a perfect view of Hamburg's press landscape.",
            image_repeater_details: 14553,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "The material for the first page",
            description_repeater_details:
              '"You need willpower - and cigarettes." For Helmut Schmidt, both were crucial to good press relations. Since 1946, the Pressehaus has been the traditional home of ZEIT Verlag, the property\'s main tenant. But long before the former chancellor began his second career as an editor here, Marion Gräfin Dönhoff, Rudolf Augstein and Henri Nannen fought over opinions and circulations in the clinker brick building.',
            image_repeater_details: 14552,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Walking with the ZEIT",
            description_repeater_details:
              "The historic building is located at the entrance to Hamburg's Kontorhausviertel district, a UNESCO World Heritage Site. It is just a few minutes' walk from the Mönckebergstrasse shopping boulevard and the city hall. The modernization of the building, which has space for 18,962 m² of usable space, is being carried out in accordance with the requirements of historic preservation. After Schmidt's death in 2015, the traditional press address was renamed Helmut Schmidt House.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Speersort 1, Hamburg",
          lat: 53.5495575,
          lng: 9.998602600000027,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Helmut-Schmidt-Haus</title>\n<meta name="description" content="Im Hamburger Pressehaus lieferten zeitweise gleich drei Nachrichtenmagazine die Schlagzeilen, die ganz Deutschland bewegten." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/helmut-schmidt-haus/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Helmut-Schmidt-Haus" />\n<meta property="og:description" content="Im Hamburger Pressehaus lieferten zeitweise gleich drei Nachrichtenmagazine die Schlagzeilen, die ganz Deutschland bewegten." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/helmut-schmidt-haus/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-20T09:46:12+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/PHH_Totale_001_TEASERE-1.jpg" />\n\t<meta property="og:image:width" content="1500" />\n\t<meta property="og:image:height" content="1500" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/helmut-schmidt-haus/","url":"https://www.art-invest.de/en/projekt/helmut-schmidt-haus/","name":"Art-Invest Real Estate | Helmut-Schmidt-Haus","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-03-11T11:00:03+00:00","dateModified":"2022-10-20T09:46:12+00:00","description":"Im Hamburger Pressehaus lieferten zeitweise gleich drei Nachrichtenmagazine die Schlagzeilen, die ganz Deutschland bewegten.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/helmut-schmidt-haus/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/helmut-schmidt-haus/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/helmut-schmidt-haus/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Helmut-Schmidt-Haus"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Helmut-Schmidt-Haus",
        description:
          "Im Hamburger Pressehaus lieferten zeitweise gleich drei Nachrichtenmagazine die Schlagzeilen, die ganz Deutschland bewegten.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/helmut-schmidt-haus/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Helmut-Schmidt-Haus",
        og_description:
          "Im Hamburger Pressehaus lieferten zeitweise gleich drei Nachrichtenmagazine die Schlagzeilen, die ganz Deutschland bewegten.",
        og_url: "https://www.art-invest.de/en/projekt/helmut-schmidt-haus/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-20T09:46:12+00:00",
        og_image: [
          {
            width: 1500,
            height: 1500,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/PHH_Totale_001_TEASERE-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/helmut-schmidt-haus/",
              url: "https://www.art-invest.de/en/projekt/helmut-schmidt-haus/",
              name: "Art-Invest Real Estate | Helmut-Schmidt-Haus",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-03-11T11:00:03+00:00",
              dateModified: "2022-10-20T09:46:12+00:00",
              description:
                "Im Hamburger Pressehaus lieferten zeitweise gleich drei Nachrichtenmagazine die Schlagzeilen, die ganz Deutschland bewegten.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/helmut-schmidt-haus/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/helmut-schmidt-haus/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/helmut-schmidt-haus/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Helmut-Schmidt-Haus",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/PHH_Totale_001_TEASERE-1.jpg",
      place: "Hamburg",
      subtitle: "Das Haus in den Schlagzeilen",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21622",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14553",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14552",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/14553",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21622",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21622",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21649,
      date: "2014-11-18T12:00:02",
      date_gmt: "2014-11-18T11:00:02",
      guid: {
        rendered: "https://www.art-invest.de/projekt/barckhausstrasse/",
      },
      modified: "2022-10-25T11:56:29",
      modified_gmt: "2022-10-25T09:56:29",
      slug: "barckhausstrasse",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/barckhausstrasse/",
      title: {
        rendered: "Barckhausstraße",
      },
      featured_media: 21651,
      template: "",
      projekt_filter: [246, 426, 425, 255],
      acf: {
        highlight_image: 21651,
        highlight_title_project: "Barckhausstraße",
        highlight_subtitle_project: "Raum für Veränderungen",
        highlight_description_project:
          "A new Place to Be &amp; to Work in Frankfurt's West End: The elegant office building is a place for modern office space that can be flexibly designed to meet every need. The completely renovated building with 2,180 sqm of floor space aligns itself with Barckhausstrasse.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Refurbishment",
        location: "Barckhausstraße 1-3, 60325 Frankfurt am Main, Germany",
        property: "2,181 sqm",
        area: "5,945.56 sqm",
        zertifizierung: "",
        parcels: "74",
        use_for: "Office",
        acquired: "2012",
        realization: "1964 construction - 2010-13 refurbishment",
        sale: "2013",
        architecture_firm:
          "Erbauer Architkekt: Ignaz Jakubowitz, Frankfurt am Main, Architektur Refurbishment: Beye Scheid Architekten, Innenausbau: Angela Keiser Architekten",
        place: "Frankfurt",
        fakten: null,
        specifications_image_projects: 13308,
        slider: [21650],
        title_details_projects: "BARCKHAUSSTRAßE IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Room for change",
            description_repeater_details:
              "The rooms, which were completely refurbished between 2010 and 2013, meet all the requirements of modern working environments. Modern office space with excellent infrastructure and flexible areas for open office and modular cell work concepts can be found on approx. 6,000 sqm of rental space.",
            image_repeater_details: 21650,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Central in Frankfurt",
            description_repeater_details:
              "Frankfurt's city center with the Römer or the Zeil can be reached within a few minutes by foot thanks to the excellent connections to the Alte Oper, Rothschildpark as well as Grüneburgpark with the Botanical Garden. Via the proximity to the main station, the address offers very good connections to public transport, long-distance traffic and the freeway network. 74 underground parking spaces guarantee the accommodation.",
            image_repeater_details: 2947,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "The spectacle called Skyline",
            description_repeater_details:
              "The facade was given a complete makeover, the entrance area was redesigned and a new roof terrace with skyline views rounded out the extensive modernization.",
            image_repeater_details: 4393,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Barckhausstrasse 1, 60325 Frankfurt am Main",
          lat: 50.1159871,
          lng: 8.663860699999987,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Barckhausstraße</title>\n<meta name="description" content="Das elegante Bürohaus an der Barckhausstraße mit 2.180 m² Fläche ist ein Raum für hochmoderne Officeflächen, die sich flexibel gestalten lassen." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/barckhausstrasse/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Barckhausstraße" />\n<meta property="og:description" content="Das elegante Bürohaus an der Barckhausstraße mit 2.180 m² Fläche ist ein Raum für hochmoderne Officeflächen, die sich flexibel gestalten lassen." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/barckhausstrasse/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-25T09:56:29+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2014/11/FFM_Barckhausstraße_Außenansicht-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1707" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/barckhausstrasse/","url":"https://www.art-invest.de/en/projekt/barckhausstrasse/","name":"Art-Invest Real Estate | Barckhausstraße","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-11-18T11:00:02+00:00","dateModified":"2022-10-25T09:56:29+00:00","description":"Das elegante Bürohaus an der Barckhausstraße mit 2.180 m² Fläche ist ein Raum für hochmoderne Officeflächen, die sich flexibel gestalten lassen.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/barckhausstrasse/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/barckhausstrasse/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/barckhausstrasse/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Barckhausstraße"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Barckhausstraße",
        description:
          "Das elegante Bürohaus an der Barckhausstraße mit 2.180 m² Fläche ist ein Raum für hochmoderne Officeflächen, die sich flexibel gestalten lassen.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/barckhausstrasse/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Barckhausstraße",
        og_description:
          "Das elegante Bürohaus an der Barckhausstraße mit 2.180 m² Fläche ist ein Raum für hochmoderne Officeflächen, die sich flexibel gestalten lassen.",
        og_url: "https://www.art-invest.de/en/projekt/barckhausstrasse/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-25T09:56:29+00:00",
        og_image: [
          {
            width: 2560,
            height: 1707,
            url: "https://www.art-invest.de/wp-content/uploads/2014/11/FFM_Barckhausstraße_Außenansicht-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/barckhausstrasse/",
              url: "https://www.art-invest.de/en/projekt/barckhausstrasse/",
              name: "Art-Invest Real Estate | Barckhausstraße",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-11-18T11:00:02+00:00",
              dateModified: "2022-10-25T09:56:29+00:00",
              description:
                "Das elegante Bürohaus an der Barckhausstraße mit 2.180 m² Fläche ist ein Raum für hochmoderne Officeflächen, die sich flexibel gestalten lassen.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/barckhausstrasse/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/barckhausstrasse/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/barckhausstrasse/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Barckhausstraße",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2014/11/FFM_Barckhausstraße_Außenansicht-1-scaled-800x800.jpg",
      place: "Frankfurt",
      subtitle: "Raum für Veränderungen",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21649",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21650",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21651",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21649",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21649",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21699,
      date: "2014-05-06T12:00:23",
      date_gmt: "2014-05-06T10:00:23",
      guid: {
        rendered: "https://www.art-invest.de/projekt/mozartplatz/",
      },
      modified: "2022-10-27T11:01:52",
      modified_gmt: "2022-10-27T09:01:52",
      slug: "mozartplatz",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/mozartplatz/",
      title: {
        rendered: "Mozartplatz",
      },
      featured_media: 21701,
      template: "",
      projekt_filter: [246, 426, 425, 255],
      acf: {
        highlight_image: 15018,
        highlight_title_project: "Mozartplatz",
        highlight_subtitle_project: "Vielseitiger Resonanzraum",
        highlight_description_project:
          "Frankfurt without Mozart is unthinkable. His works were performed for the first time outside Vienna in the Alte Oper. Mozartplatz not only cultivates his memory but is also an outstanding office address on one of the most beautiful squares in the Westend.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment",
        location:
          "Mozartplatz / Bockenheimer Anlage 15, 60322 Frankfurt, Germany",
        property: "Approx. 7,730 sqm",
        area: "6,860 sqm (rental space)",
        zertifizierung: "",
        parcels: "98 (46 underground parking, 52 outside)",
        use_for: "Office",
        acquired: "March 2014",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Frankfurt",
        fakten: null,
        specifications_image_projects: 931,
        slider: [21701],
        title_details_projects: "MOZARTPLATZ IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Vielseitiger Resonanzraum",
            description_repeater_details:
              "The building complex contains approx. 6,860 sqm of usable surface area on which flexible space solutions can be set up to meet all the requirements of a modern working environment. The building's own entrance and exit lead to a total of 98 parking spaces in the underground garage and outdoor lots.",
            image_repeater_details: 2210,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Westend Impressions",
            description_repeater_details:
              "The building is located directly opposite the picturesque Bockenheimer Anlage with its pond and local recreation area. The opera and the Zeil are within walking distance. The location between the Old Opera House and the Eschenheimer Tor offers an ideal connection to public and individual transport.",
            image_repeater_details: 2823,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Great moments of history",
            description_repeater_details:
              "When Johann Wolfgang Amadeus Mozart met Johann Wolfgang von Goethe in Frankfurt in 1763, contrary to expectations, there was no cosmic bang. The two geniuses were still children - but the seven-year-old Mozart was to repeat his concert four more times. Such was the demand in the imperial city for the child star.",
            image_repeater_details: 2207,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Mozartplatz / Bockenheimer Anlage 15, 60322 Frankfurt",
          lat: 50.11748,
          lng: 8.674549999999954,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Mozartplatz</title>\n<meta name="description" content="Der Mozartplatz kultiviert nicht nur Mozarts Andenken, sondern ist auch eine herausragende Büroadresse an einem der schönsten Plätze im Frankfurter Westend." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/mozartplatz/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Mozartplatz" />\n<meta property="og:description" content="Der Mozartplatz kultiviert nicht nur Mozarts Andenken, sondern ist auch eine herausragende Büroadresse an einem der schönsten Plätze im Frankfurter Westend." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/mozartplatz/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-27T09:01:52+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/FFM_Mozartplatz_aussen_Seitenansicht_TEASER-1-1.jpg" />\n\t<meta property="og:image:width" content="1000" />\n\t<meta property="og:image:height" content="1000" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/mozartplatz/","url":"https://www.art-invest.de/en/projekt/mozartplatz/","name":"Art-Invest Real Estate | Mozartplatz","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-05-06T10:00:23+00:00","dateModified":"2022-10-27T09:01:52+00:00","description":"Der Mozartplatz kultiviert nicht nur Mozarts Andenken, sondern ist auch eine herausragende Büroadresse an einem der schönsten Plätze im Frankfurter Westend.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/mozartplatz/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/mozartplatz/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/mozartplatz/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Mozartplatz"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Mozartplatz",
        description:
          "Der Mozartplatz kultiviert nicht nur Mozarts Andenken, sondern ist auch eine herausragende Büroadresse an einem der schönsten Plätze im Frankfurter Westend.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/mozartplatz/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Mozartplatz",
        og_description:
          "Der Mozartplatz kultiviert nicht nur Mozarts Andenken, sondern ist auch eine herausragende Büroadresse an einem der schönsten Plätze im Frankfurter Westend.",
        og_url: "https://www.art-invest.de/en/projekt/mozartplatz/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-27T09:01:52+00:00",
        og_image: [
          {
            width: 1000,
            height: 1000,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/FFM_Mozartplatz_aussen_Seitenansicht_TEASER-1-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/mozartplatz/",
              url: "https://www.art-invest.de/en/projekt/mozartplatz/",
              name: "Art-Invest Real Estate | Mozartplatz",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-05-06T10:00:23+00:00",
              dateModified: "2022-10-27T09:01:52+00:00",
              description:
                "Der Mozartplatz kultiviert nicht nur Mozarts Andenken, sondern ist auch eine herausragende Büroadresse an einem der schönsten Plätze im Frankfurter Westend.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/mozartplatz/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/mozartplatz/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/mozartplatz/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Mozartplatz",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/FFM_Mozartplatz_aussen_Seitenansicht_TEASER-1-1.jpg",
      place: "Frankfurt",
      subtitle: "Vielseitiger Resonanzraum",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21699",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21701",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21701",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21699",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21699",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16804,
      date: "2013-12-31T12:00:35",
      date_gmt: "2013-12-31T11:00:35",
      guid: {
        rendered: "https://www.art-invest.de/projekt/ruby-lilly-hotel/",
      },
      modified: "2020-07-08T13:53:56",
      modified_gmt: "2020-07-08T13:53:56",
      slug: "ruby-lilly-hotel",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/ruby-lilly-hotel/",
      title: {
        rendered: "Ruby Lilly Hotel",
      },
      featured_media: 16806,
      template: "",
      projekt_filter: [426, 251, 249, 425],
      acf: {
        highlight_image: 16806,
        highlight_title_project: "Ruby Lilly Hotel",
        highlight_subtitle_project: "Wie der Zeitgeist die Nacht verbringt",
        highlight_description_project:
          "It is the first luxury hotel in Germany for uncomplicated comfort: In Munich's Maxvorstadt, the RUBY Boutique Hotel with its very own philosophy of lean luxury opened in 2017.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Re-Development ",
        location: "Dachauer Str. 37, Munich; directly at the main station",
        property: "1,993 m²",
        area: "5,828 m², 174 Zimmer",
        zertifizierung: "",
        parcels: "29 parking spaces",
        use_for:
          "Designhotel with optimal space efficiency (Limited Service / Lean Luxury)",
        acquired: "Q1 2016",
        realization: "1974, Re-Development in 2016",
        sale: "",
        architecture_firm: "Ruby Hotels & Resorts",
        place: "München",
        fakten: null,
        specifications_image_projects: 16809,
        slider: null,
        title_details_projects: "RUBY LILLY HOTEL IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              "How the spirit of the times stays overnight",
            description_repeater_details:
              '"Being connected, sleeping, freshening up" – these are the essential requirements for an overnight stay according to the Munich hoteliers today. Accordingly, a RUBY hotel separates the essential from the unessential and creates a high-quality and affordable form of accommodation through lean organization and the waiver of a minibar and other props.',
            image_repeater_details: 16807,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Live streaming from the Isar",
            description_repeater_details:
              "The Viennese houses RUBY Sofie and RUBY Marie are the role model for the six-storey building in Munich's first city centre location. In addition to the luxurious 174 rooms the hotel has a café, a bar, a lounge – and its own Internet radio station: RUBY Radio streams stylish music into every room and around the world.",
            image_repeater_details: 16805,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "The luxury of short distances",
            description_repeater_details:
              "The new Munich RUBY House on Stiglmaierplatz not only has excellent connections to the public transport network, it also has its own mobility concept: RUBY Bikes. The Königplatz underground station is within walking distance, from where all the sights of the Isar metropolis can be reached.",
            image_repeater_details: 16806,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Dachauer Str. 37, München, Deutschland",
          lat: 48.1461495,
          lng: 11.559042699999964,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Ruby Lilly Hotel</title>\n<meta name="description" content="Das erste Luxushotel in Deutschland für unkomplizierten Komfort: In der Münchner Maxvorstadt eröffnet 2017 das RUBY Boutique Hotel." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/ruby-lilly-hotel/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Ruby Lilly Hotel" />\n<meta property="og:description" content="Das erste Luxushotel in Deutschland für unkomplizierten Komfort: In der Münchner Maxvorstadt eröffnet 2017 das RUBY Boutique Hotel." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/ruby-lilly-hotel/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-08T13:53:56+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/MUC_Ruby_Hotel_aussen_TEASER-Kopie-1.jpg" />\n\t<meta property="og:image:width" content="2223" />\n\t<meta property="og:image:height" content="2223" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/ruby-lilly-hotel/","url":"https://www.art-invest.de/en/projekt/ruby-lilly-hotel/","name":"Art-Invest Real Estate | Ruby Lilly Hotel","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2013-12-31T11:00:35+00:00","dateModified":"2020-07-08T13:53:56+00:00","description":"Das erste Luxushotel in Deutschland für unkomplizierten Komfort: In der Münchner Maxvorstadt eröffnet 2017 das RUBY Boutique Hotel.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/ruby-lilly-hotel/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/ruby-lilly-hotel/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/ruby-lilly-hotel/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Ruby Lilly Hotel"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Ruby Lilly Hotel",
        description:
          "Das erste Luxushotel in Deutschland für unkomplizierten Komfort: In der Münchner Maxvorstadt eröffnet 2017 das RUBY Boutique Hotel.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/ruby-lilly-hotel/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Ruby Lilly Hotel",
        og_description:
          "Das erste Luxushotel in Deutschland für unkomplizierten Komfort: In der Münchner Maxvorstadt eröffnet 2017 das RUBY Boutique Hotel.",
        og_url: "https://www.art-invest.de/en/projekt/ruby-lilly-hotel/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-08T13:53:56+00:00",
        og_image: [
          {
            width: 2223,
            height: 2223,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/MUC_Ruby_Hotel_aussen_TEASER-Kopie-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/ruby-lilly-hotel/",
              url: "https://www.art-invest.de/en/projekt/ruby-lilly-hotel/",
              name: "Art-Invest Real Estate | Ruby Lilly Hotel",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2013-12-31T11:00:35+00:00",
              dateModified: "2020-07-08T13:53:56+00:00",
              description:
                "Das erste Luxushotel in Deutschland für unkomplizierten Komfort: In der Münchner Maxvorstadt eröffnet 2017 das RUBY Boutique Hotel.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/ruby-lilly-hotel/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/ruby-lilly-hotel/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/ruby-lilly-hotel/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Ruby Lilly Hotel",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/MUC_Ruby_Hotel_aussen_TEASER-Kopie-1.jpg",
      place: "München",
      subtitle: "Wie der Zeitgeist die Nacht verbringt",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16804",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16806",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16804",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16804",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21624,
      date: "2013-10-22T12:00:33",
      date_gmt: "2013-10-22T10:00:33",
      guid: {
        rendered: "https://www.art-invest.de/projekt/72west/",
      },
      modified: "2022-10-25T10:01:03",
      modified_gmt: "2022-10-25T08:01:03",
      slug: "72west",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/72west/",
      title: {
        rendered: "72West",
      },
      featured_media: 21625,
      template: "",
      projekt_filter: [246, 426, 425, 255],
      acf: {
        highlight_image: 21625,
        highlight_title_project: "72West",
        highlight_subtitle_project: "Mitten im Westend",
        highlight_description_project:
          "The office building with approx. 2,665 sqm of state-of-the-art rental space is located in the heart of Frankfurt's West End. Located directly on the central traffic axis of Bockenheimer Landstrasse, the building sets new standards for modern working in the city.",
        highlight_logo_project: null,
        website_projects: {
          title: "www.72west.de",
          url: "https://www.72west.de/",
          target: "_blank",
        },
        external_projectpage: "",
        available_space: [""],
        project: "Investment",
        location: "Bockenheimer Landstraße 72, 60323 Frankfurt, Germany",
        property: "Approx. 500 sqm",
        area: "2,665 sqm (rental space)",
        zertifizierung: "",
        parcels: "25 underground parking spaces",
        use_for: "Office",
        acquired: "Q3 2014",
        realization: "",
        sale: "Q2 2016",
        architecture_firm: "Köhler Architekten BDA, Frankfurt",
        place: "Frankfurt",
        fakten: null,
        specifications_image_projects: 13296,
        slider: [21625],
        title_details_projects: "72WEST IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: " Mitten im Westend",
            description_repeater_details:
              "The property's central location in Frankfurt's West End, its direct proximity to Frankfurt's banking district, and its excellent connections to local public and private transportation further enhance its value. 25 underground parking spaces provide parking for employees.",
            image_repeater_details: 21625,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Noble contrasts",
            description_repeater_details:
              "The modern six-story building was completely renovated in 2007 and presents itself with first-class building quality. The representative foyer impresses with an exciting contrast of black fine stone, stainless steel and wooden elements.",
            image_repeater_details: 1492,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Bockenheimer Landstraße 72, 60323 Frankfurt",
          lat: 50.1190663,
          lng: 8.660987200000022,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | 72West</title>\n<meta name="description" content="Direkt an der zentralen Verkehrsachse der Bockenheimer Landstraße bietet das Haus mit der stilbewußten Fassade auf ca. 2.665 m² modernste Mietflächen." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/72west/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | 72West" />\n<meta property="og:description" content="Direkt an der zentralen Verkehrsachse der Bockenheimer Landstraße bietet das Haus mit der stilbewußten Fassade auf ca. 2.665 m² modernste Mietflächen." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/72west/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-25T08:01:03+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/kb_72west_0412-e1480608492873-1.jpg" />\n\t<meta property="og:image:width" content="1324" />\n\t<meta property="og:image:height" content="1324" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/72west/","url":"https://www.art-invest.de/en/projekt/72west/","name":"Art-Invest Real Estate | 72West","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2013-10-22T10:00:33+00:00","dateModified":"2022-10-25T08:01:03+00:00","description":"Direkt an der zentralen Verkehrsachse der Bockenheimer Landstraße bietet das Haus mit der stilbewußten Fassade auf ca. 2.665 m² modernste Mietflächen.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/72west/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/72west/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/72west/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"72West"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | 72West",
        description:
          "Direkt an der zentralen Verkehrsachse der Bockenheimer Landstraße bietet das Haus mit der stilbewußten Fassade auf ca. 2.665 m² modernste Mietflächen.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/72west/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | 72West",
        og_description:
          "Direkt an der zentralen Verkehrsachse der Bockenheimer Landstraße bietet das Haus mit der stilbewußten Fassade auf ca. 2.665 m² modernste Mietflächen.",
        og_url: "https://www.art-invest.de/en/projekt/72west/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-25T08:01:03+00:00",
        og_image: [
          {
            width: 1324,
            height: 1324,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/kb_72west_0412-e1480608492873-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/72west/",
              url: "https://www.art-invest.de/en/projekt/72west/",
              name: "Art-Invest Real Estate | 72West",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2013-10-22T10:00:33+00:00",
              dateModified: "2022-10-25T08:01:03+00:00",
              description:
                "Direkt an der zentralen Verkehrsachse der Bockenheimer Landstraße bietet das Haus mit der stilbewußten Fassade auf ca. 2.665 m² modernste Mietflächen.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/72west/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/72west/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/72west/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "72West",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/kb_72west_0412-e1480608492873-1.jpg",
      place: "Frankfurt",
      subtitle: "Mitten im Westend",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21624",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21625",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21625",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21624",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21624",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21652,
      date: "2013-10-08T12:00:41",
      date_gmt: "2013-10-08T10:00:41",
      guid: {
        rendered: "https://www.art-invest.de/projekt/brandtelf/",
      },
      modified: "2022-10-25T12:00:53",
      modified_gmt: "2022-10-25T10:00:53",
      slug: "brandtelf",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/brandtelf/",
      title: {
        rendered: "Brandtelf",
      },
      featured_media: 21653,
      template: "",
      projekt_filter: [246, 426, 425, 263],
      acf: {
        highlight_image: 1498,
        highlight_title_project: "Brandtelf",
        highlight_subtitle_project: "Wieder alles Hochdeutsch",
        highlight_description_project:
          "The former state representation of Baden-Württemberg was once the embassy and shop window of the 'Ländle' in Bonn's government district. Today, behind the listed facade of the \"brandtelf\" lies a modern office and administration building with approx. 12,000 sqm of flexibly configurable floor space.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Project development",
        location:
          "An der Museumsmeile / Grundstückscarrée Heussallee / Willy-Brandt-Allee // Welckerstraße / Schlegelstraße",
        property: "7,700 sqm",
        area: "12,000 sqm",
        zertifizierung: "",
        parcels: "",
        use_for: "Office",
        acquired: "2011",
        realization: "2012",
        sale: "2012 / The property was sold to aik",
        architecture_firm: "Architekturbüro JÜRGENSEN & JÜRGENSEN",
        place: "Bonn",
        fakten: null,
        specifications_image_projects: 13294,
        slider: null,
        title_details_projects: "BRANDTELF IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Wieder alles Hochdeutsch",
            description_repeater_details:
              "The five-story new building, including underground parking, on Bonn's prominent Museum Mile encompasses an entire street carrée between Willy-Brandt-Allee, Heussallee, Welckerstrasse and Schlegelstrasse. Landmark decisions were once taken here, such as the way into the first grand coalition; since the government moved here, the lingua franca has returned to High German.",
            image_repeater_details: 21653,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Between the United Nations and German History",
            description_repeater_details:
              'The "brandtelf" is located in the direct proximity of the UN Campus, the Deutsche Welle and the Posttower. The House of German History, the Exhibition Hall of the Federal Republic of Germany and the Art Museum of the City of Bonn are within walking distance.',
            image_repeater_details: 1505,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Excellent sustainability",
            description_repeater_details:
              'The "brandtelf" has been awarded the Silver Seal of Approval by the German Sustainable Building Council (DGNB) and the Real Estate Award 2012 in the category "Project Development New Building".',
            image_repeater_details: 1500,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Willy-Brandt-Allee 13, 53113 Bonn, Deutschland",
          lat: 50.71717510272596,
          lng: 7.121119519049103,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Brandtelf</title>\n<meta name="description" content="Heute liegt hinter der denkmalgeschützten Fassade des &quot;brandtelf&quot; ein moderner Büro- und Verwaltungsbau mit ca. 12.000 m² flexibel gestaltbarer Nutzfläche." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/brandtelf/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Brandtelf" />\n<meta property="og:description" content="Heute liegt hinter der denkmalgeschützten Fassade des &quot;brandtelf&quot; ein moderner Büro- und Verwaltungsbau mit ca. 12.000 m² flexibel gestaltbarer Nutzfläche." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/brandtelf/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-25T10:00:53+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/BN_brandtelf_Aussen_Fernsicht_TEASER-1.jpg" />\n\t<meta property="og:image:width" content="960" />\n\t<meta property="og:image:height" content="960" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/brandtelf/","url":"https://www.art-invest.de/en/projekt/brandtelf/","name":"Art-Invest Real Estate | Brandtelf","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2013-10-08T10:00:41+00:00","dateModified":"2022-10-25T10:00:53+00:00","description":"Heute liegt hinter der denkmalgeschützten Fassade des \\"brandtelf\\" ein moderner Büro- und Verwaltungsbau mit ca. 12.000 m² flexibel gestaltbarer Nutzfläche.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/brandtelf/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/brandtelf/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/brandtelf/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Brandtelf"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Brandtelf",
        description:
          'Heute liegt hinter der denkmalgeschützten Fassade des "brandtelf" ein moderner Büro- und Verwaltungsbau mit ca. 12.000 m² flexibel gestaltbarer Nutzfläche.',
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/brandtelf/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Brandtelf",
        og_description:
          'Heute liegt hinter der denkmalgeschützten Fassade des "brandtelf" ein moderner Büro- und Verwaltungsbau mit ca. 12.000 m² flexibel gestaltbarer Nutzfläche.',
        og_url: "https://www.art-invest.de/en/projekt/brandtelf/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-25T10:00:53+00:00",
        og_image: [
          {
            width: 960,
            height: 960,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/BN_brandtelf_Aussen_Fernsicht_TEASER-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/brandtelf/",
              url: "https://www.art-invest.de/en/projekt/brandtelf/",
              name: "Art-Invest Real Estate | Brandtelf",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2013-10-08T10:00:41+00:00",
              dateModified: "2022-10-25T10:00:53+00:00",
              description:
                'Heute liegt hinter der denkmalgeschützten Fassade des "brandtelf" ein moderner Büro- und Verwaltungsbau mit ca. 12.000 m² flexibel gestaltbarer Nutzfläche.',
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/brandtelf/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/brandtelf/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/brandtelf/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Brandtelf",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/BN_brandtelf_Aussen_Fernsicht_TEASER-1.jpg",
      place: "Bonn",
      subtitle: "Wieder alles Hochdeutsch",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21652",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21653",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21652",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21652",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21682,
      date: "2013-09-10T12:00:40",
      date_gmt: "2013-09-10T10:00:40",
      guid: {
        rendered:
          "https://www.art-invest.de/projekt/holiday-inn-express-airport/",
      },
      modified: "2022-10-27T10:00:26",
      modified_gmt: "2022-10-27T08:00:26",
      slug: "holiday-inn-express-airport",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/holiday-inn-express-airport/",
      title: {
        rendered: "Holiday Inn Express",
      },
      featured_media: 21684,
      template: "",
      projekt_filter: [426, 251, 425, 259],
      acf: {
        highlight_image: 21683,
        highlight_title_project: "Holiday Inn Express",
        highlight_subtitle_project: "Im Herzen der deutschen Mittelschicht",
        highlight_description_project:
          "The metropolitan region Stuttgart is considered one of the strongest business locations in Europe. With more than 10 million passengers at Germany's sixth-largest airport and direct proximity to the new Stuttgart Trade Fair Center, Leinfeld-Echterdingen benefits in particular. The Holiday Inn Express offers comfortable space to stay overnight for visitors to one of the most sought-after locations in the region.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project:
          "Owner-operated; first property to establish an owner-operator structure; expansion to Generation 4 of the Holiday Inn Express brand",
        location:
          "Dieselstrasse 20, Leinfelden-Echterdingen; direct proximity to Stuttgart Airport and the New Trade Fair Centre",
        property: "2,022 sqm",
        area: "4,948 sqm, 145 rooms",
        zertifizierung: "",
        parcels: "90, 61 of which are in underground parking",
        use_for: "3* hotel",
        acquired: "Q4 2015",
        realization: "2007",
        sale: "",
        architecture_firm: "",
        place: "Stuttgart, Airport",
        fakten: null,
        specifications_image_projects: 21684,
        slider: [21684],
        title_details_projects: "HOLIDAY IN EXPRESS IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Modern concept in a central location",
            description_repeater_details:
              "The hotel has 145 modern rooms. The property is centrally located in Leinfelden-Echterdingen just five minutes by shuttle from Stuttgart Airport and the Stuttgart Trade Fair Center. It takes 20 minutes to reach Stuttgart's main train station by S-Bahn - or by car directly to the A8 autobahn. An underground garage with 61 parking spaces and 19 above-ground parking spaces is open to the public.",
            image_repeater_details: 1529,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "A region takes off",
            description_repeater_details:
              "The Leinfelden-Echterdingen microlocation benefits from being embedded in the Stuttgart region. It is one of the largest business locations in Europe, and various international companies have their headquarters here. The surrounding area with its proximity to the New Trade Fair Center as well as numerous medium-sized companies in the region and the increasing number of air passengers are boosting the development of the hotel market in Leinfelden-Echterdingen.",
            image_repeater_details: 21684,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Dieselstraße 20, Leinfelden-Echterdingen, Deutschland",
          lat: 48.69751029999999,
          lng: 9.166420799999969,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Holiday Inn Express</title>\n<meta name="description" content="Das Holiday Inn Express bietet komfortablen Raum zum Übernachten in direkter Nachbarschaft des Stuttgarter Flughafens- ausgezeichnet mit drei Sternen." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/holiday-inn-express-airport/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Holiday Inn Express" />\n<meta property="og:description" content="Das Holiday Inn Express bietet komfortablen Raum zum Übernachten in direkter Nachbarschaft des Stuttgarter Flughafens- ausgezeichnet mit drei Sternen." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/holiday-inn-express-airport/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-27T08:00:26+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2018/09/Holiday-Inn-Express-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1707" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/holiday-inn-express-airport/","url":"https://www.art-invest.de/en/projekt/holiday-inn-express-airport/","name":"Art-Invest Real Estate | Holiday Inn Express","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2013-09-10T10:00:40+00:00","dateModified":"2022-10-27T08:00:26+00:00","description":"Das Holiday Inn Express bietet komfortablen Raum zum Übernachten in direkter Nachbarschaft des Stuttgarter Flughafens- ausgezeichnet mit drei Sternen.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/holiday-inn-express-airport/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/holiday-inn-express-airport/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/holiday-inn-express-airport/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Holiday Inn Express"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Holiday Inn Express",
        description:
          "Das Holiday Inn Express bietet komfortablen Raum zum Übernachten in direkter Nachbarschaft des Stuttgarter Flughafens- ausgezeichnet mit drei Sternen.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/holiday-inn-express-airport/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Holiday Inn Express",
        og_description:
          "Das Holiday Inn Express bietet komfortablen Raum zum Übernachten in direkter Nachbarschaft des Stuttgarter Flughafens- ausgezeichnet mit drei Sternen.",
        og_url:
          "https://www.art-invest.de/en/projekt/holiday-inn-express-airport/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-27T08:00:26+00:00",
        og_image: [
          {
            width: 2560,
            height: 1707,
            url: "https://www.art-invest.de/wp-content/uploads/2018/09/Holiday-Inn-Express-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/holiday-inn-express-airport/",
              url: "https://www.art-invest.de/en/projekt/holiday-inn-express-airport/",
              name: "Art-Invest Real Estate | Holiday Inn Express",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2013-09-10T10:00:40+00:00",
              dateModified: "2022-10-27T08:00:26+00:00",
              description:
                "Das Holiday Inn Express bietet komfortablen Raum zum Übernachten in direkter Nachbarschaft des Stuttgarter Flughafens- ausgezeichnet mit drei Sternen.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/holiday-inn-express-airport/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/holiday-inn-express-airport/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/holiday-inn-express-airport/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Holiday Inn Express",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2018/09/Holiday-Inn-Express-1-scaled-800x800.jpg",
      place: "Stuttgart, Airport",
      subtitle: "Mitten in der deutschen Mitte",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21682",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21684",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21684",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21682",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21682",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16676,
      date: "2013-08-24T12:00:37",
      date_gmt: "2013-08-24T10:00:37",
      guid: {
        rendered: "https://www.art-invest.de/projekt/gfk/",
      },
      modified: "2020-07-03T13:37:41",
      modified_gmt: "2020-07-03T13:37:41",
      slug: "gfk",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/gfk/",
      title: {
        rendered: "GfK",
      },
      featured_media: 16678,
      template: "",
      projekt_filter: [246, 426, 425, 260],
      acf: {
        highlight_image: 16678,
        highlight_title_project: "GfK",
        highlight_subtitle_project: "Umschlagplatz für Synergien",
        highlight_description_project:
          'In a joint venture with Aurelis and Pegasus Capital Partners in Nuremberg, Art-Invest Real Estate is developing the new company headquarters for the market research company "Gesellschaft für Konsumforschung" (GfK SE) on a 20,300 m² site – the former Kohlenhof area.',
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Development",
        location:
          "Kohlenhofstraße, 90443 Nuremberg; city center near train station",
        property: "20,300 m²",
        area: "38,800 m²",
        zertifizierung: "",
        parcels: "825",
        use_for: "Office, Gastronomy, Parking",
        acquired: "2016",
        realization: "2019",
        sale: "",
        architecture_firm: "KSP Jürgen Engel",
        place: "Nuremberg",
        fakten: null,
        specifications_image_projects: 13594,
        slider: null,
        title_details_projects: "GFK IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Tradition meets modernity",
            description_repeater_details:
              "The architecture of the new GfK headquarters is not only a characteristic mirror of the main tenant. With its symbiosis of brick facade and modern elements, the building represents a successful architectural reinterpretation of the former industrial site. Also convincing: the building's representational factor. The spacious, modern lobby with institutional flair impresses visitors as soon as they enter the building.",
            image_repeater_details: 4416,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "A workplace with a quality of stay",
            description_repeater_details:
              "Large window areas and light-flooded, pleasant rooms create a high-quality stay at the workplace. Terrace areas on the 5th floor also provide an extraordinary feel-good factor. A green, spacious inner courtyard on the 1st floor is an oasis of relaxation and rounds off the generous range of outdoor areas.",
            image_repeater_details: 16677,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Individual room concepts",
            description_repeater_details:
              "The flexible, modern building structure enables the implementation of all conceivable room concepts – from individual offices to mixed structures and open-plan concepts, all working environments can be realized. Despite the concept for the single-tenant GfK, there are virtually no limits to a future new tenant constellation.",
            image_repeater_details: 4430,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Kohlenhofstraße, Nürnberg",
          lat: 49.44441579999999,
          lng: 11.064682199999993,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | GfK</title>\n<meta name="description" content="Das ehemalige Kohlenhof-Areal mitten in der Stadt der &quot;Hidden Champions&quot; ist ein innovativer Campus für die Arbeitswelt von morgen." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/gfk/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | GfK" />\n<meta property="og:description" content="Das ehemalige Kohlenhof-Areal mitten in der Stadt der &quot;Hidden Champions&quot; ist ein innovativer Campus für die Arbeitswelt von morgen." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/gfk/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-03T13:37:41+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2013/08/17-0516_GfK_Eingang-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1707" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/gfk/","url":"https://www.art-invest.de/en/projekt/gfk/","name":"Art-Invest Real Estate | GfK","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2013-08-24T10:00:37+00:00","dateModified":"2020-07-03T13:37:41+00:00","description":"Das ehemalige Kohlenhof-Areal mitten in der Stadt der \\"Hidden Champions\\" ist ein innovativer Campus für die Arbeitswelt von morgen.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/gfk/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/gfk/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/gfk/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"GfK"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | GfK",
        description:
          'Das ehemalige Kohlenhof-Areal mitten in der Stadt der "Hidden Champions" ist ein innovativer Campus für die Arbeitswelt von morgen.',
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/gfk/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | GfK",
        og_description:
          'Das ehemalige Kohlenhof-Areal mitten in der Stadt der "Hidden Champions" ist ein innovativer Campus für die Arbeitswelt von morgen.',
        og_url: "https://www.art-invest.de/en/projekt/gfk/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-03T13:37:41+00:00",
        og_image: [
          {
            width: 2560,
            height: 1707,
            url: "https://www.art-invest.de/wp-content/uploads/2013/08/17-0516_GfK_Eingang-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/gfk/",
              url: "https://www.art-invest.de/en/projekt/gfk/",
              name: "Art-Invest Real Estate | GfK",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2013-08-24T10:00:37+00:00",
              dateModified: "2020-07-03T13:37:41+00:00",
              description:
                'Das ehemalige Kohlenhof-Areal mitten in der Stadt der "Hidden Champions" ist ein innovativer Campus für die Arbeitswelt von morgen.',
              breadcrumb: {
                "@id": "https://www.art-invest.de/en/projekt/gfk/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/gfk/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://www.art-invest.de/en/projekt/gfk/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "GfK",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2013/08/17-0516_GfK_Eingang-1-scaled-800x800.jpg",
      place: "Nuremberg",
      subtitle: "Umschlagplatz für Synergien",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16676",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16678",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16676",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16676",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 18080,
      date: "2013-07-02T12:00:12",
      date_gmt: "2013-07-02T10:00:12",
      guid: {
        rendered: "https://www.art-invest.de/projekt/akazienbogen/",
      },
      modified: "2021-01-25T09:33:02",
      modified_gmt: "2021-01-25T08:33:02",
      slug: "akazienbogen",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/akazienbogen/",
      title: {
        rendered: "Akazienbogen",
      },
      featured_media: 18081,
      template: "",
      projekt_filter: [246, 426, 425, 256],
      acf: {
        highlight_image: 18081,
        highlight_title_project: "Akazienbogen",
        highlight_subtitle_project: "Neuer Glanz in der Akazienstraße",
        highlight_description_project:
          "The Akazienkiez in Berlin-Schöneberg is celebrating a new old address: The elegant corner building at the intersection of Hauptstrasse and Akazienstrasse shines in new splendor with modern office and retail space.",
        highlight_logo_project: 13286,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Investment",
        location: "Hauptstraße 23 - 24 / Akazienstraße 31, Berlin-Schöneberg",
        property: "approx. 1,300 sqm",
        area: "approx. 3,650 sqm",
        zertifizierung: "",
        parcels: "32",
        use_for: "Office",
        acquired: "Q3/Q4 2015",
        realization: "",
        sale: "",
        architecture_firm: "Curt Hans Fritzsche",
        place: "Berlin",
        fakten: null,
        specifications_image_projects: 1583,
        slider: null,
        title_details_projects: "",
        details_repeater_projects: [
          {
            title_repeater_details: "An outstading facade",
            description_repeater_details:
              "The building extends over five floors with a total of approx. 3,674 sqm of floor space. A modern refurbished facade of concrete and glass elements will make the building stand out clearly in the streetscape in the future. The office spaces allow for optimal space efficiency, flexible designs for variable office requirements are included.",
            image_repeater_details: 18081,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Perfect corner location",
            description_repeater_details:
              "The connections are ideal - thanks to short distances to public transport: the Julius-Leber-Brücke train station is within walking distance. The main train station, airport and the nearest freeway are only fifteen minutes away - and in the immediate vicinity there are also numerous shopping opportunities, residential buildings and gastronomic offerings. The house has 32 parking spaces.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "The most beautiful of Schöneberg",
            description_repeater_details:
              "Can a building express the elegance of Marlene Dietrich? Hardly - and yet the architecture of the curved building radiates something of the verve of Schöneberg's most famous woman. The house was built on the approximately 1,314 m² corner lot in 1956, the year of the first Berlinale.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Akazienstraße 31, Berlin",
          lat: 52.48621,
          lng: 13.355450000000019,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Akazienbogen</title>\n<meta name="description" content="Das elegante Eckgebäude im Kreuzungsbereich Hauptstraße und Akazienstraße erstrahlt zukünftig in neuem Glanze mit modernen Büro- und Einzelhandelsflächen." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/akazienbogen/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Akazienbogen" />\n<meta property="og:description" content="Das elegante Eckgebäude im Kreuzungsbereich Hauptstraße und Akazienstraße erstrahlt zukünftig in neuem Glanze mit modernen Büro- und Einzelhandelsflächen." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/akazienbogen/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-01-25T08:33:02+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/B_Akazie_Aussenansicht_TEASER-1.jpg" />\n\t<meta property="og:image:width" content="2064" />\n\t<meta property="og:image:height" content="2063" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/akazienbogen/","url":"https://www.art-invest.de/en/projekt/akazienbogen/","name":"Art-Invest Real Estate | Akazienbogen","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2013-07-02T10:00:12+00:00","dateModified":"2021-01-25T08:33:02+00:00","description":"Das elegante Eckgebäude im Kreuzungsbereich Hauptstraße und Akazienstraße erstrahlt zukünftig in neuem Glanze mit modernen Büro- und Einzelhandelsflächen.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/akazienbogen/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/akazienbogen/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/akazienbogen/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Akazienbogen"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Akazienbogen",
        description:
          "Das elegante Eckgebäude im Kreuzungsbereich Hauptstraße und Akazienstraße erstrahlt zukünftig in neuem Glanze mit modernen Büro- und Einzelhandelsflächen.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/akazienbogen/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Akazienbogen",
        og_description:
          "Das elegante Eckgebäude im Kreuzungsbereich Hauptstraße und Akazienstraße erstrahlt zukünftig in neuem Glanze mit modernen Büro- und Einzelhandelsflächen.",
        og_url: "https://www.art-invest.de/en/projekt/akazienbogen/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-01-25T08:33:02+00:00",
        og_image: [
          {
            width: 2064,
            height: 2063,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/B_Akazie_Aussenansicht_TEASER-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/akazienbogen/",
              url: "https://www.art-invest.de/en/projekt/akazienbogen/",
              name: "Art-Invest Real Estate | Akazienbogen",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2013-07-02T10:00:12+00:00",
              dateModified: "2021-01-25T08:33:02+00:00",
              description:
                "Das elegante Eckgebäude im Kreuzungsbereich Hauptstraße und Akazienstraße erstrahlt zukünftig in neuem Glanze mit modernen Büro- und Einzelhandelsflächen.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/akazienbogen/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/akazienbogen/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/akazienbogen/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Akazienbogen",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/B_Akazie_Aussenansicht_TEASER-1.jpg",
      place: "Berlin",
      subtitle: "Neuer Glanz in der Akazienstraße",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/18080",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/18081",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=18080",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=18080",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21676,
      date: "2013-06-04T12:00:21",
      date_gmt: "2013-06-04T10:00:21",
      guid: {
        rendered: "https://www.art-invest.de/projekt/feuersee-carre/",
      },
      modified: "2022-10-27T09:41:53",
      modified_gmt: "2022-10-27T07:41:53",
      slug: "feuersee-carre",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/feuersee-carre/",
      title: {
        rendered: "Feuersee Carré",
      },
      featured_media: 21678,
      template: "",
      projekt_filter: [246, 426, 425, 259],
      acf: {
        highlight_image: 13076,
        highlight_title_project: "Feuersee Carré",
        highlight_subtitle_project: "Der Ort im Westen",
        highlight_description_project:
          "Proximity and distance. The Feuersee Carré knows the right balance. It's all in the location: The striking building complex with spacious office and residential worlds benefits from its proximity to the city center - and the advantages of being located in the middle of one of the liveliest districts of the metropolis.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment",
        location:
          "Rotebühlstrasse 50, 70178 Stuttgart, Germany; central location west of the city center, directly on the main artery Rotebühlstrasse",
        property: "2,560 sqm",
        area: "4,800 sqm",
        zertifizierung: "",
        parcels: "53",
        use_for: "Office, residential, restaurant, parking",
        acquired: "2016",
        realization: "Year of construction: 1980",
        sale: "",
        architecture_firm: "",
        place: "Stuttgart",
        fakten: null,
        specifications_image_projects: 13076,
        slider: null,
        title_details_projects: "Feuersee Carré IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "The square in the west",
            description_repeater_details:
              "In Stuttgart-West, directly opposite the Feuersee S-Bahn station, approx. 4,800 sqm of rental space will be created over the next few years for office and residential space, restaurants and parking. The complex on Rotebühlstrasse will create a modern location and residential area on a 2,560 sqm site, with spaces that are right in the middle of things and yet not in the hustle and bustle of the city center.",
            image_repeater_details: 13076,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Proximity in every direction",
            description_repeater_details:
              "No matter which destinations you want to go to, the distances remain short: The city center with Stuttgart's Schloßplatz, one of the most beautiful squares in Europe, is only 15 minutes away on foot. By streetcar and bus it is only about 15 minutes to the opera and theater. For those who want to go further: By S-Bahn across the street or by car, you can get to Echterdingen Airport in about 25 minutes.",
            image_repeater_details: 13080,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "The Carré at the lake",
            description_repeater_details:
              "The fire lake around the corner has not been extinguishing fires for a long time. On summer days, the lake with its renovated lakeside promenade provides refreshment for the entire neighborhood. After the extension of the shore with wide seating steps, the lake has become a popular meeting place in the neighborhood.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Rotebühlstraße 50, 70178 Stuttgart, Deutschland",
          lat: 48.7731685,
          lng: 9.166795900000011,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Feuersee Carré</title>\n<meta name="description" content="In Stuttgart-West entstehen in den nächsten Jahren ca. 4.800 m² Mietflächen für Büro- und Wohnwelten, Gastronomie und Parkraum." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/feuersee-carre/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Feuersee Carré" />\n<meta property="og:description" content="In Stuttgart-West entstehen in den nächsten Jahren ca. 4.800 m² Mietflächen für Büro- und Wohnwelten, Gastronomie und Parkraum." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/feuersee-carre/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-27T07:41:53+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/Stuttgart_Rotebuehlstrasse_Eckansicht_TEASER_neu-1.jpg" />\n\t<meta property="og:image:width" content="1260" />\n\t<meta property="og:image:height" content="1260" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/feuersee-carre/","url":"https://www.art-invest.de/en/projekt/feuersee-carre/","name":"Art-Invest Real Estate | Feuersee Carré","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2013-06-04T10:00:21+00:00","dateModified":"2022-10-27T07:41:53+00:00","description":"In Stuttgart-West entstehen in den nächsten Jahren ca. 4.800 m² Mietflächen für Büro- und Wohnwelten, Gastronomie und Parkraum.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/feuersee-carre/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/feuersee-carre/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/feuersee-carre/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Feuersee Carré"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Feuersee Carré",
        description:
          "In Stuttgart-West entstehen in den nächsten Jahren ca. 4.800 m² Mietflächen für Büro- und Wohnwelten, Gastronomie und Parkraum.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/feuersee-carre/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Feuersee Carré",
        og_description:
          "In Stuttgart-West entstehen in den nächsten Jahren ca. 4.800 m² Mietflächen für Büro- und Wohnwelten, Gastronomie und Parkraum.",
        og_url: "https://www.art-invest.de/en/projekt/feuersee-carre/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-27T07:41:53+00:00",
        og_image: [
          {
            width: 1260,
            height: 1260,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/Stuttgart_Rotebuehlstrasse_Eckansicht_TEASER_neu-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/feuersee-carre/",
              url: "https://www.art-invest.de/en/projekt/feuersee-carre/",
              name: "Art-Invest Real Estate | Feuersee Carré",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2013-06-04T10:00:21+00:00",
              dateModified: "2022-10-27T07:41:53+00:00",
              description:
                "In Stuttgart-West entstehen in den nächsten Jahren ca. 4.800 m² Mietflächen für Büro- und Wohnwelten, Gastronomie und Parkraum.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/feuersee-carre/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/feuersee-carre/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/feuersee-carre/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Feuersee Carré",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/Stuttgart_Rotebuehlstrasse_Eckansicht_TEASER_neu-1.jpg",
      place: "Stuttgart",
      subtitle: "Der Ort im Westen",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21676",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21678",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21676",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21676",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21720,
      date: "2015-08-16T18:48:30",
      date_gmt: "2015-08-16T16:48:30",
      guid: {
        rendered: "https://www.art-invest.de/projekt/saintgobain/",
      },
      modified: "2022-10-27T11:21:49",
      modified_gmt: "2022-10-27T09:21:49",
      slug: "saintgobain",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/saintgobain/",
      title: {
        rendered: "Saint-Gobain",
      },
      featured_media: 21722,
      template: "",
      projekt_filter: [246, 426, 425, 263],
      acf: {
        highlight_image: 21722,
        highlight_title_project: "Saint-Gobain",
        highlight_subtitle_project: "Ein prestigeträchtiger Auftritt",
        highlight_description_project:
          "When a construction group builds its European headquarters: in Aachen's northeast, the new three- to four-story building invites you into prestigious business spaces. From comprehensive design freedom to a balanced indoor climate, the energy-efficient administration building creates a highly modern and flexible working environment.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Development",
        location: "Krefelder Straße 195, Aachen, Germany",
        property: "4,500 sqm",
        area: "5,020 sqm",
        zertifizierung: "",
        parcels: "79 underground parking spaces, 4 outside parking spaces",
        use_for: "Office",
        acquired: "Q3 2013",
        realization: "Q4 2015",
        sale: "Warburg-HIH Invest Real Estate GmbH",
        architecture_firm: "kadawittfeldarchitektur GmbH",
        place: "Aachen",
        fakten: null,
        specifications_image_projects: 21723,
        slider: [15034],
        title_details_projects: "SAINT-GOBAIN IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Ein prestigeträchtiger Auftritt",
            description_repeater_details:
              "On the former site of the Aachen Tivoli stadium, the French construction group Saint-Gobain finds a state-of-the-art administrative building for its new headquarters for Germany and Central Europe. Numerous Saint-Gobain products were used in the construction so that the employees work in harmony with their products.",
            image_repeater_details: 21724,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "State-of-the-art working environments",
            description_repeater_details:
              "Indoor climate and sustainability are among the essential parameters of modern building design. The generous glass facade of the new building creates a representative and at the same time transparent appearance.",
            image_repeater_details: 21725,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "A productive climate",
            description_repeater_details:
              "The new building implements comprehensive solutions for sustainability, efficiency and comfort. Natural light, modern acoustics and the visual combination of green exterior and bright interior surfaces create the framework for an optimal working environment.",
            image_repeater_details: 21723,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Saint Gobain Film",
            description_repeater_details: "",
            image_repeater_details: 15034,
            video: "https://player.vimeo.com/video/192449053",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Krefelder Straße 195, Aachen",
          lat: 50.7885651,
          lng: 6.09467010000003,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Saint-Gobain</title>\n<meta name="description" content="Im Aachener Nordosten findet der Baukonzern Saint-Gobain ein hochmodernes Verwaltungsgebäude für seine neue Mitteleuropa- und Deutschland Generaldelegation." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/saintgobain/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Saint-Gobain" />\n<meta property="og:description" content="Im Aachener Nordosten findet der Baukonzern Saint-Gobain ein hochmodernes Verwaltungsgebäude für seine neue Mitteleuropa- und Deutschland Generaldelegation." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/saintgobain/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-27T09:21:49+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2020/03/Krefelderstr_01_1.jpg" />\n\t<meta property="og:image:width" content="1806" />\n\t<meta property="og:image:height" content="1250" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/saintgobain/","url":"https://www.art-invest.de/en/projekt/saintgobain/","name":"Art-Invest Real Estate | Saint-Gobain","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2015-08-16T16:48:30+00:00","dateModified":"2022-10-27T09:21:49+00:00","description":"Im Aachener Nordosten findet der Baukonzern Saint-Gobain ein hochmodernes Verwaltungsgebäude für seine neue Mitteleuropa- und Deutschland Generaldelegation.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/saintgobain/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/saintgobain/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/saintgobain/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Saint-Gobain"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Saint-Gobain",
        description:
          "Im Aachener Nordosten findet der Baukonzern Saint-Gobain ein hochmodernes Verwaltungsgebäude für seine neue Mitteleuropa- und Deutschland Generaldelegation.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/saintgobain/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Saint-Gobain",
        og_description:
          "Im Aachener Nordosten findet der Baukonzern Saint-Gobain ein hochmodernes Verwaltungsgebäude für seine neue Mitteleuropa- und Deutschland Generaldelegation.",
        og_url: "https://www.art-invest.de/en/projekt/saintgobain/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-27T09:21:49+00:00",
        og_image: [
          {
            width: 1806,
            height: 1250,
            url: "https://www.art-invest.de/wp-content/uploads/2020/03/Krefelderstr_01_1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/saintgobain/",
              url: "https://www.art-invest.de/en/projekt/saintgobain/",
              name: "Art-Invest Real Estate | Saint-Gobain",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2015-08-16T16:48:30+00:00",
              dateModified: "2022-10-27T09:21:49+00:00",
              description:
                "Im Aachener Nordosten findet der Baukonzern Saint-Gobain ein hochmodernes Verwaltungsgebäude für seine neue Mitteleuropa- und Deutschland Generaldelegation.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/saintgobain/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/saintgobain/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/saintgobain/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Saint-Gobain",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2020/03/Krefelderstr_01_1-800x800.jpg",
      place: "Aachen",
      subtitle: "Ein prestigeträchtiger Auftritt",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21720",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/15034",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21722",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21720",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21720",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21679,
      date: "2014-09-09T12:00:08",
      date_gmt: "2014-09-09T10:00:08",
      guid: {
        rendered: "https://www.art-invest.de/projekt/godesberger-allee/",
      },
      modified: "2022-10-27T09:47:31",
      modified_gmt: "2022-10-27T07:47:31",
      slug: "godesberger-allee",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/godesberger-allee/",
      title: {
        rendered: "Godesberger Allee",
      },
      featured_media: 21681,
      template: "",
      projekt_filter: [246, 426, 425, 263],
      acf: {
        highlight_image: 13271,
        highlight_title_project: "Godesberger Allee",
        highlight_subtitle_project: "Auf der diplomatischen Rennstrecke",
        highlight_description_project:
          "The diplomatic parquet of the Bonn Republic was Bonn-Bad Godesberg with its countless embassies. Today, the district marks the transition to the Federal Quarter, which has become the top address for corporations and international authorities - the office building at Godesberger Allee 83-91 is located directly at the entrance.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Long-term investment",
        location: "Godesberger Allee 83-91, 53175 Bonn, Bad Godesberg, Germany",
        property: "Approx. 9,500 sqm",
        area: "Approx. 18,800 sqm",
        zertifizierung: "",
        parcels: "248 underground parking spaces, 39 outdoor parking spaces",
        use_for: "Office",
        acquired: "2014",
        realization: "1990 / 1992",
        sale: "2017",
        architecture_firm: "",
        place: "Bonn",
        fakten: null,
        specifications_image_projects: 1333,
        slider: [21680, 21681],
        title_details_projects: "GODESBERGER ALLEE IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "At the diplomatic racecourse",
            description_repeater_details:
              "The building is located directly on Bonn's important north-south axis of the B9, also known as the \"Diplomaten-Rennbahn\". This means that the building has good transport links to the region's freeway network, as well as 248 underground parking spaces and a further 39 parking spaces in the outdoor areas. Via local and long-distance public transportation, one can quickly reach the nearby airport or main train station even without a diplomatic pass.",
            image_repeater_details: 21680,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Flexible rooms",
            description_repeater_details:
              "On the spacious site, the office building offers approx. 18,800 sqm of flexible rental space in which various utilization concepts can be realized. The building is fully leased.",
            image_repeater_details: 1333,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Godesberger Allee 83-91, 53175 Bonn",
          lat: 50.69812289999999,
          lng: 7.139500799999951,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Godesberger Allee</title>\n<meta name="description" content="Das Bürogebäude an der Godesberger Allee 83-91 liegt am Eingang zum Bundesviertel, der ersten Adresse für Konzerne und internationale Behörden in Bonn" />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/godesberger-allee/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Godesberger Allee" />\n<meta property="og:description" content="Das Bürogebäude an der Godesberger Allee 83-91 liegt am Eingang zum Bundesviertel, der ersten Adresse für Konzerne und internationale Behörden in Bonn" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/godesberger-allee/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-27T07:47:31+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/Godesberger_Allee_Panorama7_TEASER-1.jpg" />\n\t<meta property="og:image:width" content="2000" />\n\t<meta property="og:image:height" content="2000" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/godesberger-allee/","url":"https://www.art-invest.de/en/projekt/godesberger-allee/","name":"Art-Invest Real Estate | Godesberger Allee","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-09-09T10:00:08+00:00","dateModified":"2022-10-27T07:47:31+00:00","description":"Das Bürogebäude an der Godesberger Allee 83-91 liegt am Eingang zum Bundesviertel, der ersten Adresse für Konzerne und internationale Behörden in Bonn","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/godesberger-allee/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/godesberger-allee/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/godesberger-allee/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Godesberger Allee"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Godesberger Allee",
        description:
          "Das Bürogebäude an der Godesberger Allee 83-91 liegt am Eingang zum Bundesviertel, der ersten Adresse für Konzerne und internationale Behörden in Bonn",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/godesberger-allee/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Godesberger Allee",
        og_description:
          "Das Bürogebäude an der Godesberger Allee 83-91 liegt am Eingang zum Bundesviertel, der ersten Adresse für Konzerne und internationale Behörden in Bonn",
        og_url: "https://www.art-invest.de/en/projekt/godesberger-allee/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-27T07:47:31+00:00",
        og_image: [
          {
            width: 2000,
            height: 2000,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/Godesberger_Allee_Panorama7_TEASER-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/godesberger-allee/",
              url: "https://www.art-invest.de/en/projekt/godesberger-allee/",
              name: "Art-Invest Real Estate | Godesberger Allee",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-09-09T10:00:08+00:00",
              dateModified: "2022-10-27T07:47:31+00:00",
              description:
                "Das Bürogebäude an der Godesberger Allee 83-91 liegt am Eingang zum Bundesviertel, der ersten Adresse für Konzerne und internationale Behörden in Bonn",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/godesberger-allee/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/godesberger-allee/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/godesberger-allee/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Godesberger Allee",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/Godesberger_Allee_Panorama7_TEASER-1.jpg",
      place: "Bonn",
      subtitle: "Auf der diplomatischen Rennstrecke",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21679",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21681",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21680",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21681",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21679",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21679",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21685,
      date: "2014-02-25T12:00:28",
      date_gmt: "2014-02-25T11:00:28",
      guid: {
        rendered: "https://www.art-invest.de/projekt/hotel-mercure/",
      },
      modified: "2022-10-27T10:05:33",
      modified_gmt: "2022-10-27T08:05:33",
      slug: "hotel-mercure",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/hotel-mercure/",
      title: {
        rendered: "Hotel Mercure & Medicum",
      },
      featured_media: 21687,
      template: "",
      projekt_filter: [246, 426, 251, 425, 245, 263],
      acf: {
        highlight_image: 3848,
        highlight_title_project: "Hotel Mercure & Medicum",
        highlight_subtitle_project: "Modern mix",
        highlight_description_project:
          "The hotel building combines all the requirements of modern accommodation in the music and trade fair city of Leipzig: 174 rooms, various conference rooms, a restaurant, a bar and a wellness and fitness area - all awarded four stars.",
        highlight_logo_project: 21686,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project:
          "Investment with focus on active asset and leasing management; improvement of property quality",
        location:
          "Goldschmidtstr. 30 / Stephanstr. 4-6, Leipzig, Germany; central location within walking distance of the city center",
        property: "5,190 sqm",
        area: "6,000 sqm hotel with 174 rooms / 6,500 sqm medical and commercial building",
        zertifizierung: "",
        parcels: "174 parking spaces in the property's own underground garage",
        use_for:
          "Mixed use: 4* conference hotel, office and medical practices, residential, retail",
        acquired: "Q2 2014",
        realization: "1995",
        sale: "",
        architecture_firm: "",
        place: "Leipzig",
        fakten: null,
        specifications_image_projects: 21688,
        slider: [21687],
        title_details_projects: "HOTEL MERCURE & MEDICUM IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Modern mix",
            description_repeater_details:
              'In addition to the Mercure Hotel, the five-story building houses approx. 6,500 sqm of commercial and residential units, which are let in particular to doctors, office users and various retailers. Through its branding as "Medicum Leipzig", the building has increasingly established itself as a medical center and health center in the Graphisches Viertel district in recent years.',
            image_repeater_details: 21687,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Traditional trade fair and trading city",
            description_repeater_details:
              "The Mercure Hotel is located near Johannisplatz on the outskirts of the city center of the trade fair and trading city of Leipzig. Augustusplatz as well as the most famous sights can be reached by foot within a few minutes. It is a five-minute drive to the main train station and half an hour by car to Leipzig/Halle Airport and the trade fair grounds.",
            image_repeater_details: 3848,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Quarter in upheaval",
            description_repeater_details:
              'The Graphisches Viertel is Leipzig\'s most sought-after office submarket. Formerly known as the quarter of publishing houses and the book industry, it is now establishing itself as a modern media and trendy residential location. The surrounding area plays a central role in Leipzig as a medical center. Most of the facilities of the university hospital are located close to the property, creating optimal conditions for the successful establishment of "Medicum Leipzig".',
            image_repeater_details: 1459,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Goldschmidtstr. 30 / Stephanstr. 4-6, Leipzig",
          lat: 51.33518369999999,
          lng: 12.388604499999929,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Hotel Mercure &amp; Medicum</title>\n<meta name="description" content="Der Hotel-Bau vereint am Johannisplatz alle Anforderungen modernen Übernachtens in der Musik-und Messestadt Leipzig - ausgezeichnet mit vier Sternen." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/hotel-mercure/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Hotel Mercure &amp; Medicum" />\n<meta property="og:description" content="Der Hotel-Bau vereint am Johannisplatz alle Anforderungen modernen Übernachtens in der Musik-und Messestadt Leipzig - ausgezeichnet mit vier Sternen." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/hotel-mercure/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-27T08:05:33+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/Leipzig_Mercure_aussen_TEASER-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1705" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/hotel-mercure/","url":"https://www.art-invest.de/en/projekt/hotel-mercure/","name":"Art-Invest Real Estate | Hotel Mercure & Medicum","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-02-25T11:00:28+00:00","dateModified":"2022-10-27T08:05:33+00:00","description":"Der Hotel-Bau vereint am Johannisplatz alle Anforderungen modernen Übernachtens in der Musik-und Messestadt Leipzig - ausgezeichnet mit vier Sternen.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/hotel-mercure/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/hotel-mercure/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/hotel-mercure/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Hotel Mercure &#038; Medicum"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Hotel Mercure & Medicum",
        description:
          "Der Hotel-Bau vereint am Johannisplatz alle Anforderungen modernen Übernachtens in der Musik-und Messestadt Leipzig - ausgezeichnet mit vier Sternen.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/hotel-mercure/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Hotel Mercure & Medicum",
        og_description:
          "Der Hotel-Bau vereint am Johannisplatz alle Anforderungen modernen Übernachtens in der Musik-und Messestadt Leipzig - ausgezeichnet mit vier Sternen.",
        og_url: "https://www.art-invest.de/en/projekt/hotel-mercure/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-27T08:05:33+00:00",
        og_image: [
          {
            width: 2560,
            height: 1705,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/Leipzig_Mercure_aussen_TEASER-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/hotel-mercure/",
              url: "https://www.art-invest.de/en/projekt/hotel-mercure/",
              name: "Art-Invest Real Estate | Hotel Mercure & Medicum",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-02-25T11:00:28+00:00",
              dateModified: "2022-10-27T08:05:33+00:00",
              description:
                "Der Hotel-Bau vereint am Johannisplatz alle Anforderungen modernen Übernachtens in der Musik-und Messestadt Leipzig - ausgezeichnet mit vier Sternen.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/hotel-mercure/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/hotel-mercure/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/hotel-mercure/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Hotel Mercure & Medicum",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/Leipzig_Mercure_aussen_TEASER-1-scaled.jpg",
      place: "Leipzig",
      subtitle: "Moderner Mix",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21685",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21687",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21687",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21685",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21685",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 21691,
      date: "2013-07-16T12:00:09",
      date_gmt: "2013-07-16T10:00:09",
      guid: {
        rendered: "https://www.art-invest.de/projekt/novotel-erlangen/",
      },
      modified: "2022-10-27T10:26:33",
      modified_gmt: "2022-10-27T08:26:33",
      slug: "novotel-erlangen",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/novotel-erlangen/",
      title: {
        rendered: "Novotel",
      },
      featured_media: 21693,
      template: "",
      projekt_filter: [251, 427, 425, 263],
      acf: {
        highlight_image: 3027,
        highlight_title_project: "Novotel",
        highlight_subtitle_project: "The house on the square",
        highlight_description_project:
          "Erlangen is located in the land of inventors. Together with Nuremberg, the Franconian city forms one of the most important high-tech regions in the country. The Superior Business Novotel Erlangen creates overnight accommodations in 3-star quality close to the city center.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: "",
        available_space: [""],
        project: "Investment (long-term)",
        location:
          "Hofmannstr. 34, Erlangen, Germany; downtown location between the city center and Werner-von-Siemens-Str.",
        property: "3,573 sqm",
        area: "6,847 sqm, 170 rooms",
        zertifizierung: "",
        parcels: "94 parking spaces in the property's own underground garage",
        use_for: "3* superior business hotel",
        acquired: "Q3 2015",
        realization: "2001, renovation of the facade in 2014",
        sale: "",
        architecture_firm: "",
        place: "Erlangen",
        fakten: null,
        specifications_image_projects: 13288,
        slider: [21692],
        title_details_projects: "NOVOTEL IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "The house on the square",
            description_repeater_details:
              "The hotel opened in 2001, and after its renovation in 2014, it now boasts 170 rooms, including 19 spacious suites, on 6,847 sqm of floor space. For seminars and meetings, the house has eight function rooms. A restaurant with terrace, a lobby bar and a fitness room flank the accommodation offer. The property’s own underground parking garage has 94 parking spaces.",
            image_repeater_details: 3026,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Everything within reach",
            description_repeater_details:
              "The Novotel Erlangen is located on the eastern edge of the city center ring between the city center and the headquarters of Siemens AG. The main train station is just 2 km away, and Nuremberg Airport is 20 minutes away. The 3,573 sqm site is close to the Friedrich Alexander University with its botanical garden. The district, which is revolutionizing the future cityscape under the name Siemens Campus, is within walking distance.",
            image_repeater_details: 21692,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Hofmannstr. 34, Erlangen",
          lat: 49.5924127,
          lng: 11.012974600000007,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Novotel</title>\n<meta name="description" content="Das Superior Business Novotel Erlangen schafft unweit der Erlanger Innenstadt Übernachtungsmöglichkeiten in 3-Sterne-Qualität." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/novotel-erlangen/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Novotel" />\n<meta property="og:description" content="Das Superior Business Novotel Erlangen schafft unweit der Erlanger Innenstadt Übernachtungsmöglichkeiten in 3-Sterne-Qualität." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/novotel-erlangen/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2022-10-27T08:26:33+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2013/07/Novotel-Erlangen-Teaser-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="2560" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/novotel-erlangen/","url":"https://www.art-invest.de/en/projekt/novotel-erlangen/","name":"Art-Invest Real Estate | Novotel","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2013-07-16T10:00:09+00:00","dateModified":"2022-10-27T08:26:33+00:00","description":"Das Superior Business Novotel Erlangen schafft unweit der Erlanger Innenstadt Übernachtungsmöglichkeiten in 3-Sterne-Qualität.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/novotel-erlangen/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/novotel-erlangen/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/novotel-erlangen/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Novotel"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Novotel",
        description:
          "Das Superior Business Novotel Erlangen schafft unweit der Erlanger Innenstadt Übernachtungsmöglichkeiten in 3-Sterne-Qualität.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/novotel-erlangen/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Novotel",
        og_description:
          "Das Superior Business Novotel Erlangen schafft unweit der Erlanger Innenstadt Übernachtungsmöglichkeiten in 3-Sterne-Qualität.",
        og_url: "https://www.art-invest.de/en/projekt/novotel-erlangen/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2022-10-27T08:26:33+00:00",
        og_image: [
          {
            width: 2560,
            height: 2560,
            url: "https://www.art-invest.de/wp-content/uploads/2013/07/Novotel-Erlangen-Teaser-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/novotel-erlangen/",
              url: "https://www.art-invest.de/en/projekt/novotel-erlangen/",
              name: "Art-Invest Real Estate | Novotel",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2013-07-16T10:00:09+00:00",
              dateModified: "2022-10-27T08:26:33+00:00",
              description:
                "Das Superior Business Novotel Erlangen schafft unweit der Erlanger Innenstadt Übernachtungsmöglichkeiten in 3-Sterne-Qualität.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/novotel-erlangen/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/novotel-erlangen/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/novotel-erlangen/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Novotel",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2013/07/Novotel-Erlangen-Teaser-1-scaled.jpg",
      place: "Erlangen",
      subtitle: "Das Haus am Platz",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/21691",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21692",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/21693",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=21691",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=21691",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },

    {
      id: 16778,
      date: "2014-07-01T12:00:42",
      date_gmt: "2014-07-01T10:00:42",
      guid: {
        rendered: "https://www.art-invest.de/projekt/maincubes/",
      },
      modified: "2021-11-04T18:11:11",
      modified_gmt: "2021-11-04T17:11:11",
      slug: "maincubes",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/maincubes/",
      title: {
        rendered: "Maincubes",
      },
      featured_media: 16779,
      template: "",
      projekt_filter: [426, 425, 255, 253],
      acf: {
        highlight_image: 16779,
        highlight_title_project: "Maincubes",
        highlight_subtitle_project: "Innovative Architektur",
        highlight_description_project:
          "With its intelligent design, the innovative premium high-performance data center Maincubes creates a new home for server data in the Rhine-Main area.",
        highlight_logo_project: null,
        website_projects: {
          title: "www.maincubes.com",
          url: "https://www.maincubes.com/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://www.maincubes.com/",
          target: "_blank",
        },
        available_space: [""],
        project: "Project Development",
        location: "Goethring, 63067 Offenbach am Main",
        property: "8,333 m²",
        area: "4,200 m²",
        zertifizierung: "",
        parcels: "14",
        use_for: "Computer center",
        acquired: "2015",
        realization: "2017 - 2018",
        sale: "2015",
        architecture_firm: "ICT, Stuttgart",
        place: "Offenbach",
        fakten: null,
        specifications_image_projects: 16780,
        slider: null,
        title_details_projects: "MAINCUBES IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Innovative Architektur",
            description_repeater_details:
              "The cube in Offenbach has a total of 4,200 m² of data center space, a capacity of 6 megawatts and is located in the immediate vicinity of the central DE-CIX Internet node in Frankfurt. With 5.5 terrabyte data traffic per second, this is one of the world's leading Internet nodes.",
            image_repeater_details: 16779,
            video:
              '<iframe src="https://player.vimeo.com/video/192600184?title=0&byline=0&portrait=0" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>',
            "anchor-link": "",
          },
          {
            title_repeater_details: "New generation of data center",
            description_repeater_details:
              "Intelligent room design, sustainable efficiency and an innovative cooling system characterize the architecture of the data center, which also sets a new standard for operational security, legal security and technical safety.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Excellent data traffic",
            description_repeater_details:
              "High availability, flexibility, energy efficiency and comprehensive safety characterize the plant with the cubist facade. The designer ITC Facilities 2016 has received the German Data Center Award twice.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Goethering, Offenbach, Deutschland",
          lat: 50.10855309999999,
          lng: 8.742582399999947,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Maincubes</title>\n<meta name="description" content="Das innovative Premium-Hochleistungsrechenzentrum Maincubes schafft mit intelligentem Design eine neue Heimat für Serverdaten im Rhein-Main-Gebiet." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/maincubes/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Maincubes" />\n<meta property="og:description" content="Das innovative Premium-Hochleistungsrechenzentrum Maincubes schafft mit intelligentem Design eine neue Heimat für Serverdaten im Rhein-Main-Gebiet." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/maincubes/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T17:11:11+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/FFM_Maincubes_Visualisierung_Nacht_02TEASER-1.jpg" />\n\t<meta property="og:image:width" content="2246" />\n\t<meta property="og:image:height" content="2246" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/maincubes/","url":"https://www.art-invest.de/en/projekt/maincubes/","name":"Art-Invest Real Estate | Maincubes","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2014-07-01T10:00:42+00:00","dateModified":"2021-11-04T17:11:11+00:00","description":"Das innovative Premium-Hochleistungsrechenzentrum Maincubes schafft mit intelligentem Design eine neue Heimat für Serverdaten im Rhein-Main-Gebiet.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/maincubes/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/maincubes/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/maincubes/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Maincubes"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Maincubes",
        description:
          "Das innovative Premium-Hochleistungsrechenzentrum Maincubes schafft mit intelligentem Design eine neue Heimat für Serverdaten im Rhein-Main-Gebiet.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/maincubes/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Maincubes",
        og_description:
          "Das innovative Premium-Hochleistungsrechenzentrum Maincubes schafft mit intelligentem Design eine neue Heimat für Serverdaten im Rhein-Main-Gebiet.",
        og_url: "https://www.art-invest.de/en/projekt/maincubes/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T17:11:11+00:00",
        og_image: [
          {
            width: 2246,
            height: 2246,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/FFM_Maincubes_Visualisierung_Nacht_02TEASER-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/maincubes/",
              url: "https://www.art-invest.de/en/projekt/maincubes/",
              name: "Art-Invest Real Estate | Maincubes",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2014-07-01T10:00:42+00:00",
              dateModified: "2021-11-04T17:11:11+00:00",
              description:
                "Das innovative Premium-Hochleistungsrechenzentrum Maincubes schafft mit intelligentem Design eine neue Heimat für Serverdaten im Rhein-Main-Gebiet.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/maincubes/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: ["https://www.art-invest.de/en/projekt/maincubes/"],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/maincubes/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Maincubes",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/FFM_Maincubes_Visualisierung_Nacht_02TEASER-1.jpg",
      place: "Offenbach",
      subtitle: "Innovative Architektur",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16778",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16779",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16778",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16778",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16726,
      date: "2015-02-10T12:00:41",
      date_gmt: "2015-02-10T11:00:41",
      guid: {
        rendered: "https://www.art-invest.de/projekt/deutsche-bank-campus/",
      },
      modified: "2020-07-03T13:36:44",
      modified_gmt: "2020-07-03T13:36:44",
      slug: "deutsche-bank-campus",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/deutsche-bank-campus/",
      title: {
        rendered: "Deutsche Bank Campus(Bestand)",
      },
      featured_media: 16727,
      template: "",
      projekt_filter: [246, 426, 425, 256],
      acf: {
        highlight_image: 16727,
        highlight_title_project: "Deutsche Bank Campus",
        highlight_subtitle_project: "Ein symbolträchtiger Ort",
        highlight_description_project:
          'When the Berlin architect Günther Hönow built the impressive bank building around the corner of Ernst-Reuter-Platz in 1966, this was the setting for the "New Berlin". With the arrival of innovative digital laboratories such as Deutsche Telekom Laboratories or the Charlottenburg Innovations Centrum (CHIC), the square has once again become a scene for the "New Berlin", a creative interface in the middle of the city.',
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Development",
        location: "Otto-Suhr-Allee 6 - 16, 10585 Berlin; Berlin-Charlottenburg",
        property: "5,202 m²",
        area: "13,479 m²",
        zertifizierung: "",
        parcels: "",
        use_for: "Office",
        acquired: "Q1 2012",
        realization: "1968",
        sale: "RREEF Investment GmbH",
        architecture_firm:
          "HPP Hentrich-Petschnigg & Partner GmbH & Co. KG Köln",
        place: "Berlin",
        fakten: null,
        specifications_image_projects: 16728,
        slider: null,
        title_details_projects: "DEUTSCHE BANK CAMPUS IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Perfect proportions ",
            description_repeater_details:
              'The architect Günther Hönow (1923-2001) built the 15-storey building with 13,500 m² of floor space with a sense for form, colour and material effects. The high-rise building consists of a reinforced concrete skeleton. The all-round galleries carry white-enamelled lamellas of light metal. The balustrade and the lamellas emphasize the horizontal of the high-rise building – already in 1968 the office spaces could be designed variably. As part of the upgrading measures, the building received LEED "Gold" certification for Leadership in Energy and Environmental Design.',
            image_repeater_details: 16729,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Scene of the systems",
            description_repeater_details:
              "The Ernst-Reuter-Platz is not only one of the largest urban squares and traffic junctions in Western Europe, it is also a scene of the systems. This is where the most renowned architects of German modernism built – and literally underpinned the West Berlin claim to pioneering architecture and urban planning in the battle of systems at the city's central showcase address.",
            image_repeater_details: 16720,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "In the middle of various possibilities",
            description_repeater_details:
              "Around the Ernst-Reuter-Platz are important institutions such as the TU Berlin, Telekom Innovation Laboratories, large retail chains and residential buildings with cafés. The branching traffic axes lead to the Tiergarten, various Berlin sights and the towering new buildings at the Zoologischer Garten. You'll be fast everywhere if you don't want to linger in front of the central water fountain.",
            image_repeater_details: 14532,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Otto-Suhr-Allee 6 - 16, Berlin-Charlottenburg",
          lat: 52.5141611,
          lng: 13.319655499999953,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Deutsche Bank Campus (Bestand)</title>\n<meta name="description" content="Mit dem Einzug innovativer Digitallabore avanciert der Deutsche Bank Campus erneut zu einer kreativen Schnittstelle mitten in der Stadt." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/deutsche-bank-campus/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Deutsche Bank Campus (Bestand)" />\n<meta property="og:description" content="Mit dem Einzug innovativer Digitallabore avanciert der Deutsche Bank Campus erneut zu einer kreativen Schnittstelle mitten in der Stadt." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/deutsche-bank-campus/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-03T13:36:44+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2015/02/DSC_1376-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="1706" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/deutsche-bank-campus/","url":"https://www.art-invest.de/en/projekt/deutsche-bank-campus/","name":"Art-Invest Real Estate | Deutsche Bank Campus (Bestand)","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2015-02-10T11:00:41+00:00","dateModified":"2020-07-03T13:36:44+00:00","description":"Mit dem Einzug innovativer Digitallabore avanciert der Deutsche Bank Campus erneut zu einer kreativen Schnittstelle mitten in der Stadt.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/deutsche-bank-campus/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/deutsche-bank-campus/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/deutsche-bank-campus/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Deutsche Bank Campus (Bestand)"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Deutsche Bank Campus (Bestand)",
        description:
          "Mit dem Einzug innovativer Digitallabore avanciert der Deutsche Bank Campus erneut zu einer kreativen Schnittstelle mitten in der Stadt.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/deutsche-bank-campus/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Deutsche Bank Campus (Bestand)",
        og_description:
          "Mit dem Einzug innovativer Digitallabore avanciert der Deutsche Bank Campus erneut zu einer kreativen Schnittstelle mitten in der Stadt.",
        og_url: "https://www.art-invest.de/en/projekt/deutsche-bank-campus/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-03T13:36:44+00:00",
        og_image: [
          {
            width: 2560,
            height: 1706,
            url: "https://www.art-invest.de/wp-content/uploads/2015/02/DSC_1376-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/deutsche-bank-campus/",
              url: "https://www.art-invest.de/en/projekt/deutsche-bank-campus/",
              name: "Art-Invest Real Estate | Deutsche Bank Campus (Bestand)",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2015-02-10T11:00:41+00:00",
              dateModified: "2020-07-03T13:36:44+00:00",
              description:
                "Mit dem Einzug innovativer Digitallabore avanciert der Deutsche Bank Campus erneut zu einer kreativen Schnittstelle mitten in der Stadt.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/deutsche-bank-campus/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/deutsche-bank-campus/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/deutsche-bank-campus/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Deutsche Bank Campus (Bestand)",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2015/02/DSC_1376-1-scaled-800x800.jpg",
      place: "Berlin",
      subtitle: "Ein symbolträchtiger Ort",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16726",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16727",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16726",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16726",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 17088,
      date: "2020-08-26T08:59:25",
      date_gmt: "2020-08-26T08:59:25",
      guid: {
        rendered: "https://www.art-invest.de/projekt/eastend-offices-3/",
      },
      modified: "2021-11-04T18:02:48",
      modified_gmt: "2021-11-04T17:02:48",
      slug: "eastend-offices",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/eastend-offices/",
      title: {
        rendered: "Eastend Offices",
      },
      featured_media: 16774,
      template: "",
      projekt_filter: [246, 427, 425, 255],
      acf: {
        highlight_image: 19505,
        highlight_title_project: "Eastend Offices",
        highlight_subtitle_project:
          "Dynamisches Arbeiten im Frankfurter Ostend",
        highlight_description_project:
          "The exclusive office property in Frankfurt's Ostend – one of the most dynamic quarters in Frankfurt – scores with its open construction and optimal working atmosphere.",
        highlight_logo_project: 19506,
        website_projects: {
          title: "www.eastend-offices.de",
          url: "https://eastend-offices.de/",
          target: "_blank",
        },
        external_projectpage: {
          title: "To project page",
          url: "https://eastend-offices.de/",
          target: "_blank",
        },
        available_space: {
          title: "zum Flächenangebot",
          url: "https://www.aire-mag.com/de/flaechen/eastend-offices",
          target: "_blank",
        },
        project: "Investment",
        location:
          "Hanauer Landstraße 151-153 / Ferdinand-Happ-Str. 32, Frankfurt",
        property: "2,700 m² ",
        area: "8,566 m² ",
        zertifizierung: "",
        parcels: "",
        use_for: "Office",
        acquired: "Q4 2018",
        realization: "",
        sale: "",
        architecture_firm: "",
        place: "Frankfurt",
        fakten: null,
        specifications_image_projects: 16774,
        slider: [17090, 16774],
        title_details_projects: "EASTEND OFFICES IM DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details:
              "High working standard in light-flooded rooms",
            description_repeater_details:
              "In the Eastend Offices, modernity meets tradition: a harmonious open architecture with a natural stone facade is interrupted by large window fronts. The bright office building with a room height of three metres offers an optimal working atmosphere due to electrical sun protection and a lighting system suitable for computer workstations. The landscaped inner courtyard and the large roof terrace provide for outdoor retreat.",
            image_repeater_details: 16774,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details:
              "Varied structure thanks to small-scale rental",
            description_repeater_details:
              "With their three development cores and individual room design options, the Eastend Offices are ideally suited for small-scale renting. With the main tenant being the State of Hessen, located with the 5th Frankfurt Police Station, and a mixture of marketing offices, IT service providers and medical practices, the tenant structure is heterogeneous.",
            image_repeater_details: 19505,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Historical flair in a central location",
            description_repeater_details:
              "The Hanauer Landstraße is part of the Untermainstraße, a historically important trade route that ran from the Main estuary in Mainz through Frankfurt in the direction of Fulda. The quarter is traditionally considered an industrial and commercial location, but in recent decades creative agencies, companies from the pharmaceutical, IT and financial sectors, as well as car dealerships have also settled here.",
            image_repeater_details: null,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Hanauer Landstraße 151-153, Frankfurt am Main, Deutschland",
          lat: 50.1124855,
          lng: 8.7148072,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Eastend Offices</title>\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/eastend-offices/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Eastend Offices" />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/eastend-offices/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T17:02:48+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2019/06/hanauer_ldstr_151_CF021925-1.jpg" />\n\t<meta property="og:image:width" content="1234" />\n\t<meta property="og:image:height" content="917" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/eastend-offices/","url":"https://www.art-invest.de/en/projekt/eastend-offices/","name":"Art-Invest Real Estate | Eastend Offices","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2020-08-26T08:59:25+00:00","dateModified":"2021-11-04T17:02:48+00:00","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/eastend-offices/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/eastend-offices/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/eastend-offices/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Eastend Offices"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Eastend Offices",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical: "https://www.art-invest.de/en/projekt/eastend-offices/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Eastend Offices",
        og_url: "https://www.art-invest.de/en/projekt/eastend-offices/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T17:02:48+00:00",
        og_image: [
          {
            width: 1234,
            height: 917,
            url: "https://www.art-invest.de/wp-content/uploads/2019/06/hanauer_ldstr_151_CF021925-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://www.art-invest.de/en/projekt/eastend-offices/",
              url: "https://www.art-invest.de/en/projekt/eastend-offices/",
              name: "Art-Invest Real Estate | Eastend Offices",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2020-08-26T08:59:25+00:00",
              dateModified: "2021-11-04T17:02:48+00:00",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/eastend-offices/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/eastend-offices/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/eastend-offices/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Eastend Offices",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2019/06/hanauer_ldstr_151_CF021925-1-800x800.jpg",
      place: "Frankfurt",
      subtitle: "Dynamik im Frankfurter Ostend",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/17088",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "acf:attachment": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16774",
          },
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/17090",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16774",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=17088",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=17088",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16719,
      date: "2015-02-24T12:00:34",
      date_gmt: "2015-02-24T11:00:34",
      guid: {
        rendered:
          "https://www.art-invest.de/projekt/deutsche-bank-campus-neubau/",
      },
      modified: "2020-07-03T13:15:39",
      modified_gmt: "2020-07-03T13:15:39",
      slug: "deutsche-bank-campus-neubau",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/deutsche-bank-campus-neubau/",
      title: {
        rendered: "Deutsche Bank Campus(Neubau)",
      },
      featured_media: 16721,
      template: "",
      projekt_filter: [246, 426, 425, 256],
      acf: {
        highlight_image: 16725,
        highlight_title_project: "Deutsche Bank Campus",
        highlight_subtitle_project: "Maximale Flexibilität",
        highlight_description_project:
          "The new office complex on the Otto-Suhr-Allee in Berlin sets urbanistic accents in the City West. With the seven-storey new building, Deutsche Bank added around 25,000 m² of rental space to its existing building at Ernst-Reuter-Platz, creating a state-of-the-art campus area in Berlin-Charlottenburg.",
        highlight_logo_project: null,
        website_projects: "",
        external_projectpage: null,
        available_space: [""],
        project: "Development",
        location: "Otto-Suhr-Allee 6 - 16, 10585 Berlin-Charlottenburg",
        property: "8,518 m²",
        area: "24,635 m²",
        zertifizierung: "",
        parcels: "186 TG",
        use_for: "Office",
        acquired: "Q1 2012",
        realization: "Q4 2016",
        sale: "Q3 2016",
        architecture_firm: "HPP Hentrich-Petschnigg & Partner GmbH & Co. KG",
        place: "Berlin",
        fakten: null,
        specifications_image_projects: 16724,
        slider: null,
        title_details_projects: "DEUTSCHE BANK CAMPUS (NEUBAU) IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "A highly symbolic location",
            description_repeater_details:
              "Deutsche Bank is strengthening its presence in the capital city at Ernst-Reuter-Platz. Under the name of the first Governing Mayor of West Berlin, the city found space to develop at Ernst-Reuter-Platz in the 1950s. Today the location is celebrating a renaissance. In addition to Deutsche Bank and the Technical University of Berlin, various companies have discovered the central and easily accessible square as a new location.",
            image_repeater_details: 16720,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Spacious communication rooms",
            description_repeater_details:
              'The public restaurant "Dave B" and the canteen on the ground floor form the communicative base of the new building. In the direct vicinity of the training and conference rooms, there are meeting places for approximately 2,500 employees.',
            image_repeater_details: 16722,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "25,000 m² sustainability",
            description_repeater_details:
              'Thanks to the construction method, the office areas can be designed completely flexible, thus enabling sustainable use of the building. 186 parking spaces in the underground car park are supplemented by numerous bicycle parking facilities around the complex. The new building has been awarded LEED "Gold" certification for Leadership in Energy and Environmental Design – and boasts an excellent environmental balance sheet for every square meter of floor space.',
            image_repeater_details: 14039,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Otto-Suhr-Allee 6 - 16, Berlin-Charlottenburg",
          lat: 52.5141611,
          lng: 13.319655499999953,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Deutsche Bank Campus (Neubau)</title>\n<meta name="description" content="Mit dem Neubau erweitert die Deutsche Bank das Bestandsgebäude am Ernst-Reuter-Platz und schafft so ein hochmodernes Campus-Areal in Berlin-Charlottenburg." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/deutsche-bank-campus-neubau/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Deutsche Bank Campus (Neubau)" />\n<meta property="og:description" content="Mit dem Neubau erweitert die Deutsche Bank das Bestandsgebäude am Ernst-Reuter-Platz und schafft so ein hochmodernes Campus-Areal in Berlin-Charlottenburg." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/deutsche-bank-campus-neubau/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2020-07-03T13:15:39+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2015/02/deutsche-bank-campus-neubau-08-teaser-1.jpg" />\n\t<meta property="og:image:width" content="2169" />\n\t<meta property="og:image:height" content="2169" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/deutsche-bank-campus-neubau/","url":"https://www.art-invest.de/en/projekt/deutsche-bank-campus-neubau/","name":"Art-Invest Real Estate | Deutsche Bank Campus (Neubau)","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2015-02-24T11:00:34+00:00","dateModified":"2020-07-03T13:15:39+00:00","description":"Mit dem Neubau erweitert die Deutsche Bank das Bestandsgebäude am Ernst-Reuter-Platz und schafft so ein hochmodernes Campus-Areal in Berlin-Charlottenburg.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/deutsche-bank-campus-neubau/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/deutsche-bank-campus-neubau/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/deutsche-bank-campus-neubau/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Deutsche Bank Campus (Neubau)"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Deutsche Bank Campus (Neubau)",
        description:
          "Mit dem Neubau erweitert die Deutsche Bank das Bestandsgebäude am Ernst-Reuter-Platz und schafft so ein hochmodernes Campus-Areal in Berlin-Charlottenburg.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/deutsche-bank-campus-neubau/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Deutsche Bank Campus (Neubau)",
        og_description:
          "Mit dem Neubau erweitert die Deutsche Bank das Bestandsgebäude am Ernst-Reuter-Platz und schafft so ein hochmodernes Campus-Areal in Berlin-Charlottenburg.",
        og_url:
          "https://www.art-invest.de/en/projekt/deutsche-bank-campus-neubau/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2020-07-03T13:15:39+00:00",
        og_image: [
          {
            width: 2169,
            height: 2169,
            url: "https://www.art-invest.de/wp-content/uploads/2015/02/deutsche-bank-campus-neubau-08-teaser-1.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/deutsche-bank-campus-neubau/",
              url: "https://www.art-invest.de/en/projekt/deutsche-bank-campus-neubau/",
              name: "Art-Invest Real Estate | Deutsche Bank Campus (Neubau)",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2015-02-24T11:00:34+00:00",
              dateModified: "2020-07-03T13:15:39+00:00",
              description:
                "Mit dem Neubau erweitert die Deutsche Bank das Bestandsgebäude am Ernst-Reuter-Platz und schafft so ein hochmodernes Campus-Areal in Berlin-Charlottenburg.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/deutsche-bank-campus-neubau/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/deutsche-bank-campus-neubau/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/deutsche-bank-campus-neubau/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Deutsche Bank Campus (Neubau)",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2015/02/deutsche-bank-campus-neubau-08-teaser-1.jpg",
      place: "Berlin",
      subtitle: "Maximale Flexibilität",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16719",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16721",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16719",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16719",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
    {
      id: 16763,
      date: "2015-01-27T12:00:17",
      date_gmt: "2015-01-27T11:00:17",
      guid: {
        rendered:
          "https://www.art-invest.de/projekt/reese-haus-an-der-kleinen-alster/",
      },
      modified: "2021-11-04T18:08:13",
      modified_gmt: "2021-11-04T17:08:13",
      slug: "reese-haus-an-der-kleinen-alster",
      status: "publish",
      type: "projekt",
      link: "https://www.art-invest.de/en/projekt/reese-haus-an-der-kleinen-alster/",
      title: {
        rendered: "Reese-Haus an der kleinen Alster",
      },
      featured_media: 16765,
      template: "",
      projekt_filter: [246, 248, 427, 425, 245],
      acf: {
        highlight_image: 16767,
        highlight_title_project: "Reese-Haus an der kleinen Alster",
        highlight_subtitle_project: "Auf Augenhöhe mit dem Bürgermeister",
        highlight_description_project:
          'The Reese-Haus is located in the centre of Hamburg, opposite the "Hamburger Rathaus", directly at the political pulse of the city. Due to its exposed location, it connects the Rathausmarkt with the Kleine Alster. On the largest free area in the city, in front of the venerable sandstone building, merchants\' spirit meets politics, Alster gulls meet Alster swans. It could not be more representative.',
        highlight_logo_project: 16768,
        website_projects: {
          title: "www.reese-haus.de",
          url: "http://www.reese-haus.de",
          target: "",
        },
        external_projectpage: {
          title: "To project page",
          url: "http://www.reese-haus.de",
          target: "_blank",
        },
        available_space: {
          title: "zum Flächenangebot",
          url: "https://www.aire-mag.com/de/flaechen/reesehaus-an-der-kleinen-alster",
          target: "_blank",
        },
        project: "Development",
        location: "Rathausmarkt 5, Hamburg (City)",
        property: "1,172 m²",
        area: "Gross floor area (existing property): 8,127 m²",
        zertifizierung: "",
        parcels: "5 parking spaces",
        use_for: "Office / Retail",
        acquired: "Q1 2015",
        realization: "planned for Q4 2017",
        sale: "",
        architecture_firm: "Kunst & Herbert, Büro für Forschung und Hausbau",
        place: "Hamburg",
        fakten: null,
        specifications_image_projects: 16769,
        slider: null,
        title_details_projects: "REESE HAUS AN DER KLEINEN ALSTER IN DETAIL",
        details_repeater_projects: [
          {
            title_repeater_details: "Auf Augenhöhe mit dem Bürgermeister",
            description_repeater_details:
              "The tenants will find excellent 4,280 m² of office space with high-quality equipment in the bright and newly developed rooms. Anything is possible: Separate workspaces or shared open-plan structures can be modularly adapted to the office floors. Whoever steps onto the surrounding roof terrace finds himself directly at eye level with the first mayor.",
            image_repeater_details: 16766,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "Hamburg’s transformation",
            description_repeater_details:
              "It was the visionary miller Heiner Reese who, with the upper mill on the site of today's Reese House, supplied the up-and-coming Hanseatic city with flour. With the dam on today's Jungfernstieg, Hamburg's cityscape made a radical transformation: the Alster River became an Alster Lake, an idyllic place of Hanseatic activity.",
            image_repeater_details: 16764,
            video: "",
            "anchor-link": "",
          },
          {
            title_repeater_details: "The most beautiful free space in town",
            description_repeater_details:
              "The Rathausmarkt is the urban development and atmospheric interface of the Hanseatic city – in former times the horse-drawn tram lines used to stop here. Today, it is the buses of the metro lines M4 and M5 and the underground of the U3 line. The shopping streets from the direction of the main railway station and Gänsemarkt unite here at the largest square in the city.",
            image_repeater_details: 14167,
            video: "",
            "anchor-link": "",
          },
        ],
        map: {
          address: "Rathausmarkt 5, Hamburg (City)",
          lat: 53.5514253,
          lng: 9.993423300000018,
        },
      },
      yoast_head:
        '<!-- This site is optimized with the Yoast SEO plugin v19.8 - https://yoast.com/wordpress/plugins/seo/ -->\n<title>Art-Invest Real Estate | Reese-Haus an der kleinen Alster</title>\n<meta name="description" content="Das Reese-Haus bietet exzellente 4.280 m² Office-Mietflächen direkt gegenüber vom Rathaus und verbindet damit den Rathausmarkt mit der Kleinen Alster." />\n<meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />\n<link rel="canonical" href="https://www.art-invest.de/en/projekt/reese-haus-an-der-kleinen-alster/" />\n<meta property="og:locale" content="en_US" />\n<meta property="og:type" content="article" />\n<meta property="og:title" content="Art-Invest Real Estate | Reese-Haus an der kleinen Alster" />\n<meta property="og:description" content="Das Reese-Haus bietet exzellente 4.280 m² Office-Mietflächen direkt gegenüber vom Rathaus und verbindet damit den Rathausmarkt mit der Kleinen Alster." />\n<meta property="og:url" content="https://www.art-invest.de/en/projekt/reese-haus-an-der-kleinen-alster/" />\n<meta property="og:site_name" content="Art-Invest Real Estate" />\n<meta property="article:modified_time" content="2021-11-04T17:08:13+00:00" />\n<meta property="og:image" content="https://www.art-invest.de/wp-content/uploads/2016/11/RAT_Links-final-03_TEASER-e1479926508927-1-scaled.jpg" />\n\t<meta property="og:image:width" content="2560" />\n\t<meta property="og:image:height" content="2560" />\n\t<meta property="og:image:type" content="image/jpeg" />\n<meta name="twitter:card" content="summary_large_image" />\n<script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebPage","@id":"https://www.art-invest.de/en/projekt/reese-haus-an-der-kleinen-alster/","url":"https://www.art-invest.de/en/projekt/reese-haus-an-der-kleinen-alster/","name":"Art-Invest Real Estate | Reese-Haus an der kleinen Alster","isPartOf":{"@id":"https://www.art-invest.de/#website"},"datePublished":"2015-01-27T11:00:17+00:00","dateModified":"2021-11-04T17:08:13+00:00","description":"Das Reese-Haus bietet exzellente 4.280 m² Office-Mietflächen direkt gegenüber vom Rathaus und verbindet damit den Rathausmarkt mit der Kleinen Alster.","breadcrumb":{"@id":"https://www.art-invest.de/en/projekt/reese-haus-an-der-kleinen-alster/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://www.art-invest.de/en/projekt/reese-haus-an-der-kleinen-alster/"]}]},{"@type":"BreadcrumbList","@id":"https://www.art-invest.de/en/projekt/reese-haus-an-der-kleinen-alster/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Startseite","item":"https://www.art-invest.de/en/"},{"@type":"ListItem","position":2,"name":"Reese-Haus an der kleinen Alster"}]},{"@type":"WebSite","@id":"https://www.art-invest.de/#website","url":"https://www.art-invest.de/","name":"Art-Invest Real Estate","description":"Art-Invest","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"https://www.art-invest.de/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"}]}</script>\n<!-- / Yoast SEO plugin. -->',
      yoast_head_json: {
        title: "Art-Invest Real Estate | Reese-Haus an der kleinen Alster",
        description:
          "Das Reese-Haus bietet exzellente 4.280 m² Office-Mietflächen direkt gegenüber vom Rathaus und verbindet damit den Rathausmarkt mit der Kleinen Alster.",
        robots: {
          index: "index",
          follow: "follow",
          "max-snippet": "max-snippet:-1",
          "max-image-preview": "max-image-preview:large",
          "max-video-preview": "max-video-preview:-1",
        },
        canonical:
          "https://www.art-invest.de/en/projekt/reese-haus-an-der-kleinen-alster/",
        og_locale: "en_US",
        og_type: "article",
        og_title: "Art-Invest Real Estate | Reese-Haus an der kleinen Alster",
        og_description:
          "Das Reese-Haus bietet exzellente 4.280 m² Office-Mietflächen direkt gegenüber vom Rathaus und verbindet damit den Rathausmarkt mit der Kleinen Alster.",
        og_url:
          "https://www.art-invest.de/en/projekt/reese-haus-an-der-kleinen-alster/",
        og_site_name: "Art-Invest Real Estate",
        article_modified_time: "2021-11-04T17:08:13+00:00",
        og_image: [
          {
            width: 2560,
            height: 2560,
            url: "https://www.art-invest.de/wp-content/uploads/2016/11/RAT_Links-final-03_TEASER-e1479926508927-1-scaled.jpg",
            type: "image/jpeg",
          },
        ],
        twitter_card: "summary_large_image",
        schema: {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id":
                "https://www.art-invest.de/en/projekt/reese-haus-an-der-kleinen-alster/",
              url: "https://www.art-invest.de/en/projekt/reese-haus-an-der-kleinen-alster/",
              name: "Art-Invest Real Estate | Reese-Haus an der kleinen Alster",
              isPartOf: {
                "@id": "https://www.art-invest.de/#website",
              },
              datePublished: "2015-01-27T11:00:17+00:00",
              dateModified: "2021-11-04T17:08:13+00:00",
              description:
                "Das Reese-Haus bietet exzellente 4.280 m² Office-Mietflächen direkt gegenüber vom Rathaus und verbindet damit den Rathausmarkt mit der Kleinen Alster.",
              breadcrumb: {
                "@id":
                  "https://www.art-invest.de/en/projekt/reese-haus-an-der-kleinen-alster/#breadcrumb",
              },
              inLanguage: "en-US",
              potentialAction: [
                {
                  "@type": "ReadAction",
                  target: [
                    "https://www.art-invest.de/en/projekt/reese-haus-an-der-kleinen-alster/",
                  ],
                },
              ],
            },
            {
              "@type": "BreadcrumbList",
              "@id":
                "https://www.art-invest.de/en/projekt/reese-haus-an-der-kleinen-alster/#breadcrumb",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Startseite",
                  item: "https://www.art-invest.de/en/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Reese-Haus an der kleinen Alster",
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://www.art-invest.de/#website",
              url: "https://www.art-invest.de/",
              name: "Art-Invest Real Estate",
              description: "Art-Invest",
              potentialAction: [
                {
                  "@type": "SearchAction",
                  target: {
                    "@type": "EntryPoint",
                    urlTemplate:
                      "https://www.art-invest.de/?s={search_term_string}",
                  },
                  "query-input": "required name=search_term_string",
                },
              ],
              inLanguage: "en-US",
            },
          ],
        },
      },
      featured_image:
        "https://www.art-invest.de/wp-content/uploads/2016/11/RAT_Links-final-03_TEASER-e1479926508927-1-scaled.jpg",
      place: "Hamburg",
      subtitle: "Bürgermeisternah & partnerschaftlich",
      _links: {
        self: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt/16763",
          },
        ],
        collection: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt",
          },
        ],
        about: [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/types/projekt",
          },
        ],
        "wp:featuredmedia": [
          {
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media/16765",
          },
        ],
        "wp:attachment": [
          {
            href: "https://www.art-invest.de/en/wp-json/wp/v2/media?parent=16763",
          },
        ],
        "wp:term": [
          {
            taxonomy: "projektfilter",
            embeddable: true,
            href: "https://www.art-invest.de/en/wp-json/wp/v2/projekt_filter?post=16763",
          },
        ],
        curies: [
          {
            name: "wp",
            href: "https://api.w.org/{rel}",
            templated: true,
          },
        ],
      },
    },
  ];
};
